<template>
	<div class="Tasks">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<div :style="isDomLoading ? 'visibility: hidden; height: 1px' : ''">
			<el-card
				v-if="$route.name != 'ChildPages'"
				class="box-card theme-color no-shadow no-border custom-element__card"
				style="overflow: visible !important; background: #fff"
			>
				<div class="flex">
					<div
						class="tab-link cursor-pointer"
						:class="{ 'active-tab-link': activeTabLink == 'INSIGHTS' }"
						@click="setTabLink('INSIGHTS')"
					>
						<i class="el-icon-s-data default-color"></i>
						Dashboard
					</div>
					<div
						class="tab-link cursor-pointer"
						:class="{ 'active-tab-link': activeTabLink == 'AUDIT' }"
					>
						<el-dropdown @command="setTabLink">
							<span class="el-dropdown-link category-tab-text">
								Projects<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item
									v-for="(item, index) in audit_sub_category_list"
									:key="'audit-sub-category-item-' + index"
									:command="'AUDIT_' + JSON.stringify(item)"
									>{{ item.name }}</el-dropdown-item
								>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div
						class="tab-link cursor-pointer"
						:class="{ 'active-tab-link': activeTabLink == 'TASKS' }"
					>
						<el-dropdown @command="setTabLink">
							<span class="el-dropdown-link category-tab-text">
								Tasks<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item
									v-for="(item, index) in task_sub_category_list"
									:key="'task-sub-category-item-' + index"
									:command="'TASKS_' + JSON.stringify(item)"
									>{{ item.name }}</el-dropdown-item
								>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<div
						class="tab-link cursor-pointer ml-6"
						:class="{ 'active-tab-link': activeTabLink == 'UNASSIGNED_TASKS' }"
						@click="setTabLink('UNASSIGNED_TASKS')"
					>
						Form Templates
					</div>
				</div>
			</el-card>
			<template v-if="activeTabLink == 'INSIGHTS'">
				<el-card
					class="box-card mt-1 theme-color no-shadow no-border custom-element__card"
					style="overflow: visible !important"
					:style="
						main_report_category_id != 'cleanliness_reports' &&
						main_report_category_id != 'audit_reports' &&
						main_report_category_id != 'tasks_reports' &&
						activeTabLink != 'INSIGHTS'
							? 'margin-bottom: 160px'
							: ''
					"
				>
					<div class="sub-menu-section bg-white">
						<div>
							<div class="mt-3">
								<div>
									<div
										style="
											display: flex;
											align-items: center;
											margin-bottom: 10px;
										"
									>
										<span
											class="tab-link cursor-pointer"
											:class="
												dashboardActiveTabLink == 'audit'
													? 'active-tab-link'
													: ''
											"
											@click="dashboardActiveTabLink = 'audit'"
											>Projects</span
										>
										<span
											class="tab-link cursor-pointer"
											:class="
												dashboardActiveTabLink == 'other'
													? 'active-tab-link'
													: ''
											"
											@click="dashboardActiveTabLink = 'other'"
											>Tasks</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Filters -->
					<el-row :gutter="20" class="bg-white">
						<el-col :span="24">
							<task-dashboard-filter
								:outlet-lists="store_list"
								:calendar-type-list="viewList"
								:task-intermediate-categories="task_sub_category_list"
								:audit-intermediate-categories="audit_sub_category_list"
								:initial-from-date="fromDate"
								:initial-to-date="toDate"
								:dashboard-tab="dashboardActiveTabLink"
								:selected-type="view"
								:selected-intermediate-category="selected_audit_type"
								:select-outlet="select_outlet"
								@changedSelectedOutlet="changedSelectedOutlet"
								@changedDateTypeViewList="changedDateTypeViewList"
								@changedFromDate="changedFromDate"
								@changedToDate="changedToDate"
								@changedSelectedAuditType="changedSelectedAuditType"
							></task-dashboard-filter>
						</el-col>
					</el-row>
					<!-- ./Filters -->
					<div  class="mt-4">
						<el-row
							v-if="
								selected_audit_type != 'overall_missing_logs' &&
								selected_audit_type != 'equipments_and_products_missing_logs'
							"
							:gutter="20"
							type="flex"
							class="row-bg"
							justify="space-between"
						>
							<!-- Graph for performance by location/user -->
							<el-col :span="24">
								<location-insights-graph
									:get-outlet-name="getOutletName"
									:from-date="fromDate"
									:to-date="toDate"
									:outlet="select_outlet"
									:intermediate-category="selected_audit_type"
									:dashboard-tab="dashboardActiveTabLink"
									:audit-intermediate-categories="audit_sub_category_list"
									:task-intermediate-categories="task_sub_category_list"
									:outlet-lists="store_list"
									:calendar-type-list="viewList"
									:selected-type="view"
									:select-outlet="select_outlet"
									@changedSelectedOutlet="changedSelectedOutlet"
									@changedDateTypeViewList="changedDateTypeViewList"
									@changedFromDate="changedFromDate"
									@changedToDate="changedToDate"
									@changedSelectedAuditType="changedSelectedAuditType"
								></location-insights-graph>
							</el-col>
							<!-- ./Graph for performance by location/user -->
						</el-row>
						<el-row
							v-if="
								selected_audit_type != 'overall_missing_logs' &&
								selected_audit_type != 'equipments_and_products_missing_logs'
							"
							class="mt-4"
						>
							<!-- Graph for performance by category -->
							<el-col :span="12">
								<category-insights-graph
									:from-date="fromDate"
									:to-date="toDate"
									:outlet="select_outlet"
									:intermediate-category="selected_audit_type"
									:dashboard-tab="dashboardActiveTabLink"
									:audit-intermediate-categories="audit_sub_category_list"
									:task-intermediate-categories="task_sub_category_list"
									:outlet-lists="store_list"
									:calendar-type-list="viewList"
									:selected-type="view"
									:select-outlet="select_outlet"
									@changedSelectedOutlet="changedSelectedOutlet"
									@changedDateTypeViewList="changedDateTypeViewList"
									@changedFromDate="changedFromDate"
									@changedToDate="changedToDate"
									@changedSelectedAuditType="changedSelectedAuditType"
								></category-insights-graph>
							</el-col>
							<el-col :span="1"></el-col>
							<el-col :span="11">
								<steps-insights-graph
									:from-date="fromDate"
									:to-date="toDate"
									:outlet="select_outlet"
									:intermediate-category="selected_audit_type"
									:dashboard-tab="dashboardActiveTabLink"
									:audit-intermediate-categories="audit_sub_category_list"
									:task-intermediate-categories="task_sub_category_list"
									:outlet-lists="store_list"
									:calendar-type-list="viewList"
									:select-outlet="select_outlet"
									@changedSelectedOutlet="changedSelectedOutlet"
									@changedDateTypeViewList="changedDateTypeViewList"
									@changedFromDate="changedFromDate"
									@changedToDate="changedToDate"
									@changedSelectedAuditType="changedSelectedAuditType"
								></steps-insights-graph>
							</el-col>
							<!-- ./Graph for performance by steps -->
						</el-row>

						<el-row
							v-if="
								dashboardActiveTabLink == 'audit' &&
								selected_audit_type != 'overall_missing_logs' &&
								selected_audit_type != 'equipments_and_products_missing_logs'
							"
							:gutter="20"
							class="bg-white"
							:class="!selected_audit_report_outlet.current_step ? 'mt-4' : ''"
						>
							<!-- Last Audit Conducted -->
							<el-col
								v-if="selected_audit_report_outlet.current_step == false"
								:span="24"
							>
								<el-card class="mt-4" style="box-shadow: none; border: none">
									<el-row :gutter="20" class="my-2">
										<el-col :xs="24" :sm="24" :md="12">
											<span><b>Project Reports</b></span> -
											<span>{{ fromDate }} to {{ toDate }}</span>
										</el-col>
										<el-col :xs="24" :sm="24" :md="12" class="text-right">
											<el-input
												v-model="searched_last_audit_location"
												placeholder="Search by location"
												style="max-width: 240px"
												size="mini"
											>
												<i
													slot="prefix"
													class="el-input__icon el-icon-search"
												></i>
											</el-input>
											<el-button
												class="btn submit-btn"
												style="margin-left: 10px"
												size="mini"
												icon="el-icon-download"
												:style="
													!filteredLastAuditConductedList.length
														? 'opacity: 0.6; cursor: not-allowed;'
														: ''
												"
												:disabled="!filteredLastAuditConductedList.length"
												@click="downloadLastAuditConducted"
												>Download Reports</el-button
											>
										</el-col>
									</el-row>
									<template
										v-if="
											dashboardActiveTabLink == 'audit' &&
											selected_audit_report_outlet.current_step == false &&
											!reportLoader
										"
									>
										<table v-loading="reportLoader" class="task-table">
											<thead>
												<tr>
													<th>LOCATION ID</th>
													<th>
														LOCATION
														<el-popover placement="right" trigger="click">
															<el-input
																v-model="searched_audit_report_location"
																size="mini"
																placeholder="Search Location"
															></el-input>
															<div
																style="
																	max-height: 250px;
																	overflow: auto;
																	margin-top: 10px;
																"
															>
																<el-checkbox-group
																	v-model="selected_audit_report_locations"
																>
																	<template
																		v-if="
																			auditReportLocations &&
																			auditReportLocations.length
																		"
																	>
																		<el-checkbox
																			v-for="(
																				location, index
																			) in auditReportLocations.filter(
																				(data) =>
																					!searched_audit_report_location ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_audit_report_location.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="location"
																			style="display: block"
																		></el-checkbox>
																	</template>
																</el-checkbox-group>
															</div>
															<div class="flex justify-between mt-4">
																<span
																	class="text-xs cursor-pointer primary-theme-color"
																	@click="selectAllAuditReportLocations()"
																	>Select all</span
																>
																<span
																	class="text-xs cursor-pointer"
																	@click="resetSelectedAuditReportLocations()"
																	>Reset</span
																>
															</div>
															<span slot="reference">
																<img
																	src="../../../../../src/assets/images/filter-icon.png"
																	width="9"
																	class="cursor-pointer"
																/>
															</span>
														</el-popover>
													</th>
													<th>
														REGION
														<el-popover placement="right" trigger="click">
															<el-input
																v-model="searched_audit_report_region"
																size="mini"
																placeholder="Search Region"
															></el-input>
															<div
																style="
																	max-height: 250px;
																	overflow: auto;
																	margin-top: 10px;
																"
															>
																<el-checkbox-group
																	v-model="selected_audit_report_regions"
																>
																	<template
																		v-if="
																			auditReportRegions &&
																			auditReportRegions.length
																		"
																	>
																		<el-checkbox
																			v-for="(
																				region, index
																			) in auditReportRegions.filter(
																				(data) =>
																					!searched_audit_report_region ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_audit_report_region.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="region"
																			style="display: block"
																		></el-checkbox>
																	</template>
																</el-checkbox-group>
															</div>
															<div class="flex justify-between mt-4">
																<span
																	class="text-xs cursor-pointer primary-theme-color"
																	@click="selectAllAuditReportRegions()"
																	>Select all</span
																>
																<span
																	class="text-xs cursor-pointer"
																	@click="resetSelectedAuditReportRegions()"
																	>Reset</span
																>
															</div>
															<span slot="reference">
																<img
																	src="../../../../../src/assets/images/filter-icon.png"
																	width="9"
																	class="cursor-pointer"
																/>
															</span>
														</el-popover>
													</th>
													<th>
														AREA LEAD
														<el-popover placement="right" trigger="click">
															<el-input
																v-model="searched_audit_report_area_lead"
																size="mini"
																placeholder="Search Area Lead"
															></el-input>
															<div
																style="
																	max-height: 250px;
																	overflow: auto;
																	margin-top: 10px;
																"
															>
																<el-checkbox-group
																	v-model="selected_audit_report_area_leads"
																>
																	<template
																		v-if="
																			auditReportAreaLeads &&
																			auditReportAreaLeads.length
																		"
																	>
																		<el-checkbox
																			v-for="(
																				area_lead, index
																			) in auditReportAreaLeads.filter(
																				(data) =>
																					!searched_audit_report_area_lead ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_audit_report_area_lead.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="area_lead"
																			style="display: block"
																		></el-checkbox>
																	</template>
																</el-checkbox-group>
															</div>
															<div class="flex justify-between mt-4">
																<span
																	class="text-xs cursor-pointer primary-theme-color"
																	@click="selectAllAuditReportAreaLeads()"
																	>Select all</span
																>
																<span
																	class="text-xs cursor-pointer"
																	@click="resetSelectedAuditReportAreaLeads()"
																	>Reset</span
																>
															</div>
															<span slot="reference">
																<img
																	src="../../../../../src/assets/images/filter-icon.png"
																	width="9"
																	class="cursor-pointer"
																/>
															</span>
														</el-popover>
													</th>
													<!-- Hidden Temporarily (Do not delete) -->
													<!-- <th>
                          GRADE
                          <el-popover placement="right" trigger="click">
                            <el-input v-model="searched_audit_report_grade" size="mini" placeholder="Search Area Lead"></el-input>
                            <div style="max-height: 250px; overflow: auto; margin-top: 10px;">
                              <el-checkbox-group v-model="selected_audit_report_grades">
                                <template v-if="auditReportAreaLeads && auditReportAreaLeads.length">
                                <el-checkbox
                                  v-for="(grade, index) in auditReportGrades.filter(data => !searched_audit_report_grade || data.toLowerCase().includes(searched_audit_report_grade.toLowerCase()))"
                                  :key="index" class="mb-2 checkbox-lable" :label="grade" style="display: block"></el-checkbox>
                                </template>
                              </el-checkbox-group>
                            </div>
                            <div class="flex justify-between mt-4">
                              <span class="text-xs cursor-pointer primary-theme-color"
                                @click="selectAllAuditReportGrades()">Select all</span>
                              <span class="text-xs cursor-pointer" @click="resetSelectedAuditReportGrades()">Reset</span>
                            </div>
                            <span slot="reference">
                              <img src="../../../../../src/assets/images/filter-icon.png" width="9" class="cursor-pointer" />
                            </span>
                          </el-popover>
                        </th> -->
													<th>
														POINTS AVAILABLE
														<span slot="reference" class="cursor-pointer">
															<i
																v-if="
																	last_audit_location_total_points_order ==
																	'desc'
																"
																class="el-icon-caret-top"
																style="font-size: 12px"
																@click="
																	last_audit_location_total_points_order =
																		'asc';
																	last_audit_location_achieved_points_order =
																		'';
																	last_audit_location_completion_percentage_order =
																		'';
																	last_audit_location_percentage_points_order =
																		'';
																"
															></i>
															<i
																v-if="
																	last_audit_location_total_points_order ==
																		'' ||
																	last_audit_location_total_points_order ==
																		'asc'
																"
																class="el-icon-caret-bottom"
																style="font-size: 12px"
																@click="
																	last_audit_location_total_points_order =
																		'desc';
																	last_audit_location_achieved_points_order =
																		'';
																	last_audit_location_percentage_points_order =
																		'';
																	last_audit_location_completion_percentage_order =
																		'';
																"
															></i>
														</span>
													</th>
													<th>
														POINTS ACHIEVED
														<span slot="reference" class="cursor-pointer">
															<i
																v-if="
																	last_audit_location_achieved_points_order ==
																	'desc'
																"
																class="el-icon-caret-top"
																style="font-size: 12px"
																@click="
																	last_audit_location_achieved_points_order =
																		'asc';
																	last_audit_location_total_points_order = '';
																	last_audit_location_percentage_points_order =
																		'';
																	last_audit_location_completion_percentage_order =
																		'';
																"
															></i>
															<i
																v-if="
																	last_audit_location_achieved_points_order ==
																		'' ||
																	last_audit_location_achieved_points_order ==
																		'asc'
																"
																class="el-icon-caret-bottom"
																style="font-size: 12px"
																@click="
																	last_audit_location_achieved_points_order =
																		'desc';
																	last_audit_location_total_points_order = '';
																	last_audit_location_percentage_points_order =
																		'';
																	last_audit_location_completion_percentage_order =
																		'';
																"
															></i>
														</span>
													</th>
													<th>
														SCORE %
														<span slot="reference" class="cursor-pointer">
															<i
																v-if="
																	last_audit_location_percentage_points_order ==
																	'desc'
																"
																class="el-icon-caret-top"
																style="font-size: 12px"
																@click="
																	last_audit_location_percentage_points_order =
																		'asc';
																	last_audit_location_total_points_order = '';
																	last_audit_location_achieved_points_order =
																		'';
																	last_audit_location_completion_percentage_order =
																		'';
																"
															></i>
															<i
																v-if="
																	last_audit_location_percentage_points_order ==
																		'' ||
																	last_audit_location_percentage_points_order ==
																		'asc'
																"
																class="el-icon-caret-bottom"
																style="font-size: 12px"
																@click="
																	last_audit_location_percentage_points_order =
																		'desc';
																	last_audit_location_total_points_order = '';
																	last_audit_location_achieved_points_order =
																		'';
																	last_audit_location_completion_percentage_order =
																		'';
																"
															></i>
														</span>
													</th>
													<th>
														COMPLETION %
														<span slot="reference" class="cursor-pointer">
															<i
																v-if="
																	last_audit_location_completion_percentage_order ==
																	'desc'
																"
																class="el-icon-caret-top"
																style="font-size: 12px"
																@click="
																	last_audit_location_completion_percentage_order =
																		'asc';
																	last_audit_location_total_points_order = '';
																	last_audit_location_achieved_points_order =
																		'';
																	last_audit_location_percentage_points_order =
																		'';
																"
															></i>
															<i
																v-if="
																	last_audit_location_completion_percentage_order ==
																		'' ||
																	last_audit_location_completion_percentage_order ==
																		'asc'
																"
																class="el-icon-caret-bottom"
																style="font-size: 12px"
																@click="
																	last_audit_location_completion_percentage_order =
																		'desc';
																	last_audit_location_total_points_order = '';
																	last_audit_location_achieved_points_order =
																		'';
																	last_audit_location_percentage_points_order =
																		'';
																"
															></i>
														</span>
													</th>
													<th>&nbsp;</th>
												</tr>
											</thead>
											<tbody style="height: 300px; overflow-y: scroll">
												<template
													v-for="(
														item, index
													) in filteredLastAuditConductedList"
												>
													<tr
														v-if="index >= startnumber - 1 && index < endnumber"
														:key="'audit-conducted-item-' + index"
													>
														<td>
															{{ item.store_id }}
														</td>
														<td>
															{{ item.name ? item.name : "-" }}
														</td>
														<td>
															{{ item.region_name }}
														</td>
														<td>
															{{ item.subregion_name }}
														</td>
														<!-- Hidden temporaryly (Do not delete) -->
														<!-- <td>{{ item.grade ? item.grade : '-' }}</td> -->
														<td>
															{{
																item.total_yes_no_points
																	? item.total_yes_no_points
																	: "-"
															}}
														</td>
														<td>
															{{
																item
																	? item.total_yes_no_points_achieved
																		? item.total_yes_no_points_achieved
																		: "-"
																	: "-"
															}}
														</td>
														<td>{{ item.yes_no_points_percentage + "%" }}</td>
														<td>{{ item.completion_rate + "%" }}</td>
														<td>
															<span
																style="
																	text-decoration: underline;
																	cursor: pointer;
																	color: #d26300;
																"
																@click="
																	openAuditReportLocation(item, 'category');
																	resetAllAuditReportFilters();
																	audit_reports_inner_modal = true;
																"
															>
																View Details
															</span>
														</td>
													</tr>
												</template>
											</tbody>
										</table>
										<!-- Pagination -->
										<el-row :gutter="20" class="mt-4">
											<el-col :span="8" class="text-left">
												<div>
													<b>Showing</b> {{ startnumber }} to {{ endnumber }} of
													{{ filteredLastAuditConductedList.length }} results
												</div>
											</el-col>
											<el-col :span="8" class="text-center">
												<el-select
													v-model="perPage"
													name="per_page"
													placeholder="select per page"
													style="width: 90px !important"
													size="mini"
												>
													<el-option label="10" :value="10"></el-option>
													<el-option label="25" :value="25"></el-option>
													<el-option label="50" :value="50"></el-option>
													<el-option label="100" :value="100"></el-option>
												</el-select>
												&nbsp;<b>per page</b>
											</el-col>
											<el-col :span="8" class="text-right">
												<el-pagination
													background
													layout="prev, pager, next"
													:total="filteredLastAuditConductedList.length"
													:page-size="perPage"
													:current-page.sync="currentPage"
												></el-pagination>
											</el-col>
										</el-row>
									</template>
								</el-card>
							</el-col>

							<!-- AUDIT REPORTS STARTS HERE -->

							<!-- AUDIT REPORTS ENDS HERE -->
							<!-- ./Last Audit Conducted -->
							<div class="reportPopup">
								<el-dialog
									:visible.sync="audit_reports_inner_modal"
									:close-on-click-modal="true"
									width="95%"
									top="0"
									custom-class="customClass audit-report-details"
									:lock-scroll="true"
									:show-close="true"
								>
									<div class="text-left" style="padding: 0 20px 0 20px">
										<el-button
											icon="el-icon-back"
											class="submit-btn"
											size="mini"
											@click="
												resetAuditReports();
												resetAllAuditReportFilters();
												audit_reports_inner_modal = false;
											"
										>
											Back
										</el-button>
									</div>
									<el-row
										v-if="
											dashboardActiveTabLink == 'audit' &&
											selected_audit_type != 'overall_missing_logs' &&
											selected_audit_type !=
												'equipments_and_products_missing_logs' &&
											selected_audit_report_outlet.current_step == true
										"
										:gutter="20"
										class="mt-4 bg-white py-2"
										:class="activeTabLink != 'INSIGHTS' ? 'mb-4' : ''"
										style="margin-left: 20px; margin-right: 20px"
									>
										<el-col :span="24">
											<el-breadcrumb
												v-if="
													dashboardActiveTabLink == 'audit' &&
													selected_audit_type != 'overall_missing_logs' &&
													selected_audit_type !=
														'equipments_and_products_missing_logs' &&
													selected_audit_report_outlet.current_step == true
												"
												separator-class="el-icon-arrow-right"
											>
												<el-breadcrumb-item
													><span
														class="link-text"
														style="color: #d26300; text-transform: capitalize"
														@click="
															resetAuditReports();
															resetAllAuditReportFilters();
															audit_reports_inner_modal = false;
														"
														>Audit</span
													></el-breadcrumb-item
												>
												<el-breadcrumb-item
													><span
														class="link-text"
														style="color: #d26300; text-transform: capitalize"
														@click="
															handleAuditReportsBreadcrumb('outlet');
															resetAllAuditReportFilters();
														"
														>{{ selected_audit_report_outlet.name }}</span
													>
												</el-breadcrumb-item>
												<el-breadcrumb-item
													v-if="
														dashboardActiveTabLink == 'audit' &&
														selected_audit_type != 'overall_missing_logs' &&
														selected_audit_type !=
															'equipments_and_products_missing_logs' &&
														selected_audit_report_outlet.current_step == true &&
														selected_audit_report_category.current_step == true
													"
												>
													<span
														style="color: #d26300; text-transform: capitalize"
														class="link-text"
														@click="
															handleAuditReportsBreadcrumb('category');
															resetAllAuditReportFilters();
														"
														>{{ selected_audit_report_category.name }}</span
													>
												</el-breadcrumb-item>
												<el-breadcrumb-item
													v-if="
														dashboardActiveTabLink == 'audit' &&
														selected_audit_type != 'overall_missing_logs' &&
														selected_audit_type !=
															'equipments_and_products_missing_logs' &&
														selected_audit_report_outlet.current_step == true &&
														selected_audit_report_category.current_step ==
															true &&
														selected_audit_report_task.current_step == true
													"
												>
													<span style="text-transform: capitalize">{{
														selected_audit_report_task.name
													}}</span>
												</el-breadcrumb-item>
											</el-breadcrumb>
										</el-col>
									</el-row>
									<el-row
										:gutter="20"
										class="mt-2"
										style="margin-left: 10px; margin-right: 10px"
									>
										<el-col
											v-if="
												selected_audit_report_outlet.current_step == true &&
												selected_audit_report_category.current_step == false
											"
											:span="24"
										>
											<table class="task-table mt-4">
												<thead>
													<tr>
														<th>
															SUB CATEGORY
															<el-popover placement="right" trigger="click">
																<el-input
																	v-model="searched_audit_report_sub_category"
																	size="mini"
																	placeholder="Search Sub-category"
																></el-input>
																<div
																	style="
																		max-height: 250px;
																		overflow: auto;
																		margin-top: 10px;
																	"
																>
																	<el-checkbox-group
																		v-model="
																			selected_audit_report_sub_categories
																		"
																	>
																		<template
																			v-if="
																				auditReportSubCategories &&
																				auditReportSubCategories.length
																			"
																		>
																			<el-checkbox
																				v-for="(
																					location, index
																				) in auditReportSubCategories.filter(
																					(data) =>
																						!searched_audit_report_sub_category ||
																						data
																							.toLowerCase()
																							.includes(
																								searched_audit_report_sub_category.toLowerCase()
																							)
																				)"
																				:key="index"
																				class="mb-2 checkbox-lable"
																				:label="location"
																				style="display: block"
																			></el-checkbox>
																		</template>
																	</el-checkbox-group>
																</div>
																<div class="flex justify-between mt-4">
																	<span
																		class="text-xs cursor-pointer primary-theme-color"
																		@click="selectAllAuditReportSubCategories()"
																		>Select all</span
																	>
																	<span
																		class="text-xs cursor-pointer"
																		@click="
																			resetSelectedAuditReportSubCategories()
																		"
																		>Reset</span
																	>
																</div>
																<span slot="reference">
																	<img
																		src="../../../../../src/assets/images/filter-icon.png"
																		width="9"
																		class="cursor-pointer"
																	/>
																</span>
															</el-popover>
														</th>
														<th>
															INTERMEDIATE CATEGORY
															<el-popover placement="right" trigger="click">
																<el-input
																	v-model="
																		searched_audit_report_intermediate_category
																	"
																	size="mini"
																	placeholder="Search Intermediate Category"
																></el-input>
																<div
																	style="
																		max-height: 250px;
																		overflow: auto;
																		margin-top: 10px;
																	"
																>
																	<el-checkbox-group
																		v-model="
																			selected_audit_report_intermediate_categories
																		"
																	>
																		<template
																			v-if="
																				auditReportIntermediateCategories &&
																				auditReportIntermediateCategories.length
																			"
																		>
																			<el-checkbox
																				v-for="(
																					location, index
																				) in auditReportIntermediateCategories.filter(
																					(data) =>
																						!searched_audit_report_intermediate_category ||
																						data
																							.toLowerCase()
																							.includes(
																								searched_audit_report_intermediate_category.toLowerCase()
																							)
																				)"
																				:key="index"
																				class="mb-2 checkbox-lable"
																				:label="location"
																				style="display: block"
																			></el-checkbox>
																		</template>
																	</el-checkbox-group>
																</div>
																<div class="flex justify-between mt-4">
																	<span
																		class="text-xs cursor-pointer primary-theme-color"
																		@click="
																			selectAllAuditReportIntermediateCategories()
																		"
																		>Select all</span
																	>
																	<span
																		class="text-xs cursor-pointer"
																		@click="
																			resetSelectedAuditReportIntermediateCategories()
																		"
																		>Reset</span
																	>
																</div>
																<span slot="reference">
																	<img
																		src="../../../../../src/assets/images/filter-icon.png"
																		width="9"
																		class="cursor-pointer"
																	/>
																</span>
															</el-popover>
														</th>
														<th>POINTS AVAILABLE</th>
														<th>POINTS ACHIEVED</th>
														<th>SCORE %</th>
														<!-- <th v-for="(element, key) in audit_report_date_arr" :key="'audit-report-dates-'+key"
                            style="width: 140px; text-transform: uppercase;">
                            <div style="margin-bottom: 4px">{{ moment(element).format('Do MMM') }}</div>
                          </th> -->
														<th>&nbsp;</th>
													</tr>
												</thead>
												<tbody>
													<tr
														v-for="(
															item, index
														) in filteredAuditReportCategories"
														:key="'audit-reports-category-list-' + index"
													>
														<td style="font-weight: 700">{{ item.name }}</td>
														<td style="font-weight: 700">
															{{ item.data[0].intermediate_category_name }}
														</td>
														<td style="font-weight: 700">
															{{ item.data[0].total_yes_no_points }}
														</td>
														<td style="font-weight: 700">
															{{ item.data[0].total_yes_no_points_achieved }}
														</td>
														<td style="font-weight: 700">
															{{ item.data[0].yes_no_points_percentage }}%
														</td>
														<td>
															<span
																style="
																	text-decoration: underline;
																	cursor: pointer;
																	color: #d26300;
																"
																@click="
																	openAuditReportLocation(item, 'task');
																	resetAllAuditReportFilters();
																"
															>
																View Details
															</span>
														</td>
													</tr>
												</tbody>
											</table>
										</el-col>

										<el-col
											v-else-if="
												selected_audit_report_outlet.current_step == true &&
												selected_audit_report_category.current_step == true &&
												selected_audit_report_task.current_step == false
											"
											:span="24"
										>
											<el-table
												:data="filteredAuditReportTasks"
												class="audit-report-tasks-dashboard-task-table"
												max-height="600"
											>
												<el-table-column align="center" width="250" fixed>
													<template slot="header" slot-scope="scope">
														TASKS&nbsp;
														<el-popover placement="right" trigger="click">
															<el-input
																v-model="searched_audit_report_task"
																size="mini"
																placeholder="Search Task"
															></el-input>
															<div
																style="
																	max-height: 250px;
																	overflow: auto;
																	margin-top: 10px;
																"
															>
																<el-checkbox-group
																	v-model="selected_audit_report_tasks"
																>
																	<template
																		v-if="
																			auditReportTasks &&
																			auditReportTasks.length
																		"
																	>
																		<el-checkbox
																			v-for="(
																				location, index
																			) in auditReportTasks.filter(
																				(data) =>
																					!searched_audit_report_task ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_audit_report_task.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="location"
																			style="display: block"
																		></el-checkbox>
																	</template>
																</el-checkbox-group>
															</div>
															<div class="flex justify-between mt-4">
																<span
																	class="text-xs cursor-pointer primary-theme-color"
																	@click="selectAllAuditReportTasks()"
																	>Select all</span
																>
																<span
																	class="text-xs cursor-pointer"
																	@click="resetSelectedAuditReportTasks()"
																	>Reset</span
																>
															</div>
															<span slot="reference">
																<img
																	src="../../../../../src/assets/images/filter-icon.png"
																	width="9"
																	class="cursor-pointer"
																/>
															</span>
														</el-popover>
													</template>
													<template slot-scope="scope">
														<span
															style="
																text-decoration: underline;
																cursor: pointer;
																word-break: break-word;
															"
															class="title"
															@click="
																openAuditReportLocation(scope.row, 'subtask');
																resetAllAuditReportFilters();
															"
														>
															{{ scope.row.name }}
														</span>
													</template>
												</el-table-column>
												<el-table-column
													v-for="(
														dateItem, dateIndex
													) in all_audit_report_dates"
													:key="'date-header-' + dateIndex"
													align="center"
												>
													<template slot="header" slot-scope="scope">
														<span class="capitalize">{{
															moment(dateItem).format("Do MMM")
														}}</span>
													</template>
													<template slot-scope="scope">
														<template v-for="(el, ind) in scope.row.data">
															<span :key="'audit-task-' + ind">
																<template
																	v-if="
																		el.due_date &&
																		el.completion_date &&
																		el.completion_date != 'NaT'
																	"
																>
																	<template
																		v-if="
																			new Date(el.completion_date) <=
																				new Date(el.due_date) &&
																			moment(
																				new Date(el.completion_date)
																			).format('YYYY-MM-DD') ==
																				moment(new Date(dateItem)).format(
																					'YYYY-MM-DD'
																				)
																		"
																	>
																		<i
																			style="color: #67c23a"
																			class="text-base el-icon-success"
																		></i>
																	</template>
																	<template
																		v-else-if="
																			new Date(el.completion_date) >
																				new Date(el.due_date) &&
																			moment(
																				new Date(el.completion_date)
																			).format('YYYY-MM-DD') ==
																				moment(new Date(dateItem)).format(
																					'YYYY-MM-DD'
																				)
																		"
																	>
																		<i
																			style="color: #f56c6c"
																			class="text-base el-icon-error"
																		></i>
																	</template>
																</template>
																<template
																	v-else-if="el.due_date && !el.completion_date"
																>
																	<template
																		v-if="
																			new Date(el.due_date) < new Date() &&
																			moment(dateItem).format('YYYY-MM-DD') ==
																				moment(el.due_date).format('YYYY-MM-DD')
																		"
																	>
																		<i
																			style="color: #f56c6c"
																			class="text-base el-icon-error"
																		></i>
																	</template>
																</template>
															</span>
														</template>
													</template>
												</el-table-column>
											</el-table>
										</el-col>

										<el-col
											v-else-if="
												selected_audit_report_outlet.current_step == true &&
												selected_audit_report_category.current_step == true &&
												selected_audit_report_task.current_step == true
											"
											:span="24"
										>
											<el-table
												:data="filteredAuditReportSubTasks"
												class="audit-report-tasks-dashboard-task-table"
												max-height="600"
											>
												<el-table-column align="center" width="250" fixed>
													<template slot="header" slot-scope="scope">
														SUBTASK&nbsp;
														<el-popover placement="right" trigger="click">
															<el-input
																v-model="searched_audit_report_subtask"
																size="mini"
																placeholder="Search Sub-Task"
															></el-input>
															<div
																style="
																	max-height: 250px;
																	overflow: auto;
																	margin-top: 10px;
																"
															>
																<el-checkbox-group
																	v-model="selected_audit_report_subtasks"
																>
																	<template
																		v-if="
																			auditReportSubTasks &&
																			auditReportSubTasks.length
																		"
																	>
																		<el-checkbox
																			v-for="(
																				location, index
																			) in auditReportSubTasks.filter(
																				(data) =>
																					!searched_audit_report_subtask ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_audit_report_subtask.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="location"
																			style="display: block"
																		></el-checkbox>
																	</template>
																</el-checkbox-group>
															</div>
															<div class="flex justify-between mt-4">
																<span
																	class="text-xs cursor-pointer primary-theme-color"
																	@click="selectAllAuditReportSubTasks()"
																	>Select all</span
																>
																<span
																	class="text-xs cursor-pointer"
																	@click="resetSelectedAuditReportSubTasks()"
																	>Reset</span
																>
															</div>
															<span slot="reference">
																<img
																	src="../../../../../src/assets/images/filter-icon.png"
																	width="9"
																	class="cursor-pointer"
																/>
															</span>
														</el-popover>
													</template>
													<template slot-scope="scope">
														<span style="word-break: break-word">
															<div
																class="title"
																style="font-size: 12px !important"
																v-html="scope.row.name"
															></div>
															<template v-if="scope.row.attachments && scope.row.attachments.length">
                             							 <div class="mt-2"><span style="cursor:pointer; text-decoration: underline;"
                                  @click="openAuditSubTaskImageCommentModal(scope.row.attachments, '')">View Image</span></div>
                            </template>
                            <template v-if="scope.row.comment">
                              <div class="mt-2"><span style="cursor:pointer; text-decoration: underline;"
                                  @click="openAuditSubTaskImageCommentModal([], scope.row.comment)">View Comment</span></div>
                            </template>
														</span>
													</template>
												</el-table-column>
												<el-table-column
													v-for="(
														dateItem, dateIndex
													) in all_audit_report_dates"
													:key="'date-column-' + dateIndex"
													align="center"
													min-width="140"
												>
													<template slot="header" slot-scope="scope">
														<span class="capitalize">{{
															moment(dateItem).format("Do MMM")
														}}</span>
													</template>
													<template slot-scope="scope">
														<template v-for="(el, ind) in scope.row.data">
															<span :key="'audit-task-' + ind">
																<template
																	v-if="
																		el.due_date &&
																		el.completion_date &&
																		el.completion_date != 'NaT'
																	"
																>
																	<template
																		v-if="
																			new Date(el.completion_date) <=
																				new Date(el.due_date) &&
																			moment(
																				new Date(el.completion_date)
																			).format('YYYY-MM-DD') ==
																				moment(new Date(dateItem)).format(
																					'YYYY-MM-DD'
																				)
																		"
																	>
																		<span
																			style="color: #502314; font-size: 12px"
																		>
																			<template v-if="el.not_applicable"
																				>N.A</template
																			>
																			<template v-else-if="el.boolean_value"
																				>Yes</template
																			>
																			<template v-else>No</template>
																		</span>
																	</template>
																	<template
																		v-else-if="
																			new Date(el.completion_date) >
																				new Date(el.due_date) &&
																			moment(
																				new Date(el.completion_date)
																			).format('YYYY-MM-DD') ==
																				moment(new Date(dateItem)).format(
																					'YYYY-MM-DD'
																				)
																		"
																	>
																		<!-- <i style="color: #F56C6C;" class="text-base el-icon-error"></i> -->
																		<span
																			style="color: #f56c6c; font-size: 12px"
																		>
																			<template v-if="el.not_applicable"
																				>N.A</template
																			>
																			<template v-else-if="el.boolean_value"
																				>Yes</template
																			>
																			<template v-else>No</template>
																		</span>
																	</template>
																</template>
																<template
																	v-else-if="el.due_date && !el.completion_date"
																>
																	<template
																		v-if="
																			new Date(el.due_date) < new Date() &&
																			moment(dateItem).format('YYYY-MM-DD') ==
																				moment(el.due_date).format('YYYY-MM-DD')
																		"
																	>
																		<i
																			style="color: #f56c6c; font-size: 12px"
																			class="text-base el-icon-error"
																		></i>
																	</template>
																	<template
																		v-else-if="
																			moment(dateItem).format('YYYY-MM-DD') ==
																			moment(el.due_date).format('YYYY-MM-DD')
																		"
																		>-</template
																	>
																</template>
															</span>
														</template>
													</template>
												</el-table-column>
											</el-table>
										</el-col>
									</el-row>
								</el-dialog>
							</div>
						</el-row>
						<!-- Tasks Reports For Dashboard -->
						<div
							v-if="
								dashboardActiveTabLink == 'other' &&
								selected_audit_type != 'overall_missing_logs' &&
								selected_audit_type != 'equipments_and_products_missing_logs'
							"
							class="mt-4 bg-white"
							style="
								padding: 0 10px;
								margin-top: 25px;
								margin-left: -10px;
								margin-right: -10px;
							"
						>
							<el-row>
								<el-col :span="24">
									<el-row :gutter="20" class="bg-white pt-4 mt-2">
										<el-col :xs="24" :sm="24" :md="12" class="text-left">
											<span><b>Task Reports</b></span> -
											<span>{{ fromDate }} to {{ toDate }}</span>
										</el-col>
										<el-col :xs="24" :sm="24" :md="12" class="text-right">
											<el-button
												class="btn submit-btn"
												size="mini"
												icon="el-icon-download"
												@click="downloadTaskCsvReport"
												>Download Reports</el-button
											>
										</el-col>
									</el-row>
									<el-row
										v-if="dashboardActiveTabLink == 'other'"
										:gutter="20"
										class="bg-white pb-4 mt-2"
									>
										<el-col :span="24">
											<table class="task-table mt-4">
												<thead>
													<tr>
														<th>LOCATION ID</th>
														<th>
															LOCATION
															<el-popover placement="right" trigger="click">
																<el-input
																	v-model="search_location_for_task"
																	size="mini"
																	placeholder="Search Location"
																></el-input>
																<div
																	style="
																		max-height: 250px;
																		overflow: auto;
																		margin-top: 10px;
																	"
																>
																	<el-checkbox-group
																		v-model="selected_location_filter_for_task"
																	>
																		<el-checkbox
																			v-for="(
																				location, index
																			) in location_for_task_reports.filter(
																				(data) =>
																					!search_location_for_task ||
																					data
																						.toLowerCase()
																						.includes(
																							search_location_for_task.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="location"
																			style="display: block"
																		></el-checkbox>
																	</el-checkbox-group>
																</div>
																<div class="flex justify-between mt-4">
																	<span
																		class="text-xs cursor-pointer primary-theme-color"
																		@click="selectAllAuditReportsLocations()"
																		>Select all</span
																	>
																	<span
																		class="text-xs cursor-pointer"
																		@click="
																			resetSelectedAuditReportsLocations()
																		"
																		>Reset</span
																	>
																</div>
																<span slot="reference">
																	<img
																		src="../../../../../src/assets/images/filter-icon.png"
																		width="9"
																		class="cursor-pointer"
																	/>
																</span>
															</el-popover>
														</th>
														<th>
															REGION
															<el-popover placement="right" trigger="click">
																<el-input
																	v-model="searched_task_reports_region_name"
																	size="mini"
																	placeholder="Search Region"
																></el-input>
																<div
																	style="
																		max-height: 250px;
																		overflow: auto;
																		margin-top: 10px;
																	"
																>
																	<el-checkbox-group
																		v-model="selected_task_reports_regions"
																	>
																		<el-checkbox
																			v-for="(
																				location, index
																			) in taskReportsUniqueRegions.filter(
																				(data) =>
																					!searched_task_reports_region_name ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_task_reports_region_name.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="location"
																			style="display: block"
																		></el-checkbox>
																	</el-checkbox-group>
																</div>
																<div class="flex justify-between mt-4">
																	<span
																		class="text-xs cursor-pointer primary-theme-color"
																		@click="
																			selected_task_reports_regions = [
																				...taskReportsUniqueRegions,
																			]
																		"
																		>Select all</span
																	>
																	<span
																		class="text-xs cursor-pointer"
																		@click="selected_task_reports_regions = []"
																		>Reset</span
																	>
																</div>
																<span slot="reference">
																	<img
																		src="../../../../../src/assets/images/filter-icon.png"
																		width="9"
																		class="cursor-pointer"
																	/>
																</span>
															</el-popover>
														</th>
														<th>
															AREA LEAD
															<el-popover placement="right" trigger="click">
																<el-input
																	v-model="searched_task_reports_subregion_name"
																	size="mini"
																	placeholder="Search Area Lead"
																></el-input>
																<div
																	style="
																		max-height: 250px;
																		overflow: auto;
																		margin-top: 10px;
																	"
																>
																	<el-checkbox-group
																		v-model="selected_task_reports_subregions"
																	>
																		<el-checkbox
																			v-for="(
																				location, index
																			) in taskReportsUniqueSubRegions.filter(
																				(data) =>
																					!searched_task_reports_subregion_name ||
																					data
																						.toLowerCase()
																						.includes(
																							searched_task_reports_subregion_name.toLowerCase()
																						)
																			)"
																			:key="index"
																			class="mb-2 checkbox-lable"
																			:label="location"
																			style="display: block"
																		></el-checkbox>
																	</el-checkbox-group>
																</div>
																<div class="flex justify-between mt-4">
																	<span
																		class="text-xs cursor-pointer primary-theme-color"
																		@click="
																			selected_task_reports_subregions = [
																				...taskReportsUniqueSubRegions,
																			]
																		"
																		>Select all</span
																	>
																	<span
																		class="text-xs cursor-pointer"
																		@click="
																			selected_task_reports_subregions = []
																		"
																		>Reset</span
																	>
																</div>
																<span slot="reference">
																	<img
																		src="../../../../../src/assets/images/filter-icon.png"
																		width="9"
																		class="cursor-pointer"
																	/>
																</span>
															</el-popover>
														</th>
														<th>
															TOTAL TASKS
															<span>
																<i
																	v-if="
																		sort_by_descending_task_report_task_assigned
																	"
																	class="el-icon-caret-top text-base cursor-pointer"
																	@click="sortByAscendingTaskReportsAssigned()"
																></i>
																<i
																	v-else
																	class="el-icon-caret-bottom text-base cursor-pointer"
																	@click="sortByDescendingTaskReportsAssigned()"
																></i>
															</span>
														</th>
														<th>
															COMPLETED
															<span>
																<i
																	v-if="
																		sort_by_descending_task_report_task_completed
																	"
																	class="el-icon-caret-top text-base cursor-pointer"
																	@click="sortByAscendingTaskReportsCompleted()"
																></i>
																<i
																	v-else
																	class="el-icon-caret-bottom text-base cursor-pointer"
																	@click="
																		sortByDescendingTaskReportsCompleted()
																	"
																></i>
															</span>
														</th>
														<th>
															INCOMPLETE
															<span>
																<i
																	v-if="
																		sort_by_descending_task_report_task_incomplete
																	"
																	class="el-icon-caret-top text-base cursor-pointer"
																	@click="
																		sortByAscendingTaskReportsIncomplete()
																	"
																></i>
																<i
																	v-else
																	class="el-icon-caret-bottom text-base cursor-pointer"
																	@click="
																		sortByDescendingTaskReportsIncomplete()
																	"
																></i>
															</span>
														</th>
														<th>
															COMPLETION %
															<span>
																<i
																	v-if="
																		sort_by_descending_task_report_task_completion_rate
																	"
																	class="el-icon-caret-top text-base cursor-pointer"
																	@click="
																		sortByAscendingTaskReportsCompletionRate()
																	"
																></i>
																<i
																	v-else
																	class="el-icon-caret-bottom text-base cursor-pointer"
																	@click="
																		sortByDescendingTaskReportsCompletionRate()
																	"
																></i>
															</span>
														</th>

														<th>&nbsp;</th>
													</tr>
												</thead>
												<tbody
													v-if="getTaskReports.length"
													v-loading="is_audit_report_list_loading"
													style="max-height: 300px"
												>
													<template v-for="(i, index) in getTaskReports">
														<tr
															v-if="
																index >= taskReportStartNumber - 1 &&
																index < taskReportEndNumber
															"
															:key="index"
														>
															<td>{{ i.store_id }}</td>
															<td class="capitalize" style="text-align: center">
																<div style="font-weight: 700">
																	<span
																		style="
																			text-decoration: underline;
																			cursor: pointer;
																		"
																		@click="
																			getTaskOutletReport(i.basics, i.name);
																			resetAllTaskReportFilters();
																		"
																		>{{ i.name }}</span
																	>
																</div>
															</td>
															<td class="capitalize">{{ i.region_name }}</td>
															<td class="capitalize">{{ i.subregion_name }}</td>
															<td>
																{{ i.total }}
															</td>
															<td>{{ i.completed }}</td>
															<td>
																{{
																	i.total - i.completed
																		? i.total - i.completed
																		: 0
																}}
															</td>
															<td>
																{{
																	i.completion_rate != "-"
																		? i.completion_rate + "%"
																		: i.completion_rate
																}}
															</td>
															<td>
																<span
																	style="
																		margin-left: 8px;
																		color: #d26300;
																		text-decoration: underline;
																		cursor: pointer;
																	"
																	@click="
																		getTaskCategoryData(i.basics, i.name);
																		resetAllTaskReportFilters();
																	"
																	>View Details</span
																>
															</td>
														</tr>
													</template>
												</tbody>
											</table>

											<div
												v-if="!getTaskReports.length"
												v-loading="is_task_report_list_loading"
												class="text-center primary-theme-color text-sm font-semibold"
												style="padding: 15px"
											>
												No data available
											</div>

											<!-- Pagination -->
											<el-row :gutter="20" class="mt-4">
												<el-col :span="8" class="text-left">
													<div>
														<b>Showing</b> {{ taskReportStartNumber }} to
														{{ taskReportEndNumber }} of
														{{ getTaskReports.length }} results
													</div>
												</el-col>
												<el-col :span="8" class="text-center">
													<el-select
														v-model="taskReportPerPage"
														name="per_page"
														placeholder="select per page"
														style="width: 90px !important"
														size="mini"
													>
														<el-option label="10" :value="10"></el-option>
														<el-option label="25" :value="25"></el-option>
														<el-option label="50" :value="50"></el-option>
														<el-option label="100" :value="100"></el-option>
													</el-select>
													&nbsp;<b>per page</b>
												</el-col>
												<el-col :span="8" class="text-right">
													<el-pagination
														background
														layout="prev, pager, next"
														:total="getTaskReports.length"
														:page-size="taskReportPerPage"
														:current-page.sync="taskReportCurrentPage"
													></el-pagination>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</div>
						<!-- ./Tasks Reports For Dashboard -->

						<!-- Missing Logs -->
						<missing-log
							v-if="
								selected_audit_type == 'overall_missing_logs' ||
								selected_audit_type == 'equipments_and_products_missing_logs'
							"
							:is-loading="logsLoading"
							:from-date="fromDate"
							:to-date="toDate"
							:log-reports="logReports"
							:missing-log-type="selected_audit_type"
							:store-list="store_list"
							:selected-outlet="select_outlet"
							:dashboard-tab="dashboardActiveTabLink"
							:audit-intermediate-categories="audit_sub_category_list"
							:task-intermediate-categories="task_sub_category_list"
						/>
						<!-- ./Missing Logs -->
					</div>
					<div style="display: none">
						<el-card shadow="none">
							<div style="text-align: center; margin-top: 100px">
								<img src="../../../../assets/images/Union.png" />
							</div>
							<div style="text-align: center; font-weight: 200">
								There is nothing to show you right now
							</div>
						</el-card>
					</div>
				</el-card>
			</template>

			<el-card
				v-if="activeTabLink != 'INSIGHTS'"
				class="box-card mt-1 theme-color no-shadow no-border custom-element__card"
				style="overflow: visible !important"
				:style="
					main_report_category_id != 'cleanliness_reports' &&
					main_report_category_id != 'audit_reports' &&
					main_report_category_id != 'tasks_reports' &&
					activeTabLink != 'INSIGHTS'
						? 'margin-bottom: 160px'
						: ''
				"
			>
				<div
					v-if="main_report_category_id != 'tasks_reports'"
					class="sub-menu-section"
				>
					<div
						v-if="
							main_report_category_id != 'cleanliness_reports' &&
							main_report_category_id != 'audit_reports' &&
							main_report_category_id != 'tasks_reports' &&
							activeTabLink != 'INSIGHTS'
						"
						class="mr-2"
						style="width: 300px"
					>
						<p class="input-label">Location</p>
						<el-select
							v-model="select_outlet"
							filterable
							sortable
							size="small"
							style="width: 100%"
							placeholder="Select Store"
							name="Select Store"
							class="capitalize"
							@change="goToTask()"
						>
							<el-option
								v-for="(item, index) in store_list"
								:key="index"
								:value="item.id"
								:label="item.name"
								class="capitalize"
							>
							</el-option>
						</el-select>
					</div>

					<div
						v-if="
							main_report_category_id != 'cleanliness_reports' &&
							main_report_category_id != 'audit_reports' &&
							main_report_category_id != 'tasks_reports' &&
							activeTabLink != 'INSIGHTS'
						"
					>
						<el-input
							v-if="
								activeTabLink == 'AUDIT' ||
								activeTabLink == 'TASKS' ||
								activeTabLink == 'COMPETITION'
							"
							v-model="search_emp_name"
							size="small"
							placeholder="Search By Task name"
							prefix-icon="el-icon-search"
							style="width: 350px"
						></el-input>

						<el-input
							v-if="activeTabLink == 'UNASSIGNED_TASKS'"
							v-model="search_by_tasks_title"
							placeholder="Search By task title"
							size="small"
							prefix-icon="el-icon-search"
							style="width: 350px"
						></el-input>
					</div>

					<div
						v-if="
							main_report_category_id != 'cleanliness_reports' &&
							main_report_category_id != 'audit_reports' &&
							main_report_category_id != 'tasks_reports' &&
							activeTabLink != 'INSIGHTS'
						"
						class="flex"
						style="margin-left: auto"
					>
						<!-- <el-button
							class="submit-btn"
							size="small"
							@click="opeDialogOnCommand('CREATE_TASK_LIST')"
							>CREATE FORM
						</el-button>

						<el-button
							class="submit-btn"
							size="small"
							@click="opeDialogOnCommand('ASSIGN_TASK')"
							>ASSIGN</el-button
						> -->
					</div>
				</div>
				<div>
					<div class="mt-3">
						<!-- Assigned Task Table -->
						<div
							v-if="
								activeTabLink == 'AUDIT' ||
								activeTabLink == 'TASKS' ||
								activeTabLink == 'COMPETITION'
							"
							v-loading="is_task_progress_loading || is_tasks_list_loading"
						>
							<!-- Category Dropdown -->
							<template
								v-if="
									activeTabLink == 'TASKS' &&
									main_report_category_id != 'tasks_reports' &&
									main_report_category_id != 'audit_reports'
								"
							>
								<el-row :gutter="20">
									<el-col :span="24">
										<h2 class="title link my-1">
											{{
												selected_dropdown_category.name
													? selected_dropdown_category.name
													: ""
											}}
										</h2>
									</el-col>
								</el-row>
							</template>
							<!-- ./Category Dropdown -->

							<!-- category name list -->
							<div
								style="display: flex; align-items: center; margin-bottom: 10px"
							>
								<template
									v-for="(
										category, category_index
									) in assigned_task_category_names"
								>
									<span
										v-if="
											(activeTabLink == 'AUDIT' &&
												category.main_category == 'audit') ||
											(activeTabLink == 'TASKS' &&
												category.main_category == 'other') ||
											(activeTabLink == 'COMPETITION' &&
												category.main_category == 'cleanliness')
										"
										:key="category_index"
										class="tab-link cursor-pointer"
										:class="{
											'active-tab-link':
												active_assigned_task_category.name == category.name,
										}"
										@click="handleAssignedTaskCategory(category)"
									>
										<span>{{ category.name }}</span>
									</span>
								</template>
							</div>

							<template
								v-if="
									active_assigned_task_category.name != 'Reports' &&
									main_report_category_id != 'cleanliness_reports' &&
									active_assigned_task_category.name != 'Reports' &&
									main_report_category_id != 'audit_reports'
								"
							>
								<table v-if="activeTabLink == 'TASKS'" class="task-table">
									<thead>
										<tr>
											<th style="width: 190px">TASK</th>

											<th style="width: 150px">
												EMPLOYEE
												<el-popover placement="bottom" trigger="click">
													<el-input
														v-model="task_emp_search_term"
														size="mini"
														placeholder="Search Employee"
													></el-input>
													<div
														style="
															max-height: 250px;
															overflow: auto;
															margin-top: 10px;
														"
													>
														<el-checkbox-group v-model="task_emp_selected_list">
															<el-checkbox
																v-for="(
																	status, status_index
																) in tasksEmployees.filter(
																	(data) =>
																		!task_emp_search_term ||
																		data
																			.toLowerCase()
																			.includes(
																				task_emp_search_term.toLowerCase()
																			)
																)"
																:key="status_index"
																class="mb-2 checkbox-lable"
																:label="status"
																style="display: block"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="
																	() =>
																		(task_emp_selected_list = [
																			...tasksEmployees,
																		])
																"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="() => (task_emp_selected_list = [])"
																>Reset</span
															>
														</div>
													</div>

													<span slot="reference" class="cursor-pointer">
														<img
															v-if="!task_emp_selected_list.length"
															src="../../../../../src/assets/images/filter-icon.png"
															width="9"
															alt=""
														/>
														<img
															v-else-if="task_emp_selected_list.length"
															src="../../../../../src/assets/images/filter.png"
															width="9"
															alt=""
														/>
													</span>
												</el-popover>
											</th>

											<th style="width: 150px">
												FREQUENCY
												<el-popover placement="bottom" trigger="click">
													<el-input
														v-model="task_freq_search_term"
														size="mini"
														placeholder="Search Frequency"
													></el-input>
													<div
														style="
															max-height: 250px;
															overflow: auto;
															margin-top: 10px;
														"
													>
														<el-checkbox-group
															v-model="task_freq_selected_list"
														>
															<el-checkbox
																v-for="(
																	status, status_index
																) in tasksFrequencyList.filter(
																	(data) =>
																		!task_freq_search_term ||
																		data
																			.toLowerCase()
																			.includes(
																				task_freq_search_term.toLowerCase()
																			)
																)"
																:key="status_index"
																class="mb-2 checkbox-lable"
																:label="status"
																style="display: block"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="
																	() =>
																		(task_freq_selected_list = [
																			...tasksFrequencyList,
																		])
																"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="() => (task_freq_selected_list = [])"
																>Reset</span
															>
														</div>
													</div>

													<span slot="reference" class="cursor-pointer">
														<img
															v-if="!task_freq_selected_list.length"
															src="../../../../../src/assets/images/filter-icon.png"
															width="9"
															alt=""
														/>
														<img
															v-else-if="task_freq_selected_list.length"
															src="../../../../../src/assets/images/filter.png"
															width="9"
															alt=""
														/>
													</span>
												</el-popover>
											</th>

											<th style="width: 150px">
												TIME
												<el-popover placement="bottom" trigger="click">
													<el-input
														v-model="task_time_search_term"
														size="mini"
														placeholder="Search Time"
													></el-input>
													<div
														style="
															max-height: 250px;
															overflow: auto;
															margin-top: 10px;
														"
													>
														<el-checkbox-group
															v-model="task_time_selected_list"
														>
															<el-checkbox
																v-for="(
																	status, status_index
																) in tasksTimeList.filter(
																	(data) =>
																		!task_time_search_term ||
																		data
																			.toLowerCase()
																			.includes(
																				task_time_search_term.toLowerCase()
																			)
																)"
																:key="status_index"
																class="mb-2 checkbox-lable"
																:label="status"
																style="display: block"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="
																	() =>
																		(task_time_selected_list = [
																			...tasksTimeList,
																		])
																"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="() => (task_time_selected_list = [])"
																>Reset</span
															>
														</div>
													</div>

													<span slot="reference" class="cursor-pointer">
														<img
															v-if="!task_time_selected_list.length"
															src="../../../../../src/assets/images/filter-icon.png"
															width="9"
															alt=""
														/>
														<img
															v-else-if="task_time_selected_list.length"
															src="../../../../../src/assets/images/filter.png"
															width="9"
															alt=""
														/>
													</span>
												</el-popover>
											</th>

											<th style="width: 130px">
												STATUS

												<el-popover placement="bottom" trigger="click">
													<div>
														<el-checkbox-group v-model="selected_status_list">
															<el-checkbox
																v-for="(
																	status, status_index
																) in task_status_filter_options"
																:key="status_index"
																class="mb-2 checkbox-lable"
																:label="status.text"
																style="display: block"
																@change="changeFilterTaskStatus()"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllTaskStatus()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetSelectedTaskStatus()"
																>Reset</span
															>
														</div>
													</div>

													<span slot="reference" class="cursor-pointer">
														<img
															v-if="!statusActiveFilter"
															src="../../../../../src/assets/images/filter-icon.png"
															width="9"
															alt=""
														/>
														<img
															v-if="statusActiveFilter"
															src="../../../../../src/assets/images/filter.png"
															width="9"
															alt=""
														/>
													</span>
												</el-popover>
											</th>
										</tr>
									</thead>

									<tbody
										v-if="getAssignedTasksListData.length"
										id="overlay-disabled"
										style="max-height: 370px"
									>
										<template v-for="(i, index) in getAssignedTasksListData">
											<tr
												:key="index"
												v-if="
													i.category &&
													active_assigned_task_category.name == i.category.name
												"
											>
												<td style="width: 190px" v-if="!i.is_category_head">
													<div
														style="word-break: break-word; padding-bottom: 5px"
													>
														<span
															style="
																text-decoration: underline;
																font-weight: 600;
																cursor: pointer;
															"
															@click="
																i.is_assigned
																	? editAssignedTask(i, 'CHANGE_TASK_STATUS')
																	: editAssignedTask(i, 'EDIT_TASK')
															"
														>
															{{ i.task_name }}
														</span>
													</div>

													<div v-if="i.checklist.length" class="text-xs">
														Steps -
														{{
															i.checklist.filter((e) => {
																return e.is_completed;
															}).length
														}}
														/ {{ i.checklist.length }} completed
													</div>
												</td>

												<td v-if="!i.is_category_head" style="width: 150px">
													<div class="text-xs">{{ i.emp_name }}</div>
													<div class="text-xs mt-1">
														{{ i.emp_designation }}
													</div>
												</td>

												<td v-if="!i.is_category_head" style="width: 150px">
													{{ i.frequency }}
												</td>

												<td v-if="!i.is_category_head" style="width: 150px">
													{{
														i.start_time && i.end_time
															? i.start_time + " - " + i.end_time
															: "-"
													}}
												</td>

												<td v-if="!i.is_category_head" style="width: 130px">
													<div
														class="cursor-pointer"
														style=""
														:class="
															i.task_status == 'Open'
																? 'open-status-dropdown'
																: i.task_status == 'Completed'
																? 'completed-status-dropdown'
																: i.task_status == 'Overdue' ||
																  i.task_status == 'Unassigned'
																? 'overdue-status-dropdown'
																: i.task_status == 'Upcoming'
																? 'upcoming-status-dropdown'
																: ''
														"
														@click="editAssignedTask(i, 'CHANGE_TASK_STATUS')"
													>
														{{
															i.task_status == "Open"
																? "Pending"
																: i.task_status
														}}
													</div>
												</td>
											</tr>
										</template>
									</tbody>
								</table>

								<table v-else class="task-table">
									<thead>
										<tr>
											<th style="width: 190px">TASK</th>

											<th style="width: 150px">
												POINTS AVAILABLE
												<span slot="reference" class="cursor-pointer">
													<i
														class="el-icon-caret-top"
														@click="sortByAscendingPointsAvailable"
														v-if="sort_by_descending_points_available"
														style="font-size: 12px"
													></i>
													<i
														class="el-icon-caret-bottom"
														@click="sortByDescendingPointsAvailable"
														v-if="sort_by_ascending_points_available"
														style="font-size: 12px"
													></i>
												</span>
											</th>

											<th style="width: 150px">
												POINTS ACHIEVED
												<span slot="reference" class="cursor-pointer">
													<i
														class="el-icon-caret-top"
														@click="sortByAscendingPointsAchieved"
														v-if="sort_by_descending_points_achieved"
														style="font-size: 12px"
													></i>
													<i
														class="el-icon-caret-bottom"
														@click="sortByDescendingPointsAchieved"
														v-if="sort_by_ascending_points_achieved"
														style="font-size: 12px"
													></i>
												</span>
											</th>

											<th style="width: 150px">
												PERCENTAGE
												<span slot="reference" class="cursor-pointer">
													<i
														v-if="sort_by_descending_scoring_percentage"
														class="el-icon-caret-top"
														style="font-size: 12px"
														@click="sortByAscendingScoringPercentage"
													></i>
													<i
														v-else-if="sort_by_ascending_scoring_percentage"
														class="el-icon-caret-bottom"
														style="font-size: 12px"
														@click="sortByDescendingScoringPercentage"
													></i>
												</span>
											</th>

											<th style="width: 130px">
												STATUS

												<el-popover placement="bottom" trigger="click">
													<div>
														<el-checkbox-group v-model="selected_status_list">
															<el-checkbox
																v-for="(
																	status, status_index
																) in task_status_filter_options"
																:key="status_index"
																class="mb-2 checkbox-lable"
																:label="status.text"
																style="display: block"
																@change="changeFilterTaskStatus()"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllTaskStatus()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetSelectedTaskStatus()"
																>Reset</span
															>
														</div>
													</div>

													<span slot="reference" class="cursor-pointer">
														<img
															v-if="!statusActiveFilter"
															src="../../../../../src/assets/images/filterBlack.png"
															width="9"
															alt=""
														/>
														<img
															v-if="statusActiveFilter"
															src="../../../../../src/assets/images/filterBlack.png"
															width="9"
															alt=""
														/>
													</span>
												</el-popover>
											</th>
										</tr>
									</thead>

									<tbody
										v-if="getAssignedTasksListData.length"
										id="overlay-disabled"
										style="max-height: 370px"
									>
										<template v-for="(i, index) in getAssignedTasksListData">
											<tr
												v-if="
													i.category &&
													active_assigned_task_category.name == i.category.name
												"
												:key="index"
											>
												<td v-if="!i.is_category_head" style="width: 190px">
													<div
														style="word-break: break-word; padding-bottom: 5px"
													>
														<span
															style="
																text-decoration: underline;
																font-weight: 600;
																cursor: pointer;
															"
															@click="
																i.is_assigned
																	? editAssignedTask(i, 'CHANGE_TASK_STATUS')
																	: editAssignedTask(i, 'EDIT_TASK')
															"
														>
															{{ i.task_name }}
														</span>
													</div>

													<div v-if="i.checklist.length" class="text-xs">
														Steps -
														{{
															i.checklist.filter((e) => {
																return e.is_completed;
															}).length
														}}
														/ {{ i.checklist.length }} completed
													</div>
												</td>

												<td v-if="!i.is_category_head" style="width: 150px">
													{{ i.total_scoring_points_yes_no }} <br />
												</td>

												<td v-if="!i.is_category_head" style="width: 150px">
													{{ i.total_scoring_points_yes_no_achieved }}
												</td>

												<td v-if="!i.is_category_head" style="width: 150px">
													{{
														i.scoring_percentage_yes_no
															? Number(i.scoring_percentage_yes_no).toPrecision(
																	4
															  )
															: i.scoring_percentage_yes_no
													}}%
												</td>

												<td v-if="!i.is_category_head" style="width: 130px">
													<div
														class="cursor-pointer"
														style=""
														:class="
															i.task_status == 'Open'
																? 'open-status-dropdown'
																: i.task_status == 'Completed'
																? 'completed-status-dropdown'
																: i.task_status == 'Overdue' ||
																  i.task_status == 'Unassigned'
																? 'overdue-status-dropdown'
																: i.task_status == 'Upcoming'
																? 'upcoming-status-dropdown'
																: ''
														"
														@click="editAssignedTask(i, 'CHANGE_TASK_STATUS')"
													>
														{{
															i.task_status == "Open"
																? "Pending"
																: i.task_status
														}}
													</div>
												</td>
											</tr>
										</template>
									</tbody>
								</table>

								<div
									v-if="!getAssignedTasksListData.length"
									class="text-center primary-theme-color text-sm font-semibold"
									style="padding: 15px"
								>
									No data available
								</div>
							</template>
						</div>

						<!-- Task Table -->
						<template
							v-if="
								(active_assigned_task_category.name != 'Reports' &&
									main_report_category_id != 'cleanliness_reports') ||
								(active_assigned_task_category.name != 'Reports' &&
									main_report_category_id != 'audit_reports')
							"
						>
							<div
								v-if="activeTabLink == 'UNASSIGNED_TASKS'"
								v-loading="is_task_progress_loading || is_tasks_list_loading"
							>
								<!-- category name list -->
								<div
									style="
										display: flex;
										align-items: center;
										margin-bottom: 10px;
										overflow-y: auto;
										padding-bottom: 5px;
									"
								>
									<span
										v-for="(
											category, category_index
										) in unassigned_task_category_names"
										:key="category_index"
										class="tab-link cursor-pointer"
										:class="{
											'active-tab-link':
												active_unassigned_task_category == category,
										}"
										@click="active_unassigned_task_category = category"
									>
										{{ category }}
									</span>
								</div>

								<table class="task-table">
									<thead>
										<tr>
											<th>
												LOCATION

												<el-popover placement="bottom" trigger="click">
													<div>
														<el-checkbox-group v-model="selected_store_list">
															<el-checkbox
																v-for="(
																	storeName, name_index
																) in task_assigned_store_filter_options"
																:key="name_index"
																class="mb-2 checkbox-lable"
																:label="storeName.text"
																style="display: block"
																@change="changeFilterStatusStoreName"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllStoreName()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetSelectedStoreName()"
																>Reset</span
															>
														</div>
													</div>

													<i
														class="el-icon-caret-bottom cursor-pointer"
														slot="reference"
														style="font-size: 12px"
													></i>
												</el-popover>
											</th>

											<th>DESIGNATION</th>

											<th style="width: 220px">TASK</th>

											<th style="width: 120px">POINTS</th>

											<th style="width: 120px">
												FREQUENCY

												<el-popover placement="bottom" trigger="click">
													<div>
														<el-checkbox-group v-model="selected_repeat_list">
															<el-checkbox
																v-for="(
																	freq, freq_index
																) in task_repeat_options"
																:key="freq_index"
																class="mb-2 checkbox-lable"
																:label="freq.text"
																style="display: block"
																@change="changeFilterStatusFreq"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllFreq()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetSelectedFreq()"
																>Reset</span
															>
														</div>
													</div>

													<i
														class="el-icon-caret-bottom cursor-pointer"
														slot="reference"
														style="font-size: 12px"
													></i>
												</el-popover>
											</th>

											<th style="width: 120px">TIME</th>

											<th>
												CREATED BY
												<el-popover placement="bottom" trigger="click">
													<div>
														<el-checkbox-group v-model="selected_created_list">
															<el-checkbox
																v-for="(
																	i, index
																) in task_createdby_filter_options"
																:key="index"
																class="mb-2 checkbox-lable"
																:label="i.text"
																style="display: block"
																@change="changeFilterStatusCreatedBy"
															></el-checkbox>
														</el-checkbox-group>

														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllCreatedBy()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetSelectedCreatedBy()"
																>Reset</span
															>
														</div>
													</div>

													<i
														class="el-icon-caret-bottom cursor-pointer"
														slot="reference"
														style="font-size: 12px"
													></i>
												</el-popover>
											</th>

											<th style="width: 100px"></th>
										</tr>
									</thead>

									<tbody
										v-if="getUnassignedTasksListData.length"
										style="max-height: 370px"
									>
										<template v-for="(i, index) in getUnassignedTasksListData">
											<tr
												:key="index"
												v-if="
													i.category_info &&
													active_unassigned_task_category ==
														i.category_info.name
												"
											>
												<td v-if="!i.is_category_head" style="text-align: left">
													{{ i.outlet_name }}
												</td>
												<td v-if="!i.is_category_head">
													<div v-if="i.designations_info.length < 1">-</div>

													<div v-else class="capitalize">
														<el-dropdown v-if="i.designations_info.length > 1">
															<span class="el-dropdown-link">
																{{ i.designations_info[0].name }} +
																{{ i.designations_info.length - 1 }}
																<i
																	class="el-icon-arrow-down el-icon--right"
																></i>
															</span>

															<el-dropdown-menu slot="dropdown">
																<el-dropdown-item
																	disabled
																	v-for="(des, index) in i.designations_info"
																	:key="index"
																	>{{ des.name }}
																</el-dropdown-item>
															</el-dropdown-menu>
														</el-dropdown>

														<div
															v-else
															v-for="(des, index) in i.designations_info"
															:key="index"
														>
															{{ des.name }}
														</div>
													</div>
												</td>
												<td v-if="!i.is_category_head" style="width: 220px">
													<div
														class="font-bold"
														style="word-break: break-word; padding-bottom: 5px"
													>
														<span
															style="
																text-decoration: underline;
																font-weight: 600;
																cursor: pointer;
															"
															@click="editUnassignTask(i)"
														>
															{{ i.name }}
														</span>
													</div>

													<div v-if="i.checklist.length" class="text-xs">
														Steps - {{ i.checklist.length }} steps
													</div>
												</td>

												<td v-if="!i.is_category_head" style="width: 120px">
													{{ i.total_audit_points }} Points
												</td>

												<td v-if="!i.is_category_head" style="width: 120px">
													{{
														i.frequency == "daily"
															? "Daily"
															: i.frequency == "days_of_week" ||
															  i.frequency == "weekly"
															? "Weekly"
															: i.frequency == "one_time"
															? "One Time"
															: i.frequency == "monthly"
															? "Monthly"
															: "-"
													}}
												</td>

												<td v-if="!i.is_category_head" style="width: 120px">
													<div
														v-for="(time, index) in i.task_times_info"
														:key="index"
													>
														{{
															time.start_time ? time.start_time.slice(0, 5) : ""
														}}
														-
														{{ time.end_time ? time.end_time.slice(0, 5) : "" }}
													</div>
												</td>

												<td v-if="!i.is_category_head">
													<div
														class="font-bold"
														style="
															word-break: break-word;
															font-size: 11px;
															padding-top: 5px;
														"
													>
														{{ i.created_by_name }}
													</div>

													<div>
														{{ i.created_date | formatDate }}
													</div>
												</td>

												<td v-if="!i.is_category_head" style="width: 100px">
													<i
														class="el-icon-edit-outline cursor-pointer mr-2 default-icon"
														@click="editUnassignTask(i)"
													></i>
													<i
														class="el-icon-delete cursor-pointer default-icon"
														@click="openDeleteTaskWarningDailog(i.id)"
													></i>
												</td>
											</tr>
										</template>
									</tbody>
								</table>

								<div
									v-if="!getUnassignedTasksListData.length"
									class="text-center primary-theme-color text-sm font-semibold"
									style="padding: 15px"
								>
									No data available
								</div>
							</div>
						</template>
					</div>
				</div>

				<!-- confirmation dialog to delete task -->
				<el-dialog
					title="Warning"
					:visible.sync="delete_task_confirmation_dialog"
					width="40%"
					top="10px"
					customClass="tasks__delete-confirmation-modal"
				>
					<div>
						Warning This task if assigned to any employees will also get
						removed. Do you wish to continue?
					</div>
					<span slot="footer" class="dialog-footer">
						<div class="flex justify-end">
							<BaseButton
								type="submit"
								style="width: 100px"
								buttonclass="btn p-2 text-xs cancel-btn"
								@click="delete_task_confirmation_dialog = false"
							>
								Cancel
							</BaseButton>
							<BaseButton
								type="submit"
								style="width: 100px"
								class="ml-4"
								buttonclass="btn p-2 text-xs"
								@click="deleteTask()"
							>
								Confirm
							</BaseButton>
						</div>
					</span>
				</el-dialog>

				<!-- dialog to edit assigned task -->
				<div class="reportPopup">
					<el-dialog
						:title="
							selected_assigned_task.selected_action == 'EDIT_TASK'
								? 'Edit Task Assignment'
								: 'Change Task Status'
						"
						:visible.sync="edit_task_dialog_visible"
						:close-on-click-modal="true"
						width="95%"
						top="0"
						custom-class="customClass"
						:lock-scroll="true"
						:show-close="true"
					>
						<div v-loading="is_edit_task_loading">
							<div>
								<div class="text-left" style="padding: 0 20px 0 20px">
									<el-button
										icon="el-icon-back"
										class="submit-btn"
										size="mini"
										@click="edit_task_dialog_visible = false"
									>
										Back
									</el-button>
								</div>

								<div class="step-container" style="padding: 0 20px 0 20px">
									<div
										style="
											display: flex;
											align-items: center;
											justify-content: space-between;
										"
									>
										<div class="title capitalize" style="font-size: 1.4em">
											{{ selected_assigned_task.task_name }}
										</div>
									</div>

									<div style="color:black" class="custom-dialog-header mt-2">
										<span
											class="font-bold text-xs block"
											style="font-size: 14px; font-weight: 700;"
											>Steps -
										</span>

										&nbsp;

										<span
											v-if="
												selected_assigned_task.selected_action ==
													'CHANGE_TASK_STATUS' &&
												selected_assigned_task.is_assigned
											"
											style="font-size: 14px; font-weight: 700;"
										>
											{{ getSelectedChecklistCount }} /
											{{ selected_assigned_task.checklist.length }}
										</span>

										<span v-else style="font-size: 14px; font-weight: 700;">
											{{ selected_assigned_task.checklist.length }}
										</span>
									</div>

									<div
										v-if="
											selected_assigned_task.checklist &&
											selected_assigned_task.checklist.length
										"
										class="mt-2"
										style="max-height: 500px; overflow-y: scroll"
									>
										<div
											v-for="(
												checklist, checklist_index
											) in selected_assigned_task.checklist"
											:key="checklist_index"
										>
											<el-card class="box-card mb-2">
												<div class="flex items-center">
													<div class="flex items-center">
														<div
															v-if="
																checklist.subtask_info &&
																checklist.subtask_info.subtask_type ==
																	'checklist' &&
																selected_assigned_task.selected_action ==
																	'CHANGE_TASK_STATUS' &&
																selected_assigned_task.is_assigned
															"
															style="margin-right: 10px"
														>
															<el-checkbox
																v-model="checklist.boolean_value"
																class="custom-size-checkbox"
															></el-checkbox>
														</div>
														<span
															style="
																color: #502314;
																font-size: 0.9rem;
																font-weight: 500;
															"
															v-html="
																checklist.subtask_info &&
																checklist.subtask_info.label
																	? checklist.subtask_info.label
																	: ''
															"
														></span>
													</div>

													<div
														v-if="
															checklist.subtask_info.subtask_type ==
																'temperature' &&
															checklist.subtask_info.num_value_min != null &&
															checklist.subtask_info.num_value_max != null
														"
														class="text-sm"
														style="
															margin-left: 15px;
															font-size: 0.8rem;
															color: #999;
														"
													>
														(Ideal Range:
														{{ checklist.subtask_info.num_value_min }}&deg; C to
														{{ checklist.subtask_info.num_value_max }}&deg; C)
													</div>

													<div
														v-else-if="
															checklist.subtask_info.subtask_type == 'tpc' &&
															checklist.subtask_info.num_value_min != null &&
															checklist.subtask_info.num_value_max != null
														"
														class="text-sm"
														style="
															margin-left: 15px;
															font-size: 0.8rem;
															color: #999;
														"
													>
														(Ideal Range:
														{{ checklist.subtask_info.num_value_min }} TPM to
														{{ checklist.subtask_info.num_value_max }} TPM)
													</div>
												</div>

												<div
													v-if="
														(selected_assigned_task.selected_action ==
															'CHANGE_TASK_STATUS' &&
															selected_assigned_task.is_assigned) ||
														selected_assigned_task.selected_action ==
															'EDIT_TASK'
													"
													class="mt-4"
													style="width: 100%"
												>
													<div
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'rating'
														"
														class="flex items-center"
													>
														<el-rate
															v-model="checklist.num_value"
															:allow-half="true"
															text-color="#D26300"
															:disabled="checklist.not_applicable"
														></el-rate>

														<span
															v-if="checklist.num_value"
															style="
																color: #d26300;
																font-size: 0.9rem;
																margin-left: 10px;
															"
														>
															{{ checklist.num_value }} / 5
														</span>
													</div>

													<el-input
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'text'
														"
														v-model="checklist.text_value"
														type="textarea"
														:rows="4"
														resize="none"
														placeholder="Please input"
														size="small"
														style="width: 100%"
														:maxlength="500"
														:show-word-limit="true"
														:disabled="checklist.not_applicable"
													></el-input>

													<div
														v-if="
															checklist.subtask_info.subtask_type ==
																'temperature' ||
															checklist.subtask_info.subtask_type == 'tpc'
														"
													>
														<div style="display: flex; align-items: center">
															<div style="display: flex; align-items: center">
																<span class="text-sm"
																	>Test Value &nbsp;&nbsp;&nbsp;</span
																>
																<input
																	v-model="checklist.num_value"
																	type="number"
																	:placeholder="
																		checklist.subtask_info.subtask_type ==
																		'temperature'
																			? 'Temp in C'
																			: 'tpm value'
																	"
																	class="custom-number-input"
																	style="
																		width: 32%;
																		height: 32px;
																		line-height: 32px;
																	"
																	:style="
																		checkNumberInRange(
																			checklist.num_value,
																			checklist.subtask_info.num_value_min,
																			checklist.subtask_info.num_value_max
																		)
																	"
																	:disabled="
																		(checklist.retest_value != '' &&
																			checklist.retest_value != null) ||
																		checklist.not_applicable
																	"
																/>

																<div
																	v-if="
																		checklist.num_value != '' &&
																		checklist.num_value != null &&
																		checklist.num_value >=
																			checklist.subtask_info.num_value_min &&
																		checklist.num_value <=
																			checklist.subtask_info.num_value_max
																	"
																>
																	&nbsp;&nbsp;&nbsp;
																	<i
																		class="el-icon-success"
																		style="color: #29b823; font-size: 1.1rem"
																	></i>
																</div>
															</div>

															<div
																v-if="
																	checklist.num_value != null &&
																	checklist.num_value != undefined &&
																	checklist.num_value != '' &&
																	Object.keys(
																		checkNumberInRange(
																			checklist.num_value,
																			checklist.subtask_info.num_value_min,
																			checklist.subtask_info.num_value_max
																		)
																	).length
																"
																style="display: flex; align-items: center"
															>
																<span class="text-sm"
																	>Retest Value &nbsp;&nbsp;&nbsp;</span
																>

																<input
																	v-model="checklist.retest_value"
																	type="number"
																	:placeholder="
																		checklist.subtask_info.subtask_type ==
																		'temperature'
																			? 'Temp in C'
																			: 'tpm value'
																	"
																	class="custom-number-input"
																	style="
																		width: 30%;
																		height: 32px;
																		line-height: 32px;
																	"
																	:style="
																		checkNumberInRange(
																			checklist.retest_value,
																			checklist.subtask_info.num_value_min,
																			checklist.subtask_info.num_value_max
																		)
																	"
																	:disabled="checklist.not_applicable"
																/>

																<div
																	v-if="
																		checklist.retest_value &&
																		!Object.keys(
																			checkNumberInRange(
																				checklist.retest_value,
																				checklist.subtask_info.num_value_min,
																				checklist.subtask_info.num_value_max
																			)
																		).length
																	"
																>
																	&nbsp;&nbsp;&nbsp;
																	<i
																		class="el-icon-success"
																		style="color: #29b823; font-size: 1.1rem"
																	></i>
																</div>
															</div>
														</div>

														<div
															v-if="
																checklist.num_value &&
																Object.keys(
																	checkNumberInRange(
																		checklist.num_value,
																		checklist.subtask_info.num_value_min,
																		checklist.subtask_info.num_value_max
																	)
																).length &&
																checklist.retest_value &&
																Object.keys(
																	checkNumberInRange(
																		checklist.retest_value,
																		checklist.subtask_info.num_value_min,
																		checklist.subtask_info.num_value_max
																	)
																).length
															"
															class="mt-4 mb-2"
														>
															<div class="text-sm mb-1">Describe Issue</div>

															<el-input
																v-model="checklist.description"
																type="textarea"
																:rows="2"
																resize="none"
																placeholder="Enter Description"
																size="small"
																style="width: 100%"
																:maxlength="500"
																:show-word-limit="true"
															>
															</el-input>

															<div class="flex items-center mt-4">
																<div style="width: 281px">
																	<div class="text-sm mb-1">
																		Resolution Expected Date
																	</div>

																	<el-date-picker
																		v-model="checklist.date"
																		size="small"
																		type="date"
																		placeholder="Select Date"
																	></el-date-picker>
																</div>

																<div>
																	<div class="text-sm mb-1">Raise Ticket</div>

																	<el-select
																		v-model="checklist.raise_ticket"
																		placeholder="Select"
																		size="small"
																		clearable
																	>
																		<el-option
																			label="Admin"
																			value="admin"
																		></el-option>
																		<el-option
																			label="Maintenance"
																			value="maintenance"
																		></el-option>
																		<el-option
																			label="IT"
																			value="IT"
																		></el-option>
																		<el-option
																			label="HR"
																			value="HR"
																		></el-option>
																	</el-select>
																</div>
															</div>
														</div>
													</div>

													<input
														type="number"
														v-model="checklist.num_value"
														:min="checklist.subtask_info.num_value_min"
														:max="checklist.subtask_info.num_value_max"
														placeholder="Enter number"
														class="custom-number-input"
														style="width: 15%; height: 32px; line-height: 32px"
														v-if="
															checklist.subtask_info.subtask_type == 'number'
														"
														:disabled="checklist.not_applicable"
													/>

													<div
														style="display: flex; align-items: center"
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'scoring'
														"
													>
														<div style="font-weight: 600">Points</div>

														<input
															type="number"
															v-model="checklist.num_value"
															:min="0"
															:max="checklist.subtask_info.num_value_max"
															:disabled="checklist.not_applicable"
															@change="
																checklist.num_value >
																checklist.subtask_info.num_value_max
																	? (checklist.num_value =
																			checklist.subtask_info.num_value_max)
																	: checklist.num_value < 0
																	? (checklist.num_value = 0)
																	: null
															"
															class="custom-number-input"
															style="
																width: 30%;
																height: 32px;
																line-height: 32px;
																margin-left: 20px;
															"
														/>

														<div
															style="margin-left: 20px"
															v-if="checklist.subtask_info.num_value_max"
														>
															Out of {{ checklist.subtask_info.num_value_max }}
														</div>
													</div>

													<el-date-picker
														v-model="checklist.datetime_value"
														type="datetime"
														placeholder="Select date and time"
														size="small"
														style="width: 30%"
														:disabled="checklist.not_applicable"
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'datetime'
														"
													>
													</el-date-picker>

													<div
														class="flex items-center"
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'yes_no'
														"
													>
														<div
															style="
																padding: 8px 15px;
																font-size: 0.8rem;
																border: 1px solid #ddd;
																border-radius: 4px;
																cursor: pointer;
															"
															:style="[
																!checklist.not_applicable &&
																checklist.boolean_value == true
																	? {
																			backgroundColor: '#00d028',
																			color: '#fff',
																	  }
																	: {},
															]"
															@click="
																checklist.boolean_value = true;
																checklist.not_applicable = false;
															"
														>
															YES
														</div>

														<div
															style="
																padding: 8px 15px;
																font-size: 0.8rem;
																border: 1px solid #ddd;
																border-radius: 4px;
																margin-left: 10px;
																cursor: pointer;
															"
															:style="[
																!checklist.not_applicable &&
																checklist.boolean_value == false
																	? {
																			backgroundColor: '#d60918',
																			color: '#fff',
																	  }
																	: {},
															]"
															@click="
																checklist.boolean_value = false;
																checklist.not_applicable = false;
															"
														>
															NO
														</div>

														<div
															v-if="checklist.subtask_info.show_not_applicable"
															style="
																padding: 8px 15px;
																font-size: 0.8rem;
																border: 1px solid #ddd;
																border-radius: 4px;
																margin-left: 10px;
																cursor: pointer;
															"
															:style="[
																checklist.not_applicable
																	? {
																			backgroundColor: '#d60918',
																			color: '#fff',
																	  }
																	: {},
															]"
															@click="
																checklist.not_applicable = true;
																checklist.boolean_value = null;
															"
														>
															NOT APPLICABLE
														</div>

														<span
															style="
																color: #d26300;
																font-size: 0.8rem;
																font-weight: 500;
																cursor: pointer;
																margin-left: 15px;
															"
															@click="
																checklist.not_applicable = false;
																checklist.boolean_value = null;
															"
															>Clear</span
														>

														<el-popover
															placement="right"
															width="400"
															trigger="hover"
															title="Look for"
															v-if="activeTabLink == 'AUDIT'"
														>
															<div
																v-if="
																	active_assigned_task_category.name ==
																	'Food Quality'
																"
															>
																<div
																	v-if="checklist_index == 0"
																	style="word-break: break-word"
																>
																	• Watch three cook cycles from start to finish
																	<br />
																	• Product being drained for five seconds over
																	the <br />
																	fryer before being moved to the holding
																	station • Approved AccuSaltTM Dispenser is
																	used <br />
																	• Salt falling from the dispenser without
																	shaking <br />
																	while being held 12 – 18 inches above the
																	station • Team Members not adjusting how the
																	salt <br />
																	dispersed over the product • Product shuffled
																	after salting <br />
																</div>

																<div
																	v-if="checklist_index == 1"
																	style="word-break: break-word"
																>
																	• Two groups of Product, one nearing expiry
																	<br />
																	• Mixing of the two groups of Product <br />
																</div>

																<div v-else style="word-break: break-word">
																	• Products not held on the Ribbon Rack for
																	more than 1 minute, and only when needed
																	<br />
																</div>
															</div>

															<div
																v-if="
																	active_assigned_task_category.name == 'People'
																"
															>
																<div
																	v-if="checklist_index == 0"
																	style="word-break: break-word"
																>
																	• The module completion report provided by RBI
																	<br />
																	• The posted restaurant roster (such as a
																	schedule) and the number of persons in the BK
																	LINK report provided by RBI <br />
																	• Position-based module completions (i.e.
																	excluding Foundations, CRT, and regional
																	modules) for team members that were hired more
																	than six weeks prior <br />
																</div>

																<div
																	v-if="checklist_index == 1"
																	style="word-break: break-word"
																>
																	• RTT books and binders available in the
																	Manager’s Office or in the Training Room
																	<br />
																	• RTT proficiency chart in the Manager’s
																	Office <br />
																	Training Room, or on the King Board <br />
																	• The proficiency chart being at “3” for any
																	three Team Members working by themselves on a
																	station without trainer supervision
																</div>

																<div v-else style="word-break: break-word">
																	• Restaurant having a posted training plan in
																	the Manager’s Office, Training Room, or on the
																	King Board <br />
																	• A system of follow-ups on Team Members in
																	place in some form
																</div>
															</div>

															<i
																slot="reference"
																class="el-icon-info cursor-pointer ml-4"
																style="color: #d26300"
															/>
														</el-popover>
													</div>

													<div
														class="mt-4"
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type ==
																'radio_options'
														"
													>
														<div class="flex items-center justify-between">
															<div class="text-sm mb-2">
																Please select from below:
															</div>

															<span
																style="
																	color: #d26300;
																	font-size: 0.8rem;
																	font-weight: 500;
																	cursor: pointer;
																	margin-left: 15px;
																"
																@click="checklist.radio_option_selected = null"
																>Clear</span
															>
														</div>

														<div
															class="mb-2"
															v-for="(option, option_index) in checklist
																.subtask_info.radio_options"
															:key="option_index"
														>
															<el-radio
																v-model="checklist.radio_option_selected"
																:label="option.id"
																:disabled="checklist.not_applicable"
																>{{ option.label }}
															</el-radio>
														</div>
													</div>

													<div
														class="mt-4"
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'yes_no' &&
															checklist.boolean_value == false &&
															select_outlet ==
																'ca8cff00-ee1c-46c8-a2da-039b871a2145' &&
															activeTabLink == 'AUDIT' &&
															selected_assigned_task.task_name ==
																'Modules are completed as required on BK LINK or RTT is present and complete' &&
															active_assigned_task_category.name == 'People'
														"
													>
														<div class="text-sm mb-2">
															Please select from below:
														</div>

														<div>
															<el-radio v-model="checked" label="1"
																>Module completion is at or above 95%</el-radio
															>
														</div>
														<div class="mt-2">
															<el-radio v-model="checked" label="2"
																>Module completion between 90% and
																94.9%</el-radio
															>
														</div>
														<div class="mt-2">
															<el-radio v-model="checked" label="3"
																>Module completion between 85% and
																89.9%</el-radio
															>
														</div>
														<div class="mt-2">
															<el-radio v-model="checked" label="4"
																>Module completion between 80% and
																84.9%</el-radio
															>
														</div>
														<div class="mt-2">
															<el-radio v-model="checked" label="5"
																>Module completion less than 80%</el-radio
															>
														</div>
													</div>

													<div
														class="mt-4"
														v-if="
															checklist.subtask_info &&
															checklist.subtask_info.subtask_type == 'image'
														"
													>
														<div class="flex items-center">
															<el-button size="mini">
																<i
																	class="el-icon-upload"
																	style="
																		color: #d26300;
																		font-size: 20px;
																		vertical-align: middle;
																	"
																></i>
																Upload File
															</el-button>

															<input
																id="fileUpload"
																ref="fileUpload"
																accept="image/*, application/pdf,"
																multiple="multiple"
																style="display: none"
																@change="getFile()"
																:disabled="
																	imageData.length +
																		selected_assigned_task.file_list.length >=
																	4
																"
															/>
														</div>

														<div
															style="
																font-size: 0.7rem;
																margin-top: 5px;
																white-space: nowrap;
															"
														>
															<p class="my-2">
																(JPEG, JPG, PNG, GIF) Max file size of 16 MB
																<br />
																Maximum allowed (4 files)
															</p>
														</div>

														<div
															v-for="(file, file_index) in imageData"
															:key="file_index"
															class="my-2"
															style="font-size: 0.8rem"
														>
															<div class="flex items-center">
																<span>
																	<i
																		class="el-icon-circle-check"
																		style="color: #00d447"
																	></i>
																	{{ imageData[file_index].file_name }}
																</span>

																<span v-if="!checklist.not_applicable">
																	<i
																		class="el-icon-circle-close cursor-pointer"
																		style="color: red; margin-left: 15px"
																		@click="removeFile(file_index)"
																	></i>
																</span>
															</div>
														</div>

														<div
															v-for="(
																file_data, data_index
															) in selected_assigned_task.file_list"
															:key="data_index"
															class="my-2"
															style="font-size: 0.8rem"
														>
															<div class="flex items-center">
																<span class="flex">
																	<i
																		class="el-icon-circle-check"
																		style="color: #00d447; margin-right: 5px"
																	></i>
																	<p>{{ file_data.file_name }}</p>
																</span>

																<span
																	v-if="
																		selected_assigned_task.task_status !=
																			'Unassigned' &&
																		selected_assigned_task.selected_action !=
																			'EDIT_TASK' &&
																		!checklist.not_applicable
																	"
																>
																	<i
																		class="el-icon-circle-close cursor-pointer"
																		style="color: red; margin-left: 15px"
																		@click="
																			removeSelectedFile(
																				data_index,
																				file_data.id
																			)
																		"
																	></i>
																</span>
															</div>
														</div>
													</div>

													<div
														style="
															display: flex;
															justify-content: space-between;
															flex-direction: row;
														"
													>
														<div class="steps-actions-wrapper">
															<!-- Task Steps Comment -->
															<div
																style="
																	margin-top: 20px;
																	display: flex;
																	justify-content: space-between;
																	align-items: center;
																"
															>
																<div
																	v-if="
																		checklist.subtask_info &&
																		checklist.subtask_info.allow_comment
																	"
																>
																	<u
																		style="color: #d26300; cursor: pointer"
																		v-if="
																			!checklist.toggle_add_comment_section &&
																			!checklist.not_applicable
																		"
																		@click="
																			checklist.toggle_add_comment_section = true
																		"
																		>Add Comment</u
																	>
																	<u
																		v-else
																		style="color: #999999; cursor: pointer"
																		>Add Comment</u
																	>
																</div>
															</div>
															<!-- Task Steps Image -->
															<span
																v-if="
																	checklist.attachments &&
																	checklist.attachments.length
																"
																@click="
																	showTaskStepsAttachment(
																		checklist.attachments,
																		checklist.comment
																	)
																"
															>
																<i class="el-icon-camera-solid"></i>
																<span
																	class="pl-1"
																	style="
																		text-decoration: underline;
																		cursor: pointer;
																		color: #d26300;
																	"
																	>View Image</span
																>
															</span>
														</div>
														<el-switch
															style="display: block"
															:value="checklist.not_applicable"
															active-color="#d26300"
															inactive-color="#999999"
															inactive-text="N.A"
														></el-switch>
													</div>

													<div
														class="mt-4"
														v-if="checklist.toggle_add_comment_section"
													>
														<el-input
															v-model="checklist.comment"
															type="textarea"
															:rows="2"
															resize="none"
															placeholder="Add your comment"
															size="small"
															style="width: 100%"
															:maxlength="500"
															:show-word-limit="true"
														>
														</el-input>

														<div
															style="
																display: flex;
																justify-content: flex-end;
																margin-top: 10px;
															"
														>
															<u
																style="color: #d26300; cursor: pointer"
																@click="
																	checklist.toggle_add_comment_section = false
																"
																>Hide Comment</u
															>
														</div>
													</div>
												</div>
											</el-card>
										</div>
									</div>

									<div class="mt-2" v-else>
										<el-card
											class="box-card"
											v-if="
												selected_assigned_task.selected_action ==
												'CHANGE_TASK_STATUS'
											"
										>
											<div class="flex">
												<label class="font-bold text-xs block">Status - </label>
												&nbsp;

												<el-checkbox
													v-model="selected_assigned_task.marked_as_completed"
													class="ml-8"
													style="margin-right: 10px"
												></el-checkbox>
												<span>Mark as completed</span>
											</div>
										</el-card>
									</div>

									<el-card class="box-card mt-2" slot="footer">
										<div class="dialog-footer">
											<div class="flex justify-end">
												<el-button
													class="cancel-btn"
													size="small"
													plain
													:disabled="user_access_level != 'admin'"
													@click="closeEditDialogVisible()"
													>CANCEL</el-button
												>

												<el-button
													class="submit-btn ml-4"
													size="small"
													:disabled="false"
													@click="saveEditAssignedTask('form-3')"
													>UPDATE</el-button
												>
											</div>
										</div>
									</el-card>
								</div>
							</div>
						</div>
					</el-dialog>
				</div>

				<!-- create task dialog -->
				<div class="reportPopup">
					<el-dialog
						:title="filter_.id ? 'Edit Task' : 'Create Task'"
						:visible.sync="create_task_dialog_visible"
						:before-close="closeCreateTaskDialog"
						:close-on-click-modal="true"
						width="95%"
						top="0"
						custom-class="customClass"
						:lock-scroll="true"
						:show-close="true"
					>
						<div class="text-left" style="padding: 0 20px 0 20px">
							<el-button
								icon="el-icon-back"
								class="submit-btn"
								size="mini"
								@click="create_task_dialog_visible = false"
							>
								Back
							</el-button>
						</div>

						<div v-loading="is_create_task_loading" style="padding: 30px 20px">
							<!-- <div class="title capitalize" style="font-size: 1.4em">
								Create Form
							</div> -->
							<div
								class="mb-4"
								style="
									height: 570px;
									overflow: scroll;
									border-top: 1px solid #ccc;
									border-bottom: 1px solid #ccc;
								"
							>
								<form data-vv-scope="form-1">
									<el-row class="mt-5" :gutter="15">
										<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
											<div v-if="!filter_.id">
												<label class="block mb-1 font-bold text-xs input-lable">
													Select Location
													<span style="color: red; font-weight: 400">*</span>
												</label>

												<base-locations-dropdown
													:placeholder="'Select Location'"
													@update="dropDownUpdateForCreateTask"
												>
												</base-locations-dropdown>
											</div>

											<div v-else>
												<label class="block mb-1 font-bold text-xs input-lable">
													Location
													<span style="color: red; font-weight: 400">*</span>
												</label>

												<el-input
													disabled
													v-model="filter_.location"
												></el-input>
											</div>
										</el-col>

										<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
											<label class="block mb-1 font-bold text-xs input-lable"
												>Select Designation
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<el-select
												multiple
												v-model="selectedDesignation"
												filterable
												collapse-tags
												v-validate="'required'"
												style="width: 100%"
												placeholder="Select Designation"
												name="Select Designation"
												class="capitalize"
											>
												<el-option
													v-for="(item, index) in designationListNew"
													:key="index"
													:value="item.id"
													:label="item.name"
													class="capitalize"
												>
												</el-option>
											</el-select>
											<span
												v-show="
													errors.has('form-1.Select Designation') &&
													error_on_empty_fields
												"
												class="text-red-dark text-xs"
											>
												{{ errors.first("form-1.Select Designation") }}
											</span>
										</el-col>
									</el-row>

									<el-row :gutter="15" class="mt-2">
										<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
											<label class="block mb-1 font-bold text-xs input-lable"
												>Category
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<el-select
												v-model="selected_main_category"
												filterable
												v-validate="'required'"
												style="width: 100%"
												placeholder="Select Category"
												name="Select Category"
												size="small"
												class="capitalize"
											>
												<el-option
													v-for="(item, index) in main_category_list.filter(
														(el) => el.name != 'Competition'
													)"
													:key="index"
													:value="item.value"
													:label="item.name"
													class="capitalize"
												>
													{{ item.name }}
												</el-option>
											</el-select>

											<span
												v-show="
													errors.has('form-1.Select Category') &&
													error_on_empty_fields
												"
												class="text-red-dark text-xs"
											>
												{{ errors.first("form-1.Select Category") }}
											</span>
										</el-col>
									</el-row>

									<el-row :gutter="15" class="mt-2">
										<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
											<label class="block mb-1 font-bold text-xs input-lable">
												Intermediate Category
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<el-select
												v-model="selected_form_template_intermediate_category"
												filterable
												name="selected_form_template_intermediate_category"
												style="width: 100%"
												:disabled="!selected_main_category"
												v-validate="'required'"
												placeholder="Select intermediate category"
												size="small"
												class="capitalize"
											>
												<template v-if="selected_main_category == 'audit'">
													<el-option
														v-for="(item, index) in audit_sub_category_list"
														:key="'audit-cat-' + index"
														:label="item.name"
														:value="item.id"
													></el-option>
												</template>
												<template v-else-if="selected_main_category == 'other'">
													<el-option
														v-for="(item, index) in task_sub_category_list"
														:key="'task-cat-' + index"
														:label="item.name"
														:value="item.id"
													></el-option>
												</template>
											</el-select>

											<span
												v-show="
													errors.has(
														'form-1.selected_form_template_intermediate_category'
													) && error_on_empty_fields
												"
												class="text-red-dark text-xs"
											>
												{{
													errors.first(
														"form-1.selected_form_template_intermediate_category"
													)
												}}
											</span>
										</el-col>
									</el-row>

									<el-row :gutter="15" class="mt-2">
										<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
											<label class="block mb-1 font-bold text-xs input-lable">
												Sub Category
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<el-select
												v-model="selected_category"
												filterable
												v-validate="'required'"
												style="width: 100%"
												placeholder="Select Sub Category"
												name="Select Sub Category"
												size="small"
												class="capitalize"
												:disabled="
													!selected_main_category ||
													!selected_form_template_intermediate_category
												"
												@input="addCategory($event)"
											>
												<el-option
													label="add new"
													value="add new"
													style="color: #d26300"
													>Add-Edit Category</el-option
												>
												<el-option
													v-for="(item, index) in category_list
														.filter(
															(el) =>
																!selected_main_category ||
																el.main_category == selected_main_category
														)
														.filter(
															(el) =>
																!selected_form_template_intermediate_category ||
																el.intermediate_category_info.id ==
																	selected_form_template_intermediate_category
														)"
													:key="index"
													:value="item.id"
													:label="item.name"
													class="capitalize"
												>
													{{ item.name }}
												</el-option>
											</el-select>

											<span
												v-show="
													errors.has('form-1.Select Sub Category') &&
													error_on_empty_fields
												"
												class="text-red-dark text-xs"
											>
												{{ errors.first("form-1.Select Sub Category") }}
											</span>
										</el-col>
									</el-row>

									<el-row :gutter="15" class="mt-2">
										<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
											<label class="block mb-1 font-bold text-xs input-lable">
												Title
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<el-input
												v-model="task_category"
												v-validate="'required'"
												:placeholder="'Enter Title'"
												name="Audit Title"
												style="width: 100%"
												size="small"
											>
											</el-input>

											<span
												v-show="
													errors.has('form-1.Audit Title') &&
													error_on_empty_fields
												"
												class="text-red-dark text-xs"
											>
												{{ errors.first("form-1.Audit Title") }}
											</span>
										</el-col>
									</el-row>

									<template v-if="selected_main_category == 'audit'">
										<div class="flex items-center my-4">
											<label class="font-bold text-xs input-lable">
												Points Calculation Method
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<div class="ml-6">
												<el-radio
													v-model="points_calculation_method"
													label="overall_activity"
													>Overall Activity</el-radio
												>
												<el-radio
													v-model="points_calculation_method"
													label="by_steps"
													>By Steps</el-radio
												>
											</div>
										</div>

										<el-row
											:gutter="15"
											class="mt-2"
											v-if="points_calculation_method == 'overall_activity'"
										>
											<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
												<label class="block mb-1 font-bold text-xs input-lable">
													Expected Value - All Steps
													<span style="color: red; font-weight: 400">*</span>
												</label>

												<el-select
													v-model="expected_value"
													filterable
													v-validate="
														points_calculation_method == 'overall_activity'
															? 'required'
															: ''
													"
													style="width: 100%"
													placeholder="Expected Value"
													name="Expected Value"
													size="small"
													class="capitalize"
												>
													<el-option label="Yes" value="yes"></el-option>
													<el-option label="No" value="no"></el-option>
												</el-select>

												<span
													v-show="
														errors.has('form-1.Expected Value') &&
														error_on_empty_fields
													"
													class="text-red-dark text-xs"
												>
													{{ errors.first("form-1.Expected Value") }}
												</span>
											</el-col>

											<el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
												<label class="block mb-1 font-bold text-xs input-lable">
													Total Points
													<span style="color: red; font-weight: 400">*</span>
												</label>

												<el-input
													v-model="total_points"
													v-validate="
														points_calculation_method == 'overall_activity'
															? 'required'
															: ''
													"
													placeholder="Total Points"
													name="Total Points"
													size="small"
												>
												</el-input>

												<span
													v-show="
														errors.has('form-1.Total Points') &&
														error_on_empty_fields
													"
													class="text-red-dark text-xs"
												>
													{{ errors.first("form-1.Total Points") }}
												</span>
											</el-col>
										</el-row>

										<div class="my-4">
											<div class="flex items-center">
												<label class="mb-1 font-bold text-xs input-lable"
													>Is Deduction Applicable
													<span style="color: red; font-weight: 400">*</span>
												</label>

												<div class="ml-6">
													<el-radio v-model="deduction_type" label="yes"
														>Yes</el-radio
													>
													<el-radio v-model="deduction_type" label="no"
														>No</el-radio
													>
												</div>
											</div>
										</div>

										<el-row
											:gutter="15"
											class="my-4"
											v-if="deduction_type == 'yes'"
										>
											<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
												<label class="block mb-1 font-bold text-xs input-lable">
													Deduction Method
													<span style="color: red; font-weight: 400">*</span>
												</label>

												<el-select
													v-model="deduction_method"
													filterable
													v-validate="'required'"
													style="width: 100%"
													placeholder="Deduction Method"
													name="Deduction Method"
													size="small"
													class="capitalize"
												>
													<el-option
														label="Percentage"
														value="percentage"
													></el-option>
													<el-option label="Points" value="points"></el-option>
													<el-option
														label="mark_score_zero"
														value="Mark Score Zero"
													></el-option>
												</el-select>

												<span
													v-show="
														errors.has('form-1.Deduction Method') &&
														error_on_empty_fields
													"
													class="text-red-dark text-xs"
												>
													{{ errors.first("form-1.Deduction Method") }}
												</span>
											</el-col>
										</el-row>
									</template>

									<el-row :gutter="15" class="mt-2">
										<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
											<el-row :gutter="10">
												<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
													<label
														class="block mb-1 font-bold text-xs input-lable"
													>
														Steps
														<span
															class="font-xs font-medium"
															style="color: #000"
															>(optional)</span
														>
													</label>
												</el-col>

												<el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
												</el-col>

												<el-col
													:xs="4"
													:sm="4"
													:md="4"
													:lg="4"
													:xl="4"
													v-if="points_calculation_method == 'by_steps'"
												>
												</el-col>

												<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
												</el-col>

												<el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
												</el-col>

												<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
												</el-col>

												<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
													&nbsp;
												</el-col>
											</el-row>

											<div
												v-for="(item, check_index) in check_list"
												:key="check_index"
											>
												<!-- First inner row -->
												<el-row :gutter="10" class="mt-2 mb-4">
													<el-col
														:xs="1"
														:sm="1"
														:md="1"
														:lg="1"
														:xl="1"
														align="center"
													>
														<div>
															<b>{{ check_index + 1 }}</b>
														</div>
													</el-col>
													<el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
														<el-input
															v-model="item.label"
															:rows="5"
															type="textarea"
															:placeholder="'Step ' + (check_index + 1)"
															style="width: 100%"
														></el-input>
													</el-col>
													<el-col
														:xs="2"
														:sm="2"
														:md="2"
														:lg="2"
														:xl="2"
														align="center"
													>
														<el-row :gutter="20">
															<el-col :span="24">
																<el-tooltip
																	content="Delete Step"
																	placement="top"
																	effect="light"
																>
																	<i
																		class="el-icon-delete cursor-pointer mt-2 default-icon"
																		@click="deleteSubStep(check_index, item.id)"
																	></i>
																</el-tooltip>
															</el-col>
															<el-col :span="24">
																<div
																	style="
																		font-size: 0.8rem;
																		cursor: pointer;
																		margin-top: 10px;
																		text-decoration: underline;
																	"
																	@click="openAddInfoModal(check_index)"
																>
																	<div style="color: #d26300; font-size: 25px">
																		<i class="el-icon-info"></i>
																	</div>
																	<div>Add Info</div>
																</div>
															</el-col>
															<el-col
																:span="24"
																v-if="item.subtask_type == 'radio_options'"
															>
																<div
																	style="
																		color: #d26300;
																		font-size: 0.8rem;
																		cursor: pointer;
																		margin-top: 10px;
																		text-decoration: underline;
																	"
																	@click="
																		openDialogToAddRadioOptions(check_index)
																	"
																>
																	View Details
																</div>
															</el-col>
														</el-row>
													</el-col>
												</el-row>
												<!-- ./First inner row -->
												<!-- Second inner row -->
												<el-row :gutter="10" class="mt-2 mb-4">
													<el-col
														:xs="1"
														:sm="1"
														:md="1"
														:lg="1"
														:xl="1"
														align="center"
													>
													</el-col>
													<el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
														<div class="flex mb-2">
															<label><b>Input Type</b></label>
														</div>
														<div class="flex">
															<el-select
																v-model="item.subtask_type"
																placeholder="Select"
																style="width: 100%"
																size="small"
																:disabled="!selected_main_category"
																@click="
																	item.subtask_type == 'radio_options'
																		? openDialogToAddRadioOptions(check_index)
																		: ''
																"
															>
																<template
																	v-for="(item, freq_index) in check_list_type"
																>
																	<el-option
																		:key="freq_index"
																		:label="item.title"
																		:value="item.value"
																		v-if="
																			((selected_main_category ==
																				'cleanliness' ||
																				selected_main_category == 'audit') &&
																				item.value == 'yes_no') ||
																			(selected_main_category !=
																				'cleanliness' &&
																				selected_main_category != 'audit')
																		"
																	></el-option>
																</template>
															</el-select>
														</div>
													</el-col>

													<el-col
														:span="3"
														v-if="points_calculation_method == 'by_steps'"
													>
														<div
															class="flex mb-2"
															v-if="
																item.subtask_type == 'yes_no' ||
																item.subtask_type == 'yes_no_not_applicable' ||
																item.subtask_type == 'tpc' ||
																item.subtask_type == 'scoring'
															"
														>
															<label><b>Expected Value</b></label>
														</div>
														<div class="flex items-center">
															<input
																type="number"
																v-model="item.num_value_min"
																placeholder="Min"
																class="custom-number-input"
																style="width: 100%; height: 32px"
																v-if="
																	item.subtask_type == 'temperature' ||
																	item.subtask_type == 'tpc'
																"
															/>

															<input
																type="number"
																v-model="item.num_value_max"
																:placeholder="
																	item.subtask_type == 'scoring'
																		? 'Enter number'
																		: item.subtask_type == 'temperature'
																		? 'Max'
																		: ''
																"
																class="custom-number-input"
																style="
																	width: 100%;
																	height: 32px;
																	margin-left: 5px;
																"
																v-if="
																	item.subtask_type == 'temperature' ||
																	item.subtask_type == 'tpc' ||
																	item.subtask_type == 'scoring'
																"
															/>
														</div>
														<span
															v-show="
																item.subtask_type != 'yes_no' &&
																item.subtask_type != 'yes_no_not_applicable' &&
																item.subtask_type != 'temperature' &&
																item.subtask_type != 'tpc' &&
																item.subtask_type != 'scoring'
															"
															>&nbsp;</span
														>
														<div
															style="display: flex; align-items: center"
															v-show="item.subtask_type == 'yes_no'"
														>
															<div
																style="
																	padding: 7px 10px;
																	font-size: 0.8rem;
																	border: 1px solid #ddd;
																	border-radius: 4px;
																	cursor: pointer;
																	width: 55px;
																	text-align: center;
																"
																:style="[
																	item.boolean_value == true ||
																	item.num_value_max
																		? {
																				backgroundColor: '#00d028',
																				color: '#fff',
																		  }
																		: {},
																]"
																@click="
																	item.boolean_value = true;
																	item.num_value_max = 1;
																	item.num_value_min = 0;
																	item.show_not_applicable = false;
																"
															>
																YES
															</div>

															<div
																style="
																	padding: 7px 10px;
																	font-size: 0.8rem;
																	border: 1px solid #ddd;
																	border-radius: 4px;
																	margin-left: 10px;
																	cursor: pointer;
																	width: 55px;
																	text-align: center;
																"
																:style="[
																	item.boolean_value == false ||
																	item.num_value_min
																		? {
																				backgroundColor: '#d60918',
																				color: '#fff',
																		  }
																		: {},
																]"
																@click="
																	item.boolean_value = false;
																	item.num_value_max = 0;
																	item.num_value_min = 1;
																	item.show_not_applicable = false;
																"
															>
																NO
															</div>
														</div>
													</el-col>

													<el-col
														:span="2"
														:class="
															item.subtask_type == 'yes_no'
																? 'br-secondary'
																: ''
														"
													>
														<div
															class="flex mb-2"
															v-if="item.subtask_type == 'yes_no'"
														>
															<label><b>Show N.A</b></label>
														</div>
														<div>
															<el-switch
																v-if="item.subtask_type == 'yes_no'"
																v-model="item.show_not_applicable"
																active-color="#13ce66"
																inactive-color="#e2eaef"
															>
															</el-switch>
														</div>
													</el-col>

													<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
														<div
															class="flex mb-2"
															v-if="
																item.subtask_type == 'yes_no' ||
																item.subtask_type == 'yes_no_not_applicable'
															"
														>
															<label><b>Conditions</b></label>
														</div>
														<div>
															<el-switch
																v-if="
																	item.subtask_type == 'yes_no' ||
																	(item.subtask_type ==
																		'yes_no_not_applicable' &&
																		item.show_not_applicable === false)
																"
																v-model="item.allow_conditions"
																active-color="#13ce66"
																inactive-color="#e2eaef"
															>
															</el-switch>
														</div>
													</el-col>

													<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
														<el-row
															:gutter="10"
															v-if="
																(item.subtask_type == 'yes_no' &&
																	item.allow_conditions) ||
																(item.subtask_type == 'yes_no_not_applicable' &&
																	item.show_not_applicable === false &&
																	item.allow_conditions)
															"
														>
															<el-col
																:xs="24"
																:sm="12"
																:md="12"
																:lg="12"
																:xl="12"
															>
																<div class="mb-2">
																	<label><b>If Yes</b></label>
																</div>

																<el-select
																	v-model="item.step_if_yes"
																	filterable
																	style="width: 100%"
																	placeholder="Select"
																	size="small"
																	class="capitalize"
																>
																	<template
																		v-for="(item, index) in if_yes_options"
																	>
																		<el-option
																			:key="index"
																			:label="item.label"
																			:value="item.value"
																			v-if="item.value != check_index + 1"
																		></el-option>
																	</template>
																</el-select>
															</el-col>

															<el-col
																:xs="24"
																:sm="12"
																:md="12"
																:lg="12"
																:xl="12"
															>
																<div class="mb-2">
																	<label><b>If No</b></label>
																</div>
																<el-select
																	v-model="item.step_if_no"
																	filterable
																	style="width: 100%"
																	placeholder="Select"
																	size="small"
																	class="capitalize"
																>
																	<template
																		v-for="(item, index) in if_no_options"
																	>
																		<el-option
																			:key="index"
																			:label="item.label"
																			:value="item.value"
																			v-if="item.value != check_index + 1"
																		></el-option>
																	</template>
																</el-select>
															</el-col>
														</el-row>
													</el-col>

													<el-col
														:span="3"
														v-if="points_calculation_method == 'by_steps'"
													>
														<div class="mb-2">
															<label><b>Points</b></label>
														</div>
														<el-input
															v-model="item.total_points"
															placeholder="Points"
															size="small"
														>
														</el-input>
													</el-col>

													<el-col :span="4">
														<div class="flex mb-2">
															<label><b>Image</b></label>
														</div>
														<el-switch
															v-model="item.image_mandatory"
															active-color="#13ce66"
															inactive-color="#e2eaef"
														>
														</el-switch>
														<span class="px-2">{{
															item.image_mandatory
																? "(Mandatory)"
																: "(Optional)"
														}}</span>
													</el-col>
												</el-row>
												<!-- ./Second inner row -->
											</div>

											<div class="mt-2">
												<el-button
													class="submit-btn mt-2"
													size="mini"
													@click="addMoreCheckList()"
													>ADD MORE</el-button
												>
											</div>
										</el-col>
									</el-row>

									<el-row :gutter="20" class="my-4">
										<el-col :span="6">
											<label class="block mb-1 font-bold text-xs input-lable"
												>Task Frequency
												<span style="color: red; font-weight: 400">*</span>
											</label>

											<el-select
												v-model="repeat_frequency"
												placeholder="Select Frequency"
												name="Repeat"
												v-validate="'required'"
												style="width: 100%"
												size="small"
												@change="setList()"
											>
												<el-option
													v-for="(item, freq_index) in frequency_list"
													:key="freq_index"
													:label="item.title"
													:value="item.value"
												>
												</el-option>
											</el-select>

											<span
												v-show="
													errors.has('form-1.Repeat') && error_on_empty_fields
												"
												class="text-red-dark text-xs"
											>
												{{ errors.first("form-1.Repeat") }}
											</span>
										</el-col>

										<el-col :span="6" v-if="repeat_frequency == 'weekly'">
											<label class="block mb-1 font-bold text-xs input-lable"
												>Select Days</label
											>
											<el-select
												v-model="weekly_frequency"
												filterable
												multiple
												collapse-tags
												placeholder="Select Frequency"
												name="Select Days"
												size="small"
												v-validate="
													repeat_frequency == 'weekly' ? 'required' : null
												"
											>
												<el-option
													v-for="(item, week_index) in weekly_frequency_list"
													:key="week_index"
													:label="item.title"
													:value="item.value"
												>
												</el-option>
											</el-select>

											<span
												v-show="
													errors.has('form-1.Select Days') &&
													error_on_empty_fields
												"
												class="block text-red-dark text-xs"
											>
												{{ errors.first("form-1.Select Days") }}
											</span>
										</el-col>

										<el-col :span="6" v-if="repeat_frequency == 'monthly'">
											<label class="block mb-1 font-bold text-xs input-lable"
												>Select Date</label
											>
											<el-select
												multiple
												v-model="monthly_frequency"
												collapse-tags
												placeholder="Select Frequency"
												name="Select Date"
												size="small"
												v-validate="
													repeat_frequency == 'monthly' ? 'required' : null
												"
											>
												<el-option
													v-for="(item, day_index) in 31"
													:key="day_index"
													:label="item"
													:value="item"
													:disabled="disableDateOptions(item)"
												>
												</el-option>
												<el-option
													label="Last day of month"
													:disabled="disableDateOptions(true)"
													:value="true"
												>
												</el-option>
											</el-select>

											<span
												v-show="
													errors.has('form-1.Select Date') &&
													error_on_empty_fields
												"
												class="block text-red-dark text-xs"
											>
												{{ errors.first("form-1.Select Date") }}
											</span>
										</el-col>
									</el-row>

									<el-row
										v-if="repeat_frequency == 'monthly'"
										:gutter="15"
										class="mt-2"
									>
										<el-col :span="24">
											<el-checkbox v-model="form_template_last_day_of_month"
												>Last day of month</el-checkbox
											>
										</el-col>
									</el-row>

									<el-row :gutter="15" class="mt-2">
										<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
											<el-row
												:gutter="15"
												class="mb-4"
												v-for="(date, date_index) in time_task_list"
												:key="date_index"
											>
												<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
													<label
														class="block mb-1 font-bold text-xs input-lable"
													>
														Start Time
													</label>

													<el-time-select
														v-model="date.start_time"
														name="Start Time"
														style="width: 100%"
														:picker-options="{
															start: '00:00',
															end: '23:00',
														}"
														placeholder="Start Time"
														size="small"
													>
													</el-time-select>
												</el-col>

												<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
													<label
														class="block mb-1 font-bold text-xs input-lable"
													>
														End Time
													</label>

													<el-time-select
														v-model="date.end_time"
														name="End Time"
														style="width: 100%"
														:picker-options="{
															start: '00:00',
															end: '23:00',
														}"
														placeholder="End Time"
														size="small"
													>
													</el-time-select>
												</el-col>

												<el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
													<i
														class="el-icon-delete cursor-pointer mt-2 default-icon"
														v-if="repeat_frequency != 'one_time'"
														@click="deleteTimeFromTaskList(date_index)"
													></i>
												</el-col>
											</el-row>

											<div class="mt-2" v-if="repeat_frequency != 'one_time'">
												<el-button
													class="submit-btn"
													size="mini"
													@click="addMoreTimeToTaskList()"
													>ADD MORE</el-button
												>
											</div>
										</el-col>
									</el-row>
								</form>
							</div>
							<div slot="footer" class="dialog-footer flex justify-end">
								<el-button
									class="cancel-btn"
									size="mini"
									@click="task_preview_dialog = true"
								>
									PREVIEW
									<span style="margin-left: 6px">
										<img
											style="width: 12px"
											src="../../../../assets/images/view.png"
									/></span>
								</el-button>

								<el-button
									class="cancel-btn"
									size="mini"
									@click="create_task_dialog_visible = false"
								>
									CANCEL
								</el-button>

								<el-button
									class="submit-btn"
									size="mini"
									@click="createTask('form-1')"
								>
									{{ filter_.id ? "UPDATE" : "ADD" }}
								</el-button>
							</div>
						</div>
					</el-dialog>
					<!-- title="Assign Task" -->
				</div>
			</el-card>

			<!-- add info dialog -->
			<el-dialog
				title="Add Info"
				:visible.sync="show_add_info_dialog"
				:before-close="closeAddInfoModal"
				custom-class="add-info__header"
				width="55%"
			>
				<div>
					<el-input
						v-model="add_info_content"
						type="textarea"
						:rows="5"
						placeholder="Add more information to describe the step"
					></el-input>
				</div>
				<div slot="footer" class="dialog-footer flex justify-end">
					<el-button
						class="cancel-btn"
						size="mini"
						@click="show_add_info_dialog = false"
					>
						CANCEL
					</el-button>

					<el-button class="submit-btn" size="mini" @click="updateInfo">
						UPDATE
					</el-button>
				</div>
			</el-dialog>
			<!-- ./add info dialog -->

			<!-- assign task dialog -->
			<el-dialog
				title="Assign Task"
				:visible.sync="assign_task_dialog_visible"
				:before-close="closeAssignTaskDialog"
				custom-class="assign-task__modal"
				top="0"
				width="55%"
			>
				<div v-loading="is_emp_list_loading">
					<form data-vv-scope="form-2">
						<!-- select week and task section -->
						<el-row :gutter="15">
							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
								<label class="block mb-1 font-bold text-xs">
									Select Location
									<span style="color: red; font-weight: 400">*</span>
								</label>

								<BaseLocationsSingleSelect
									class="dropDown"
									:placeholder="'Select Location'"
									@update="dropDownUpdateForCreateTask"
								/>
							</el-col>

							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
								<label class="block mb-1 font-bold text-xs"
									>Select Designation
									<span style="color: red; font-weight: 400">*</span></label
								>
								<el-select
									v-model="selectedDesignationForAssignTask"
									filterable
									collapse-tags
									v-validate="'required'"
									style="width: 100%"
									placeholder="Select Designation"
									name="Select Designation"
									class="capitalize"
									@change="getTaskList()"
								>
									<el-option
										v-for="(item, index) in designationList"
										:key="index"
										:value="item.id"
										:label="item.name"
										class="capitalize"
									>
									</el-option>
								</el-select>

								<span
									v-show="
										errors.has('form-1.Select Designation') &&
										error_on_empty_fields
									"
									class="text-red-dark text-xs"
								>
									{{ errors.first("form-2.Select Designation") }}
								</span>
							</el-col>
						</el-row>
						<el-row :gutter="20" class="mt-5">
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
								<label class="block mb-1 font-bold text-xs"
									>Select Task
									<span style="color: red; font-weight: 400">*</span></label
								>
								<el-select
									v-model="select_task"
									v-validate="'required'"
									filterable
									size="small"
									placeholder="Select Task"
									name="Select Task"
									style="width: 100%"
									@change="getEmployeeByTask()"
								>
									<el-option
										v-for="(item, task_index) in task_list"
										:key="task_index"
										:label="item.name"
										:value="task_index"
									>
										{{ item.name }}
										<span
											v-if="item.start_time.length"
											style="font-size: 12px; color: #928e8e"
										>
											({{
												item.start_time.slice(0, 5) +
												" to " +
												item.end_time.slice(0, 5)
											}})
										</span>
									</el-option>
								</el-select>

								<span
									v-show="
										errors.has('form-2.Select Task') && error_on_empty_fields
									"
									class="text-red-dark text-xs"
								>
									{{ errors.first("form-2.Select Task") }}
								</span>
							</el-col>
						</el-row>

						<el-row :gutter="20" class="mt-5">
							<el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9">
								<div class="flex">
									<label class="block mb-1 font-bold text-xs mr-4"
										>Frequency
									</label>
									<p class="capitalize">
										{{
											selected_task_freq == "one_time"
												? "One Time"
												: selected_task_freq
										}}
									</p>
								</div>
							</el-col>
							<el-col
								:xs="15"
								:sm="15"
								:md="15"
								:lg="15"
								:xl="15"
								v-if="
									selected_task_freq.length &&
									selected_task_freq != 'daily' &&
									selected_task_freq != 'one_time'
								"
							>
								<div class="flex">
									<label class="block mb-1 font-bold text-xs mr-4">Days</label>
									<div
										v-for="(day, day_index) in selected_task_days"
										:key="day_index"
										class="capitalize"
									>
										<span v-if="day_index != 0">, </span>{{ day + " " }}
									</div>
								</div>
							</el-col>
						</el-row>

						<el-row :gutter="20" class="mt-5">
							<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
								<label class="block mb-1 font-bold text-xs"
									>Select Employee
									<span style="color: red; font-weight: 400">*</span></label
								>
								<el-select
									v-model="selected_assignTaskemp"
									filterable
									v-validate="'required'"
									size="small"
									placeholder="Select Employee"
									name="Select Employee"
									style="width: 100%"
									@change="getTaskAssignment()"
								>
									<el-option
										v-for="(item, emp_index) in assignTask_empList"
										:key="emp_index"
										:label="item.full_name"
										:value="item.id"
									>
									</el-option>
								</el-select>

								<span
									v-show="
										errors.has('form-2.Select Employee') &&
										error_on_empty_fields
									"
									class="text-red-dark text-xs"
								>
									{{ errors.first("form-2.Select Employee") }}
								</span>
							</el-col>
						</el-row>

						<el-row :gutter="20" class="mt-5" v-if="!isSelectedLocationRegion">
							<el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
								<label class="block mb-1 font-bold text-xs"
									>Applicable Store
								</label>
								<el-select
									v-model="selected_assignTaskStore"
									filterable
									multiple
									placeholder="Select Store"
									name="Select Store"
									style="width: 100%"
									size="small"
									@change="selectFunction()"
								>
									<el-option
										style="color: #d26300; width: 130px; z-index: 1"
										value="selectAll"
										label="Select All"
										:disabled="
											selected_assignTaskStore.includes('NA') ? true : false
										"
									>
									</el-option>
									<el-option
										style="
											color: #d26300;
											margin-top: -35px;
											margin-right: 0px;
											text-align: right;
											z-index: 0;
										"
										value="clearAll"
										label="Clear All"
										:disabled="
											selected_assignTaskStore.includes('NA') ? true : false
										"
									>
									</el-option>
									<el-option
										label="Not Applicable"
										value="NA"
										:disabled="
											selected_assignTaskStore.length &&
											!selected_assignTaskStore.includes('NA')
												? true
												: false
										"
									>
									</el-option>
									<el-option
										v-for="(item, store_index) in assignTask_storeList"
										:key="store_index"
										:label="item.name"
										:value="item.id"
										:disabled="
											selected_assignTaskStore.includes('NA') ? true : false
										"
									>
									</el-option>
								</el-select>
							</el-col>
						</el-row>
						<!-- select start, end time and impact -->
						<el-row :gutter="20" class="mt-5">
							<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
								<label class="block mb-1 font-bold text-xs"
									>Start Date
									<span style="color: red; font-weight: 400">*</span></label
								>
								<el-date-picker
									v-model="assignTask_start_date"
									value-format="yyyy-MM-dd"
									type="date"
									v-validate="'required'"
									:clearable="false"
									placeholder="Start Date"
									name="Start Date"
									:picker-options="datePickerOptionsAt"
									size="small"
									style="width: 100%"
								/>
								<span
									v-show="
										errors.has('form-2.start Date') && error_on_empty_fields
									"
									class="text-red-dark text-xs"
								>
									{{ errors.first("form-2.start Date") }}
								</span>
							</el-col>
							<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
								<label class="block mb-1 font-bold text-xs"
									>End Date
									<span style="color: red; font-weight: 400">*</span></label
								>
								<el-date-picker
									v-model="assignTask_end_date"
									value-format="yyyy-MM-dd"
									v-validate="'required'"
									type="date"
									:clearable="false"
									placeholder="End Date"
									name="End Date"
									:picker-options="datePickerOptionsAt"
									size="small"
									style="width: 100%"
								/>
								<span
									v-show="
										errors.has('form-2.end Date') && error_on_empty_fields
									"
									class="text-red-dark text-xs"
								>
									{{ errors.first("form-2.end Date") }}
								</span>
							</el-col>

							<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
								<label class="block mb-1 font-bold text-xs">Start Time </label>
								<el-time-select
									v-model="start_time"
									size="small"
									style="width: 100%"
									placeholder="Start Time"
									name="Start Time"
									:picker-options="{
										start: '00:00',
										end: '23:00',
									}"
								></el-time-select>
							</el-col>

							<el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
								<label class="block mb-1 font-bold text-xs">End Time </label>
								<el-time-select
									v-model="end_time"
									size="small"
									style="width: 100%"
									placeholder="End Time"
									name="End Time"
									:picker-options="{
										start: '00:00',
										end: '23:00',
									}"
								></el-time-select>
							</el-col>
						</el-row>

						<div class="flex mt-2">
							<label class="block mb-1 font-bold text-xs">Task Reminder </label>
							<div class="ml-10">24 Hrs</div>
						</div>
					</form>
				</div>

				<div slot="footer" class="dialog-footer flex justify-end">
					<el-button
						class="cancel-btn"
						size="mini"
						@click="assign_task_dialog_visible = false"
					>
						CANCEL
					</el-button>

					<el-button
						class="submit-btn"
						size="mini"
						@click="assignTask('form-2')"
					>
						ASSIGN
					</el-button>
				</div>
			</el-dialog>

			<!-- report tab -->
			<el-card
				class="box-card mt-1 theme-color no-shadow no-border custom-element__card"
				v-if="
					(active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'cleanliness_reports') ||
					(active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'audit_reports') ||
					(active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'tasks_reports' &&
						activeTabLink != 'INSIGHTS')
				"
			>
				<div
					class="tab mt-2"
					v-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'tasks_reports'
					"
				>
					<div class="flex items-center flex-wrap">
						<div class="special-option">
							<p class="input-label">Quick Report</p>
							<el-select
								v-model="task_view"
								style="max-width: 200px"
								placeholder="Select"
								@change="showDateByQueryReportForTask(view)"
							>
								<el-option
									v-for="(item, index) in viewList"
									:key="index"
									:value="item.id"
									:label="item.name"
								>
									{{ item.name }}
								</el-option>
							</el-select>
						</div>

						<div class="special-option">
							<p class="input-label">From</p>
							<!-- v-model="task_from_date" -->
							<el-date-picker
								v-model="fromDate"
								v-validate="'required'"
								type="date"
								value-format="yyyy-MM-dd"
								:style="
									errors.has('task_from_date')
										? 'border: 1px solid #d26300; border-radius: 4px;'
										: ''
								"
								style="max-width: 170px"
								placeholder="Pick a day"
								name="task_from_date"
								:disabled="task_view != 'daily' && task_view != 'customDt'"
								:picker-options="datePickerOptions"
							>
							</el-date-picker>
						</div>

						<div class="special-option">
							<p class="input-label">To</p>
							<el-date-picker
								v-model="toDate"
								value-format="yyyy-MM-dd"
								type="date"
								style="max-width: 170px"
								:style="
									errors.has('task_to_date')
										? 'border: 1px solid #d26300; border-radius: 4px;'
										: ''
								"
								placeholder="Pick a day"
								name="task_to_date"
								:disabled="task_view != 'daily' && task_view != 'customDt'"
								:picker-options="{
									disabledDate: disabledTaskReportToDate,
									firstDayOfWeek: 1,
								}"
							>
							</el-date-picker>
						</div>

						<div class="special-option" style="margin-top: 30px">
							<el-button
								size="small"
								class="toggle-btn"
								:style="
									errors.has('task_to_date') || errors.has('task_from_date')
										? 'cursor: not-allowed'
										: ''
								"
								:disabled="
									errors.has('task_to_date') || errors.has('task_from_date')
								"
								style="
									min-width: 90px;
									height: 35px;
									background: rgb(210, 99, 0);
									color: #ffff;
									border: 1px solid rgb(210, 99, 0);
								"
								@click="getTasksReportData"
								>Go</el-button
							>
						</div>
					</div>
				</div>

				<div>
					<div
						class="tab mt-2"
						v-if="
							active_assigned_task_category.name == 'Reports' &&
							main_report_category_id == 'audit_reports' &&
							selected_audit_report_outlet.current_step == false
						"
					>
						<el-row>
							<el-col :span="4">
								<span class="input-label pr-2">From</span>
								<el-date-picker
									v-model="fromDate"
									v-validate="'required'"
									type="date"
									value-format="yyyy-MM-dd"
									:style="
										errors.has('task_from_date')
											? 'border: 1px solid #d26300; border-radius: 4px;'
											: ''
									"
									style="max-width: 170px"
									placeholder="Pick a day"
									name="task_from_date"
									@change="getReports(null, 'audit')"
									:picker-options="datePickerOptions"
								>
								</el-date-picker>
							</el-col>

							<el-col :span="4">
								<span class="input-label pr-2">To</span>
								<el-date-picker
									v-model="toDate"
									value-format="yyyy-MM-dd"
									type="date"
									style="max-width: 170px"
									:style="
										errors.has('task_to_date')
											? 'border: 1px solid #d26300; border-radius: 4px;'
											: ''
									"
									placeholder="Pick a day"
									name="task_to_date"
									@change="getReports(null, 'audit')"
									:picker-options="{
										disabledDate: disabledTaskReportToDate,
										firstDayOfWeek: 1,
									}"
								>
								</el-date-picker>
							</el-col>

							<el-col :span="16" style="text-align: right">
								<el-button
									class="cancel-btn ml-4"
									size="mini"
									v-if="
										(active_assigned_task_category.name == 'Reports' &&
											main_report_category_id == 'audit_reports' &&
											selected_audit_report_outlet.current_step == false) ||
										(active_assigned_task_category.name == 'Reports' &&
											main_report_category_id == 'tasks_reports')
									"
									:disabled="loading"
									plain
									@click="downloadAuditReportsCsv()"
								>
									<template v-if="loading"> Downloading... </template>
									<template v-else>
										Download Reports <i class="el-icon-download"></i>
									</template>
								</el-button>
							</el-col>
						</el-row>
					</div>
					<div style="text-align: right">
						<el-button
							class="submit-btn"
							size="mini"
							v-if="
								!selected_locations_for_nomination.length &&
								active_report_tab == 'COMPETITION' &&
								user_designation != 'Area Lead' &&
								active_assigned_task_category.name == 'Reports' &&
								main_report_category_id != 'audit_reports' &&
								active_assigned_task_category.name == 'Reports' &&
								main_report_category_id != 'tasks_reports'
							"
							@click="enable_nomination = true"
							>NOMINATE</el-button
						>

						<el-button
							class="submit-btn"
							size="mini"
							v-if="
								selected_locations_for_nomination.length &&
								active_report_tab == 'COMPETITION' &&
								user_designation != 'Area Lead'
							"
							:loading="is_nomaination_processing"
							@click="submitNomination()"
							>SUBMIT NOMINTAION</el-button
						>

						<el-button
							class="cancel-btn ml-4"
							size="mini"
							plain
							v-if="enable_nomination && active_report_tab == 'COMPETITION'"
							@click="cancelNomination()"
							>CANCEL
						</el-button>

						<template
							v-if="
								active_assigned_task_category.name != 'Reports' &&
								main_report_category_id != 'audit_reports'
							"
						>
							<el-button
								class="cancel-btn ml-4"
								size="mini"
								v-if="
									(active_assigned_task_category.name == 'Reports' &&
										main_report_category_id == 'audit_reports' &&
										selected_audit_report_outlet.current_step == false) ||
									(active_assigned_task_category.name == 'Reports' &&
										main_report_category_id == 'tasks_reports')
								"
								plain
								@click="getReportCSVDownload()"
								>Download Reports <i class="el-icon-download"></i
							></el-button>
						</template>
					</div>
				</div>

				<div
					v-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'cleanliness_reports'
					"
				>
					<!-- for Regional Managers and REM -->
					<div
						class="task-table mt-2"
						v-if="
							user_designation == 'Regional Manager' ||
							user_designation == 'REM' ||
							user_access_level == 'admin'
						"
					>
						<div
							style="font-size: 0.9rem; font-weight: bold; color: #502314"
							v-if="user_designation == 'Regional Manager'"
						>
							Competition Ranking - Regional Manager
						</div>
						<div
							style="font-size: 0.9rem; font-weight: bold; color: #502314"
							v-else-if="user_designation == 'REM'"
						>
							Competition Ranking - REM
						</div>
						<div
							style="font-size: 0.9rem; font-weight: bold; color: #502314"
							v-else-if="user_access_level == 'admin'"
						>
							Competition Ranking - Regional Manager / REM
						</div>

						<table class="mt-2">
							<thead>
								<tr>
									<th>
										LOCATION

										<el-popover placement="right" trigger="click">
											<el-input
												v-model="search_location"
												size="mini"
												placeholder="Search Location"
											></el-input>

											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_location_filter">
													<el-checkbox
														v-for="(
															location, index
														) in locations_for_rem_lead.filter(
															(data) =>
																!search_location ||
																data
																	.toLowerCase()
																	.includes(search_location.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="location"
														style="display: block"
													>
													</el-checkbox>
												</el-checkbox-group>
											</div>

											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selectAllLocations()"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="resetSelectedLocations()"
													>Reset</span
												>
											</div>

											<span slot="reference">
												<img
													src="../../../../../src/assets/images/filter-icon.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>

									<th>REGION</th>

									<th>NAME</th>

									<th>
										RANK
										<span>
											<i
												v-if="sort_by_ascending_rank"
												class="el-icon-caret-top text-base cursor-pointer"
												@click="sortByDescendingRank()"
											></i>

											<i
												v-else
												class="el-icon-caret-bottom text-base cursor-pointer"
												@click="sortByAscendingRank()"
											></i>
										</span>
									</th>

									<th>POINTS AVAILABLE</th>

									<th>POINTS ACHIEVED</th>

									<th>PERCENTAGE</th>

									<th>COMMENTS</th>

									<th>&nbsp;</th>
								</tr>
							</thead>

							<tbody
								v-if="rem_lead_reportable_data.length"
								v-loading="is_report_list_loading"
								style="max-height: 300px"
							>
								<tr v-for="(i, index) in rem_lead_reportable_data" :key="index">
									<td class="capitalize" style="text-align: left">
										<div style="font-weight: 700">{{ i.name }}</div>

										<div
											style="
												padding: 4px;
												color: #fff;
												font-size: 0.6rem;
												border-radius: 4px;
												width: fit-content;
												margin-top: 5px;
											"
											v-if="i.is_nominated"
											:style="[
												user_designation == 'Market Lead' ||
												user_access_level == 'admin'
													? { background: '#D26300' }
													: { background: '#438544' },
											]"
										>
											NOMINATED
										</div>
									</td>

									<td>{{ i.region_name ? i.region_name : "-" }}</td>

									<td>
										<div>{{ i.user_name ? i.user_name : "" }}</div>
										<div>
											{{ i.designation ? "( " + i.designation + " )" : "" }}
										</div>
									</td>

									<td>
										{{ i.total_yes_no_points_achieved > 0 ? i.rank : "-" }}
									</td>

									<td>
										{{ i.total_yes_no_points ? i.total_yes_no_points : 0 }}
									</td>

									<td>
										{{
											i.total_yes_no_points_achieved
												? i.total_yes_no_points_achieved
												: 0
										}}
									</td>

									<td>{{ i.yes_no_points_percentage }}%</td>

									<td>
										<el-popover
											placement="left"
											trigger="click"
											:disabled="!i.comments"
										>
											{{ i.comments }}

											<div
												slot="reference"
												style="
													text-overflow: ellipsis;
													white-space: nowrap;
													overflow: hidden;
												"
											>
												{{ i.comments }}
											</div>
										</el-popover>

										<span
											v-if="!i.comments"
											@click="addComment(i, index)"
											style="
												margin-left: 8px;
												color: #d26300;
												text-decoration: underline;
												cursor: pointer;
											"
										>
											Add Comment
										</span>

										<div class="mt-1">
											<span
												v-if="i.comments"
												@click="addComment(i, index)"
												title="Edit"
												style="
													margin-left: 8px;
													color: #d26300;
													cursor: pointer;
													font-size: 0.9rem;
												"
											>
												<i class="el-icon-edit"></i>
											</span>

											<span
												v-if="i.comments"
												@click="deleteComment(i, index)"
												title="Delete"
												style="
													margin-left: 8px;
													color: #d26300;
													cursor: pointer;
													font-size: 0.9rem;
												"
											>
												<i class="el-icon-delete-solid"></i>
											</span>
										</div>
									</td>

									<td>
										<template
											v-if="
												user_designation == 'REM' ||
												user_designation == 'Regional Manager' ||
												user_access_level == 'admin'
											"
										>
											<el-checkbox
												v-model="i.is_nomination_enabled"
												@change="selectNomination(index, $event)"
												v-if="enable_nomination"
												:disabled="
													i.is_nominated ||
													(isNominationDisabled && !i.is_nomination_enabled) ||
													!i.total_yes_no_points_achieved
												"
											>
											</el-checkbox>
										</template>

										<span
											@click="
												getViewDetailsData(
													i,
													user_designation == 'Market Lead' ||
														user_access_level == 'admin'
														? 'Market Lead'
														: 'Area Lead'
												)
											"
											style="
												margin-left: 8px;
												color: #d26300;
												text-decoration: underline;
												cursor: pointer;
											"
										>
											View Details
										</span>
									</td>
								</tr>
							</tbody>
						</table>
						<div
							v-if="!getReportTableData.length"
							class="text-center primary-theme-color text-sm font-semibold"
							style="padding: 15px"
							v-loading="is_report_list_loading"
						>
							No data available
						</div>
					</div>

					<!-- for market lead and other employees-->
					<div class="task-table mt-2">
						<div
							v-if="
								user_designation == 'Regional Manager' ||
								user_designation == 'REM' ||
								user_designation == 'Market Lead' ||
								user_access_level == 'admin'
							"
							style="font-size: 0.9rem; font-weight: bold; color: #502314"
						>
							Competition Ranking - Market Lead
						</div>

						<table class="mt-2">
							<thead>
								<tr>
									<th>
										LOCATION

										<el-popover placement="right" trigger="click">
											<el-input
												v-model="search_location"
												size="mini"
												placeholder="Search Location"
											></el-input>

											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group v-model="selected_location_filter">
													<el-checkbox
														v-for="(location, index) in location_array.filter(
															(data) =>
																!search_location ||
																data
																	.toLowerCase()
																	.includes(search_location.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="location"
														style="display: block"
													>
													</el-checkbox>
												</el-checkbox-group>
											</div>

											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selectAllLocations()"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="resetSelectedLocations()"
													>Reset</span
												>
											</div>

											<span slot="reference">
												<img
													src="../../../../../src/assets/images/filter-icon.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>

									<th>REGION</th>

									<th>NAME</th>

									<th>
										RANK
										<span>
											<i
												v-if="sort_by_ascending_rank"
												class="el-icon-caret-top text-base cursor-pointer"
												@click="sortByDescendingRank()"
											></i>

											<i
												v-else
												class="el-icon-caret-bottom text-base cursor-pointer"
												@click="sortByAscendingRank()"
											></i>
										</span>
									</th>

									<th>POINTS AVAILABLE</th>

									<th>POINTS ACHIEVED</th>

									<th>PERCENTAGE</th>

									<th>COMMENTS</th>

									<th>&nbsp;</th>
								</tr>
							</thead>

							<tbody
								v-if="getReportTableData.length"
								v-loading="is_report_list_loading"
								style="max-height: 300px"
							>
								<tr v-for="(i, index) in getReportTableData" :key="index">
									<td class="capitalize" style="text-align: left">
										<div style="font-weight: 700">{{ i.name }}</div>

										<div
											style="
												padding: 4px;
												color: #fff;
												font-size: 0.6rem;
												border-radius: 4px;
												width: fit-content;
												margin-top: 5px;
											"
											v-if="i.is_nominated"
											:style="[
												user_designation == 'Market Lead' ||
												user_access_level == 'admin'
													? { background: '#D26300' }
													: { background: '#438544' },
											]"
										>
											NOMINATED
										</div>
									</td>

									<td>{{ i.region_name ? i.region_name : "-" }}</td>

									<td>{{ i.user_name ? i.user_name : "-" }}</td>

									<td>
										{{ i.total_yes_no_points_achieved > 0 ? i.rank : "-" }}
									</td>

									<td>
										{{ i.total_yes_no_points ? i.total_yes_no_points : 0 }}
									</td>

									<td>
										{{
											i.total_yes_no_points_achieved
												? i.total_yes_no_points_achieved
												: 0
										}}
									</td>

									<td>{{ i.yes_no_points_percentage }}%</td>

									<td>
										<el-popover
											placement="left"
											trigger="click"
											:disabled="!i.comments"
										>
											{{ i.comments }}

											<div
												slot="reference"
												style="
													text-overflow: ellipsis;
													white-space: nowrap;
													overflow: hidden;
												"
											>
												{{ i.comments }}
											</div>
										</el-popover>

										<span
											v-if="!i.comments"
											@click="addComment(i, index)"
											style="
												margin-left: 8px;
												color: #d26300;
												text-decoration: underline;
												cursor: pointer;
											"
										>
											Add Comment
										</span>

										<div class="mt-1">
											<span
												v-if="i.comments"
												@click="addComment(i, index)"
												title="Edit"
												style="
													margin-left: 8px;
													color: #d26300;
													cursor: pointer;
													font-size: 0.9rem;
												"
											>
												<i class="el-icon-edit"></i>
											</span>

											<span
												v-if="i.comments"
												@click="deleteComment(i, index)"
												title="Delete"
												style="
													margin-left: 8px;
													color: #d26300;
													cursor: pointer;
													font-size: 0.9rem;
												"
											>
												<i class="el-icon-delete-solid"></i>
											</span>
										</div>
									</td>

									<td>
										<template v-if="user_designation == 'Market Lead'">
											<el-checkbox
												v-model="i.is_nomination_enabled"
												@change="selectNomination(index, $event)"
												v-if="enable_nomination"
												:disabled="
													i.is_nominated ||
													(isNominationDisabled && !i.is_nomination_enabled) ||
													!i.total_yes_no_points_achieved
												"
											>
											</el-checkbox>
										</template>

										<span
											@click="
												getViewDetailsData(
													i,
													user_designation == 'Market Lead' ||
														user_access_level == 'admin' ||
														user_designation == 'Regional Manager' ||
														user_designation == 'REM'
														? 'Market Lead'
														: 'Area Lead'
												)
											"
											style="
												margin-left: 8px;
												color: #d26300;
												text-decoration: underline;
												cursor: pointer;
											"
										>
											View Details
										</span>
									</td>
								</tr>
							</tbody>
						</table>

						<div
							v-if="!getReportTableData.length"
							class="text-center primary-theme-color text-sm font-semibold"
							style="padding: 15px"
							v-loading="is_report_list_loading"
						>
							No data available
						</div>
					</div>

					<!-- for area lead only-->
					<div
						class="task-table mt-2"
						v-if="
							user_designation == 'Regional Manager' ||
							user_designation == 'REM' ||
							user_designation == 'Market Lead' ||
							user_access_level == 'admin'
						"
					>
						<div style="font-size: 0.9rem; font-weight: bold; color: #502314">
							Competition Ranking - Area Lead
						</div>

						<table class="mt-2">
							<thead>
								<tr>
									<th>
										LOCATION

										<el-popover placement="right" trigger="click">
											<el-input
												v-model="search_location_for_area_lead"
												size="mini"
												placeholder="Search Location"
											>
											</el-input>

											<div
												style="
													max-height: 250px;
													overflow: auto;
													margin-top: 10px;
												"
											>
												<el-checkbox-group
													v-model="selected_location_filter_for_area_lead"
												>
													<el-checkbox
														v-for="(
															location, index
														) in locations_for_area_lead.filter(
															(data) =>
																!search_location_for_area_lead ||
																data
																	.toLowerCase()
																	.includes(
																		search_location_for_area_lead.toLowerCase()
																	)
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="location"
														style="display: block"
													>
													</el-checkbox>
												</el-checkbox-group>
											</div>

											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selectAllLocationsForAreaLead()"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="resetSelectedLocationsForAreaLead()"
													>Reset</span
												>
											</div>

											<span slot="reference">
												<img
													src="../../../../../src/assets/images/filter-icon.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</th>

									<th>REGION</th>

									<th>NAME</th>

									<th>
										RANK
										<span>
											<i
												v-if="sort_by_ascending_rank_for_area_lead"
												class="el-icon-caret-top text-base cursor-pointer"
												@click="sortByDescendingRankForAreaLead()"
											></i>

											<i
												v-else
												class="el-icon-caret-bottom text-base cursor-pointer"
												@click="sortByAscendingRankForAreaLead()"
											></i>
										</span>
									</th>

									<th>POINTS AVAILABLE</th>

									<th>POINTS ACHIEVED</th>

									<th>PERCENTAGE</th>

									<th>COMMENTS</th>

									<th>&nbsp;</th>
								</tr>
							</thead>

							<tbody
								v-if="getAreaLeadReportTableData.length"
								v-loading="is_report_list_loading"
								style="max-height: 300px"
							>
								<tr
									v-for="(i, index) in getAreaLeadReportTableData"
									:key="index"
								>
									<td class="capitalize" style="text-align: left">
										<div style="font-weight: 700">{{ i.name }}</div>

										<div
											style="
												padding: 4px;
												background: #438544;
												color: #fff;
												font-size: 0.6rem;
												border-radius: 4px;
												width: fit-content;
												margin-top: 5px;
											"
											v-if="i.is_nominated"
										>
											NOMINATED
										</div>
									</td>

									<td>{{ i.region_name ? i.region_name : "-" }}</td>

									<td>{{ i.user_name ? i.user_name : "-" }}</td>

									<td>
										{{ i.total_yes_no_points_achieved > 0 ? i.rank : "-" }}
									</td>

									<td>
										{{ i.total_yes_no_points ? i.total_yes_no_points : 0 }}
									</td>

									<td>
										{{
											i.total_yes_no_points_achieved
												? i.total_yes_no_points_achieved
												: 0
										}}
									</td>

									<td>{{ i.yes_no_points_percentage }}%</td>

									<td>
										<el-popover
											placement="left"
											trigger="click"
											:disabled="!i.comments"
										>
											{{ i.comments }}

											<div
												slot="reference"
												style="
													text-overflow: ellipsis;
													white-space: nowrap;
													overflow: hidden;
												"
											>
												{{ i.comments }}
											</div>
										</el-popover>

										<span
											v-if="!i.comments"
											@click="addComment(i, index)"
											style="
												margin-left: 8px;
												color: #d26300;
												text-decoration: underline;
												cursor: pointer;
											"
										>
											Add Comment
										</span>

										<div class="mt-1">
											<span
												v-if="i.comments"
												@click="addComment(i, index)"
												title="Edit"
												style="
													margin-left: 8px;
													color: #d26300;
													cursor: pointer;
													font-size: 0.9rem;
												"
											>
												<i class="el-icon-edit"></i>
											</span>

											<span
												v-if="i.comments"
												@click="deleteComment(i, index)"
												title="Delete"
												style="
													margin-left: 8px;
													color: #d26300;
													cursor: pointer;
													font-size: 0.9rem;
												"
											>
												<i class="el-icon-delete-solid"></i>
											</span>
										</div>
									</td>

									<td>
										<span
											@click="getViewDetailsData(i, 'Area Lead')"
											style="
												margin-left: 8px;
												color: #d26300;
												text-decoration: underline;
												cursor: pointer;
											"
										>
											View Details
										</span>
									</td>
								</tr>
							</tbody>
						</table>

						<div
							v-if="!getAreaLeadReportTableData.length"
							class="text-center primary-theme-color text-sm font-semibold"
							style="padding: 15px"
							v-loading="is_report_list_loading"
						>
							No data available
						</div>
					</div>
				</div>

				<!-- AUDIT REPORTS STARTS HERE -->
				<div>
					<el-breadcrumb
						separator-class="el-icon-arrow-right"
						v-if="
							active_assigned_task_category.name == 'Reports' &&
							main_report_category_id == 'audit_reports' &&
							selected_audit_report_outlet.current_step == true
						"
					>
						<el-breadcrumb-item
							><span
								class="link-text"
								style="color: #d26300; text-transform: capitalize"
								@click="resetAuditReports"
								>Audit</span
							></el-breadcrumb-item
						>
						<el-breadcrumb-item
							><span
								class="link-text"
								style="color: #d26300; text-transform: capitalize"
								@click="handleAuditReportsBreadcrumb('outlet')"
								>{{ selected_audit_report_outlet.name }}</span
							>
						</el-breadcrumb-item>
						<el-breadcrumb-item
							v-if="
								active_assigned_task_category.name == 'Reports' &&
								main_report_category_id == 'audit_reports' &&
								selected_audit_report_outlet.current_step == true &&
								selected_audit_report_category.current_step == true
							"
						>
							<span
								@click="handleAuditReportsBreadcrumb('category')"
								class="link-text"
								style="color: #d26300; text-transform: capitalize"
								>{{ selected_audit_report_category.name }}</span
							>
						</el-breadcrumb-item>
						<el-breadcrumb-item
							v-if="
								active_assigned_task_category.name == 'Reports' &&
								main_report_category_id == 'audit_reports' &&
								selected_audit_report_outlet.current_step == true &&
								selected_audit_report_category.current_step == true &&
								selected_audit_report_task.current_step == true
							"
						>
							<span style="text-transform: capitalize">{{
								selected_audit_report_task.name
							}}</span>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>

				<div
					style="overflow-x: scroll"
					v-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'audit_reports' &&
						selected_audit_report_outlet.current_step == false
					"
				>
					<table class="task-table mt-2" style="overflow-x: hidden">
						<thead>
							<tr>
								<th style="width: 160px; text-align: left">
									LOCATION

									<el-popover placement="right" trigger="click">
										<el-input
											v-model="search_location_for_audit"
											size="mini"
											placeholder="Search Location"
										></el-input>

										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group
												v-model="selected_location_filter_for_audit"
											>
												<el-checkbox
													v-for="(
														location, index
													) in location_for_audit_reports.filter(
														(data) =>
															!search_location_for_audit ||
															data
																.toLowerCase()
																.includes(
																	search_location_for_audit.toLowerCase()
																)
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="location"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>

										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selectAllAuditReportsLocations()"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="resetSelectedAuditReportsLocations()"
												>Reset</span
											>
										</div>

										<span slot="reference">
											<img
												src="../../../../../src/assets/images/filter-icon.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</th>

								<th
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-dates-' + key"
									style="width: 140px"
								>
									<div style="margin-bottom: 4px; text-transform: uppercase">
										{{ moment(element).format("Do MMM") }}
									</div>
									<div>
										<span
											style="
												display: inline-block;
												width: 50%;
												text-align: right;
												padding-right: 10px;
												font-size: 9px;
											"
											>GRADE</span
										>
										<span
											style="
												display: inline-block;
												width: 50%;
												text-align: left;
												padding-left: 15px;
												font-size: 9px;
											"
											>POINTS</span
										>
									</div>
								</th>

								<th style="width: 140px">&nbsp;</th>
							</tr>
						</thead>

						<tbody
							v-if="getAuditReports.length"
							v-loading="is_audit_report_list_loading"
							style="max-height: 300px"
						>
							<tr v-for="(i, index) in getAuditReports" :key="index">
								<td
									class="capitalize"
									style="text-align: center; width: 160px; text-align: left"
								>
									<div style="font-weight: 700">
										<span
											style="text-decoration: underline; cursor: pointer"
											@click="openAuditReportLocation(i, 'category')"
											>{{ i.name }}</span
										>
									</div>
								</td>

								<td
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-date-elements-' + key"
									style="width: 140px"
								>
									<template v-for="(item_element, key_index) in i.data">
										<div
											:key="'date_dues_' + key_index"
											v-if="
												item_element.due_date != 0 &&
												moment(item_element.due_date).format('YYYY-MM-DD') ==
													element
											"
										>
											<template v-if="item_element.grade == 'Fail'">
												<span style="display: inline-block; width: 100%">{{
													item_element.grade
												}}</span>
											</template>
											<template v-else>
												<span
													style="
														display: inline-block;
														width: 50%;
														text-align: right;
														padding-right: 10px;
													"
													>{{ item_element.grade }}</span
												>
												<span
													style="
														display: inline-block;
														width: 50%;
														text-align: left;
														padding-left: 15px;
													"
													>{{ item_element.total_yes_no_points_achieved }} of
													{{ item_element.total_yes_no_points }} ({{
														item_element.yes_no_points_percentage
													}}%)</span
												>
											</template>
										</div>
									</template>
								</td>

								<td style="width: 140px">
									<span
										style="
											text-decoration: underline;
											cursor: pointer;
											color: rgb(210, 99, 0);
										"
										@click="openAuditReportLocation(i, 'category')"
										>View Details</span
									>
								</td>
							</tr>
						</tbody>
					</table>

					<div
						v-if="!getAuditReports.length"
						class="text-center primary-theme-color text-sm font-semibold"
						style="padding: 15px"
						v-loading="is_audit_report_list_loading"
					>
						No data available
					</div>
				</div>

				<div
					v-else-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'audit_reports' &&
						selected_audit_report_outlet.current_step == true &&
						selected_audit_report_category.current_step == false
					"
				>
					<table class="task-table mt-4">
						<thead>
							<tr>
								<th>SUB CATEGORY</th>
								<th
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-dates-' + key"
									style="width: 140px; text-transform: uppercase"
								>
									<div style="margin-bottom: 4px">
										{{ moment(element).format("Do MMM") }}
									</div>
								</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, index) in audit_report_categories"
								:key="'audit-reports-category-list-' + index"
							>
								<td style="font-weight: 700">{{ item.name }}</td>
								<td
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-date-elements-' + key"
									style="width: 140px"
								>
									<template v-for="(el, ind) in item.data">
										<span
											v-if="el.due_date == element"
											:key="'audit-cat-' + ind"
										>
											<template v-if="el.report_type == 'yes_no_points'"
												>{{ el.total_yes_no_points_achieved }} of
												{{ el.total_yes_no_points }} ({{
													el.yes_no_points_percentage
												}}%)</template
											>
											<template v-else-if="el.report_type == 'general'"
												>-</template
											>
										</span>
									</template>
								</td>
								<td>
									<span
										style="
											text-decoration: underline;
											cursor: pointer;
											color: #d26300;
										"
										@click="openAuditReportLocation(item, 'task')"
									>
										View Details
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div
					v-else-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'audit_reports' &&
						selected_audit_report_outlet.current_step == true &&
						selected_audit_report_category.current_step == true &&
						selected_audit_report_task.current_step == false
					"
				>
					<table class="task-table mt-4">
						<thead>
							<tr>
								<th style="text-align: left">TASKS</th>
								<th
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-dates-' + key"
									style="width: 140px; text-transform: uppercase"
								>
									<div style="margin-bottom: 4px">
										{{ moment(element).format("Do MMM") }}
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, index) in audit_report_tasks"
								:key="'audit-ports-task-' + index"
							>
								<td style="font-weight: 700; text-align: left">
									<span
										style="text-decoration: underline; cursor: pointer"
										class="title"
										@click="openAuditReportLocation(item, 'subtask')"
									>
										{{ item.name }}
									</span>
								</td>
								<td
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-date-elements-' + key"
									style="width: 140px"
									class="title"
								>
									<template v-for="(el, ind) in item.data">
										<span
											v-if="el.due_date == element"
											:key="'audit-task-' + ind"
										>
											<template v-if="el.report_type == 'yes_no_points'"
												>{{ el.total_yes_no_points_achieved }} of
												{{ el.total_yes_no_points }} ({{
													el.yes_no_points_percentage
												}}%)</template
											>
											<template v-else-if="el.report_type == 'general'">
												<i
													v-if="el.status == 'Completed'"
													style="color: #67c23a"
													class="text-base el-icon-success"
												></i>
												<i
													v-else
													style="color: #f56c6c"
													class="text-base el-icon-error"
												></i>
											</template>
										</span>
									</template>
								</td>
							</tr>
							<tr v-if="audit_report_tasks.length == 0">
								<td>No data available</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div
					v-else-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'audit_reports' &&
						selected_audit_report_outlet.current_step == true &&
						selected_audit_report_category.current_step == true &&
						selected_audit_report_task.current_step == true
					"
				>
					<table class="task-table mt-4">
						<thead>
							<tr>
								<th style="text-align: left">SUBTASK</th>
								<th
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-dates-' + key"
									style="width: 140px"
								>
									<div style="margin-bottom: 4px; text-transform: uppercase">
										{{ moment(element).format("Do MMM") }}
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, index) in audit_report_sub_tasks"
								:key="'audit-ports-task-' + index"
							>
								<td style="font-weight: 700; text-align: left">
									<div class="title" v-html="item.name"></div>
								</td>
								<td
									v-for="(element, key) in audit_report_date_arr"
									:key="'audit-report-date-elements-' + key"
									style="width: 140px"
									class="title"
								>
									<template v-for="(el, ind) in item.data">
										<span
											v-if="el.due_date == element"
											:key="'audit-subtask-' + ind"
										>
											<template v-if="el.report_type == 'yes_no_points'">
												<span v-if="el.not_applicable == true">N.A</span>
												<span v-else-if="el.boolean_value == true">YES</span>
												<span v-else-if="el.boolean_value == false">NO</span>
												<span v-else>-</span>
											</template>
											<template v-else-if="el.report_type == 'general'">
												<i
													style="color: #67c23a"
													class="text-base el-icon-success"
													v-if="el.boolean_value == true"
												></i>
												<i
													style="color: #f56c6c"
													class="text-base el-icon-error"
													v-else-if="el.boolean_value == false"
												></i>
												<template v-else>-</template>
											</template>
											<template v-else>
												<span v-if="el.not_applicable == true">N.A</span>
												<span v-else-if="el.boolean_value == true">YES</span>
												<span v-else-if="el.boolean_value == false">NO</span>
											</template>
										</span>
										<span v-else :key="'audit-subtask-el-' + ind">-</span>
									</template>
								</td>
							</tr>
							<tr v-if="audit_report_sub_tasks.length == 0">
								<td>No data available</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- AUDIT REPORTS ENDS HERE -->
				<div
					v-if="
						active_assigned_task_category.name == 'Reports' &&
						main_report_category_id == 'tasks_reports'
					"
				>
					<div class="text-right my-2">
						<el-button
							class="btn submit-btn"
							size="mini"
							icon="el-icon-download"
							@click="downloadTaskCsvReport"
							>Download Reports</el-button
						>
					</div>
					<table class="task-table mt-4">
						<thead>
							<tr>
								<th>
									LOCATION
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="search_location_for_task"
											size="mini"
											placeholder="Search Location"
										></el-input>
										<div
											style="
												max-height: 250px;
												overflow: auto;
												margin-top: 10px;
											"
										>
											<el-checkbox-group
												v-model="selected_location_filter_for_task"
											>
												<el-checkbox
													v-for="(
														location, index
													) in location_for_task_reports.filter(
														(data) =>
															!search_location_for_task ||
															data
																.toLowerCase()
																.includes(
																	search_location_for_task.toLowerCase()
																)
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="location"
													style="display: block"
												></el-checkbox>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selectAllAuditReportsLocations()"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="resetSelectedAuditReportsLocations()"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												src="../../../../../src/assets/images/filter-icon.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</th>
								<th>
									TASK ASSIGNED
									<span>
										<i
											v-if="sort_by_ascending_task_report_task_assigned"
											class="el-icon-caret-top text-base cursor-pointer"
											@click="sortByAscendingTaskReportsAssigned()"
										></i>
										<i
											v-else
											class="el-icon-caret-bottom text-base cursor-pointer"
											@click="sortByDescendingTaskReportsAssigned()"
										></i>
									</span>
								</th>
								<th>
									COMPLETED
									<span>
										<i
											v-if="sort_by_ascending_task_report_task_completed"
											class="el-icon-caret-top text-base cursor-pointer"
											@click="sortByAscendingTaskReportsCompleted()"
										></i>
										<i
											v-else
											class="el-icon-caret-bottom text-base cursor-pointer"
											@click="sortByDescendingTaskReportsCompleted()"
										></i>
									</span>
								</th>
								<th>
									INCOMPLETE
									<span>
										<i
											v-if="sort_by_ascending_task_report_task_incomplete"
											class="el-icon-caret-top text-base cursor-pointer"
											@click="sortByAscendingTaskReportsIncomplete()"
										></i>
										<i
											v-else
											class="el-icon-caret-bottom text-base cursor-pointer"
											@click="sortByDescendingTaskReportsIncomplete()"
										></i>
									</span>
								</th>
								<th>
									COMPLETION RATE
									<span>
										<i
											v-if="sort_by_ascending_task_report_task_completion_rate"
											class="el-icon-caret-top text-base cursor-pointer"
											@click="sortByAscendingTaskReportsCompletionRate()"
										></i>
										<i
											v-else
											class="el-icon-caret-bottom text-base cursor-pointer"
											@click="sortByDescendingTaskReportsCompletionRate()"
										></i>
									</span>
								</th>

								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody
							v-if="getTaskReports.length"
							v-loading="is_audit_report_list_loading"
							style="max-height: 300px"
						>
							<tr v-for="(i, index) in getTaskReports" :key="index">
								<td class="capitalize" style="text-align: center">
									<div style="font-weight: 700">
										<span
											style="text-decoration: underline; cursor: pointer"
											@click="getTaskOutletReport(i.basics, i.name)"
											>{{ i.name }}</span
										>
									</div>
								</td>
								<td>
									{{ i.total }}
								</td>
								<td>{{ i.completed }}</td>
								<td>
									{{ i.total - i.completed ? i.total - i.completed : "-" }}
								</td>
								<td>
									{{
										i.completion_rate != "-"
											? i.completion_rate + "%"
											: i.completion_rate
									}}
								</td>
								<td>
									<span
										@click="getTaskCategoryData(i.basics, i.name)"
										style="
											margin-left: 8px;
											color: #d26300;
											text-decoration: underline;
											cursor: pointer;
										"
									>
										View Details
									</span>
								</td>
							</tr>
						</tbody>
					</table>

					<div
						v-if="!getTaskReports.length"
						class="text-center primary-theme-color text-sm font-semibold"
						style="padding: 15px"
						v-loading="is_task_report_list_loading"
					>
						No data available
					</div>
				</div>
			</el-card>

			<!--date wise report dialog -->
			<div class="reportPopup">
				<el-dialog
					:visible.sync="dialog_visible"
					:close-on-click-modal="true"
					width="95%"
					top="0"
					custom-class="customClass"
					:lock-scroll="true"
					:show-close="true"
				>
					<div class="theme-color">
						<div class="text-left" style="padding: 0 20px 0 20px">
							<el-button
								icon="el-icon-back"
								class="submit-btn"
								size="mini"
								@click="
									dialog_visible = false;
									selected_filter_task = [];
								"
							>
								Back
							</el-button>
						</div>
						<div
							class="title capitalize mt-2"
							style="padding: 0 20px; font-size: 1.4em"
						>
							{{ selected_report.name }}
						</div>
						<div class="table-sec" style="padding: 0 20px">
							<div class="breadcrumbs flex items-center mt-4 mb-2">
								<div
									class="breadcrumbs-inn"
									v-for="(i, index) in breadcrumbs"
									:key="index"
								>
									<div
										class="item"
										@click="changeTblData(i, index)"
										:style="[
											index < breadcrumbs.length - 1
												? { color: '#d26300', cursor: 'pointer' }
												: { color: '#606266' },
										]"
									>
										{{ i.name }}
									</div>
									<i
										class="el-icon-arrow-right"
										v-if="index < breadcrumbs.length - 1"
									></i>
								</div>
							</div>
							<table class="task-table" v-loading="is_datewise_reports_loading">
								<thead>
									<tr>
										<th style="width: 200px">
											TASK

											<el-popover placement="bottom" trigger="click">
												<div>
													<el-checkbox-group v-model="selected_filter_task">
														<el-checkbox
															v-for="(taskName, name_index) in task_array"
															:key="name_index"
															class="mb-2 checkbox-lable"
															:label="taskName"
															style="display: block"
														></el-checkbox>
													</el-checkbox-group>

													<div class="flex justify-between mt-4">
														<span
															class="text-xs cursor-pointer primary-theme-color"
															@click="selectAllTaskName()"
															>Select all</span
														>
														<span
															class="text-xs cursor-pointer"
															@click="resetSelectedTaskName()"
															>Reset</span
														>
													</div>
												</div>

												<span slot="reference" class="cursor-pointer">
													<img
														src="../../../../../src/assets/images/filter-icon.png"
														width="9"
													/>
												</span>
											</el-popover>
										</th>

										<th
											v-for="(i, index) in date_list"
											:key="
												'competition-dates-' + index + new Date().getTime() * 10
											"
										>
											{{ i | formatReportDate }}
										</th>
									</tr>
								</thead>

								<tbody>
									<tr
										v-for="(report_data, d_index) in getDateWiseReportDetails"
										:key="d_index"
									>
										<td
											style="
												width: 200px;
												font-weight: 600;
												text-decoration: underline;
											"
											@click="getDateWiseSubstepReport(report_data)"
										>
											<span style="cursor: pointer">{{
												report_data.name
											}}</span>
										</td>

										<td
											v-for="(i, index) in report_data.data"
											:key="index + new Date().getTime()"
										>
											{{ i.total_yes_no_points_achieved }} Out of
											{{ i.total_yes_no_points }}
											<span>({{ i.yes_no_points_percentage }}%)</span>
										</td>
									</tr>
								</tbody>
							</table>

							<div
								v-if="!getDateWiseReportDetails.length"
								class="text-center text-sm font-semibold"
								style="padding: 15px; color: #d26300"
							>
								No data available
							</div>
						</div>
					</div>
				</el-dialog>
			</div>

			<!-- date wise task steps -->
			<div class="reportPopup">
				<el-dialog
					:visible.sync="dialog_visible_for_steps_report"
					:close-on-click-modal="true"
					width="95%"
					top="0"
					custom-class="customClass"
					:lock-scroll="true"
					:show-close="true"
				>
					<div class="theme-color">
						<div>
							<div class="text-left" style="padding: 0 20px 0 20px">
								<el-button
									icon="el-icon-back"
									class="submit-btn"
									size="mini"
									@click="
										dialog_visible_for_steps_report = false;
										selected_sub_task_filter_task = [];
										breadcrumbs.pop();
									"
								>
									Back
								</el-button>
							</div>

							<div class="ReportDetails">
								<div class="store-sec">
									<div
										class="title capitalize mt-2"
										style="padding: 0 20px; font-size: 1.4em"
									>
										{{ selected_sub_task.name }}
									</div>

									<div class="table-sec" style="padding: 0 20px">
										<div class="breadcrumbs flex items-center mt-4 mb-2">
											<div
												class="breadcrumbs-inn"
												v-for="(i, index) in breadcrumbs"
												:key="index"
											>
												<div
													class="item"
													@click="changeTblData(i, index)"
													:style="[
														index < breadcrumbs.length - 1
															? { color: '#d26300', cursor: 'pointer' }
															: { color: '#606266' },
													]"
												>
													{{ i.name }}
												</div>

												<i
													class="el-icon-arrow-right"
													v-if="index < breadcrumbs.length - 1"
												></i>
											</div>
										</div>

										<div class="task-table">
											<table
												class="task-table"
												v-loading="is_datewise_steps_reports_loading"
											>
												<thead>
													<tr>
														<th style="width: 200px">
															STEPS

															<el-popover placement="bottom" trigger="click">
																<div>
																	<el-checkbox-group
																		v-model="selected_sub_task_filter_task"
																	>
																		<el-checkbox
																			v-for="(
																				taskName, name_index
																			) in sub_task_array"
																			:key="name_index"
																			class="mb-2 checkbox-lable"
																			:label="taskName"
																			style="display: block"
																		></el-checkbox>
																	</el-checkbox-group>

																	<div class="flex justify-between mt-4">
																		<span
																			class="text-xs cursor-pointer primary-theme-color"
																			@click="selectSubTaskName()"
																			>Select all</span
																		>
																		<span
																			class="text-xs cursor-pointer"
																			@click="resetSelectedSubTaskName()"
																			>Reset</span
																		>
																	</div>
																</div>

																<span slot="reference" class="cursor-pointer">
																	<img
																		src="../../../../../src/assets/images/filter-icon.png"
																		width="9"
																	/>
																</span>
															</el-popover>
														</th>

														<th
															v-for="(i, index) in date_list_for_sub_step"
															:key="index"
															:style="{
																width:
																	100 / date_list_for_sub_step.length + '%',
															}"
														>
															{{ i | formatReportDate }}
														</th>
													</tr>
												</thead>

												<tbody>
													<tr
														v-for="(
															report_data, d_index
														) in getSelectedStepReportDetails"
														:key="d_index"
													>
														<td style="width: 200px; font-weight: 600">
															{{ report_data.name }}
														</td>

														<td
															v-for="(i, index) in report_data.data"
															:key="index"
															:style="{
																width:
																	100 / date_list_for_sub_step.length + '%',
															}"
														>
															{{ i.total_yes_no_points_achieved }} Out of
															{{ i.total_yes_no_points }}
														</td>
													</tr>
												</tbody>
											</table>

											<div
												v-if="!getSelectedStepReportDetails.length"
												class="text-center text-sm font-semibold"
												style="padding: 15px; color: #d26300"
											>
												No data available
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>

			<!-- add new category dialog -->
			<el-dialog
				title="Add Categories"
				:visible.sync="add_new_category_dialog"
				width="50%"
				custom-class="add-categories__modal"
			>
				<div v-loading="is_category_list_loading">
					<div>
						<div
							id="add-category-wrapper"
							style="height: 200px; overflow-y: auto"
						>
							<div
								v-for="(category, category_index) in add_category_list"
								:key="category_index"
								class="py-2 flex items-center"
							>
								<el-input
									v-model="category.name"
									:placeholder="'Category ' + (category_index + 1)"
									size="medium"
									style="width: 50%"
									type="text"
									@input="category.isChange = true"
								/>
								<div class="ml-5">
									<i
										class="el-icon-delete cursor-pointer default-icon"
										width="22px"
										@click="deleteCategory(category_index)"
									></i>
								</div>
							</div>
						</div>

						<div class="flex items-center mt-5">
							<BaseButton
								type="submit"
								style="width: 100px"
								buttonclass="btn p-2 text-xs"
								@click="addMoreCategory()"
							>
								Add More
							</BaseButton>
						</div>
					</div>

					<span
						slot="footer"
						class="dialog-footer flex"
						style="justify-content: flex-end"
					>
						<BaseButton
							type="submit"
							style="width: 100px"
							buttonclass="btn p-2 text-xs cancel-btn"
							@click="add_new_category_dialog = false"
						>
							Cancel
						</BaseButton>

						<BaseButton
							type="submit"
							style="width: 100px"
							buttonclass="btn p-2 text-xs ml-2"
							@click="addUpdateCategory()"
						>
							Update
						</BaseButton>
					</span>
				</div>
			</el-dialog>

			<!-- image-popup -->
			<div class="image-popup">
				<el-dialog :visible.sync="image_dialog_visible" width="700px">
					<div class="image-main-sec">
						<div>
							<img
								class="next-prev-btn prev-image"
								@click="nextPreviousImg('prev')"
								src="../../../../assets/images/back.png"
								alt=""
							/>
						</div>
						<div class="image-div" v-loading="is_image_loading">
							<img :src="current_image" alt="" />
						</div>
						<div>
							<img
								class="next-prev-btn next-image"
								@click="nextPreviousImg('next')"
								src="../../../../assets/images/next.png"
								alt=""
							/>
						</div>
					</div>
					<div class="flex justify-end mb-6">
						<div>
							<img
								@click="downloadImage()"
								style=""
								class="down-icon"
								src="../../../../assets/images/downloading.png"
								alt=""
							/>
						</div>
					</div>
				</el-dialog>
			</div>

			<!-- tasks preview dialog -->
			<el-dialog
				title="Task Preview"
				:visible.sync="task_preview_dialog"
				width="50%"
				custom-class="gray-background"
			>
				<div v-loading="is_edit_task_loading">
					<div style="padding: 10px">
						<el-card class="box-card">
							<el-row :gutter="10" class="mt-4">
								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<el-row>
										<el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
											<label class="font-bold text-xs block">Location</label>
										</el-col>

										<el-col
											:xs="12"
											:sm="12"
											:md="12"
											:lg="16"
											:xl="16"
											class="capitalize text-sm"
										>
											{{ task_preview.outlet_name }}
										</el-col>
									</el-row>
								</el-col>

								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<el-row>
										<el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
											<label class="font-bold text-xs block">Task</label>
										</el-col>

										<el-col
											:xs="12"
											:sm="12"
											:md="12"
											:lg="16"
											:xl="16"
											class="capitalize text-sm"
										>
											{{ task_preview.name }}
										</el-col>
									</el-row>
								</el-col>
							</el-row>

							<el-row :gutter="10" class="mt-4">
								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<el-row>
										<el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
											<label class="font-bold text-xs block mt-2"
												>Start Time</label
											>
										</el-col>

										<el-col
											:xs="12"
											:sm="12"
											:md="12"
											:lg="16"
											:xl="16"
											class="capitalize text-sm"
										>
											<el-time-select
												v-model="task_preview.start_time"
												style="width: 60%"
												:picker-options="{
													start: '00:00',
													end: '23:00',
												}"
												disabled
												placeholder="Start Time"
												size="mini"
											>
											</el-time-select>
										</el-col>
									</el-row>
								</el-col>

								<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
									<el-row>
										<el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
											<label class="font-bold text-xs block mt-2"
												>End Time</label
											>
										</el-col>

										<el-col
											:xs="12"
											:sm="12"
											:md="12"
											:lg="16"
											:xl="16"
											class="capitalize text-sm"
										>
											<el-time-select
												v-model="task_preview.end_time"
												style="width: 60%"
												:picker-options="{
													start: '00:00',
													end: '23:00',
												}"
												disabled
												placeholder="End Time"
												size="mini"
											>
											</el-time-select>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-card>

						<div class="mt-2 pb-4">
							<div  class="flex mb-1">
								<label class="font-bold text-xs block">Steps - </label>

								&nbsp;

								<span v-if="check_list">
									{{ check_list.length }}
								</span>
							</div>

							<div
								v-if="check_list && check_list.length && isChecklistSelected"
							>
								<el-card
									v-for="(checklist, checklist_index) in check_list"
									:key="checklist_index"
									class="box-card mb-2"
									style="border-left: solid 5px #4e86e3"
								>
									<div class="flex items-center">
										<div class="flex items-center">
											<div
												v-if="checklist.subtask_type == 'checklist'"
												style="margin-right: 10px"
											>
												<div
													style="
														height: 17px;
														width: 17px;
														border: 1px solid #dcdfe6;
														border-radius: 2px;
													"
												></div>
											</div>

											<span class="capitalize" v-html="checklist.label"> </span>
										</div>

										<div
											class="text-sm"
											style="margin-left: 15px; font-size: 0.8rem; color: #999"
											v-if="
												checklist.subtask_type == 'temperature' &&
												checklist.num_value_min != null &&
												checklist.num_value_max != null
											"
										>
											(Ideal Range:
											{{ checklist.num_value_min }}&deg; C to
											{{ checklist.num_value_max }}&deg; C)
										</div>

										<div
											class="text-sm"
											style="margin-left: 15px; font-size: 0.8rem; color: #999"
											v-else-if="
												checklist.subtask_type == 'tpc' &&
												checklist.num_value_min != null &&
												checklist.num_value_max != null
											"
										>
											(Ideal Range:
											{{ checklist.num_value_min }} TPM to
											{{ checklist.num_value_max }} TPM)
										</div>
									</div>

									<div class="mt-4" style="width: 100%">
										<div
											class="flex items-center"
											v-if="checklist.subtask_type == 'rating'"
										>
											<div class="flex items-center">
												<i
													class="el-icon-star-off"
													style="
														margin-right: 20px;
														font-size: 1.3rem;
														color: #dae1e7;
													"
												></i>
												<i
													class="el-icon-star-off"
													style="
														margin-right: 20px;
														font-size: 1.3rem;
														color: #dae1e7;
													"
												></i>
												<i
													class="el-icon-star-off"
													style="
														margin-right: 20px;
														font-size: 1.3rem;
														color: #dae1e7;
													"
												></i>
												<i
													class="el-icon-star-off"
													style="
														margin-right: 20px;
														font-size: 1.3rem;
														color: #dae1e7;
													"
												></i>
												<i
													class="el-icon-star-off"
													style="
														margin-right: 20px;
														font-size: 1.3rem;
														color: #dae1e7;
													"
												></i>
											</div>
										</div>

										<div
											style="
												padding: 5px 15px;
												height: 88px;
												border-radius: 4px;
												border: 1px solid #dcdfe6;
												color: #d1d2d3;
												font-size: 0.8rem;
												position: relative;
											"
											v-if="checklist.subtask_type == 'text'"
										>
											Please input

											<span style="position: absolute; bottom: 5px; right: 10px"
												>0/280</span
											>
										</div>

										<div
											style="display: flex; align-items: center"
											v-if="checklist.subtask_type == 'scoring'"
										>
											<div style="font-weight: 600">Points</div>

											<div
												style="
													padding: 0 15px;
													height: 32px;
													line-height: 32px;
													width: 30%;
													border-radius: 4px;
													border: 1px solid #dcdfe6;
													color: #d1d2d3;
													font-size: 0.8rem;
													margin-left: 20px;
												"
											>
												<span>Enter number</span>
											</div>

											<div
												style="margin-left: 20px"
												v-if="checklist.num_value_max"
											>
												Out of {{ checklist.num_value_max }}
											</div>
										</div>

										<div
											style="
												padding: 0 15px;
												height: 32px;
												line-height: 32px;
												width: 30%;
												border-radius: 4px;
												border: 1px solid #dcdfe6;
												color: #d1d2d3;
												font-size: 0.8rem;
											"
											v-if="
												checklist.subtask_type == 'number' ||
												checklist.subtask_type == 'temperature' ||
												checklist.subtask_type == 'tpc'
											"
										>
											<span v-if="checklist.subtask_type == 'number'"
												>Enter number</span
											>
											<span v-if="checklist.subtask_type == 'temperature'"
												>Temp in &#x2103;</span
											>
											<span v-if="checklist.subtask_type == 'tpc'"
												>tpm value</span
											>
										</div>

										<div
											style="
												padding: 0 15px;
												height: 32px;
												line-height: 32px;
												width: 35%;
												border-radius: 4px;
												border: 1px solid #dcdfe6;
												color: #d1d2d3;
												font-size: 0.8rem;
											"
											v-if="checklist.subtask_type == 'datetime'"
										>
											<span
												><i class="el-icon-time"></i> &nbsp;Select date and
												time</span
											>
										</div>

										<div class="flex" v-if="checklist.subtask_type == 'yes_no'">
											<div
												style="
													padding: 8px 15px;
													font-size: 0.8rem;
													border: 1px solid #ddd;
													border-radius: 4px;
												"
											>
												Yes
											</div>

											<div
												style="
													padding: 8px 15px;
													font-size: 0.8rem;
													border: 1px solid #ddd;
													border-radius: 4px;
													margin-left: 10px;
												"
											>
												No
											</div>
										</div>

										<div class="mt-4" v-if="checklist.subtask_type == 'image'">
											<div class="flex items-center">
												<el-button size="mini">
													<i
														class="el-icon-upload"
														style="
															color: #d26300;
															font-size: 20px;
															vertical-align: middle;
														"
													></i>
													Upload File
												</el-button>
											</div>

											<div
												style="
													font-size: 0.7rem;
													margin-top: 5px;
													white-space: nowrap;
												"
											>
												<p class="my-2">
													(JPEG, JPG, PNG, GIF) Max file size of 16 MB <br />
													Maximum allowed (4 files)
												</p>
											</div>
										</div>

										<div style="display: flex; justify-content: flex-end">
											<div>
												<u style="color: #d26300; cursor: pointer"
													>Add Comment</u
												>
											</div>
										</div>
									</div>
								</el-card>
							</div>

							<div
								v-if="!isChecklistSelected && !check_list && !check_list.length"
							>
								<el-card class="box-card">
									<div class="flex">
										<label class="font-bold text-xs block">Status - </label>
										&nbsp;

										<el-checkbox
											class="ml-8"
											style="margin-right: 10px"
										></el-checkbox>
										<span>Mark as completed</span>
									</div>
								</el-card>
							</div>
						</div>
					</div>
				</div>

				<span slot="footer" class="dialog-footer">
					<div class="flex justify-end">
						<BaseButton
							type="submit"
							style="width: 100px"
							buttonclass="btn p-2 text-xs"
							@click="task_preview_dialog = false"
						>
							Cancel
						</BaseButton>
					</div>
				</span>
			</el-dialog>

			<template v-if="active_assigned_task_category.name != 'Reports'">
				<!--task summary -->
				<div
					class="start-task-overlay"
					v-if="
						(select_outlet && activeTabLink == 'AUDIT') ||
						activeTabLink == 'TASKS' ||
						activeTabLink == 'COMPETITION'
					"
					v-loading="is_task_progress_loading || is_tasks_list_loading"
				>
					<div
						class="text-right"
						v-if="activeTabLink == 'AUDIT' || activeTabLink == 'TASKS'"
					>
						<i
							class="el-icon-arrow-up"
							style="
								color: #502314;
								font-size: 1.2rem;
								cursor: pointer;
								font-weight: 600;
							"
							v-if="!toogle_summary"
							@click="toogle_summary = true"
						></i>

						<i
							class="el-icon-arrow-down"
							style="
								color: #502314;
								font-size: 1.2rem;
								cursor: pointer;
								font-weight: 600;
							"
							v-if="toogle_summary"
							@click="toogle_summary = false"
						></i>
					</div>
					<h3 class="title capitalize" style="font-size: 16px">
						Summary<template v-if="activeTabLink == 'TASKS'"
							>&nbsp;-&nbsp;{{
								selected_dropdown_category.name
									? selected_dropdown_category.name
									: ""
							}}</template
						>
					</h3>
					<div v-if="toogle_summary">
						<!-- category wise points -->
						<table class="task-table mt-2" v-if="activeTabLink != 'TASKS'">
							<thead>
								<tr>
									<th>CATEGORIES</th>
									<th>POINTS AVAILABLE</th>
									<th>POINTS ACHIEVED</th>
									<th>PERCENTAGE</th>
								</tr>
							</thead>

							<tbody>
								<tr
									v-for="(
										deduction, deduction_index
									) in audit_summary_list.non_deduction"
									:key="deduction_index + Math.random()"
								>
									<td class="title capitalize" style="text-align: left">
										{{ deduction.name }}
									</td>
									<td>
										{{
											deduction
												? deduction.total_yes_no_points
													? deduction.total_yes_no_points
													: "-"
												: "-"
										}}
									</td>
									<td>
										{{
											deduction
												? deduction.total_yes_no_points_achieved
													? deduction.total_yes_no_points_achieved
													: "-"
												: "-"
										}}
									</td>
									<td>{{ deduction.yes_no_points_percentage }}%</td>
								</tr>
<tr
									v-for="(item, item_index) in audit_summary_list.intolerable"
									:key="item_index + Math.random()"
								>
							
									<td class="title capitalize" style="text-align: left">
										{{ item.name }}
									</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td
										:style="[
											item.mark_zero > 0
												? { color: '#29b823' }
												: { color: '#d60918' },
										]"
									>
										{{ item.mark_zero > 0 ? "YES" : "NO" }}
									</td>
								</tr>
								<tr style="background: #ffffff">
									<td
										style="color: #d26300; font-weight: 600; text-align: left"
									>
										TOTAL
									</td>

									<td style="color: #d26300; font-weight: 600">
										{{
											audit_summary_list
												? audit_summary_list.non_deduction_summary
													? audit_summary_list.non_deduction_summary
															.total_yes_no_points
														? audit_summary_list.non_deduction_summary
																.total_yes_no_points
														: "-"
													: "-"
												: "-"
										}}
									</td>

									<td style="color: #d26300; font-weight: 600">
										{{
											audit_summary_list
												? audit_summary_list.non_deduction_summary
													? audit_summary_list.non_deduction_summary
															.total_yes_no_points_achieved
													: "-"
												: "-"
										}}
									</td>

									<td style="color: #d26300; font-weight: 600">
										{{
											audit_summary_list.non_deduction_summary
												.yes_no_points_percentage
										}}
									</td>
								</tr>

								<!-- category wise deduction -->
								<tr
									v-for="(
										deduction, deduction_index
									) in audit_summary_list.deduction"
									:key="deduction_index + Math.random()"
								>
									<td class="title capitalize" style="text-align: left">
										{{ deduction.name }}
									</td>
									<td>
										{{
											deduction
												? deduction.total_yes_no_points
													? deduction.total_yes_no_points
													: "-"
												: "-"
										}}
									</td>
									<td>
										{{
											deduction
												? deduction.total_yes_no_points_achieved
													? deduction.total_yes_no_points_achieved
													: "-"
												: "-"
										}}
									</td>
									<td>{{ deduction.deduction }}</td>
								</tr>

								<!-- category wise observed -->
								
							</tbody>
						</table>

						<table
							class="task-table mt-2"
							v-else-if="
								activeTabLink == 'TASKS' && task_sub_category_list.length > 0
							"
						>
							<thead>
								<tr>
									<th>CATEGORIES</th>
									<th>TOTAL TASKS</th>
									<th>COMPLETED</th>
									<th>PENDING</th>
									<th>COMPLETION RATE</th>
								</tr>
							</thead>

							<tbody>
								<tr
									v-for="(item, item_index) in audit_summary_list"
									:key="'task-summary-list-item-' + item_index"
								>
									<td class="title capitalize" style="text-align: left">
										{{ item.name }}
									</td>
									<td>{{ item.total }}</td>
									<td>{{ item.completed }}</td>
									<td>{{ item.total - item.completed }}</td>
									<td>
										{{
											item.total == 0
												? "0.00 %"
												: ((item.completed / item.total) * 100).toFixed(2) +
												  " %"
										}}
									</td>
								</tr>
								<tr v-if="audit_summary_list.length == 0">
									<td colspan="5" class="title">No data available</td>
								</tr>
							</tbody>
						</table>
					</div>

					<table class="task-table mt-4" v-if="activeTabLink == 'AUDIT'">
						<thead>
							<tr>
								<th>&nbsp;</th>
								<th>POINTS AVAILABLE</th>
								<th>POINTS ACHIEVED</th>
								<th>PERCENTAGE</th>
								<th>RESULT</th>
								<!-- <th>GRADE</th> -->
							</tr>
						</thead>

						<tbody>
							<tr>
								<td>
									<div class="title capitalize">
										{{ select_outlet ? getOutletName : "" }}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											audit_summary_list
												? audit_summary_list.overall_score
													? audit_summary_list.overall_score.total_yes_no_points
														? audit_summary_list.overall_score
																.total_yes_no_points
														: 0
													: 0
												: 0
										}}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											audit_summary_list.overall_score
												.total_yes_no_points_achieved
												? audit_summary_list.overall_score
														.total_yes_no_points_achieved
												: 0
										}}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											audit_summary_list.overall_score.yes_no_points_percentage
												? audit_summary_list.overall_score
														.yes_no_points_percentage
												: 0
										}}%
									</div>
								</td>

								<td>
									<div style="font-size: 0.9rem">
										{{
											audit_summary_list.overall_score.rev_result
												? audit_summary_list.overall_score.rev_result
												: "-"
										}}
									</div>
								</td>
<!-- 
								<td
									style="color: #d26300; font-weight: 600; font-size: 0.9rem"
									:style="[
										audit_summary_list.overall_score.grade == 'Pass'
											? { color: '#29b823' }
											: { color: '#d60918' },
									]"
								>
									{{
										audit_summary_list.overall_score.grade
											? audit_summary_list.overall_score.grade
											: "-"
									}}
								</td> -->
							</tr>
						</tbody>
					</table>

					<table
						class="task-table mt-4"
						v-if="activeTabLink == 'TASKS' && task_sub_category_list.length > 0"
					>
						<thead>
							<tr>
								<th>&nbsp;</th>
								<th>TOTAL TASKS</th>
								<th>COMPLETED</th>
								<th>PENDING</th>
								<th>COMPLETION RATE (%)</th>
								<th>&nbsp;</th>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td>
									<div class="title capitalize">
										{{ select_outlet ? getOutletName : "" }}
									</div>
								</td>

								<td>
									<div class="title">
										{{ task_summary_info.total ? task_summary_info.total : 0 }}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_summary_info.completed
												? task_summary_info.completed
												: 0
										}}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_summary_info.pending ? task_summary_info.pending : 0
										}}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_summary_info.completion_percentage
												? task_summary_info.completion_percentage
												: "0.00 %"
										}}
									</div>
								</td>

								<td>
									<el-tag
										style="
											min-width: 100px;
											text-transform: uppercase;
											cursor: not-allowed;
											font-weight: 600;
											color: white;
											background: green;
											border-color: green;
										"
										v-if="
											taskSummaryCompletionStatus.status == 'complete' &&
											task_summary_info.total == task_summary_info.completed &&
											task_summary_info.total != 0
										"
									>
										SUBMITTED
									</el-tag>
									<el-button
										v-else
										class="submit-btn"
										:disabled="taskSubmitDisabled"
										@click="updateTaskSummayCompletionStatus"
										>SUBMIT</el-button
									>
								</td>
							</tr>
						</tbody>
					</table>

					<table class="task-table mt-4" v-if="activeTabLink == 'COMPETITION'">
						<thead>
							<tr>
								<th>&nbsp;</th>
								<th>POINTS AVAILABLE</th>
								<th>POINTS ACHIEVED</th>
								<th>PERCENTAGE</th>
								<th>RANK</th>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td>
									<div class="title capitalize">
										{{ select_outlet ? getOutletName : "" }}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_rank
												? task_rank.total_yes_no_points
													? format_two_decimal_places(
															task_rank.total_yes_no_points
													  )
													: 0
												: 0
										}}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_rank.total_yes_no_points_achieved
												? task_rank.total_yes_no_points_achieved
												: 0
										}}
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_rank.yes_no_points_percentage
												? format_two_decimal_places(
														task_rank.yes_no_points_percentage
												  )
												: 0
										}}
										%
									</div>
								</td>

								<td>
									<div class="title">
										{{
											task_rank.total_yes_no_points_achieved > 0
												? task_rank.rank
												: "-"
										}}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div
						style="width: 40%; margin: 15px auto 10px auto"
						v-if="is_task_in_progress"
					>
						<el-progress
							:stroke-width="12"
							:percentage="
								task_rank.percentage_completed
									? Number(task_rank.percentage_completed)
									: 0
							"
							:color="'#67c23a'"
						></el-progress>
					</div>
				</div>
			</template>

			<!-- add new comments dialog -->
			<el-dialog
				title="Add Comment"
				:visible.sync="add_comment_dialog"
				width="50%"
				custom-class="add-comment__modal"
			>
				<div>
					<el-input
						v-model="add_reports_comment"
						type="textarea"
						:rows="7"
						resize="none"
						placeholder="Add comment"
						size="small"
						style="width: 100%"
						:maxlength="500"
						:show-word-limit="true"
					>
					</el-input>
				</div>

				<span
					slot="footer"
					class="dialog-footer flex"
					style="justify-content: flex-end"
				>
					<el-button
						class="cancel-btn"
						style="width: 100px"
						size="mini"
						@click="add_comment_dialog = false"
					>
						Cancel
					</el-button>

					<el-button
						class="submit-btn"
						style="width: 100px"
						size="mini"
						:loader="is_comment_updating"
						@click="updateComment()"
					>
						Update
					</el-button>
				</span>
			</el-dialog>

			<!-- add new radio options dialog -->
			<el-dialog
				title="Add Options"
				:visible.sync="add_radio_options_dialog_visibility"
				width="50%"
			>
				<div>
					<el-row :gutter="10" class="mb-3">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<label class="block font-bold text-md input-lable">
								OPTION
							</label>
						</el-col>

						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<label class="block font-bold text-md input-lable">
								POINTS
							</label>
						</el-col>
					</el-row>

					<el-row
						:gutter="10"
						v-for="(option, index) in radio_options"
						:key="index"
						class="mb-4"
					>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<el-input
								v-model="option.label"
								:placeholder="`Add option ${index + 1}`"
								size="small"
								style="width: 100%"
							>
							</el-input>
						</el-col>

						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
							<div class="flex items-center">
								<el-input
									v-model="option.num_value"
									:placeholder="`Add point ${index + 1}`"
									size="small"
									style="width: 60%"
								>
								</el-input>

								<div>
									<i
										class="el-icon-delete cursor-pointer ml-2 default-icon"
										@click="deleteRadioOption(index)"
									></i>
								</div>
							</div>
						</el-col>
					</el-row>

					<div class="mt-2">
						<el-button
							class="submit-btn mt-2"
							size="mini"
							@click="addMoreOptionsToChecklist()"
							>ADD MORE</el-button
						>
					</div>
				</div>

				<span
					slot="footer"
					class="dialog-footer flex"
					style="justify-content: flex-end"
				>
					<el-button
						class="cancel-btn"
						style="width: 100px"
						size="mini"
						@click="add_radio_options_dialog_visibility = false"
					>
						Cancel
					</el-button>

					<el-button
						class="submit-btn"
						style="width: 100px"
						size="mini"
						:loader="is_comment_updating"
						@click="addRadioOptions()"
					>
						Update
					</el-button>
				</span>
			</el-dialog>

			<!-- Task report details dialog -->
			<el-dialog
				:visible.sync="task_report_detail_show"
				:close-on-click-modal="true"
				width="95%"
				top="0"
				custom-class="customClass"
				:lock-scroll="true"
				:show-close="true"
			>
				<div class="tab">
					<el-card class="box-card">
						<div style="padding: 0 20px 0 20px" class="text-left">
							<el-button
								icon="el-icon-back"
								class="submit-btn"
								size="mini"
								@click="
									task_report_detail_show = false;
									resetAllTaskReportFilters();
								"
							>
								Back
							</el-button>
						</div>

						<div
							style="padding: 30px 20px"
							v-loading="is_task_report_list_loading"
						>
							<div class="my-2">
								<!-- Category Wise CSV -->
								<div
									v-if="task_report_type == 'category'"
									class="text-right px-2"
								>
									<el-button
										class="submit-btn"
										icon="el-icon-download"
										size="small"
										@click="downloadTaskCategoryReport"
										>Download Reports</el-button
									>
								</div>
								<!-- ./Category Wise CSV -->
								<!-- Employee Wise CSV -->
								<div
									v-if="task_report_type == 'employee'"
									class="text-right px-2"
								>
									<el-button
										class="submit-btn"
										icon="el-icon-download"
										size="small"
										@click="downloadTaskEmployeeReport"
										>Download Reports</el-button
									>
								</div>
								<!-- ./Employee Wise CSV -->
								<!-- Task Wise CSV -->
								<div v-if="task_report_type == 'task'" class="text-right px-2">
									<el-button
										class="submit-btn"
										icon="el-icon-download"
										size="small"
										@click="downloadTaskWiseReport"
										>Download Reports</el-button
									>
								</div>
								<!-- ./Task Wise CSV -->
								<!-- Step Wise CSV -->
								<div
									v-if="task_report_type == 'subtask'"
									class="text-right px-2"
								>
									<el-button
										class="submit-btn"
										icon="el-icon-download"
										size="small"
										@click="downloadStepWiseReport"
										>Download Reports</el-button
									>
								</div>
								<!-- ./Step Wise CSV -->
								<el-breadcrumb
									v-if="task_report_breadcrumb_elements.length > 0"
									separator-class="el-icon-arrow-right"
								>
									<el-breadcrumb-item>
										<span
											class="link-text"
											style="color: #d26300; text-transform: capitalize"
											@click="
												task_report_detail_show = false;
												resetAllTaskReportFilters();
											"
											>Task</span
										>
									</el-breadcrumb-item>
									<el-breadcrumb-item
										v-for="(item, index) in task_report_breadcrumb_elements"
										:key="'task-report-breadcrumb-item-' + index"
									>
										<span
											:class="
												task_report_breadcrumb_elements.length - 1 == index
													? ''
													: 'link-text'
											"
											:style="
												task_report_breadcrumb_elements.length - 1 == index
													? 'text-transform: capitalize;'
													: 'color: #d26300; text-transform: capitalize;'
											"
											@click="
												handleTaskReportBreadcrumb(item.title, index);
												resetAllTaskReportFilters();
											"
											>{{ item.title }}</span
										>
									</el-breadcrumb-item>
								</el-breadcrumb>
							</div>
							<table
								v-if="task_report_type == 'employee'"
								class="task-table mt-2"
							>
								<thead>
									<tr>
										<!-- <th>EMP ID</th> -->
										<th>
											EMPLOYEE NAME
											<el-popover placement="right" trigger="click">
												<el-input
													v-model="searched_task_report_employee_name"
													size="mini"
													placeholder="Search Employee"
												></el-input>
												<div
													style="
														max-height: 250px;
														overflow: auto;
														margin-top: 10px;
													"
												>
													<el-checkbox-group
														v-model="selected_task_report_employee_names"
													>
														<template
															v-if="
																taskReportEmployees &&
																taskReportEmployees.length
															"
														>
															<el-checkbox
																v-for="(
																	employee, index
																) in taskReportEmployees.filter(
																	(data) =>
																		!searched_task_report_employee_name ||
																		data
																			.toLowerCase()
																			.includes(
																				searched_task_report_employee_name.toLowerCase()
																			)
																)"
																:key="index"
																class="mb-2 checkbox-lable"
																:label="employee"
																style="display: block"
															></el-checkbox>
														</template>
													</el-checkbox-group>
												</div>
												<div class="flex justify-between mt-4">
													<span
														class="text-xs cursor-pointer primary-theme-color"
														@click="selectAllTaskReportsEmployees()"
														>Select all</span
													>
													<span
														class="text-xs cursor-pointer"
														@click="resetSelectedTaskReportsEmployees()"
														>Reset</span
													>
												</div>
												<span slot="reference">
													<img
														src="../../../../../src/assets/images/filter-icon.png"
														width="9"
														class="cursor-pointer"
													/>
												</span>
											</el-popover>
										</th>
										<th>
											TOTAL
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_total_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportTotalAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportTotalDescending"
												></i>
											</span>
										</th>
										<th>
											COMPLETED
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_completed_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportCompletedAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportCompletedDescending"
												></i>
											</span>
										</th>
										<th>
											INCOMPLETE
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_incomplete_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportIncompleteAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportIncompleteDescending"
												></i>
											</span>
										</th>
										<th>
											COMPLETION RATE
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_completion_rate_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportCompletionRateAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportCompletionRateDescending"
												></i>
											</span>
										</th>
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<template v-if="filteredTaskReportEmployees.length > 0">
										<tr
											v-for="(item, index) in filteredTaskReportEmployees"
											:key="'task-report-emp-' + index"
										>
											<td>{{ item.name }}</td>
											<td>{{ item.total }}</td>
											<td>{{ item.completed }}</td>
											<td>{{ item.incomplete }}</td>
											<td>{{ item.completion_rate }}%</td>
											<td>
												<span
													style="
														color: #d26300;
														text-decoration: underline;
														cursor: pointer;
													"
													@click="
														getTaskEmployeeTasksData(item.basics, item.name);
														resetAllTaskReportFilters();
													"
													>View Details</span
												>
											</td>
										</tr>
									</template>
									<tr v-else>
										<td colspan="7">NO DATA AVAILABLE</td>
									</tr>
								</tbody>
							</table>

							<table
								v-if="task_report_type == 'category'"
								class="task-table mt-2"
							>
								<thead>
									<tr>
										<th>
											CATEGORY
											<el-popover placement="right" trigger="click">
												<el-input
													v-model="searched_task_report_category"
													size="mini"
													placeholder="Search Category"
												></el-input>
												<div
													style="
														max-height: 250px;
														overflow: auto;
														margin-top: 10px;
													"
												>
													<el-checkbox-group
														v-model="selected_task_report_categories"
													>
														<template
															v-if="
																taskReportCategories &&
																taskReportCategories.length
															"
														>
															<el-checkbox
																v-for="(
																	category, index
																) in taskReportCategories.filter(
																	(data) =>
																		!searched_task_report_category ||
																		data
																			.toLowerCase()
																			.includes(
																				searched_task_report_category.toLowerCase()
																			)
																)"
																:key="index"
																class="mb-2 checkbox-lable"
																:label="category"
																style="display: block"
															></el-checkbox>
														</template>
													</el-checkbox-group>
												</div>
												<div class="flex justify-between mt-4">
													<span
														class="text-xs cursor-pointer primary-theme-color"
														@click="selectAllTaskReportCategories()"
														>Select all</span
													>
													<span
														class="text-xs cursor-pointer"
														@click="resetAllSelectedTaskReportCategories()"
														>Reset</span
													>
												</div>
												<span slot="reference">
													<img
														src="../../../../../src/assets/images/filter-icon.png"
														width="9"
														class="cursor-pointer"
													/>
												</span>
											</el-popover>
										</th>
										<th>
											INTERMEDIATE CATEGORY
											<el-popover placement="right" trigger="click">
												<el-input
													v-model="searched_task_report_intermediate_category"
													size="mini"
													placeholder="Search Intermediate Category"
												></el-input>
												<div
													style="
														max-height: 250px;
														overflow: auto;
														margin-top: 10px;
													"
												>
													<el-checkbox-group
														v-model="
															selected_task_report_intermediate_categories
														"
													>
														<template
															v-if="
																taskReportIntermediateCategories &&
																taskReportIntermediateCategories.length
															"
														>
															<el-checkbox
																v-for="(
																	category, index
																) in taskReportIntermediateCategories.filter(
																	(data) =>
																		!searched_task_report_intermediate_category ||
																		data
																			.toLowerCase()
																			.includes(
																				searched_task_report_intermediate_category.toLowerCase()
																			)
																)"
																:key="index"
																class="mb-2 checkbox-lable"
																:label="category"
																style="display: block"
															></el-checkbox>
														</template>
													</el-checkbox-group>
												</div>
												<div class="flex justify-between mt-4">
													<span
														class="text-xs cursor-pointer primary-theme-color"
														@click="selectAllTaskReportIntermediateCategories()"
														>Select all</span
													>
													<span
														class="text-xs cursor-pointer"
														@click="
															resetAllSelectedTaskReportIntermediateCategories()
														"
														>Reset</span
													>
												</div>
												<span slot="reference">
													<img
														src="../../../../../src/assets/images/filter-icon.png"
														width="9"
														class="cursor-pointer"
													/>
												</span>
											</el-popover>
										</th>
										<th>
											TOTAL
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_total_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportTotalAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportTotalDescending"
												></i>
											</span>
										</th>
										<th>
											COMPLETED
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_completed_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportCompletedAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportCompletedDescending"
												></i>
											</span>
										</th>
										<th>
											INCOMPLETE
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_incomplete_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportIncompleteAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportIncompleteDescending"
												></i>
											</span>
										</th>
										<th>
											COMPLETION RATE
											<span slot="reference" class="cursor-pointer">
												<i
													v-if="sort_by_task_report_completion_rate_descending"
													class="el-icon-caret-top"
													style="font-size: 12px"
													@click="sortByTaskReportCompletionRateAscending"
												></i>
												<i
													v-else
													class="el-icon-caret-bottom"
													style="font-size: 12px"
													@click="sortByTaskReportCompletionRateDescending"
												></i>
											</span>
										</th>
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<template v-if="filteredTaskReportCategories.length > 0">
										<tr
											v-for="(item, index) in filteredTaskReportCategories"
											:key="'task-report-emp-' + index"
										>
											<td>{{ item.name }}</td>
											<td>{{ item.intermediate_category_name }}</td>
											<td>{{ item.total }}</td>
											<td>{{ item.completed == "-" ? 0 : item.completed }}</td>
											<td>{{ item.total - item.completed }}</td>
											<td>
												{{
													item.completion_rate == "-"
														? "0%"
														: item.completion_rate + "%"
												}}
											</td>
											<td>
												<span
													style="
														color: #d26300;
														text-decoration: underline;
														cursor: pointer;
													"
													@click="
														getTaskCategoryTasksData(item.basics, item.name);
														resetAllTaskReportFilters();
													"
													>View Details</span
												>
											</td>
										</tr>
									</template>
									<tr v-else>
										<td colspan="7">NO DATA AVAILABLE</td>
									</tr>
								</tbody>
							</table>

							<div style="position: relative; overflow: hidden">
								<div
									v-if="task_report_type == 'task'"
									class="table-outer event-table"
									style="min-width: 1000px; margin-left: 150px"
								>
									<table class="task-table report-tbl-inner mt-2">
										<thead>
											<tr>
												<th class="fixed-div" style="left: 0px; width: 150px">
													TASK&nbsp;
													<el-popover placement="right" trigger="click">
														<el-input
															v-model="searched_task_report_task"
															size="mini"
															placeholder="Search Task"
														></el-input>
														<div
															style="
																max-height: 250px;
																overflow: auto;
																margin-top: 10px;
															"
														>
															<el-checkbox-group
																v-model="selected_task_report_task"
															>
																<template
																	v-if="
																		taskReportTaskLists &&
																		taskReportTaskLists.length
																	"
																>
																	<el-checkbox
																		v-for="(
																			task, index
																		) in taskReportTaskLists.filter(
																			(data) =>
																				!searched_task_report_task ||
																				data
																					.toLowerCase()
																					.includes(
																						searched_task_report_task.toLowerCase()
																					)
																		)"
																		:key="index"
																		class="mb-2 checkbox-lable"
																		:label="task"
																		style="display: block"
																	></el-checkbox>
																</template>
															</el-checkbox-group>
														</div>
														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllTaskReportTasks()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetAllSelectedTaskReportTasks()"
																>Reset</span
															>
														</div>
														<span slot="reference">
															<img
																src="../../../../../src/assets/images/filter-icon.png"
																width="9"
																class="cursor-pointer"
															/>
														</span>
													</el-popover>
												</th>
												<th
													class=""
													:style="[
														all_task_report_dates.length > 10
															? { width: '110px' }
															: {
																	width:
																		100 / all_task_report_dates.length + '%',
															  },
													]"
												>
													FREQUENCY
													<el-popover placement="right" trigger="click">
														<el-input
															v-model="searched_task_report_frequency"
															size="mini"
															placeholder="Search Frequency"
														></el-input>
														<div
															style="
																max-height: 250px;
																overflow: auto;
																margin-top: 10px;
															"
														>
															<el-checkbox-group
																v-model="selected_task_report_frequency"
															>
																<template
																	v-if="
																		taskReportFrequency &&
																		taskReportFrequency.length
																	"
																>
																	<el-checkbox
																		v-for="(
																			task, index
																		) in taskReportFrequency.filter(
																			(data) =>
																				!searched_task_report_frequency ||
																				data
																					.toLowerCase()
																					.includes(
																						searched_task_report_frequency.toLowerCase()
																					)
																		)"
																		:key="index"
																		class="mb-2 checkbox-lable"
																		:label="task"
																		style="display: block"
																	></el-checkbox>
																</template>
															</el-checkbox-group>
														</div>
														<div class="flex justify-between mt-4">
															<span
																class="text-xs cursor-pointer primary-theme-color"
																@click="selectAllTaskReportFrequency()"
																>Select all</span
															>
															<span
																class="text-xs cursor-pointer"
																@click="resetAllSelectedTaskReportFrequency()"
																>Reset</span
															>
														</div>
														<span slot="reference">
															<img
																src="../../../../../src/assets/images/filter-icon.png"
																width="9"
																class="cursor-pointer"
															/>
														</span>
													</el-popover>
												</th>
												<th
													v-for="(i, index) in all_task_report_dates"
													:key="index + new Date().getTime() * 10"
													:style="[
														all_task_report_dates.length > 10
															? { width: '110px' }
															: {
																	width:
																		100 / all_task_report_dates.length + '%',
															  },
													]"
												>
													{{ i | formatReportDate }}
												</th>
											</tr>
										</thead>

										<tbody>
											<tr
												v-for="(item, index) in taskReportTasks"
												:key="'task-report-emp-' + index"
											>
												<td
													class="fixed-div fonts-bold"
													style="
														left: 0px;
														width: 150px;
														text-decoration: underline;
														cursor: pointer;
													"
													@click="
														openTaskReportSubTask(item.basics, item.name);
														resetAllTaskReportFilters();
													"
												>
													{{ item.name }}
												</td>
												<td
													class=""
													:style="[
														all_task_report_dates.length > 10
															? { width: '110px' }
															: {
																	width:
																		100 / all_task_report_dates.length + '%',
															  },
													]"
												>
													{{
														item.records
															? item.records.length
																? item.records[item.records.length - 1]
																	? item.records[item.records.length - 1]
																			.frequency
																		? item.records[item.records.length - 1]
																				.frequency
																		: "-"
																	: "-"
																: "-"
															: "-"
													}}
												</td>
												<td
													v-for="(
														i, indexTaskReportDate
													) in all_task_report_dates"
													:key="
														'task-report-date-column-' + indexTaskReportDate
													"
													:style="[
														all_task_report_dates.length > 10
															? { width: '110px' }
															: {
																	width:
																		100 / all_task_report_dates.length + '%',
															  },
													]"
												>
													<span
														v-html="compareTaskReportDateTime(i, item.records)"
													></span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							<div
								v-if="task_report_type == 'subtask'"
								class="table-outer task-table-outer event-table task-query"
							>
								<table class="task-table report-tbl-inner mt-2">
									<thead>
										<tr>
											<th class="task-fix-div fix-div" style="width: 200px">
												SUBTASK&nbsp;
												<el-popover placement="right" trigger="click">
													<el-input
														v-model="searched_task_report_sub_task"
														size="mini"
														placeholder="Search Sub Task"
													></el-input>
													<div
														style="
															max-height: 250px;
															overflow: auto;
															margin-top: 10px;
														"
													>
														<el-checkbox-group
															v-model="selected_task_report_sub_task"
														>
															<template
																v-if="
																	taskReportSubTask && taskReportSubTask.length
																"
															>
																<el-checkbox
																	v-for="(
																		sub_task, index
																	) in taskReportSubTask.filter(
																		(data) =>
																			!searched_task_report_sub_task ||
																			data
																				.toLowerCase()
																				.includes(
																					searched_task_report_sub_task.toLowerCase()
																				)
																	)"
																	:key="index"
																	class="mb-2 checkbox-lable"
																	:label="sub_task"
																	style="display: block"
																></el-checkbox>
															</template>
														</el-checkbox-group>
													</div>
													<div class="flex justify-between mt-4">
														<span
															class="text-xs cursor-pointer primary-theme-color"
															@click="selectAllTaskReportSubTask()"
															>Select all</span
														>
														<span
															class="text-xs cursor-pointer"
															@click="resetAllSelectedTaskReportSubTask()"
															>Reset</span
														>
													</div>
													<span slot="reference">
														<img
															src="../../../../../src/assets/images/filter-icon.png"
															width="9"
															class="cursor-pointer"
														/>
													</span>
												</el-popover>
											</th>

											<th
												v-for="(i, index) in subtasks_reports_dates"
												:key="index + new Date().getTime() * 10"
												:style="[
													subtasks_reports_dates.length > 10
														? { width: '110px' }
														: {
																width:
																	100 / subtasks_reports_dates.length + '%',
														  },
												]"
											>
												{{ i | formatReportDate }}
											</th>
										</tr>
									</thead>

									<tbody>
										<template v-if="taskReportSubTaskList.length > 0">
											<tr
												v-for="(item, index) in taskReportSubTaskList"
												:key="'task-report-emp-' + index"
											>
												<td class="task-fix-div fix-div" style="width: 200px">
													<div
														style="text-transform: capitalize"
														v-html="item.name"
													></div>
													<div
														v-if="
															(item.num_value_min != 0 ||
																item.num_value_max != 0) &&
															item.num_value_min != '' &&
															item.num_value_max != '' &&
															item.num_value_min != null &&
															item.num_value_max != null
														"
													>
														({{ item.num_value_min }}&deg; C to
														{{ item.num_value_max }}&deg; C)
													</div>
												</td>

												<td
													v-for="(
														i, indexSubTaskReportDates
													) in subtasks_reports_dates"
													:key="
														'task-report-date-column-' + indexSubTaskReportDates
													"
													:style="[
														subtasks_reports_dates.length > 10
															? { width: '110px' }
															: {
																	width:
																		100 / subtasks_reports_dates.length + '%',
															  },
													]"
												>
													<template
														v-if="item.records[0].subtask_type == 'image'"
													>
														<template
															v-if="checkIfTaskIsCompleted(item.records, i)"
														>
															<div class="mt-2">
																<i
																	style="color: #67c23a"
																	class="text-base el-icon-success"
																></i>
															</div>
														</template>
														<template v-else>
															<div class="mt-2">
																<i
																	style="color: #f56c6c"
																	class="text-base el-icon-error"
																></i>
															</div>
														</template>
													</template>
													<template
														v-if="checkIfTaskIsCompleted(item.records, i)"
													>
														<div v-html="getTaskValue(item.records, i)"></div>
													</template>
													<template v-else>
														<div class="mt-2">-</div>
													</template>
													<template v-if="checkIfDateHasImage(item.records, i)">
														<div class="mt-2">
															<span
																style="
																	cursor: pointer;
																	text-decoration: underline;
																"
																@click="openAttachmentsModal(item.records, i)"
																>View Image</span
															>
														</div>
													</template>
													<template
														v-if="checkIfDateHasComment(item.records, i)"
													>
														<div class="mt-2">
															<span
																style="
																	cursor: pointer;
																	text-decoration: underline;
																"
																@click="openCommentModal(item.records, i)"
																>View Comment</span
															>
														</div>
													</template>
												</td>
											</tr>
										</template>

										<tr v-else>
											<td colspan="7">NO DATA AVAILABLE</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</el-card>
				</div>
			</el-dialog>
			<!-- ./Task report details dialog -->

			<!-- Task Report Image Modal -->
			<el-dialog
				:visible.sync="showTaskReportsImageModal"
				:close-on-click-modal="true"
				width="90%"
				top="0"
				custom-class="customClass image_modal_task_reports"
				:lock-scroll="true"
				:show-close="true"
				:fullscreen="true"
				:before-close="resetImageModal"
			>
				<span slot="title"></span>
				<div style="padding: 0 20px 0 20px" class="text-left">
					<el-button
						icon="el-icon-back"
						class="submit-btn"
						size="mini"
						@click="
							showTaskReportsImageModal = false;
							taskReportsImgArr = [];
						"
					>
						Back
					</el-button>
				</div>

				<div style="padding: 30px 20px">
					<div v-if="taskReportsImgArr.length == 0" style="text-align: center">
						<p>No image available</p>
					</div>
					<div v-else>
						<el-row :gutter="20">
							<el-col
								v-for="(item, indexTaskReportImage) in taskReportsImgArr"
								:key="'task-item-image-' + indexTaskReportImage"
								:xs="8"
								:sm="8"
								:md="8"
								:lg="8"
								:xl="8"
							>
								<img :src="item" style="width: 100%" />
							</el-col>
						</el-row>
					</div>
				</div>
			</el-dialog>
			<!-- ./Task Report Image Modal -->

			<!-- Task Report Comment Modal -->
			<el-dialog
				:visible.sync="showTaskReportsCommentModal"
				:close-on-click-modal="true"
				width="90%"
				top="0"
				custom-class="customClass comment_modal_task_reports"
				:lock-scroll="true"
				:show-close="true"
				:fullscreen="true"
			>
				<span slot="title"></span>
				<div style="padding: 0 20px 0 20px" class="text-left">
					<el-button
						icon="el-icon-back"
						class="submit-btn"
						size="mini"
						@click="showTaskReportsCommentModal = false"
					>
						Back
					</el-button>
				</div>
				<div style="padding: 30px 20px">
					<el-row :gutter="20">
						<el-col
							v-if="taskReportsImageComment"
							:xs="24"
							:sm="24"
							:md="24"
							:lg="24"
							:xl="24"
						>
							<p class="mt-4">{{ taskReportsImageComment }}</p>
						</el-col>
					</el-row>
				</div>
			</el-dialog>
			<!-- ./Task Report Comment Modal -->
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "../../../../eventBus";
import LabourPalnningService from "../../../../services/labourPalnningService";
import moment from "moment";
import BaseLocationsDropdown from "../../../baseLocationsDD/BaseLocationsDD.vue";
import BaseLocationsSingleSelect from "../../../baseLocationSingleSelect/BaseLocationSingleSelect.vue";
import { CommonMixin } from "../../../../../mixins/common.mixin";
import { serverAddr, serverAddrForCSV } from "../../../../networkConfig";
import LocationInsightsGraph from "./locationInsights/LocationInsightsGraph.vue";
import CategoryInsightsGraph from "./categoryInsights/categoryInsights.vue";
import StepsInsightsGraph from "./stepsInsights/stepsInsights.vue";
import exportFromJSON from "export-from-json";
import MissingLog from "./missingLogs/missingLog.vue";
import TaskSkeletonLoader from "./taskSkeletonLoader.vue";
import TaskDashboardFilter from "./TaskComponents/TaskDashboardFilter.vue";
export default {
	name: "Tasks",
	components: {
		BaseLocationsDropdown,
		TaskSkeletonLoader,
		BaseLocationsSingleSelect,
		"location-insights-graph": LocationInsightsGraph,
		"category-insights-graph": CategoryInsightsGraph,
		"steps-insights-graph": StepsInsightsGraph,
		"missing-log": MissingLog,
		TaskDashboardFilter,
	},

	filters: {
		date_filter(date) {
			if (date) {
				return moment(date).format("DD/MM");
			}
		},
		day_filter(date) {
			if (date) {
				return moment(date).format("LLLL").slice(0, 3);
			}
		},
		formatDate(date) {
			if (date) {
				let d = new Date(date);
				return moment(d).format("ddd,Do MMM YYYY,h:mm A");
			}
		},
		formatReportDate(date) {
			if (date) {
				let d = new Date(date);
				return moment(d).format("Do MMM YYYY");
			}
		},
	},

	mixins: [CommonMixin],

	data() {
		return {
			isDomLoading: true,
			activeTabLink: "INSIGHTS",
			date: moment().format("YYYY-MM-DD"), //set yesterday's date
			to_date: moment(
				new Date(new Date().setDate(new Date().getDate() - 1))
			).format("YYYY-MM-DD"), //set yesterday's date

			delete_task_confirmation_dialog: false,
			create_task_dialog_visible: false,
			assign_task_dialog_visible: false,

			error_on_empty_fields: false,

			is_tasks_list_loading: false,
			is_emp_list_loading: false,
			is_edit_task_loading: false,
			is_create_task_loading: false,

			select_outlet: "",

			is_function_field_is_empty: false,
			assigned_tasks_list: [],
			unassigned_tasks_list: [],
			task_assigned_store_filter_options: [],
			task_fun_filter_options: [],
			task_repeat_options: [],
			task_assigners_filter_options: [],
			applicable_store_filter_options: [],
			task_createdby_filter_options: [],
			employees_for_tasks: [],

			emp_filter_options: [],
			task_status_filter_options: [],

			search_emp_name: "",
			search_by_tasks_title: "",

			store_name: [],
			function_name: [],

			selected_main_category: "",
			selected_category: "",
			main_category_list: [
				{
					name: "Competition",
					value: "cleanliness",
				},
				{
					name: "Audit",
					value: "audit",
				},
				{
					name: "Tasks",
					value: "other",
				},
			],
			category_list: [],
			add_new_category_dialog: false,
			is_category_list_loading: false,
			add_category_list: [],
			select_store_name: "",
			select_function: [],
			task_category: "",
			description: "",
			select_task: "",
			selected_task_id: "",
			assignTask_empList: [],
			isSelectedLocationRegion: false,
			selected_assignTaskemp: "",
			assignTask_storeList: [],
			selected_assignTaskStore: [],

			assignTask_start_date: moment().format("YYYY-MM-DD"),
			assignTask_end_date: moment().format("YYYY-MM-DD"),
			datePickerOptionsAt: {
				disabledDate: this.disabledDueDateAt,
				firstDayOfWeek: 1,
			},

			start_time: "",
			end_time: "",
			impact_operations: "no",
			select_week: "",
			firstdays: "",
			lastdays: "",
			filter_: {
				id: "",
				location: "",
				location_id: "",
			},
			dateRangeOptions: {
				firstDayOfWeek: 1,
			},
			customDateFormat: "",
			daysOfWeek: [],
			store_list: [],
			check_list_for_assign_task: [],
			check_list: [
				{
					label: "",
					serial_no: 1,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					image_mandatory: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
				},
				{
					label: "",
					serial_no: 2,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					image_mandatory: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
				},
			],
			time_task_list: [
				{
					start_time: "",
					end_time: "",
				},
			],
			task_list: [],
			employee_list: [],

			check_list_type: [
				{
					title: "Checklist",
					value: "checklist",
				},
				{
					title: "Yes / No",
					value: "yes_no",
				},
				{
					title: "Temperature",
					value: "temperature",
				},
				{
					title: "TPM",
					value: "tpc",
				},
				{
					title: "Number",
					value: "number",
				},
				{
					title: "Text",
					value: "text",
				},
				{
					title: "Date / Time",
					value: "datetime",
				},
				{
					title: "Rating",
					value: "rating",
				},
				{
					title: "Image",
					value: "image",
				},
				{
					title: "Scoring",
					value: "scoring",
				},
				{
					title: "Select any one",
					value: "radio_options",
				},
			],

			task_assign_type: "auto",

			repeat_frequency: "one_time",
			frequency_list: [
				{
					title: "One Time",
					value: "one_time",
				},
				{
					title: "Daily",
					value: "daily",
				},
				{
					title: "Weekly",
					value: "weekly",
				},
				{
					title: "Monthly",
					value: "monthly",
				},
			],

			weekly_frequency: [],
			weekly_frequency_list: [
				{
					title: "Monday",
					value: "monday",
				},
				{
					title: "Tuesday",
					value: "tuesday",
				},
				{
					title: "Wednesday",
					value: "wednesday",
				},
				{
					title: "Thursday",
					value: "thursday",
				},
				{
					title: "Friday",
					value: "friday",
				},
				{
					title: "Saturday",
					value: "saturday",
				},
				{
					title: "Sunday",
					value: "sunday",
				},
			],

			monthly_frequency: [],

			taskDuration: null,
			taskDurations: [],
			assignedCount: 0,
			frequency: null,
			disableFrequencyOptions: null,
			loc_selected: [],
			filters: {},
			task_id: "",
			assigned_emp: [],
			delete_id: "",
			edit_task_dialog_visible: false,
			selected_assigned_task: {
				atloyee: "",
				start_time: "",
				end_time: "",
				description: "",
				due_date: "",
				outlet_name: "",
				checklist: "",
				task_status: "",
				assigned_by: "",
				task_obj_id: "",
				task_id: "",
				task_name: "",
				created_date: "",
				impact_operation: "",
				marked_as_completed: false,
				selected_action: "",
				file_list: "",
			},
			is_steps_toggled: false,
			file_list: [],
			functions_list: [],
			selected_function: "",
			moment: moment,

			sort_by_ascending_date: false,
			sort_by_descending_date: false,

			selected_store_list: [],
			storeActiveFilter: false,

			selected_function_list: [],
			functionActiveFilter: false,

			selected_repeat_list: [],
			repeatActiveFilter: false,

			selected_created_list: [],
			createdActiveFilter: false,

			selected_assigned_by_list: [],
			assignedByActiveFilter: false,

			selected_applicable_store: [],
			applicableStoreActiveFilter: false,

			selected_emp_list: [],
			empActiveFilter: false,

			selected_status_list: [],
			statusActiveFilter: false,

			// reports letiables
			viewList: [
				{
					name: "Week To Date",
					id: "wtd",
					isDisabled: false,
				},
				{
					name: "Month To Date",
					id: "mtd",
					isDisabled: false,
				},
				{
					name: "Year To Date",
					id: "ytd",
					isDisabled: false,
				},
				{
					name: "Custom Date",
					id: "customDt",
					isDisabled: false,
				},
			],
			selectedCountry: [],
			user_access_level: "",
			view: "wtd",
			task_view: "wtd",
			datePickerOptions: {
				disabledDate: this.disabledDueDate,
				firstDayOfWeek: 1,
			},
			disabledStartDate: {
				disabledDate: this.disabledToDate,
				firstDayOfWeek: 1,
			},
			fromDate: "",
			toDate: "",
			task_from_date: "",
			task_to_date: "",
			breadcrumbs: [
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
			],
			task_breadcrumbs: [
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
			],
			is_report_list_loading: false,
			table_data: [],
			topReportData: [],
			nameHeader: "region",
			firstNameHeader: "country",
			reportSummary: {},
			reportDetailsSummary: {},
			subtaskReportSummary: {},
			basics: "",
			dialog_visible: false,
			dialog_visible_for_steps_report: false,
			date_list: [],
			date_list_for_sub_step: [],
			date_wise_report: [],
			selected_subtask_report: [],
			selectedTitle: "",
			selected_sub_task: {},
			empNameArray: [],
			empIdArray: [],
			frequencyFilArray: [],
			task_array: [],
			sub_task_array: [],
			selected_emp_id: [],
			selected_emp_name: [],
			selected_frequency: [],
			selected_filter_task: [],
			activeFilter: false,
			activeFilterId: false,
			activeFilterTask: false,
			activeFilterFreq: false,
			sort_by_ascending_rank: true,
			sort_by_descending_rank: false,
			sort_by_ascending_rank_for_area_lead: true,
			sort_by_descending_rank_for_area_lead: false,
			sort_by_ascending_task_assigned: false,
			sort_by_descending_task_assigned: false,
			sort_by_ascending_completed: false,
			sort_by_descending_completed: false,
			sort_by_ascending_points_achieved: true,
			sort_by_descending_points_achieved: false,
			sort_by_ascending_comp_rate: false,
			sort_by_descending_comp_rate: true,
			sort_by_ascending_audit_report_points_available: false,
			sort_by_descending_audit_report_points_available: false,
			sort_by_ascending_audit_report_points_achieved: false,
			sort_by_descending_audit_report_points_achieved: false,
			sort_by_ascending_audit_report_percentage: false,
			sort_by_descending_audit_report_percentage: false,
			sort_by_ascending_task_report_task_assigned: false,
			sort_by_descending_task_report_task_assigned: false,
			sort_by_ascending_task_report_task_completed: false,
			sort_by_descending_task_report_task_completed: false,
			sort_by_ascending_task_report_task_incomplete: false,
			sort_by_descending_task_report_task_incomplete: false,
			sort_by_ascending_task_report_task_completion_rate: false,
			sort_by_descending_task_report_task_completion_rate: true,
			pageInfo: {
				currentPage: 1,
				totalCount: 0,
				pageSize: 5,
				search: "",
			},
			selectedBasicsDetails: {},
			category_types: [],
			createTaskFilters: {
				countries: [],
				regions: [],
				subregions: [],
				outlets: [],
			},
			designationList: [],
			selectedDesignation: [],
			selectedDesignationForAssignTask: "",
			isOutlet: false,
			imageData: [],
			current_image: "",
			current_image_path: "",
			current_image_list: [],
			image_dialog_visible: false,
			is_image_loading: false,
			selected_task_freq: "",
			selected_task_days: [],
			for_empty_report_obj: {},
			task_preview_dialog: false,
			task_preview: {},
			search_task_list: [],
			tasks_by_location_list: [],
			is_tasks_are_loading: false,
			is_task_deactivated: false,
			is_task_in_progress: false,
			is_task_submitted: false,
			active_assigned_task_category: {
				name: "",
				id: "",
			},
			active_unassigned_task_category: "",
			assigned_task_category_names: [],
			unassigned_task_category_names: [],
			task_rank: {},
			is_task_progress_loading: false,
			selected_report: {},
			is_datewise_reports_loading: false,
			is_datewise_steps_reports_loading: false,
			selected_sub_task_filter_task: [],
			selected_location_filter: [],
			location_array: [],
			locations_for_area_lead: [],
			rem_lead_reportable_data: [],
			locations_for_rem_lead: [],
			search_location: "",
			points_calculation_method: "by_steps",
			expected_value: "yes",
			total_points: "",
			deduction_type: "no",
			deduction_method: "percentage",
			selected_locations_for_nomination: [],
			enable_nomination: false,
			is_nomaination_processing: false,
			add_reports_comment: "",
			add_comment_dialog: false,
			is_comment_updating: false,
			selected_report_index: "",
			area_lead_reportable_data: [],
			user_designation: localStorage.getItem("designation"),
			selected_location_filter_for_area_lead: [],
			search_location_for_area_lead: "",
			selected_designation: "",
			toogle_summary: false,
			audit_summary_list: {
				deduction: [],
				deduction_summary: {},
				intolerable: [],
				intolerable_summary: {},
				non_deduction: [],
				non_deduction_summary: [],
				overall_score: {},
			},
			audit_reports: [],
			active_report_tab: "COMPETITION",
			is_audit_report_list_loading: false,
			search_location_for_audit: "",
			search_grade_for_audit: "",
			location_for_audit_reports: [],
			selected_location_filter_for_audit: [],
			selected_grade_filter_for_audit: [],
			checked: false,
			add_radio_options_dialog_visibility: false,
			selected_create_task_check_list_index: "",
			radio_options: [],
			main_report_category_id: "",
			if_yes_options: [],
			if_no_options: [],
			show_add_info_dialog: false,
			add_info_index: 0,
			add_info_content: "",
			selected_audit_report_outlet: {
				name: "",
				basics: "",
				current_step: false,
			},
			audit_report_categories: [],
			selected_audit_report_category: {
				name: "",
				basics: "",
				current_step: false,
			},
			audit_report_tasks: [],
			selected_audit_report_task: {
				name: "",
				basics: "",
				current_step: false,
			},
			audit_report_sub_tasks: [],
			selected_audit_report_sub_task: {
				name: "",
				basics: "",
				current_step: false,
			},
			is_task_report_list_loading: false,
			task_reports: [],
			location_for_task_reports: [],
			search_location_for_task: "",
			selected_location_filter_for_task: [],
			selected_task_reports_regions: [],
			searched_task_reports_region_name: "",
			selected_task_reports_subregions: [],
			searched_task_reports_subregion_name: "",
			task_report_detail_show: false,
			selected_task_report_dialog_title: "",
			task_report_categories: [],
			task_report_employees: [],
			task_report_type: "",
			task_report_tasks: [],
			selected_task_report_outlet: "",
			selected_task_report_category: "",
			all_task_report_dates: [],
			all_audit_report_dates: [],
			task_reports_subtasks: [],
			subtasks_reports_dates: [],
			audit_report_grades: [],
			task_report_breadcrumb_elements: [],
			taskReportsImgArr: [],
			showTaskReportsImageModal: false,
			taskReportsImageComment: "",
			showTaskReportsCommentModal: false,
			loading: false,
			audit_reports_dates: [],
			sort_by_ascending_points_available: true,
			sort_by_descending_points_available: false,
			sort_by_ascending_scoring_percentage: true,
			sort_by_descending_scoring_percentage: false,

			audit_report_date_arr: [],
			audit_sub_category_list: [],
			task_sub_category_list: [],
			selected_dropdown_category: {},
			designationListNew: [],
			task_summary_info: {},
			taskSummaryCompletionStatus: {},
			show_not_applicable: false,
			selected_audit_type: null,
			// TEST PURPOSE
			lastAuditConductedList: [],
			dashboardActiveTabLink: "audit",
			auditIntermediateCategories: [],
			taskIntermediateCategories: [],
			searched_last_audit_location: "",
			last_audit_location_total_points_order: "",
			last_audit_location_achieved_points_order: "",
			last_audit_location_percentage_points_order: "",
			last_audit_location_completion_percentage_order: "desc",
			// Last Audit Conducted By
			currentPage: 1,
			perPage: 10,
			taskDashboardSummary: {
				total: 0,
				completed: 0,
				incomplete: 0,
				in_progress: 0,
				completion_rate: 0,
			},
			logReports: [],
			logsLoading: false,
			dashboardToggle: false,
			auditReportVisibilityStatus: false,
			selectedLastAuditLocation: "",
			selectedAuditLocation: "",
			reportLoader: false,

			// Audit reports filter
			searched_audit_report_location: "",
			selected_audit_report_locations: [],
			searched_audit_report_region: "",
			selected_audit_report_regions: [],
			searched_audit_report_area_lead: "",
			selected_audit_report_area_leads: [],
			searched_audit_report_grade: "",
			selected_audit_report_grades: [],

			searched_audit_report_sub_category: "",
			selected_audit_report_sub_categories: [],
			searched_audit_report_intermediate_category: "",
			selected_audit_report_intermediate_categories: [],

			searched_audit_report_task: "",
			selected_audit_report_tasks: [],

			searched_audit_report_subtask: "",
			selected_audit_report_subtasks: [],

			// Task reports filter
			searched_task_report_employee_name: "",
			selected_task_report_employee_names: [],
			searched_task_report_category: "",
			selected_task_report_categories: [],
			searched_task_report_intermediate_category: "",
			selected_task_report_intermediate_categories: [],
			sort_by_task_report_total_ascending: false,
			sort_by_task_report_total_descending: false,
			sort_by_task_report_completed_ascending: false,
			sort_by_task_report_completed_descending: false,
			sort_by_task_report_incomplete_ascending: false,
			sort_by_task_report_incomplete_descending: false,
			sort_by_task_report_completion_rate_ascending: false,
			sort_by_task_report_completion_rate_descending: false,

			searched_task_report_task: "",
			selected_task_report_task: [],
			searched_task_report_frequency: "",
			selected_task_report_frequency: [],

			searched_task_report_sub_task: "",
			selected_task_report_sub_task: [],

			// Task Reports Pagination States
			taskReportCurrentPage: 1,
			taskReportPerPage: 10,
			task_emp_search_term: "",
			task_emp_selected_list: [],
			task_freq_search_term: "",
			task_freq_selected_list: [],
			task_time_search_term: "",
			task_time_selected_list: [],
			selected_form_template_intermediate_category: "",
			form_template_last_day_of_month: false,

			audit_reports_inner_modal: false,
		};
	},
	computed: {
		taskSubmitDisabled() {
			if (
				this.task_summary_info.total == this.task_summary_info.completed &&
				this.task_summary_info.total != 0
			) {
				if (this.taskSummaryCompletionStatus.status == "complete") {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		},
		isChecklistSelected() {
			let is_list_avaiable = "";
			for (let i = 0; i < this.check_list.length; i++) {
				if (this.check_list[i].subtask_type) {
					is_list_avaiable = true;
					break;
				}
			}
			return is_list_avaiable;
		},
		getUserAccessLevel() {
			return localStorage.getItem("user_access_level");
		},
		getUnassignedTasksListData() {
			let event_list = this.unassigned_tasks_list;
			if (this.search_by_tasks_title.length) {
				let filter_list = [];
				event_list.forEach((e) => {
					if (
						e.name
							.toLowerCase()
							.includes(this.search_by_tasks_title.toLowerCase())
					) {
						filter_list.push(e);
					}
				});
				event_list = filter_list;
			}
			if (this.selected_store_list.length) {
				event_list = event_list
					.slice()
					.filter((e) => this.selected_store_list.indexOf(e.outlet_name) > -1);
			}
			if (this.selected_repeat_list.length) {
				event_list = event_list
					.slice()
					.filter((e) => this.selected_repeat_list.indexOf(e.frequency) > -1);
			}
			if (this.selected_created_list.length) {
				event_list = event_list
					.slice()
					.filter(
						(e) => this.selected_created_list.indexOf(e.created_by_name) > -1
					);
			}
			if (this.selected_function_list.length) {
				let filter_event = [];
				for (let i = 0; i < this.selected_function_list.length; i++) {
					for (let j = 0; j < event_list.length; j++) {
						for (let k = 0; k < event_list[j].functions_info.length; k++) {
							if (
								this.selected_function_list[i] ==
								event_list[j].functions_info[k].name
							) {
								filter_event.push(event_list[j]);
							}
						}
					}
				}
				event_list = filter_event;
			}
			event_list.sort((a, b) =>
				a.outlet_name > b.outlet_name
					? 1
					: b.outlet_name > a.outlet_name
					? -1
					: 0
			);
			this.category_types = [];
			event_list.forEach((obj) => {
				if (obj.category_info != null) {
					let categories = {
						text: obj.category_info.name,
						value: obj.category_info.id,
					};
					this.category_types.push(categories);
					this.category_types = _.uniqBy(this.category_types, "text");
				}
			});
			let format_list = [];
			this.category_types.forEach((category) => {
				format_list.push({
					category_name: category.text,
					category_id: category.value,
					is_category_head: true,
				});
				event_list.forEach((listItem) => {
					if (listItem.category_info != null) {
						if (listItem.category_info.id == category.value) {
							format_list.push(listItem);
						}
					}
				});
			});
			event_list.forEach((listItem) => {
				if (listItem.category_info == null) {
					format_list.push(listItem);
				}
			});
			event_list = format_list;
			return event_list;
		},
		tasksEmployees() {
			let event_list = [...this.assigned_tasks_list];
			event_list = [
				...new Set(
					event_list.filter((el) => el.emp_name).map((el) => el.emp_name)
				),
			];
			return event_list;
		},
		tasksFrequencyList() {
			let event_list = [...this.assigned_tasks_list];
			event_list = [
				...new Set(
					event_list.filter((el) => el.frequency).map((el) => el.frequency)
				),
			];
			return event_list;
		},
		tasksTimeList() {
			let event_list = [...this.assigned_tasks_list];
			event_list = [
				...new Set(
					event_list
						.filter((el) => el.start_time && el.end_time)
						.map((el) => el.start_time + " - " + el.end_time)
				),
			];
			return event_list;
		},
		getAssignedTasksListData() {
			let event_list = this.assigned_tasks_list;
			if (this.search_emp_name.length) {
				let keys = ["emp_name", "task_name"];
				let filter_list = [];
				event_list.forEach((e) => {
					keys.forEach((a) => {
						if (
							e[a].toLowerCase().includes(this.search_emp_name.toLowerCase())
						) {
							filter_list.push(e);
						}
					});
				});
				event_list = filter_list;
			}
			if (this.selected_store_list.length) {
				event_list = event_list
					.slice()
					.filter((e) => this.selected_store_list.indexOf(e.outlet_name) > -1);
			}
			if (this.selected_assigned_by_list.length) {
				event_list = event_list
					.slice()
					.filter(
						(e) => this.selected_assigned_by_list.indexOf(e.assigned_by) > -1
					);
			}
			if (this.selected_emp_list.length) {
				event_list = event_list
					.slice()
					.filter((e) => this.selected_emp_list.indexOf(e.emp_name) > -1);
			}
			if (this.selected_applicable_store.length) {
				event_list = event_list
					.slice()
					.filter(
						(e) =>
							this.selected_applicable_store.indexOf(e.applicable_store_name) >
							-1
					);
			}
			if (this.selected_status_list.length) {
				event_list = event_list
					.slice()
					.filter((e) => this.selected_status_list.indexOf(e.task_status) > -1);
			}
			event_list.sort((a, b) =>
				a.outlet_name > b.outlet_name
					? 1
					: b.outlet_name > a.outlet_name
					? -1
					: 0
			);
			this.category_types = [];
			event_list.forEach((obj) => {
				if (obj.category != null) {
					let categories = {
						text: obj.category.name,
						value: obj.category.id,
					};
					this.category_types.push(categories);
					this.category_types = _.uniqBy(this.category_types, "text");
				}
			});
			let format_list = [];
			this.category_types.forEach((category) => {
				format_list.push({
					category_name: category.text,
					category_id: category.value,
					is_category_head: true,
				});
				event_list.forEach((listItem) => {
					if (listItem.category != null) {
						if (listItem.category.id == category.value) {
							format_list.push(listItem);
						}
					}
				});
			});
			event_list.forEach((listItem) => {
				if (listItem.category == null) {
					format_list.push(listItem);
				}
			});
			event_list = format_list;
			// Employee Filter
			if (this.activeTabLink == "TASKS" && this.task_emp_selected_list.length) {
				event_list = event_list.filter(
					(el) =>
						el.emp_name && this.task_emp_selected_list.includes(el.emp_name)
				);
			}
			// Frequency Filter
			if (
				this.activeTabLink == "TASKS" &&
				this.task_freq_selected_list.length
			) {
				event_list = event_list.filter(
					(el) =>
						el.frequency && this.task_freq_selected_list.includes(el.frequency)
				);
			}
			// Time Filter
			if (
				this.activeTabLink == "TASKS" &&
				this.task_time_selected_list.length
			) {
				event_list = event_list.filter(
					(el) =>
						el.start_time &&
						el.end_time &&
						this.task_time_selected_list.includes(
							el.start_time + " - " + el.end_time
						)
				);
			}
			return event_list;
		},

		getReportTableData: {
			get: function () {
				let event_list = JSON.parse(JSON.stringify(this.table_data));
				// Ascending descending by rank
				if (this.sort_by_ascending_rank) {
					event_list = event_list.slice().sort((a, b) => a.rank - b.rank);
				}
				if (this.sort_by_descending_rank) {
					event_list = event_list.slice().sort((a, b) => b.rank - a.rank);
				}
				if (this.selected_location_filter.length) {
					event_list = event_list
						.slice()
						.filter((e) => this.selected_location_filter.indexOf(e.name) > -1);
				}
				return event_list;
			},

			set: function (newReports) {
				this.table_data = newReports;
			},
		},

		isNominationDisabled() {
			let count = 0;
			let disabled = false;

			for (let i = 0; i < this.table_data.length; i++) {
				if (this.table_data[i].is_nomination_enabled) {
					count = count + 1;
				}
			}

			if (count > 2) {
				disabled = true;
			}

			return disabled;
		},

		getAreaLeadReportTableData: {
			get: function () {
				let event_list = JSON.parse(
					JSON.stringify(this.area_lead_reportable_data)
				);

				// Ascending decending by rank
				if (this.sort_by_ascending_rank_for_area_lead) {
					event_list = event_list.slice().sort((a, b) => a.rank - b.rank);
				}

				if (this.sort_by_descending_rank_for_area_lead) {
					event_list = event_list.slice().sort((a, b) => b.rank - a.rank);
				}

				if (this.selected_location_filter_for_area_lead.length) {
					event_list = event_list
						.slice()
						.filter(
							(e) =>
								this.selected_location_filter_for_area_lead.indexOf(e.name) > -1
						);
				}

				return event_list;
			},

			set: function (newReports) {
				this.area_lead_reportable_data = newReports;
			},

			// return event_list;
		},

		getAuditReports: {
			get() {
				let event_list = JSON.parse(JSON.stringify(this.audit_reports));

				// location filter
				if (this.selected_location_filter_for_audit.length) {
					event_list = event_list
						.slice()
						.filter(
							(e) =>
								this.selected_location_filter_for_audit.indexOf(e.name) > -1
						);
				}

				// grade filter
				if (this.selected_grade_filter_for_audit.length) {
					event_list = event_list
						.slice()
						.filter(
							(e) => this.selected_grade_filter_for_audit.indexOf(e.grade) > -1
						);
				}

				// ascending sort by points available
				if (this.sort_by_ascending_audit_report_points_available) {
					event_list = event_list
						.slice()
						.sort((a, b) => a.total_yes_no_points - b.total_yes_no_points);
				}
				// descending sort by points available
				if (this.sort_by_descending_audit_report_points_available) {
					event_list = event_list
						.slice()
						.sort((a, b) => b.total_yes_no_points - a.total_yes_no_points);
				}
				// ascending sort by points achieved
				if (this.sort_by_ascending_audit_report_points_achieved) {
					event_list = event_list
						.slice()
						.sort(
							(a, b) =>
								a.total_yes_no_points_achieved - b.total_yes_no_points_achieved
						);
				}
				// descending sort by points achieved
				if (this.sort_by_descending_audit_report_points_achieved) {
					event_list = event_list
						.slice()
						.sort(
							(a, b) =>
								b.total_yes_no_points_achieved - a.total_yes_no_points_achieved
						);
				}
				// ascending sort by percentage
				if (this.sort_by_ascending_audit_report_percentage) {
					event_list = event_list
						.slice()
						.sort(
							(a, b) => a.yes_no_points_percentage - b.yes_no_points_percentage
						);
				}
				// descending sort by points achieved
				if (this.sort_by_descending_audit_report_percentage) {
					event_list = event_list
						.slice()
						.sort(
							(a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage
						);
				}

				return event_list;
			},
			set(newReports) {
				this.audit_reports = newReports;
			},
		},
		taskReportsUniqueRegions() {
			let result = [...this.task_reports];
			result = [
				...new Set(
					result.filter((el) => el.region_name).map((el) => el.region_name)
				),
			];
			return result;
		},
		taskReportsUniqueSubRegions() {
			let result = [...this.task_reports];
			result = [
				...new Set(
					result
						.filter((el) => el.subregion_name)
						.map((el) => el.subregion_name)
				),
			];
			return result;
		},
		getTaskReports: {
			get() {
				let event_list = JSON.parse(JSON.stringify(this.task_reports));

				if (
					this.selected_location_filter_for_task &&
					this.selected_location_filter_for_task.length
				) {
					event_list = event_list.filter((e) =>
						this.selected_location_filter_for_task.includes(e.name)
					);
				}
				if (
					this.selected_task_reports_regions &&
					this.selected_task_reports_regions.length
				) {
					event_list = event_list.filter((e) =>
						this.selected_task_reports_regions.includes(e.region_name)
					);
				}
				if (
					this.selected_task_reports_subregions &&
					this.selected_task_reports_subregions.length
				) {
					event_list = event_list.filter((e) =>
						this.selected_task_reports_subregions.includes(e.subregion_name)
					);
				}

				if (this.sort_by_ascending_task_report_task_assigned) {
					event_list = event_list.sort((a, b) => a.assigned - b.assigned);
				} else if (this.sort_by_descending_task_report_task_assigned) {
					event_list = event_list.sort((a, b) => b.assigned - a.assigned);
				} else if (this.sort_by_ascending_task_report_task_completed) {
					event_list = event_list.sort((a, b) => a.completed - b.completed);
				} else if (this.sort_by_descending_task_report_task_completed) {
					event_list = event_list.sort((a, b) => b.completed - a.completed);
				} else if (this.sort_by_ascending_task_report_task_incomplete) {
					event_list = event_list.sort(
						(a, b) => a.total - a.completed - (b.total - b.completed)
					);
				} else if (this.sort_by_descending_task_report_task_incomplete) {
					event_list = event_list.sort(
						(a, b) => b.total - b.completed - (a.total - a.completed)
					);
				} else if (this.sort_by_ascending_task_report_task_completion_rate) {
					let temp = event_list.filter((el) => el.completion_rate != "-");
					temp.sort((a, b) => a.completion_rate - b.completion_rate);
					let tempTwo = event_list.filter((el) => el.completion_rate == "-");
					// event_list = event_list.sort((a, b) => a.completion_rate - b.completion_rate);
					event_list = [...temp, ...tempTwo];
				} else if (this.sort_by_descending_task_report_task_completion_rate) {
					let temp = event_list.filter((el) => el.completion_rate != "-");
					temp.sort((a, b) => b.completion_rate - a.completion_rate);
					let tempTwo = event_list.filter((el) => el.completion_rate == "-");
					// event_list = event_list.sort((a, b) => b.completion_rate - a.completion_rate);
					event_list = [...temp, ...tempTwo];
				}

				return event_list;
			},
			set(value) {
				this.task_reports = value;
			},
		},

		getDateWiseReportDetails() {
			let data_list = JSON.parse(JSON.stringify(this.date_wise_report));

			// filter tasks
			if (this.selected_filter_task.length) {
				data_list = data_list
					.slice()
					.filter((e) => this.selected_filter_task.indexOf(e.name) > -1);
			}
			return data_list;
		},
		getSelectedStepReportDetails() {
			let data_list = JSON.parse(JSON.stringify(this.selected_subtask_report));
			// filter subtask
			if (this.selected_sub_task_filter_task.length) {
				data_list = data_list
					.slice()
					.filter(
						(e) => this.selected_sub_task_filter_task.indexOf(e.name) > -1
					);
			}
			return data_list;
		},
		filterLocIds() {
			return this.loc_selected.map((obj) => obj.id);
		},
		getSelectedChecklistCount() {
			if (
				this.selected_assigned_task.checklist &&
				this.selected_assigned_task.checklist.length
			) {
				let count = 0;
				for (let i = 0; i < this.selected_assigned_task.checklist.length; i++) {
					if (this.selected_assigned_task.checklist[i].is_completed) {
						count++;
					}
				}
				return count;
			}
			return 0;
		},
		getOutletName() {
			let filtered_store = "";
			filtered_store = this.store_list.filter((e) => {
				return this.select_outlet == e.id;
			});
			return filtered_store.length ? filtered_store[0].name : "";
		},
		filteredLastAuditConductedList() {
			let audit = [...this.lastAuditConductedList];
			if (this.searched_last_audit_location) {
				audit = audit.filter((el) =>
					el.name
						.toString()
						.toLowerCase()
						.startsWith(
							this.searched_last_audit_location.toString().toLowerCase()
						)
				);
			}
			if (this.last_audit_location_total_points_order) {
				if (
					this.last_audit_location_total_points_order
						.toString()
						.toLowerCase() == "asc"
				) {
					audit.sort((a, b) => a.total_yes_no_points - b.total_yes_no_points);
				}
				if (
					this.last_audit_location_total_points_order
						.toString()
						.toLowerCase() == "desc"
				) {
					audit.sort((a, b) => b.total_yes_no_points - a.total_yes_no_points);
				}
			}
			if (this.last_audit_location_achieved_points_order) {
				if (
					this.last_audit_location_achieved_points_order
						.toString()
						.toLowerCase() == "asc"
				) {
					audit.sort(
						(a, b) =>
							a.total_yes_no_points_achieved - b.total_yes_no_points_achieved
					);
				}
				if (
					this.last_audit_location_achieved_points_order
						.toString()
						.toLowerCase() == "desc"
				) {
					audit.sort(
						(a, b) =>
							b.total_yes_no_points_achieved - a.total_yes_no_points_achieved
					);
				}
			}
			if (this.last_audit_location_percentage_points_order) {
				if (
					this.last_audit_location_percentage_points_order
						.toString()
						.toLowerCase() == "asc"
				) {
					audit.sort(
						(a, b) => a.yes_no_points_percentage - b.yes_no_points_percentage
					);
				}
				if (
					this.last_audit_location_percentage_points_order
						.toString()
						.toLowerCase() == "desc"
				) {
					audit.sort(
						(a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage
					);
				}
			}
			if (this.last_audit_location_completion_percentage_order) {
				if (
					this.last_audit_location_completion_percentage_order
						.toString()
						.toLowerCase() == "asc"
				) {
					audit.sort((a, b) => a.completion_rate - b.completion_rate);
				}
				if (
					this.last_audit_location_completion_percentage_order
						.toString()
						.toLowerCase() == "desc"
				) {
					audit.sort((a, b) => b.completion_rate - a.completion_rate);
				}
			}
			// Filters for table
			if (
				this.activeTabLink == "INSIGHTS" &&
				this.dashboardActiveTabLink == "audit"
			) {
				// location filter
				if (
					this.selected_audit_report_locations &&
					this.selected_audit_report_locations.length
				) {
					audit = audit.filter((el) =>
						this.selected_audit_report_locations.includes(el.name)
					);
				}
				// region filter
				if (
					this.selected_audit_report_regions &&
					this.selected_audit_report_regions.length
				) {
					audit = audit.filter((el) =>
						this.selected_audit_report_regions.includes(el.region_name)
					);
				}
				// area lead filter
				if (
					this.selected_audit_report_area_leads &&
					this.selected_audit_report_area_leads.length
				) {
					audit = audit.filter((el) =>
						this.selected_audit_report_area_leads.includes(el.subregion_name)
					);
				}
				// grade filter
				if (
					this.selected_audit_report_grades &&
					this.selected_audit_report_grades.length
				) {
					audit = audit.filter((el) =>
						this.selected_audit_report_grades.includes(el.grade)
					);
				}
			}
			return audit;
		},
		startnumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endnumber() {
			let end = Math.min(
				this.startnumber + this.perPage - 1,
				this.filteredLastAuditConductedList.length
			);
			return end;
		},
		auditTaskDashboardSummary() {
			return this.taskDashboardSummary;
		},
		// Audit Reports Filter Data
		auditReportLocations() {
			return [
				...new Set(
					this.lastAuditConductedList
						.filter((el) => el.name)
						.map((el) => el.name)
				),
			];
		},
		auditReportRegions() {
			return [
				...new Set(
					this.lastAuditConductedList
						.filter((el) => el.region_name)
						.map((el) => el.region_name)
				),
			];
		},
		auditReportAreaLeads() {
			return [
				...new Set(
					this.lastAuditConductedList
						.filter((el) => el.subregion_name)
						.map((el) => el.subregion_name)
				),
			];
		},
		auditReportGrades() {
			return [
				...new Set(
					this.lastAuditConductedList
						.filter((el) => el.grade)
						.map((el) => el.grade)
				),
			];
		},
		// Audit Reports Filter Data (Subcategory)
		auditReportSubCategories() {
			return [
				...new Set(
					this.audit_report_categories
						.filter((el) => el.name)
						.map((el) => el.name)
				),
			];
		},
		auditReportIntermediateCategories() {
			return [
				...new Set(
					this.audit_report_categories
						.filter((el) => el.data && el.data.length)
						.map((el) => el.data[0].intermediate_category_name)
				),
			];
		},
		// Audit Report Filter Data (Task)
		auditReportTasks() {
			return [
				...new Set(
					this.audit_report_tasks.filter((el) => el.name).map((el) => el.name)
				),
			];
		},
		// Audit Report Filter Data (Subtask)
		auditReportSubTasks() {
			return [
				...new Set(
					this.audit_report_sub_tasks
						.filter((el) => el.name)
						.map((el) => el.name)
				),
			];
		},
		// Filtered Audit Report Data
		// Category
		filteredAuditReportCategories() {
			let result = [...this.audit_report_categories];
			if (
				this.selected_audit_report_sub_categories &&
				this.selected_audit_report_sub_categories.length
			) {
				result = result.filter((el) =>
					this.selected_audit_report_sub_categories.includes(el.name)
				);
			}
			if (
				this.selected_audit_report_intermediate_categories &&
				this.selected_audit_report_intermediate_categories.length
			) {
				result = result.filter(
					(el) =>
						el.data &&
						el.data.length &&
						this.selected_audit_report_intermediate_categories.includes(
							el.data[0].intermediate_category_name
						)
				);
			}
			return result;
		},
		filteredAuditReportTasks() {
			let result = [...this.audit_report_tasks];
			if (
				this.selected_audit_report_tasks &&
				this.selected_audit_report_tasks.length
			) {
				result = result.filter((el) =>
					this.selected_audit_report_tasks.includes(el.name)
				);
			}
			return result;
		},
		filteredAuditReportSubTasks() {
			let result = [...this.audit_report_sub_tasks];
			if (
				this.selected_audit_report_subtasks &&
				this.selected_audit_report_subtasks.length
			) {
				result = result.filter((el) =>
					this.selected_audit_report_subtasks.includes(el.name)
				);
			}
			return result;
		},
		filteredTaskReportEmployees() {
			let result = [...this.task_report_employees];
			result = result.map((el) => ({
				...el,
				incomplete: el.total - el.completed,
			}));
			if (this.sort_by_task_report_total_ascending) {
				result = result.sort((a, b) => a.total - b.total);
			} else if (this.sort_by_task_report_total_descending) {
				result = result.sort((a, b) => b.total - a.total);
			} else if (this.sort_by_task_report_completed_ascending) {
				result = result.sort((a, b) => a.completed - b.completed);
			} else if (this.sort_by_task_report_completed_descending) {
				result = result.sort((a, b) => b.completed - a.completed);
			} else if (this.sort_by_task_report_incomplete_ascending) {
				result = result.sort((a, b) => a.incomplete - b.incomplete);
			} else if (this.sort_by_task_report_incomplete_descending) {
				result = result.sort((a, b) => b.incomplete - a.incomplete);
			} else if (this.sort_by_task_report_completion_rate_ascending) {
				result = result.sort((a, b) => a.completion_rate - b.completion_rate);
			} else if (this.sort_by_task_report_completion_rate_descending) {
				result = result.sort((a, b) => b.completion_rate - a.completion_rate);
			}
			if (
				this.selected_task_report_employee_names &&
				this.selected_task_report_employee_names.length
			) {
				result = result.filter((el) =>
					this.selected_task_report_employee_names.includes(el.name)
				);
			}
			return result;
		},
		filteredTaskReportCategories() {
			let result = [...this.task_report_categories];
			result = result.map((el) => ({
				...el,
				incomplete: el.total - el.completed,
			}));
			if (this.sort_by_task_report_total_ascending) {
				result = result.sort((a, b) => a.total - b.total);
			} else if (this.sort_by_task_report_total_descending) {
				result = result.sort((a, b) => b.total - a.total);
			} else if (this.sort_by_task_report_completed_ascending) {
				result = result.sort((a, b) => a.completed - b.completed);
			} else if (this.sort_by_task_report_completed_descending) {
				result = result.sort((a, b) => b.completed - a.completed);
			} else if (this.sort_by_task_report_incomplete_ascending) {
				result = result.sort((a, b) => a.incomplete - b.incomplete);
			} else if (this.sort_by_task_report_incomplete_descending) {
				result = result.sort((a, b) => b.incomplete - a.incomplete);
			} else if (this.sort_by_task_report_completion_rate_ascending) {
				result = result.sort((a, b) => a.completion_rate - b.completion_rate);
			} else if (this.sort_by_task_report_completion_rate_descending) {
				result = result.sort((a, b) => b.completion_rate - a.completion_rate);
			}
			if (
				this.selected_task_report_categories &&
				this.selected_task_report_categories.length
			) {
				result = result.filter((el) =>
					this.selected_task_report_categories.includes(el.name)
				);
			}
			if (
				this.selected_task_report_intermediate_categories &&
				this.selected_task_report_intermediate_categories.length
			) {
				result = result.filter((el) =>
					this.selected_task_report_intermediate_categories.includes(
						el.intermediate_category_name
					)
				);
			}
			return result;
		},
		taskReportEmployees() {
			return [...new Set(this.task_report_employees.map((el) => el.name))];
		},
		taskReportCategories() {
			return [...new Set(this.task_report_categories.map((el) => el.name))];
		},
		taskReportIntermediateCategories() {
			return [
				...new Set(
					this.task_report_categories.map((el) => el.intermediate_category_name)
				),
			];
		},
		taskReportTasks() {
			let result = [...this.task_report_tasks];
			if (
				this.selected_task_report_task &&
				this.selected_task_report_task.length
			) {
				result = result.filter((el) =>
					this.selected_task_report_task.includes(el.name)
				);
			}
			if (
				this.selected_task_report_frequency &&
				this.selected_task_report_frequency.length
			) {
				result = result.filter(
					(el) =>
						el.records &&
						el.records.length &&
						this.selected_task_report_frequency.includes(
							el.records[el.records.length - 1].frequency
						)
				);
			}
			return result;
		},
		taskReportTaskLists() {
			return [...new Set(this.task_report_tasks.map((el) => el.name))];
		},
		taskReportFrequency() {
			return [
				...new Set(
					this.task_report_tasks.map(
						(el) =>
							el.records &&
							el.records.length &&
							el.records[el.records.length - 1].frequency
					)
				),
			];
		},
		taskReportSubTaskList() {
			let result = [...this.task_reports_subtasks];
			if (
				this.selected_task_report_sub_task &&
				this.selected_task_report_sub_task.length
			) {
				result = result.filter((el) =>
					this.selected_task_report_sub_task.includes(el.name)
				);
			}
			return result;
		},
		taskReportSubTask() {
			return [...new Set(this.task_reports_subtasks.map((el) => el.name))];
		},
		taskReportStartNumber() {
			let start =
				this.taskReportCurrentPage * this.taskReportPerPage -
				(this.taskReportPerPage - 1);
			return start;
		},
		taskReportEndNumber() {
			let end = Math.min(
				this.taskReportStartNumber + this.taskReportPerPage - 1,
				this.getTaskReports.length
			);
			return end;
		},
		isNotTaskMissingLog() {
			let result = true;
			if (this.dashboardActiveTabLink == "other") {
				if (
					this.selected_audit_type == "overall_missing_logs" ||
					this.selected_audit_type == "equipments_and_products_missing_logs"
				) {
					result = false;
				}
			}
			return result;
		},
	},
	watch: {
		select_function(newValue, oldValue) {
			if (newValue.length) {
				this.is_function_field_is_empty = false;
			}
		},
		task_report_detail_show(newValue, oldValue) {
			if (newValue == false) {
				this.task_report_breadcrumb_elements = [];
			}
		},
		task_view(newValue, oldValue) {
			this.showDateByQueryReportForTask(newValue);
		},
		dashboardActiveTabLink(newValue, oldValue) {
			// this.select_outlet = null;
			this.selected_audit_type = null;
			if (newValue == "audit") {
				this.taskIntermediateCategories = [];
				let categoryList = this.assigned_task_category_names.find(
					(el) => el.main_category == "audit"
				);
				let audit_intermediate_categories = [];
				if (categoryList && categoryList.length) {
					for (let i = 0; i < categoryList.length; i++) {
						let check = audit_intermediate_categories.find(
							(el) => el.id == categoryList[i].intermediate_category_info.id
						);
						if (check === undefined) {
							audit_intermediate_categories.push(
								categoryList[i].intermediate_category_info
							);
						}
					}
				}
				if (audit_intermediate_categories.length) {
					this.auditIntermediateCategories = [...audit_intermediate_categories];
				}
				this.selected_audit_type =
					this.audit_sub_category_list &&
					this.audit_sub_category_list.length &&
					this.audit_sub_category_list[0] &&
					this.audit_sub_category_list[0].id
						? this.audit_sub_category_list[0].id
						: null;
			} else if (newValue == "other") {
				this.getTasksReportData(this.fromDate, this.toDate);
				this.selected_audit_type =
					this.task_sub_category_list &&
					this.task_sub_category_list.length &&
					this.task_sub_category_list[0] &&
					this.task_sub_category_list[0].id
						? this.task_sub_category_list[0].id
						: null;
			}
			// this.getTasksDashboardSummary();
			if (
				this.selected_audit_type == "overall_missing_logs" ||
				this.selected_audit_type == "equipments_and_products_missing_logs"
			) {
				this.getMissingLogs();
			} else {
				this.getTasksDashboardSummary();
				this.getTasksReportData(this.fromDate, this.toDate);
			}
		},
		async activeTabLink(newValue, oldValue) {
			// this.select_outlet.unshift('All')
			// this.$forceUpdate();
			if (newValue == "INSIGHTS") {
				this.select_outlet = null;
				this.getTasksDashboardSummary();
				this.getTasksReportData(this.fromDate, this.toDate);
				// EventBus.$emit('callAllGraphs', true);
				// window.location.reload();
				this.resetVariables();
				this.reRenderComponent();
			}
		},
		select_outlet(newValue, oldValue) {
			if (
				this.selected_audit_type == "overall_missing_logs" ||
				this.selected_audit_type == "equipments_and_products_missing_logs"
			) {
				if (newValue == null) {
					this.resetVariables();
					this.reRenderComponent();
				} else {
					this.getMissingLogs();
				}
			} else {
				this.getTasksDashboardSummary();
				this.getTasksReportData(this.fromDate, this.toDate);
			}
		},
		selected_audit_type(newValue, oldValue) {
			if (
				newValue == "overall_missing_logs" ||
				newValue == "equipments_and_products_missing_logs"
			) {
				this.getMissingLogs();
			} else {
				this.getTasksDashboardSummary();
				this.getTasksReportData(this.fromDate, this.toDate);
			}
		},
		view(newVal, oldVal) {
			if (
				this.selected_audit_type == "overall_missing_logs" ||
				this.selected_audit_type == "equipments_and_products_missing_logs"
			) {
				this.getMissingLogs();
			} else {
				this.getTasksReportData(this.fromDate, this.toDate);
			}
		},
		fromDate(newVal, oldVal) {
			if (
				this.selected_audit_type == "overall_missing_logs" ||
				this.selected_audit_type == "equipments_and_products_missing_logs"
			) {
				this.getMissingLogs();
			} else {
				this.getTasksDashboardSummary();
				this.getTasksReportData(this.fromDate, this.toDate);
			}
			let arr = [];
			for (
				let dt = new Date(this.fromDate);
				dt <= new Date(this.toDate);
				dt.setDate(dt.getDate() + 1)
			) {
				arr.push(new Date(dt));
			}
			this.all_audit_report_dates = arr;
		},
		toDate(newVal, oldVal) {
			if (
				this.selected_audit_type == "overall_missing_logs" ||
				this.selected_audit_type == "equipments_and_products_missing_logs"
			) {
				this.getMissingLogs();
			} else {
				this.getTasksDashboardSummary();
				this.getTasksReportData(this.fromDate, this.toDate);
			}
			let arr = [];
			for (
				let dt = new Date(this.fromDate);
				dt <= new Date(this.toDate);
				dt.setDate(dt.getDate() + 1)
			) {
				arr.push(new Date(dt));
			}
			this.all_audit_report_dates = arr;
		},
	},
	beforeDestroy() {
		EventBus.$off();
		this.resetVariables();
	},
	mounted: async function () {
		const self = this;
		this.user_access_level = localStorage.getItem("user_access_level");
		await this.showDayOfWeek();
		await this.getStoreList();
		await this.getAllCategories();
		await this.getDesignation();
		if (this.$route.query.title == "assign_task") {
			this.assign_task_dialog_visible = true;
		}
		await this.showDateByQueryReport("wtd");
		await this.showDateByQueryReportForTask("wtd");
		await this.getLastAuditConducted();
		EventBus.$on("getTaskCategoryData", function (payload) {
			self.getTaskCategoryData(payload.basics, payload.name);
		});
		EventBus.$on("closeAuditReportsModal", function (payload) {
			self.auditReportVisibilityStatus = false;
			self.selectedLastAuditLocation = "";
			self.selectedAuditLocation = "";
		});
		this.handleDomRender();
	},
	methods: {
		async reRenderComponent() {
			this.user_access_level = localStorage.getItem("user_access_level");
			await this.showDayOfWeek();
			await this.getStoreList();
			await this.getAllCategories();
			await this.getDesignation();
			if (this.$route.query.title == "assign_task") {
				this.assign_task_dialog_visible = true;
			}
			await this.showDateByQueryReport("wtd");
			await this.showDateByQueryReportForTask("wtd");
			await this.getLastAuditConducted();
			this.handleDomRender();
		},
		resetVariables() {
			this.isDomLoading = true;
			this.activeTabLink = "INSIGHTS";
			this.date = moment().format("YYYY-MM-DD"); //set yesterday's date
			this.to_date = moment(
				new Date(new Date().setDate(new Date().getDate() - 1))
			).format("YYYY-MM-DD"); //set yesterday's date

			this.delete_task_confirmation_dialog = false;
			this.create_task_dialog_visible = false;
			this.assign_task_dialog_visible = false;

			this.error_on_empty_fields = false;

			this.is_tasks_list_loading = false;
			this.is_emp_list_loading = false;
			this.is_edit_task_loading = false;
			this.is_create_task_loading = false;

			this.select_outlet = "";

			this.is_function_field_is_empty = false;
			this.assigned_tasks_list = [];
			this.unassigned_tasks_list = [];
			this.task_assigned_store_filter_options = [];
			this.task_fun_filter_options = [];
			this.task_repeat_options = [];
			this.task_assigners_filter_options = [];
			this.applicable_store_filter_options = [];
			this.task_createdby_filter_options = [];
			this.employees_for_tasks = [];

			this.emp_filter_options = [];
			this.task_status_filter_options = [];

			this.search_emp_name = "";
			this.search_by_tasks_title = "";

			this.store_name = [];
			this.function_name = [];

			this.selected_main_category = "";
			this.selected_category = "";
			this.main_category_list = [
				{
					name: "Competition",
					value: "cleanliness",
				},
				{
					name: "Audit",
					value: "audit",
				},
				{
					name: "Tasks",
					value: "other",
				},
			];
			this.category_list = [];
			this.add_new_category_dialog = false;
			this.is_category_list_loading = false;
			this.add_category_list = [];
			this.select_store_name = "";
			this.select_function = [];
			this.task_category = "";
			this.description = "";
			this.select_task = "";
			this.selected_task_id = "";
			this.assignTask_empList = [];
			this.isSelectedLocationRegion = false;
			this.selected_assignTaskemp = "";
			this.assignTask_storeList = [];
			this.selected_assignTaskStore = [];

			this.assignTask_start_date = moment().format("YYYY-MM-DD");
			this.assignTask_end_date = moment().format("YYYY-MM-DD");
			this.datePickerOptionsAt = {
				disabledDate: this.disabledDueDateAt,
				firstDayOfWeek: 1,
			};

			this.start_time = "";
			this.end_time = "";
			this.impact_operations = "no";
			this.select_week = "";
			this.firstdays = "";
			this.lastdays = "";
			this.filter_ = {
				id: "",
				location: "",
				location_id: "",
			};
			this.dateRangeOptions = {
				firstDayOfWeek: 1,
			};
			this.customDateFormat = "";
			this.daysOfWeek = [];
			this.store_list = [];
			this.check_list_for_assign_task = [];
			this.check_list = [
				{
					label: "",
					serial_no: 1,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					image_mandatory: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
				},
				{
					label: "",
					serial_no: 2,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					image_mandatory: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
				},
			];
			this.time_task_list = [
				{
					start_time: "",
					end_time: "",
				},
			];
			this.task_list = [];
			this.employee_list = [];

			this.check_list_type = [
				{
					title: "Checklist",
					value: "checklist",
				},
				{
					title: "Yes / No",
					value: "yes_no",
				},
				{
					title: "Temperature",
					value: "temperature",
				},
				{
					title: "TPM",
					value: "tpc",
				},
				{
					title: "Number",
					value: "number",
				},
				{
					title: "Text",
					value: "text",
				},
				{
					title: "Date / Time",
					value: "datetime",
				},
				{
					title: "Rating",
					value: "rating",
				},
				{
					title: "Image",
					value: "image",
				},
				{
					title: "Scoring",
					value: "scoring",
				},
				{
					title: "Select any one",
					value: "radio_options",
				},
			];

			this.task_assign_type = "auto";

			this.repeat_frequency = "one_time";
			this.frequency_list = [
				{
					title: "One Time",
					value: "one_time",
				},
				{
					title: "Daily",
					value: "daily",
				},
				{
					title: "Weekly",
					value: "weekly",
				},
				{
					title: "Monthly",
					value: "monthly",
				},
			];

			this.weekly_frequency = [];
			this.weekly_frequency_list = [
				{
					title: "Monday",
					value: "monday",
				},
				{
					title: "Tuesday",
					value: "tuesday",
				},
				{
					title: "Wednesday",
					value: "wednesday",
				},
				{
					title: "Thursday",
					value: "thursday",
				},
				{
					title: "Friday",
					value: "friday",
				},
				{
					title: "Saturday",
					value: "saturday",
				},
				{
					title: "Sunday",
					value: "sunday",
				},
			];

			this.monthly_frequency = [];

			this.taskDuration = null;
			this.taskDurations = [];
			this.assignedCount = 0;
			this.frequency = null;
			this.disableFrequencyOptions = null;
			this.loc_selected = [];
			this.filters = {};
			this.task_id = "";
			this.assigned_emp = [];
			this.delete_id = "";
			this.edit_task_dialog_visible = false;
			this.selected_assigned_task = {
				atloyee: "",
				start_time: "",
				end_time: "",
				description: "",
				due_date: "",
				outlet_name: "",
				checklist: "",
				task_status: "",
				assigned_by: "",
				task_obj_id: "",
				task_id: "",
				task_name: "",
				created_date: "",
				impact_operation: "",
				marked_as_completed: false,
				selected_action: "",
				file_list: "",
			};
			this.is_steps_toggled = false;
			this.file_list = [];
			this.functions_list = [];
			this.selected_function = "";

			this.sort_by_ascending_date = false;
			this.sort_by_descending_date = false;

			this.selected_store_list = [];
			this.storeActiveFilter = false;

			this.selected_function_list = [];
			this.functionActiveFilter = false;

			this.selected_repeat_list = [];
			this.repeatActiveFilter = false;

			this.selected_created_list = [];
			this.createdActiveFilter = false;

			this.selected_assigned_by_list = [];
			this.assignedByActiveFilter = false;

			this.selected_applicable_store = [];
			this.applicableStoreActiveFilter = false;

			this.selected_emp_list = [];
			this.empActiveFilter = false;

			this.selected_status_list = [];
			this.statusActiveFilter = false;

			this.viewList = [
				{
					name: "Week To Date",
					id: "wtd",
					isDisabled: false,
				},
				{
					name: "Month To Date",
					id: "mtd",
					isDisabled: false,
				},
				{
					name: "Year To Date",
					id: "ytd",
					isDisabled: false,
				},
				{
					name: "Custom Date",
					id: "customDt",
					isDisabled: false,
				},
			];
			this.selectedCountry = [];
			this.user_access_level = "";
			this.view = "wtd";
			this.task_view = "wtd";
			this.datePickerOptions = {
				disabledDate: this.disabledDueDate,
				firstDayOfWeek: 1,
			};
			this.disabledStartDate = {
				disabledDate: this.disabledToDate,
				firstDayOfWeek: 1,
			};
			this.fromDate = "";
			this.toDate = "";
			this.task_from_date = "";
			this.task_to_date = "";
			this.breadcrumbs = [
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
			];
			this.task_breadcrumbs = [
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
			];
			this.is_report_list_loading = false;
			this.table_data = [];
			this.topReportData = [];
			this.nameHeader = "region";
			this.firstNameHeader = "country";
			this.reportSummary = {};
			this.reportDetailsSummary = {};
			this.subtaskReportSummary = {};
			this.basics = "";
			this.dialog_visible = false;
			this.dialog_visible_for_steps_report = false;
			this.date_list = [];
			this.date_list_for_sub_step = [];
			this.date_wise_report = [];
			this.selected_subtask_report = [];
			this.selectedTitle = "";
			this.selected_sub_task = {};
			this.empNameArray = [];
			this.empIdArray = [];
			this.frequencyFilArray = [];
			this.task_array = [];
			this.sub_task_array = [];
			this.selected_emp_id = [];
			this.selected_emp_name = [];
			this.selected_frequency = [];
			this.selected_filter_task = [];
			this.activeFilter = false;
			this.activeFilterId = false;
			this.activeFilterTask = false;
			this.activeFilterFreq = false;
			this.sort_by_ascending_rank = true;
			this.sort_by_descending_rank = false;
			this.sort_by_ascending_rank_for_area_lead = true;
			this.sort_by_descending_rank_for_area_lead = false;
			this.sort_by_ascending_task_assigned = false;
			this.sort_by_descending_task_assigned = false;
			this.sort_by_ascending_completed = false;
			this.sort_by_descending_completed = false;
			this.sort_by_ascending_points_achieved = true;
			this.sort_by_descending_points_achieved = false;
			this.sort_by_ascending_comp_rate = false;
			this.sort_by_descending_comp_rate = true;
			this.sort_by_ascending_audit_report_points_available = false;
			this.sort_by_descending_audit_report_points_available = false;
			this.sort_by_ascending_audit_report_points_achieved = false;
			this.sort_by_descending_audit_report_points_achieved = false;
			this.sort_by_ascending_audit_report_percentage = false;
			this.sort_by_descending_audit_report_percentage = false;
			this.sort_by_ascending_task_report_task_assigned = false;
			this.sort_by_descending_task_report_task_assigned = false;
			this.sort_by_ascending_task_report_task_completed = false;
			this.sort_by_descending_task_report_task_completed = false;
			this.sort_by_ascending_task_report_task_incomplete = false;
			this.sort_by_descending_task_report_task_incomplete = false;
			this.sort_by_ascending_task_report_task_completion_rate = false;
			this.sort_by_descending_task_report_task_completion_rate = true;
			this.pageInfo = {
				currentPage: 1,
				totalCount: 0,
				pageSize: 5,
				search: "",
			};
			this.selectedBasicsDetails = {};
			this.category_types = [];
			this.createTaskFilters = {
				countries: [],
				regions: [],
				subregions: [],
				outlets: [],
			};
			this.designationList = [];
			this.selectedDesignation = [];
			this.selectedDesignationForAssignTask = "";
			this.isOutlet = false;
			this.imageData = [];
			this.current_image = "";
			this.current_image_path = "";
			this.current_image_list = [];
			this.image_dialog_visible = false;
			this.is_image_loading = false;
			this.selected_task_freq = "";
			this.selected_task_days = [];
			this.for_empty_report_obj = {};
			this.task_preview_dialog = false;
			this.task_preview = {};
			this.search_task_list = [];
			this.tasks_by_location_list = [];
			this.is_tasks_are_loading = false;
			this.is_task_deactivated = false;
			this.is_task_in_progress = false;
			this.is_task_submitted = false;
			this.active_assigned_task_category = {
				name: "",
				id: "",
			};
			this.active_unassigned_task_category = "";
			this.assigned_task_category_names = [];
			this.unassigned_task_category_names = [];
			this.task_rank = {};
			this.is_task_progress_loading = false;
			this.selected_report = {};
			this.is_datewise_reports_loading = false;
			this.is_datewise_steps_reports_loading = false;
			this.selected_sub_task_filter_task = [];
			this.selected_location_filter = [];
			this.location_array = [];
			this.locations_for_area_lead = [];
			this.rem_lead_reportable_data = [];
			this.locations_for_rem_lead = [];
			this.search_location = "";
			this.points_calculation_method = "by_steps";
			this.expected_value = "yes";
			this.total_points = "";
			this.deduction_type = "no";
			this.deduction_method = "percentage";
			this.selected_locations_for_nomination = [];
			this.enable_nomination = false;
			this.is_nomaination_processing = false;
			this.add_reports_comment = "";
			this.add_comment_dialog = false;
			this.is_comment_updating = false;
			this.selected_report_index = "";
			this.area_lead_reportable_data = [];
			this.user_designation = localStorage.getItem("designation");
			this.selected_location_filter_for_area_lead = [];
			this.search_location_for_area_lead = "";
			this.selected_designation = "";
			this.toogle_summary = false;
			this.audit_summary_list = {
				deduction: [],
				deduction_summary: {},
				intolerable: [],
				intolerable_summary: {},
				non_deduction: [],
				non_deduction_summary: [],
				overall_score: {},
			};
			this.audit_reports = [];
			this.active_report_tab = "COMPETITION";
			this.is_audit_report_list_loading = false;
			this.search_location_for_audit = "";
			this.search_grade_for_audit = "";
			this.location_for_audit_reports = [];
			this.selected_location_filter_for_audit = [];
			this.selected_grade_filter_for_audit = [];
			this.checked = false;
			this.add_radio_options_dialog_visibility = false;
			this.selected_create_task_check_list_index = "";
			this.radio_options = [];
			this.main_report_category_id = "";
			this.if_yes_options = [];
			this.if_no_options = [];
			this.show_add_info_dialog = false;
			this.add_info_index = 0;
			this.add_info_content = "";
			this.selected_audit_report_outlet = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.audit_report_categories = [];
			this.selected_audit_report_category = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.audit_report_tasks = [];
			this.selected_audit_report_task = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.audit_report_sub_tasks = [];
			this.selected_audit_report_sub_task = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.is_task_report_list_loading = false;
			this.task_reports = [];
			this.location_for_task_reports = [];
			this.search_location_for_task = "";
			this.selected_location_filter_for_task = [];
			this.selected_task_reports_regions = [];
			this.searched_task_reports_region_name = "";
			this.selected_task_reports_subregions = [];
			this.searched_task_reports_subregion_name = "";
			this.task_report_detail_show = false;
			this.selected_task_report_dialog_title = "";
			this.task_report_categories = [];
			this.task_report_employees = [];
			this.task_report_type = "";
			this.task_report_tasks = [];
			this.selected_task_report_outlet = "";
			this.selected_task_report_category = "";
			this.all_task_report_dates = [];
			this.all_audit_report_dates = [];
			this.task_reports_subtasks = [];
			this.subtasks_reports_dates = [];
			this.audit_report_grades = [];
			this.task_report_breadcrumb_elements = [];
			this.taskReportsImgArr = [];
			this.showTaskReportsImageModal = false;
			this.taskReportsImageComment = "";
			this.showTaskReportsCommentModal = false;
			this.loading = false;
			this.audit_reports_dates = [];
			this.sort_by_ascending_points_available = true;
			this.sort_by_descending_points_available = false;
			this.sort_by_ascending_scoring_percentage = true;
			this.sort_by_descending_scoring_percentage = false;

			this.audit_report_date_arr = [];
			this.audit_sub_category_list = [];
			this.task_sub_category_list = [];
			this.selected_dropdown_category = {};
			this.designationListNew = [];
			this.task_summary_info = {};
			this.taskSummaryCompletionStatus = {};
			this.show_not_applicable = false;
			this.selected_audit_type = null;
			// TEST PURPOSE
			this.lastAuditConductedList = [];
			this.dashboardActiveTabLink = "audit";
			this.auditIntermediateCategories = [];
			this.taskIntermediateCategories = [];
			this.searched_last_audit_location = "";
			this.last_audit_location_total_points_order = "";
			this.last_audit_location_achieved_points_order = "";
			this.last_audit_location_percentage_points_order = "";
			this.last_audit_location_completion_percentage_order = "desc";
			// Last Audit Conducted By
			this.currentPage = 1;
			this.perPage = 10;
			this.taskDashboardSummary = {
				total: 0,
				completed: 0,
				incomplete: 0,
				in_progress: 0,
				completion_rate: 0,
			};
			this.logReports = [];
			this.logsLoading = false;
			this.dashboardToggle = false;
			this.auditReportVisibilityStatus = false;
			this.selectedLastAuditLocation = "";
			this.selectedAuditLocation = "";
			this.reportLoader = false;

			// Audit reports filter
			this.searched_audit_report_location = "";
			this.selected_audit_report_locations = [];
			this.searched_audit_report_region = "";
			this.selected_audit_report_regions = [];
			this.searched_audit_report_area_lead = "";
			this.selected_audit_report_area_leads = [];
			this.searched_audit_report_grade = "";
			this.selected_audit_report_grades = [];

			this.searched_audit_report_sub_category = "";
			this.selected_audit_report_sub_categories = [];
			this.searched_audit_report_intermediate_category = "";
			this.selected_audit_report_intermediate_categories = [];

			this.searched_audit_report_task = "";
			this.selected_audit_report_tasks = [];

			this.searched_audit_report_subtask = "";
			this.selected_audit_report_subtasks = [];

			// Task reports filter
			this.searched_task_report_employee_name = "";
			this.selected_task_report_employee_names = [];
			this.searched_task_report_category = "";
			this.selected_task_report_categories = [];
			this.searched_task_report_intermediate_category = "";
			this.selected_task_report_intermediate_categories = [];
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;

			this.searched_task_report_task = "";
			this.selected_task_report_task = [];
			this.searched_task_report_frequency = "";
			this.selected_task_report_frequency = [];

			this.searched_task_report_sub_task = "";
			this.selected_task_report_sub_task = [];

			// Task Reports Pagination States
			this.taskReportCurrentPage = 1;
			this.taskReportPerPage = 10;
			this.task_emp_search_term = "";
			this.task_emp_selected_list = [];
			this.task_freq_search_term = "";
			this.task_freq_selected_list = [];
			this.task_time_search_term = "";
			this.task_time_selected_list = [];
			this.selected_form_template_intermediate_category = "";
			this.form_template_last_day_of_month = false;

			this.audit_reports_inner_modal = false;
		},
		changedSelectedOutlet(event) {
			this.select_outlet = event;
		},
		changedDateTypeViewList(event) {
			this.view = event;
			this.showDateByQueryReport(event);
		},
		changedFromDate(event) {
			this.fromDate = event;
		},
		changedToDate(event) {
			this.toDate = event;
		},
		changedSelectedAuditType(event) {
			this.selected_audit_type = event;
		},
		handleDomRender() {
			this.isDomLoading = true;
			setTimeout(() => {
				this.isDomLoading = false;
			}, 3500);
		},
		closeLastAuditDetailsModal() {
			this.auditReportVisibilityStatus = false;
		},
		openLastAuditDetals(outlet, outlet_name) {
			this.auditReportVisibilityStatus = true;
			this.selectedLastAuditLocation = outlet;
			this.selectedAuditLocation = outlet_name;
		},
		reportDateFormat(date) {
			if (date) {
				return moment(date).format("Do MMM YYYY");
			} else {
				return date;
			}
		},
		format_two_decimal_places(num) {
			if (num) {
				return (Math.round(num * 100) / 100).toFixed(2);
			} else {
				return num;
			}
		},
		formatTimestamp(timestamp) {
			if (new Date(timestamp).getTime() > 0) {
				let dateVal = new Date(timestamp).getDate();
				dateVal = "0" + dateVal.toString().slice(-2);
				let monthVal = new Date(timestamp).getMonth();
				monthVal = "0" + monthVal.toString().slice(-2);
				let yearVal = new Date(timestamp).getFullYear();
				return `${yearVal}-${monthVal}-${dateVal}`;
			} else {
				return timestamp;
			}
		},
		openDialogToAddRadioOptions(index) {
			this.selected_create_task_check_list_index = index;
			this.radio_options = JSON.parse(
				JSON.stringify(this.check_list[index].radio_options)
			);

			this.add_radio_options_dialog_visibility = true;
		},
		openAddInfoModal(index) {
			this.add_info_content = JSON.parse(
				JSON.stringify(this.check_list[index].info)
			);
			this.add_info_index = index;
			this.show_add_info_dialog = true;
		},
		closeAddInfoModal() {
			(this.show_add_info_dialog = false), (this.add_info_index = 0);
			this.add_info_content = "";
		},
		updateInfo() {
			this.check_list[this.add_info_index].info = this.add_info_content;
			this.closeAddInfoModal();
		},
		openAuditReportLocation(item, type = "category") {
			this.getAuditReportsByBasics(item, type);
		},

		getAuditReportsByBasics(item, report_type = "category") {
			let params = {
				basics: report_type,
				include_dates: true,
				task: null,
				filters: {
					outlets: [
						this.selected_audit_report_outlet.basics
							? this.selected_audit_report_outlet.basics
							: item.basics,
					],
				},
				designation: this.selected_designation
					? this.selected_designation
					: null,
				main_category: "audit",
				start_date: moment(this.fromDate).format("YYYY-MM-DD"),
				end_date: moment(this.toDate).format("YYYY-MM-DD"),
				include_cycle_data: true,
			};
			if (report_type == "category") {
				this.selected_audit_report_outlet.name = item.name;
				this.selected_audit_report_outlet.basics = item.basics;
			} else if (report_type == "task") {
				params.category = item.basics;
			} else if (report_type == "subtask") {
				params.task = item.basics;
			}
			if (this.activeTabLink == "INSIGHTS") {
				params.intermediate_category = this.selected_audit_type;
			}
			serverAddr
				.post(`/bk_task_assignment/report/?get_all=true`, params)
				.then((response) => {
					let responseData = JSON.parse(response.data);
					if (report_type == "category" && responseData.results) {
						this.selected_audit_report_outlet.name = item.name;
						this.selected_audit_report_outlet.basics = item.basics;
						this.selected_audit_report_outlet.current_step = true;
						this.audit_report_categories = responseData.results;
						this.selected_audit_report_category = {
							name: "",
							basics: "",
							current_step: false,
						};
						this.audit_report_tasks = [];
						this.selected_audit_report_task = {
							name: "",
							basics: "",
							current_step: false,
						};
						this.audit_report_sub_tasks = [];
						this.selected_audit_report_sub_task = {
							name: "",
							basics: "",
							current_step: false,
						};
					} else if (report_type == "task" && responseData.results) {
						this.selected_audit_report_category.name = item.name;
						this.selected_audit_report_category.basics = item.basics;
						this.selected_audit_report_category.current_step = true;
						this.audit_report_tasks = responseData.results;
						this.audit_report_sub_tasks = [];
						this.selected_audit_report_sub_task = {
							name: "",
							basics: "",
							current_step: false,
						};
					} else if (report_type == "subtask" && responseData.results) {
						this.selected_audit_report_task.name = item.name;
						this.selected_audit_report_task.basics = item.basics;
						this.selected_audit_report_task.current_step = true;
						this.audit_report_sub_tasks = responseData.results;
					}
					if (this.dashboardActiveTabLink == "audit") {
						this.audit_report_date_arr = responseData.meta.due_dates_list;
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		resetAuditReports() {
			this.selected_audit_report_outlet = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.audit_report_categories = [];
			this.selected_audit_report_category = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.audit_report_tasks = [];
			this.selected_audit_report_task = {
				name: "",
				basics: "",
				current_step: false,
			};
			this.audit_report_sub_tasks = [];
			this.selected_audit_report_sub_task = {
				name: "",
				basics: "",
				current_step: false,
			};
		},
		addRadioOptions() {
			this.check_list[
				this.selected_create_task_check_list_index
			].radio_options = [];
			for (let i = 0; i < this.radio_options.length; i++) {
				if (
					this.radio_options[i].label != "" &&
					this.radio_options[i].num_value != ""
				) {
					this.radio_options[i].serial_no = i + 1;

					this.check_list[
						this.selected_create_task_check_list_index
					].radio_options.push(this.radio_options[i]);
				}
			}
			this.add_radio_options_dialog_visibility = false;
		},
		addMoreOptionsToChecklist() {
			this.radio_options.push({
				label: "",
				num_value: "",
				serial_no: "",
			});
			for (let i = 0; i < this.radio_options.length; i++) {
				this.radio_options[i].serial_no = i + 1;
			}
		},
		deleteRadioOption(index) {
			this.radio_options.splice(index, 1);
			for (let i = 0; i < this.radio_options.length; i++) {
				this.radio_options[i].serial_no = i + 1;
			}
		},
		setActiveReportTab(link) {
			if (link == "COMPETITION") {
				this.active_report_tab = "COMPETITION";
				this.getReportData();
			} else if (link == "AUDIT") {
				this.active_report_tab = "AUDIT";
				this.getAuditReportData();
			} else if (link == "TASKS") {
				this.active_report_tab = "TASKS";
				this.getAuditReportData();
			}
		},
		selectNomination(index, e) {
			if (e) {
				this.$set(
					this.getReportTableData[index],
					"is_nomination_enabled",
					true
				);
			} else {
				this.$set(
					this.getReportTableData[index],
					"is_nomination_enabled",
					false
				);
			}
			this.selected_locations_for_nomination.push(
				this.getReportTableData[index].basics
			);
			this.getReportTableData = JSON.parse(
				JSON.stringify(this.getReportTableData)
			);
		},
		cancelNomination() {
			for (let i = 0; i < this.getReportTableData.length; i++) {
				this.getReportTableData[i].is_nomination_enabled =
					this.getReportTableData[i].is_nominated;
			}
			this.selected_locations_for_nomination = [];
			this.getReportTableData = JSON.parse(
				JSON.stringify(this.getReportTableData)
			);
			this.enable_nomination = false;
		},
		submitNomination() {
			if (this.selected_locations_for_nomination.length) {
				this.is_nomaination_processing = true; //enabled loader
				let nominations = [];
				for (let i = 0; i < this.getReportTableData.length; i++) {
					let obj = {
						outlet: this.getReportTableData[i].basics,
						nominated: this.getReportTableData[i].is_nomination_enabled,
					};
					nominations.push(obj);
				}
				serverAddr
					.post(`/bk_task_assignment/report/add-nomination/`, nominations)
					.then((response) => {
						if (response.status == 200) {
							this.getReportData();
							this.$notify.success({
								message: "Nomination submitted successfully",
								type: "success",
							});
						}
						this.is_nomaination_processing = false; //disabled loader
						this.selected_locations_for_nomination = [];
						this.enable_nomination = false;
					})
					.catch((error) => {
						console.error(error);
						this.is_nomaination_processing = false; //disabled loader
					});
			}
		},
		addComment(i, index) {
			this.add_reports_comment = i.comments;
			this.selected_report = i;
			this.selected_report_index = index;
			this.add_comment_dialog = true;
		},
		updateComment() {
			if (this.add_reports_comment.trim()) {
				this.is_comment_updating = true; //enabled btn loader on add comment dialog
				let params = {
					outlet: this.selected_report.basics,
					activity: null,
					comments: this.add_reports_comment,
				};
				serverAddr
					.post(`/bk_task_assignment/report/add-update-comments/`, params)
					.then((response) => {
						if (response.status == 200) {
							this.add_comment_dialog = false; //hide dialog
							this.getReportTableData[this.selected_report_index].comments =
								this.add_reports_comment;
							this.$notify.success({
								message: "Comment updated successfully",
								type: "success",
							});
						}
						this.is_comment_updating = false; //disabled btn loader on add comment dialog
					})
					.catch((error) => {
						console.error(error);
						this.is_comment_updating = false; //disabled btn loader on add comment dialog
					});
			}
		},
		deleteComment(i, index) {
			this.is_report_list_loading = true; //enabled loader
			let params = {
				outlet: i.basics,
				activity: "delete",
			};
			serverAddr
				.post(`/bk_task_assignment/report/add-update-comments/`, params)
				.then((response) => {
					if (response.status == 200) {
						this.is_report_list_loading = false; //disabled loader
						this.getReportTableData[index].comments = "";
						this.$notify.success({
							message: "Comment deleted successfully",
							type: "success",
						});
					}
					this.is_report_list_loading = false; //disabled loader
				})
				.catch((error) => {
					console.error(error);
					this.is_report_list_loading = false; //disabled loader
				});
		},
		checkNumberInRange(value, min, max) {
			let style_obj = {};
			if (
				value != null &&
				value != "" &&
				min != null &&
				min != "" &&
				max != null &&
				max != ""
			) {
				if (!_.inRange(value, min, max)) {
					return (style_obj = { background: "#d60918", color: "#fff" });
				}
			}
			return style_obj;
		},
		getTaskProgress() {
			if (this.active_assigned_task_category.id != "tasks_reports") {
				let user_designation = "Area Lead";
				if (this.user_access_level == "admin") {
					user_designation = "Area Lead";
				} else {
					user_designation = this.user_designation;
				}
				let params = {
					outlet: this.select_outlet,
					category: this.active_assigned_task_category.id,
					designation: user_designation,
				};
				if (
					params.category == "cleanliness_reports" ||
					params.category == "audit_reports" ||
					params.category == "tasks_reports"
				) {
					params.category = "";
				}
				return serverAddr
					.post(`/tasks/get_outlet_rank/`, params)
					.then((response) => {
						return response;
					})
					.catch((error) => {
						console.error(error);
					});
			}
		},
		submitTaskProgress(type) {
			this.is_task_progress_loading = true; //displayed btn loader
			let params = {
				outlet_id: this.select_outlet,
				save_type: "",
				for_date: null,
			};
			if (type == "START") {
				params.save_type = "start";
			} else if (type == "SUBMIT") {
				params.save_type = "submit";
				params.for_date = moment(this.date).format("YYYY-MM-DD");
			}
			serverAddr
				.post(`/add/update/task_time/`, params)
				.then((response) => {
					if (response.status == 200) {
						this.is_task_deactivated = false;
						if (type == "START") {
							let overlay = document.getElementById("overlay-disabled");
							this.is_task_in_progress = true;
							this.is_task_submitted = false;
							overlay.style.backgroundColor = "#fff";
							overlay.style.pointerEvents = "unset";
						} else if (type == "SUBMIT") {
							this.is_task_in_progress = false;
							this.is_task_submitted = true;
							this.$message.success("Task Submitted Successfully!");
						}
					}
					this.is_task_progress_loading = false; //hide btn loader
				})
				.catch((error) => {
					console.error(error);
					this.is_task_in_progress = false;
					this.is_task_submitted = false;
					this.is_task_progress_loading = false; //hide btn loader
				});
		},
		getTaskTime() {
			let params = {
				outlet_id: this.select_outlet,
				for_date: moment(this.date).format("YYYY-MM-DD"),
			};
			return serverAddr
				.post(`/get/task_time/`, params)
				.then((response) => {
					return response;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getAuditTaskSummary() {
			console.log("Calling getAuditTaskSummary");
			let params = {
				main_category: "audit",
				filters: {
					outlets: [this.select_outlet],
				},
			};
			if (
				this.activeTabLink == "INSIGHTS" &&
				this.dashboardActiveTabLink == "audit" &&
				this.selected_audit_type
			) {
				params.intermediate_category = this.selected_audit_type;
			} else {
				params.intermediate_category = this.selected_dropdown_category.id;
			}
			// TODO; TASK AND AUDIT DASHBOARD
			return serverAddr
				.post(`/bk_task_assignment/summary/`, params)
				.then((response) => {
					return response;
				})
				.catch((error) => {
					console.error(error);
					if (error.response) {
						return {
							status: error.response.status,
						};
					} else {
						return {
							status: 400,
						};
					}
				});
		},
		getOtherTaskSummary() {
			if (this.fromDate && this.toDate) {
				const params = {
					start_date: this.date,
					end_date: this.date,
					assigned: null,
					employee: null,
					basics: "category",
					include_dates: false,
					filters: {
						outlets: [this.select_outlet],
					},
					designation: null,
					main_category: "other",
					category: null,
					intermediate_category: this.selected_dropdown_category.id,
				};
				if (
					this.selected_dropdown_category &&
					this.selected_dropdown_category.filter_from_1st
				) {
					let date = new Date();
					let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
					let updatedFromDate = moment(firstDay).format("YYYY-MM-DD");
					if (updatedFromDate) {
						params.start_date = updatedFromDate;
					}
				}
				return serverAddr
					.post(`/task_assignment/report/?get_all=true`, params)
					.then(async (response) => {
						await this.getOtherTasksCompletionStatus();
						await this.getTaskSummaryCompletionStatus();
						return response;
					})
					.catch((error) => {
						console.error(error);
						if (error.response) {
							return {
								status: error.response.status,
							};
						} else {
							return {
								status: 400,
							};
						}
					});
			}
		},
		getTaskSummaryCompletionStatus() {
			const params = {
				store: this.select_outlet,
				main_category: "other",
				intermediate_category: this.selected_dropdown_category.id,
				category: "",
				for_date: this.date,
			};
			LabourPalnningService.getTaskSummaryCompletionStatus(params)
				.then((response) => {
					let responseData = JSON.parse(response.data);
					this.taskSummaryCompletionStatus = responseData;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		updateTaskSummayCompletionStatus() {
			this.is_tasks_list_loading = true;
			const params = {
				store: this.select_outlet,
				main_category: "other",
				intermediate_category: this.selected_dropdown_category.id,
				category: "",
				for_date: this.date,
				status: "complete",
			};
			LabourPalnningService.updateTaskSummayCompletionStatus(params)
				.then((response) => {
					let responseData = JSON.parse(response.data);
					this.$notify.success({
						message: "Tasks Submitted Successfully!",
						type: "success",
					});
				})
				.catch((error) => {
					console.error(error);
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
				})
				.finally(async (result) => {
					await this.getAllAssignedTasks("other");
					this.is_tasks_list_loading = false;
				});
		},
		getOtherTasksCompletionStatus() {
			const params = {
				from_date: this.date,
				to_date: this.date,
				store: this.select_outlet,
				main_category: "other",
				intermediate_category: this.selected_dropdown_category.id,
			};
			if (
				this.selected_dropdown_category &&
				this.selected_dropdown_category.filter_from_1st
			) {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				let updatedFromDate = moment(firstDay).format("YYYY-MM-DD");
				if (updatedFromDate) {
					params.from_date = updatedFromDate;
				}
			}
			serverAddr
				.post(`/task-assignment/completion-status/`, params)
				.then((response) => {
					const responseData = JSON.parse(response.data);
					if (responseData.completed >= 0 && responseData.total >= 0) {
						responseData.pending = responseData.total - responseData.completed;
						if (responseData.total == 0) {
							responseData.completion_percentage = "0.00 %";
						} else {
							responseData.completion_percentage =
								((responseData.completed / responseData.total) * 100).toFixed(
									2
								) + " %";
						}
					}
					this.task_summary_info = { ...responseData };
				})
				.catch((error) => {
					console.error(error);
				});
		},
		deleteSubStep(check_index, taskId) {
			if (taskId) {
				serverAddr
					.post(`/delete/subtask_by_id/`, {
						subtask_id: taskId,
					})
					.then((response) => {
						if (response.status == 200) {
							let yes_index_deleted_to_be = this.if_yes_options
								.map(function (e) {
									return e.value;
								})
								.indexOf(check_index + 1);
							this.if_yes_options.splice(yes_index_deleted_to_be, 1);
							let no_index_deleted_to_be = this.if_no_options
								.map(function (e) {
									return e.value;
								})
								.indexOf(check_index + 1);
							this.if_no_options.splice(no_index_deleted_to_be, 1);
							this.check_list.splice(check_index, 1);
							for (let i = 0; i < this.check_list.length; i++) {
								if (check_index + 1 == this.check_list[i].step_if_yes) {
									this.check_list[i].step_if_yes = null;
								} else if (check_index + 1 == this.check_list[i].step_if_no) {
									this.check_list[i].step_if_no = null;
								}
							}
							this.getAllUnAssignedTasks();
						}
					})
					.catch((error) => {
						console.error(error);
					});
			} else {
				let yes_index_deleted_to_be = this.if_yes_options
					.map(function (e) {
						return e.value;
					})
					.indexOf(check_index + 1);
				this.if_yes_options.splice(yes_index_deleted_to_be, 1);
				let no_index_deleted_to_be = this.if_no_options
					.map(function (e) {
						return e.value;
					})
					.indexOf(check_index + 1);
				this.if_no_options.splice(no_index_deleted_to_be, 1);
				this.check_list.splice(check_index, 1);
				for (let i = 0; i < this.check_list.length; i++) {
					if (check_index + 1 == this.check_list[i].step_if_yes) {
						this.check_list[i].step_if_yes = "";
					}
					if (check_index + 1 == this.check_list[i].step_if_no) {
						this.check_list[i].step_if_no = "";
					}
				}
			}
		},
		selectFunction() {
			for (let i in this.selected_assignTaskStore) {
				if (this.selected_assignTaskStore[i] == "selectAll") {
					this.selected_assignTaskStore = this.assignTask_storeList.map(
						(e) => e.id
					);
					break;
				} else if (this.selected_assignTaskStore[i] == "clearAll") {
					this.selected_assignTaskStore = [];
				}
			}
		},
		setList() {
			if (this.repeat_frequency == "one_time") {
				this.time_task_list = [
					{
						start_time: "",
						end_time: "",
					},
				];
			}
		},
		async getAllCategories() {
			await serverAddr
				.get(`/task/category/?get_all=true`)
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						this.category_list = res;
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				})
				.finally(async (res) => {
					await this.getCategoryHierarchy();
				});
		},
		async getCategoryHierarchy() {
			await LabourPalnningService.getCategoryHierarchy()
				.then((res) => {
					let responseData = JSON.parse(res.data);
					//------- FILTER AUDIT CATEGORIES ---------//
					let temp_category_list = responseData.find(
						(el) => el.name == "audit"
					);
					let temp_audit_intermitant_categories =
						temp_category_list.intermediate_categories;
					temp_audit_intermitant_categories = temp_audit_intermitant_categories
						.slice()
						.sort((a, b) => a.serial_no - b.serial_no);
					this.audit_sub_category_list = [...temp_audit_intermitant_categories];
					if (this.dashboardActiveTabLink == "audit") {
						this.selected_audit_type = this.audit_sub_category_list
							? this.audit_sub_category_list.length
								? this.audit_sub_category_list[0].id
								: null
							: null;
					}
					//------- FILTER AUDIT CATEGORIES ---------//
					//------- FILTER TASK CATEGORIES ---------//
					let temp_task_category_list = responseData.find(
						(el) => el.name == "other"
					);
					let temp_task_intermitant_categories =
						temp_task_category_list.intermediate_categories;
					temp_task_intermitant_categories = temp_task_intermitant_categories
						.slice()
						.sort((a, b) => a.serial_no - b.serial_no);
					this.task_sub_category_list = [...temp_task_intermitant_categories];
					if (this.dashboardActiveTabLink == "other") {
						this.selected_audit_type = this.task_sub_category_list
							? this.task_sub_category_list.length
								? this.task_sub_category_list[0].id
								: null
							: null;
					}
					//------- FILTER TASK CATEGORIES ---------//
				})
				.catch((err) => {
					console.error(err);
				});
		},
		addCategory(event) {
			if (event == "add new") {
				this.selected_category = "";
				this.add_category_list = this.category_list.slice(0); //get shadow copy of array
				this.add_category_list.forEach((element) => {
					if (element.id) {
						element.isChange = false;
					}
				});
				this.add_new_category_dialog = true;
			}
		},
		addMoreCategory() {
			let category = {
				name: "",
			};
			this.add_category_list.unshift(category);
			// to scroll to top of div after adding one more item to list
			this.scrollToTop("add-category-wrapper");
		},
		addUpdateCategory() {
			this.is_category_list_loading = true; //displyed loader
			this.add_category_list.forEach((element) => {
				if (element.name.length) {
					if (!element.id) {
						serverAddr
							.post(`/task/category/`, {
								name: element.name,
							})
							.then((response) => {
								if (response.status == 200) {
								}
							})
							.catch((error) => {
								console.error(error);
							});
					} else if (element.id && element.isChange) {
						serverAddr
							.patch(`/task/category/${element.id}/`, {
								name: element.name,
							})
							.then((response) => {
								if (response.status == 200) {
								}
							})
							.catch((error) => {
								console.error(error);
							});
					}
				}
			});
			setTimeout(() => {
				this.$notify.success({
					title: "Success",
					message: "Categories updated..!",
				});
				this.getAllCategories();
				this.is_category_list_loading = false;
				this.add_new_category_dialog = false;
			}, 2000);
		},
		scrollToTop(div) {
			let objDiv = document.getElementById(div);
			objDiv.scrollTo(0, 0);
		},
		deleteCategory(index) {
			this.is_category_list_loading = true; //displyed loader
			let category_id = this.add_category_list[index].id;
			if (category_id != undefined) {
				serverAddr
					.delete(`/task/category/${category_id}`)
					.then((response) => {
						this.add_category_list.splice(index, 1);
						setTimeout(() => {
							this.getAllCategories();
							this.is_category_list_loading = false; //disabld loader
							this.$notify.success({
								title: "Success",
								message: "Category removed..!",
							});
						}, 2000);
					})
					.catch((e) => {
						console.error(e);
					});
			} else {
				this.add_category_list.splice(index, 1);
				this.is_category_list_loading = false; //disabld loader
			}
		},
		disableDateOptions(date) {
			if (this.monthly_frequency.includes(true)) {
				if (date == 28 || date == 29 || date == 30 || date == 31) {
					return true;
				}
			} else if (
				this.monthly_frequency.includes(28) ||
				this.monthly_frequency.includes(29) ||
				this.monthly_frequency.includes(30) ||
				this.monthly_frequency.includes(31)
			) {
				if (date == true) {
					return true;
				}
			}
			return false;
		},
		selectAllEmpName() {
			this.activeFilter = true;
			this.selected_emp_name = [];
			for (let i in this.empNameArray) {
				this.selected_emp_name.push(this.empNameArray[i].text);
			}
		},
		resetSelectedEmpName() {
			this.activeFilter = false;
			this.selected_emp_name = [];
		},
		selectAllEmpId() {
			this.activeFilterId = true;
			this.selected_emp_id = [];
			for (let i in this.empIdArray) {
				this.selected_emp_id.push(this.empIdArray[i].text);
			}
		},
		resetSelectedEmpId() {
			this.activeFilterId = false;
			this.selected_emp_id = [];
		},
		sortByDescendingRank() {
			this.allFalse();
			this.sort_by_ascending_rank = false;
			this.sort_by_descending_rank = true;
		},
		sortByAscendingRank() {
			this.allFalse();
			this.sort_by_ascending_rank = true;
			this.sort_by_descending_rank = false;
		},
		sortByDescendingRankForAreaLead() {
			this.allFalse();
			this.sort_by_ascending_rank_for_area_lead = false;
			this.sort_by_descending_rank_for_area_lead = true;
		},
		sortByAscendingRankForAreaLead() {
			this.allFalse();
			this.sort_by_ascending_rank_for_area_lead = true;
			this.sort_by_descending_rank_for_area_lead = false;
		},
		sortByDescendingTaskAssigned() {
			this.allFalse();
			this.sort_by_ascending_task_assigned = false;
			this.sort_by_descending_task_assigned = true;
		},
		sortByAscendingTaskAssigned() {
			this.allFalse();
			this.sort_by_ascending_task_assigned = true;
			this.sort_by_descending_task_assigned = false;
		},
		sortByDescendingCompleted() {
			this.allFalse();
			this.sort_by_ascending_completed = false;
			this.sort_by_descending_completed = true;
		},
		sortByAscendingCompleted() {
			this.allFalse();
			this.sort_by_ascending_completed = true;
			this.sort_by_descending_completed = false;
		},
		sortByDescendingPointsAchieved() {
			this.allFalse();
			this.sort_by_ascending_points_achieved = false;
			this.sort_by_descending_points_achieved = true;
			let temp_assigned_task_list = [...this.assigned_tasks_list];
			temp_assigned_task_list.sort(
				(a, b) =>
					b.total_scoring_points_yes_no_achieved -
					a.total_scoring_points_yes_no_achieved
			);
			this.assigned_tasks_list = [...temp_assigned_task_list];
		},

		sortByAscendingPointsAchieved() {
			this.allFalse();
			this.sort_by_descending_points_achieved = false;
			this.sort_by_ascending_points_achieved = true;
			let temp_assigned_task_list = [...this.assigned_tasks_list];
			temp_assigned_task_list.sort(
				(a, b) =>
					a.total_scoring_points_yes_no_achieved -
					b.total_scoring_points_yes_no_achieved
			);
			this.assigned_tasks_list = [...temp_assigned_task_list];
		},

		sortByDescendingPointsAvailable() {
			this.allFalse();
			this.sort_by_ascending_points_available = false;
			this.sort_by_descending_points_available = true;

			let temp_assigned_task_list = [...this.assigned_tasks_list];
			temp_assigned_task_list.sort(
				(a, b) => b.total_scoring_points_yes_no - a.total_scoring_points_yes_no
			);
			this.assigned_tasks_list = [...temp_assigned_task_list];
		},
		sortByAscendingPointsAvailable() {
			this.allFalse();
			this.sort_by_descending_points_available = false;
			this.sort_by_ascending_points_available = true;
			let temp_assigned_task_list = [...this.assigned_tasks_list];
			temp_assigned_task_list.sort(
				(a, b) => a.total_scoring_points_yes_no - b.total_scoring_points_yes_no
			);
			this.assigned_tasks_list = [...temp_assigned_task_list];
		},
		sortByDescendingScoringPercentage() {
			this.allFalse();
			this.sort_by_ascending_scoring_percentage = false;
			this.sort_by_descending_scoring_percentage = true;
			let temp_assigned_task_list = [...this.assigned_tasks_list];
			temp_assigned_task_list.sort(
				(a, b) => b.scoring_percentage_yes_no - a.scoring_percentage_yes_no
			);
			this.assigned_tasks_list = [...temp_assigned_task_list];
		},
		sortByAscendingScoringPercentage() {
			this.allFalse();
			this.sort_by_descending_scoring_percentage = false;
			this.sort_by_ascending_scoring_percentage = true;
			let temp_assigned_task_list = [...this.assigned_tasks_list];
			temp_assigned_task_list.sort(
				(a, b) => a.scoring_percentage_yes_no - b.scoring_percentage_yes_no
			);
			this.assigned_tasks_list = [...temp_assigned_task_list];
		},
		sortByDescendingCompRate() {
			this.allFalse();
			this.sort_by_ascending_comp_rate = false;
			this.sort_by_descending_comp_rate = true;
		},
		sortByAscendingCompRate() {
			this.allFalse();
			this.sort_by_ascending_comp_rate = true;
			this.sort_by_descending_comp_rate = false;
		},
		sortByAscendingAuditReportsPointsAvailable() {
			this.allFalse();
			this.sort_by_ascending_audit_report_points_available = true;
			this.sort_by_descending_audit_report_points_available = false;
		},
		sortByDescendingAuditReportsPointsAvailable() {
			this.allFalse();
			this.sort_by_ascending_audit_report_points_available = false;
			this.sort_by_descending_audit_report_points_available = true;
		},
		sortByAscendingAuditReportsPointsAchieved() {
			this.allFalse();
			this.sort_by_ascending_audit_report_points_achieved = true;
			this.sort_by_descending_audit_report_points_achieved = false;
		},
		sortByDescendingAuditReportsPointsAchieved() {
			this.allFalse();
			this.sort_by_ascending_audit_report_points_achieved = false;
			this.sort_by_descending_audit_report_points_achieved = true;
		},
		sortByAscendingAuditReportsPercentage() {
			this.allFalse();
			this.sort_by_ascending_audit_report_percentage = true;
			this.sort_by_descending_audit_report_percentage = false;
		},
		sortByDescendingAuditReportsPercentage() {
			this.allFalse();
			this.sort_by_ascending_audit_report_percentage = false;
			this.sort_by_descending_audit_report_percentage = true;
		},
		sortByAscendingTaskReportsAssigned() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_assigned = true;
			this.sort_by_descending_task_report_task_assigned = false;
		},
		sortByDescendingTaskReportsAssigned() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_assigned = false;
			this.sort_by_descending_task_report_task_assigned = true;
		},
		sortByAscendingTaskReportsCompleted() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_completed = true;
			this.sort_by_descending_task_report_task_completed = false;
		},
		sortByDescendingTaskReportsCompleted() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_completed = false;
			this.sort_by_descending_task_report_task_completed = true;
		},
		sortByAscendingTaskReportsIncomplete() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_incomplete = true;
			this.sort_by_descending_task_report_task_incomplete = false;
		},
		sortByDescendingTaskReportsIncomplete() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_incomplete = false;
			this.sort_by_descending_task_report_task_incomplete = true;
		},
		sortByAscendingTaskReportsCompletionRate() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_completion_rate = true;
			this.sort_by_descending_task_report_task_completion_rate = false;
		},
		sortByDescendingTaskReportsCompletionRate() {
			this.allFalse();
			this.sort_by_ascending_task_report_task_completion_rate = false;
			this.sort_by_descending_task_report_task_completion_rate = true;
		},
		allFalse() {
			this.sort_by_ascending_rank = false;
			this.sort_by_descending_rank = false;
			this.sort_by_ascending_task_assigned = false;
			this.sort_by_descending_task_assigned = false;
			this.sort_by_ascending_completed = false;
			this.sort_by_descending_completed = false;
			this.sort_by_ascending_points_achieved = true;
			this.sort_by_descending_points_achieved = false;
			this.sort_by_ascending_comp_rate = false;
			this.sort_by_descending_comp_rate = false;
			this.sort_by_ascending_audit_report_points_available = false;
			this.sort_by_descending_audit_report_points_available = false;
			this.sort_by_ascending_audit_report_points_achieved = false;
			this.sort_by_descending_audit_report_points_achieved = false;
			this.sort_by_ascending_audit_report_percentage = false;
			this.sort_by_descending_audit_report_percentage = false;
			this.sort_by_ascending_task_report_task_assigned = false;
			this.sort_by_descending_task_report_task_assigned = false;
			this.sort_by_ascending_task_report_task_completed = false;
			this.sort_by_descending_task_report_task_completed = false;
			this.sort_by_ascending_task_report_task_completed = false;
			this.sort_by_descending_task_report_task_completed = false;
			this.sort_by_ascending_task_report_task_completion_rate = false;
			this.sort_by_descending_task_report_task_completion_rate = false;
			this.sort_by_ascending_points_available = true;
			this.sort_by_descending_points_available = false;
			this.sort_by_ascending_scoring_percentage = true;
			this.sort_by_descending_scoring_percentage = false;
		},
		selectAllTaskName() {
			this.selected_filter_task = [];
			for (let i in this.task_array) {
				this.selected_filter_task.push(this.task_array[i]);
			}
		},
		resetSelectedTaskName() {
			this.selected_filter_task = [];
		},
		selectAllLocations() {
			this.selected_location_filter = [];
			for (let i in this.location_array) {
				this.selected_location_filter.push(this.location_array[i]);
			}
		},
		resetSelectedLocations() {
			this.selected_location_filter = [];
		},
		selectAllLocationsForAreaLead() {
			this.selected_location_filter_for_area_lead = [];
			for (let i in this.locations_for_area_lead) {
				this.selected_location_filter_for_area_lead.push(
					this.locations_for_area_lead[i]
				);
			}
		},
		resetSelectedLocationsForAreaLead() {
			this.selected_location_filter_for_area_lead = [];
		},
		selectAllAuditReportsLocations() {
			this.selected_location_filter_for_audit = [];
			for (let i in this.location_for_audit_reports) {
				this.selected_location_filter_for_audit.push(
					this.location_for_audit_reports[i]
				);
			}
		},
		resetSelectedAuditReportsLocations() {
			this.selected_location_filter_for_audit = [];
		},
		selectAllAuditReportsGrades() {
			this.selected_grade_filter_for_audit = [];
			for (let i in this.audit_report_grades) {
				this.selected_grade_filter_for_audit.push(this.audit_report_grades[i]);
			}
		},
		resetSelectedAuditReportsGrades() {
			this.selected_grade_filter_for_audit = [];
		},
		selectSubTaskName() {
			this.selected_sub_task_filter_task = [];
			for (let i in this.sub_task_array) {
				this.selected_sub_task_filter_task.push(this.sub_task_array[i]);
			}
		},
		resetSelectedSubTaskName() {
			this.selected_sub_task_filter_task = [];
		},
		viewDetailsCSVDownload() {
			this.selectedTitle =
				this.selectedTitle.charAt(0).toUpperCase() +
				this.selectedTitle.slice(1);
			let nameStr =
				"Task Report of " +
				this.selectedTitle +
				" from " +
				this.fromDate +
				" to " +
				this.toDate;
			serverAddrForCSV
				.post(`/task_assignment/report/download/`, this.selectedBasicsDetails)
				.then((response) => {
					if (response.status == 200) {
						let data = response.data;
						let urlData =
							"data:text/csv;charset=UTF-8," + encodeURIComponent(data);
						let tempLink = document.createElement("a");
						tempLink.href = urlData;
						tempLink.setAttribute("download", `${nameStr}.csv`);
						tempLink.click();
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		getViewDetailsData(item, desig) {
			this.selected_report = item;
			this.selected_designation = desig;
			this.resetBreadCrumbs();
			let obj = {
				name: item.name,
				type: "task",
			};
			this.breadcrumbs.push(obj);
			this.dialog_visible = true;
			this.is_datewise_reports_loading = true;
			this.date_wise_report = [];
			this.date_list = [];
			this.task_array = [];
			this.selected_filter_task = [];
			let params = {
				basics: "task",
				include_dates: true,
				task: null,
				filters: {
					// outlets: [item.basics]
					outlets: [],
				},
				designation: this.selected_designation ? this.selected_designation : "",
			};
			serverAddr
				.post(`/bk_task_assignment/report/?get_all=true`, params)
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						let date_array = [];
						let data_array = [];
						for (let index = 0; index < res.results.length; index++) {
							for (let j = 0; j < res.results[index].data.length; j++) {
								if (
									date_array.indexOf(res.results[index].data[j].due_date) == -1
								) {
									date_array.push(res.results[index].data[j].due_date);
								}
							}
							if (this.task_array.indexOf(res.results[index].name) == -1) {
								this.task_array.push(res.results[index].name);
							}
						}
						this.date_list = JSON.parse(JSON.stringify(date_array));
						this.date_list.forEach((element) => {
							let dataObj = {
								due_date: element,
								total_yes_no_points: "",
								total_yes_no_points_achieved: "",
								yes_no_points_percentage: "",
								rank: "",
								basics: "",
							};
							data_array.push(dataObj);
						});
						for (let index = 0; index < res.results.length; index++) {
							for (
								let index2 = 0;
								index2 < res.results[index].data.length;
								index2++
							) {
								let elIndex = this.date_list.indexOf(
									res.results[index].data[index2].due_date
								);
								if (elIndex > -1) {
									data_array[elIndex].total_yes_no_points =
										res.results[index].data[index2].total_yes_no_points;
									data_array[elIndex].total_yes_no_points_achieved =
										res.results[index].data[
											index2
										].total_yes_no_points_achieved;
									data_array[elIndex].yes_no_points_percentage =
										res.results[index].data[index2].yes_no_points_percentage;
									data_array[elIndex].rank =
										res.results[index].data[index2].rank;
									data_array[elIndex].basics =
										res.results[index].data[index2].basics;
								}
							}
							res.results[index].data = data_array;
						}
						this.date_wise_report = res.results;
					}
					this.is_datewise_reports_loading = false;
				})
				.catch((error) => {
					console.error(error);
					this.is_datewise_reports_loading = false;
					this.date_wise_report = [];
					this.date_list = [];
				});
		},
		getDateWiseSubstepReport(task) {
			this.selected_sub_task = task;
			this.resetBreadCrumbs();
			let task_obj = {
				name: this.selected_report.name,
				type: "task",
			};
			this.breadcrumbs.push(task_obj);
			let sub_task_obj = {
				name: task.name,
				type: "sub_task",
			};
			this.breadcrumbs.push(sub_task_obj);
			this.dialog_visible_for_steps_report = true;
			this.is_datewise_steps_reports_loading = true;
			this.selected_subtask_report = [];
			this.date_list_for_sub_step = [];
			this.sub_task_array = [];
			this.selected_sub_task_filter_task = [];
			let params = {
				basics: "subtask",
				include_dates: true,
				task: task.basics,
				filters: {
					// outlets: [this.selected_report.basics]
					outlets: [],
				},
				designation: this.selected_designation ? this.selected_designation : "",
			};
			serverAddr
				.post(`/bk_task_assignment/report/?get_all=true`, params)
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						let date_array = [];
						let data_array = [];
						for (let index = 0; index < res.results.length; index++) {
							for (let j = 0; j < res.results[index].data.length; j++) {
								if (
									date_array.indexOf(res.results[index].data[j].due_date) == -1
								) {
									date_array.push(res.results[index].data[j].due_date);
								}
							}
							if (this.sub_task_array.indexOf(res.results[index].name) == -1) {
								this.sub_task_array.push(res.results[index].name);
							}
						}
						this.date_list_for_sub_step = JSON.parse(
							JSON.stringify(date_array)
						);
						this.date_list_for_sub_step.forEach((element) => {
							let dataObj = {
								due_date: element,
								total_yes_no_points: "",
								total_yes_no_points_achieved: "",
								yes_no_points_percentage: "",
								rank: "",
								basics: "",
							};
							data_array.push(dataObj);
						});
						for (let index = 0; index < res.results.length; index++) {
							for (
								let index2 = 0;
								index2 < res.results[index].data.length;
								index2++
							) {
								let elIndex = this.date_list_for_sub_step.indexOf(
									res.results[index].data[index2].due_date
								);
								if (elIndex > -1) {
									data_array[elIndex].total_yes_no_points =
										res.results[index].data[index2].total_yes_no_points;
									data_array[elIndex].total_yes_no_points_achieved =
										res.results[index].data[
											index2
										].total_yes_no_points_achieved;
									data_array[elIndex].yes_no_points_percentage =
										res.results[index].data[index2].yes_no_points_percentage;
									data_array[elIndex].rank =
										res.results[index].data[index2].rank;
									data_array[elIndex].basics =
										res.results[index].data[index2].basics;
								}
							}
							res.results[index].data = data_array;
						}
						this.selected_subtask_report = res.results;
					}
					this.is_datewise_steps_reports_loading = false;
					this.audit_report_date_arr = res.meta.due_dates_list;
				})
				.catch((error) => {
					console.error(error);
					this.$notify.error({
						title: "Error",
						message: "Something went wrong!",
					});
					this.is_datewise_steps_reports_loading = false;
					this.selected_subtask_report = [];
					this.date_list_for_sub_step = [];
				});
		},
		disabledDueDateAt(time) {
			return time.getTime() < Date.now() - 8.64e7;
		},
		disabledDueDate(time) {
			return time.getTime() > Date.now() - 8.64e7;
		},
		disabledToDate(time) {
			let fromDate = new Date(this.fromDate);
			fromDate = fromDate.getTime();
			if (time.getTime() <= fromDate - 8.64e7) {
				return time.getTime() < fromDate - 8.64e7;
			} else {
				return time.getTime() > Date.now() - 8.64e7;
			}
		},
		disabledTaskToDate(time) {
			let fromDate = new Date(this.task_from_date);
			fromDate = fromDate.getTime();
			if (time.getTime() <= fromDate - 8.64e7) {
				return time.getTime() < fromDate - 8.64e7;
			} else {
				return time.getTime() > Date.now() - 8.64e7;
			}
		},
		disabledTaskReportToDate(time) {
			let fromDate = new Date(this.fromDate);
			fromDate = fromDate.getTime();
			if (time.getTime() <= fromDate - 8.64e7) {
				return time.getTime() < fromDate - 8.64e7;
			} else {
				return time.getTime() > Date.now() - 8.64e7;
			}
		},
		disabledToDateAt(time) {
			let fromDate = new Date(this.assignTask_start_date);
			fromDate = fromDate.getTime();
			if (time.getTime() <= fromDate - 8.64e7) {
				return time.getTime() < fromDate - 8.64e7;
			} else {
				return time.getTime() > Date.now() - 8.64e7;
			}
		},
		changeTblData(item, index) {
			if (index == this.breadcrumbs.length - 1) return;
			if (item.type == "location") {
				this.resetBreadCrumbs(); //reset index
				this.dialog_visible = false;
				this.dialog_visible_for_steps_report = false;
			} else if (item.type == "task") {
				this.breadcrumbs.pop(); //removed last index
				this.dialog_visible_for_steps_report = false;
			}
		},
		changeTaskByLocationBreadcrumb(name, id, type) {
			if (type == "country") {
				this.filters = {
					countries: [id],
					regions: [],
					subregions: [],
					outlets: [],
				};
				this.resetTasksBreadCrumbs();
				this.task_breadcrumbs[0].name = name;
				this.task_breadcrumbs[0].type = type;
				this.task_breadcrumbs[0].id = id;
				this.basics = "region";
			} else if (type == "region") {
				this.filters = {
					countries: [],
					regions: [id],
					subregions: [],
					outlets: [],
				};
				this.basics = "subregion";
				this.task_breadcrumbs[1].name = name;
				this.task_breadcrumbs[1].type = type;
				this.task_breadcrumbs[1].id = id;
				this.task_breadcrumbs[2].name = "";
				this.task_breadcrumbs[2].type = "";
				this.task_breadcrumbs[2].id = "";
				this.task_breadcrumbs[3].name = "";
				this.task_breadcrumbs[3].type = "";
				this.task_breadcrumbs[3].id = "";
			} else if (type == "subregion") {
				this.filters = {
					countries: [],
					regions: [],
					subregions: [id],
					outlets: [],
				};
				this.basics = "outlet";
				this.task_breadcrumbs[2].name = name;
				this.task_breadcrumbs[2].type = type;
				this.task_breadcrumbs[2].id = id;
				this.task_breadcrumbs[3].name = "";
				this.task_breadcrumbs[3].type = "";
				this.task_breadcrumbs[3].id = "";
			} else if (type == "store") {
				this.filters = {
					countries: [],
					regions: [],
					subregions: [],
					outlets: [id],
				};
				this.basics = "employee";
				this.task_breadcrumbs[3].name = name;
				this.task_breadcrumbs[3].type = type;
				this.task_breadcrumbs[3].id = id;
			}
			this.getTaskById();
		},
		getTopData() {
			if (!this.fromDate || !this.toDate) {
				return;
			}
			let basics = "";
			if (this.basics == "region") {
				basics = "country";
			} else if (this.basics == "subregion") {
				basics = "region";
			} else if (this.basics == "outlet") {
				basics = "subregion";
			}
			if (basics.length) {
				serverAddr
					.post(`/task_assignment/report/?get_all=true`, {
						start_date: this.fromDate,
						end_date: this.toDate,
						basics: basics,
						include_dates: false,
						employee: null,
						filters: this.filters,
					})
					.then((response) => {
						if (response.status == 200) {
							let res = JSON.parse(response.data);
							if (res.results.length) {
								this.topReportData = res.results;
							} else {
								this.topReportData = [this.for_empty_report_obj];
							}

							this.topReportData.forEach((element) => {
								element.isTopReport = true;
								element.reportBasics = "employee";
							});
							// set nameheaders for table
							if (this.basics == "region") {
								this.nameHeader = "region";
								this.firstNameHeader = "country";
							} else if (this.basics == "subregion") {
								this.nameHeader = "subregion";
								this.firstNameHeader = "region";
							} else if (this.basics == "outlet") {
								this.nameHeader = "store";
								this.firstNameHeader = "subregion";
							} else if (this.basics == "employee") {
								this.nameHeader = "employee";
								this.firstNameHeader = "Employee name";
							}
							// add name headers in table
							let firstHead = [
								{ name: this.firstNameHeader, isNameHead: true },
							];
							this.topReportData = firstHead.concat(this.topReportData);
						}
					})
					.catch((error) => {
						console.error(error);
						this.nameHeader = "";
						this.firstNameHeader = "";
						this.loading = false;
						this.is_report_list_loading = false;
					});
			} else {
				this.topReportData = [];
			}
		},
		async getAuditReportData() {
			this.is_audit_report_list_loading = true;
			this.audit_reports = [];
			this.location_for_audit_reports = [];
			this.search_location_for_audit = "";
			this.selected_location_filter_for_audit = [];
			this.audit_report_grades = [];
			let report_res = await this.getReports(null, "audit");
			if (report_res.status == 200) {
				let res = JSON.parse(report_res.data);
				for (let i = 0; i < res.results.length; i++) {
					if (
						this.location_for_audit_reports.indexOf(res.results[i].name) == -1
					) {
						this.location_for_audit_reports.push(res.results[i].name);
					}
				}
				for (let j = 0; j < res.results.length; j++) {
					if (
						this.audit_report_grades.indexOf(res.results[j].grade) == -1 &&
						res.results[j].grade != "-"
					) {
						this.audit_report_grades.push(res.results[j].grade);
					}
				}
				this.audit_reports = res.results;
				this.audit_report_date_arr = res.meta.due_dates_list;
			}
			this.is_audit_report_list_loading = false;
		},
		async getTasksReportData(
			start_date = this.task_from_date,
			end_date = this.task_to_date
		) {
			this.is_task_report_list_loading = true;
			this.task_reports = [];
			this.location_for_task_reports = [];
			this.search_location_for_task = "";
			this.selected_location_filter_for_task = [];
			let report_res = await this.getTaskReportDetails(
				null,
				"other",
				start_date,
				end_date
			);
			if (report_res && report_res.status && report_res.status == 200) {
				let res = JSON.parse(report_res.data);
				for (let i = 0; i < res.results.length; i++) {
					if (
						this.location_for_task_reports.indexOf(res.results[i].name) == -1
					) {
						this.location_for_task_reports.push(res.results[i].name);
					}
				}
				let tempArr = [...res.results];
				tempArr.sort((a, b) => b.completion_rate - a.completion_rate);
				this.task_reports = [...tempArr];
			}
			this.is_task_report_list_loading = false;
		},
		async getReportData() {
			this.is_report_list_loading = true;
			this.table_data = [];
			this.area_lead_reportable_data = [];
			this.location_array = [];
			this.locations_for_area_lead = [];
			this.rem_lead_reportable_data = [];
			this.locations_for_rem_lead = [];
			this.search_location = "";
			this.selected_location_filter = [];
			this.resetBreadCrumbs();
			let report_res = await this.getReports(
				this.user_designation == "Market Lead" ||
					this.user_access_level == "admin" ||
					this.user_designation == "Regional Manager" ||
					this.user_designation == "REM"
					? "Market Lead"
					: "Area Lead",
				"cleanliness"
			);
			let aread_lead_reports_res = "";
			if (
				this.user_designation == "Regional Manager" ||
				this.user_designation == "REM" ||
				this.user_designation == "Market Lead" ||
				this.user_designation == "Area Lead" ||
				this.user_access_level == "admin"
			) {
				aread_lead_reports_res = await this.getReports(
					"Area Lead",
					"cleanliness"
				);
			}
			let rem_lead_reports_res = "";
			let regional_manager_reports_res = "";
			if (
				this.user_designation == "Regional Manager" ||
				this.user_designation == "REM" ||
				this.user_access_level == "admin"
			) {
				let designation_name = this.user_designation;
				if (this.user_access_level == "admin") {
					designation_name = "Regional Manager";
					regional_manager_reports_res = await this.getReports(
						designation_name,
						"cleanliness"
					);
					designation_name = "REM";
					rem_lead_reports_res = await this.getReports(
						designation_name,
						"cleanliness"
					);
				} else if (this.user_designation == "Regional Manager") {
					designation_name = "Regional Manager";
					regional_manager_reports_res = await this.getReports(
						designation_name,
						"cleanliness"
					);
				} else if (this.user_designation == "REM") {
					designation_name = "REM";
					rem_lead_reports_res = await this.getReports(
						designation_name,
						"cleanliness"
					);
				}
			}
			if (report_res.status == 200) {
				let res = JSON.parse(report_res.data);
				for (let i = 0; i < res.results.length; i++) {
					this.$set(
						res.results[i],
						"is_nomination_enabled",
						res.results[i].is_nominated
					);
					if (this.location_array.indexOf(res.results[i].name) == -1) {
						this.location_array.push(res.results[i].name);
					}
				}
				this.table_data = res.results;
			}
			if (aread_lead_reports_res.status == 200) {
				let res = JSON.parse(aread_lead_reports_res.data);
				for (let i = 0; i < res.results.length; i++) {
					if (this.locations_for_area_lead.indexOf(res.results[i].name) == -1) {
						this.locations_for_area_lead.push(res.results[i].name);
					}
				}
				this.area_lead_reportable_data = res.results;
			}

			if (regional_manager_reports_res.status == 200) {
				let res = JSON.parse(regional_manager_reports_res.data);
				for (let i = 0; i < res.results.length; i++) {
					if (this.locations_for_rem_lead.indexOf(res.results[i].name) == -1) {
						this.locations_for_rem_lead.push(res.results[i].name);
					}
				}
				let tempRes = [];
				res.results.forEach((el) => {
					let temp = { ...el };
					temp["designation"] = "Regional Manager";
					tempRes.push(temp);
				});
				this.rem_lead_reportable_data = [
					...this.rem_lead_reportable_data,
					...tempRes,
				];
			}
			if (rem_lead_reports_res.status == 200) {
				let res = JSON.parse(rem_lead_reports_res.data);
				for (let i = 0; i < res.results.length; i++) {
					if (this.locations_for_rem_lead.indexOf(res.results[i].name) == -1) {
						this.locations_for_rem_lead.push(res.results[i].name);
					}
				}
				let tempRes = [];
				res.results.forEach((el) => {
					let temp = { ...el };
					temp["designation"] = "REM";
					tempRes.push(temp);
				});
				this.rem_lead_reportable_data = [
					...this.rem_lead_reportable_data,
					...tempRes,
				];
			}
			this.is_report_list_loading = false;
		},
		getReports(designation, main_category) {
			this.resetAuditReports();
			if (main_category == "audit" || this.dashboardActiveTabLink == "audit") {
				this.audit_reports_dates = [];
				let dates = [];
				let currDate = moment(this.fromDate).startOf("day");
				let lastDate = moment(this.toDate).startOf("day");
				dates.push(moment(currDate).format("YYYY-MM-DD"));
				while (currDate.add(1, "days").diff(lastDate) < 0) {
					if (
						!dates.includes(
							moment(currDate.clone().toDate()).format("YYYY-MM-DD")
						)
					) {
						dates.push(moment(currDate.clone().toDate()).format("YYYY-MM-DD"));
					}
				}
				dates.push(moment(lastDate).format("YYYY-MM-DD"));
				for (let i = 0; i < dates.length; i++) {
					if (!this.audit_reports_dates.includes(dates[i])) {
						this.audit_reports_dates.push(dates[i]);
					}
				}
				return serverAddr
					.post(`/bk_task_assignment/report/?get_all=true`, {
						basics: "outlet",
						include_dates: true,
						start_date: moment(this.fromDate).format("YYYY-MM-DD"),
						end_date: moment(this.toDate).format("YYYY-MM-DD"),
						filters: {
							nameValuePairs: {
								outlets: [],
							},
						},
						designation: designation,
						main_category: main_category,
					})
					.then((response) => {
						let responseData = JSON.parse(response.data);
						this.audit_report_date_arr = responseData.meta.due_dates_list;
						this.audit_reports = responseData.results;
						return response;
					})
					.catch((error) => {
						console.error(error);
						this.$notify.error({
							title: "Error",
							message: "Something went wrong!",
						});
						this.is_report_list_loading = false;
					});
			} else {
				return serverAddr
					.post(`/bk_task_assignment/report/?get_all=true`, {
						basics: "outlet",
						include_dates: false,
						task: null,
						filters: {
							outlets: [],
						},
						designation: designation,
						main_category: main_category,
					})
					.then((response) => {
						let responseData = JSON.parse(response.data);
						this.audit_report_date_arr = responseData.meta.due_dates_list;
						return response;
					})
					.catch((error) => {
						console.error(error);
						this.is_report_list_loading = false;
					});
			}
		},
		getTaskReportDetails(
			designation,
			main_category,
			start_date = this.task_from_date,
			end_date = this.task_to_date
		) {
			this.resetTaskReports();
			this.is_task_report_list_loading = true;
			let startDate =
				this.activeTabLink == "INSIGHTS" ? this.fromDate : this.task_from_date;
			let endDate =
				this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
			const params = {
				basics: "outlet",
				start_date: startDate,
				end_date: endDate,
				include_dates: false,
				employee: null,
				task: null,
				filters: {
					countries: [],
					regions: [],
					subregions: [],
					outlets: [],
				},
				category: null,
			};
			if (this.activeTabLink == "INSIGHTS") {
				params.intermediate_category = this.selected_audit_type;
				if (this.select_outlet) {
					params.filters.outlets = [this.select_outlet];
				}
			}
			if (!startDate || !endDate) {
				return;
			}
			return serverAddr
				.post(`/task_assignment/report/?get_all=true`, params)
				.then((response) => {
					this.is_task_report_list_loading = false;
					return response;
				})
				.catch((error) => {
					console.error(error);
					this.is_task_report_list_loading = false;
				});
		},
		resetTaskReports() {
			this.task_reports = [];
			this.location_for_task_reports = [];
			this.search_location_for_task = "";
			this.selected_location_filter_for_task = [];
			this.location_for_task_reports = [];
			this.selected_task_report_dialog_title = "";
			this.task_report_categories = [];
			this.task_report_employees = [];
			this.task_report_type = "";
			this.task_report_tasks = [];
			this.task_report_breadcrumb_elements = [];
		},
		showTaskReportDetailDialog() {
			this.task_report_detail_show = true;
		},
		async getTaskOutletReport(outlet, title) {
			this.selected_task_report_dialog_title = title;
			this.task_report_type = "employee";
			this.task_report_breadcrumb_elements.push({
				title: title,
				level: "employee",
			});
			this.selected_task_report_outlet = outlet;
			this.showTaskReportDetailDialog();
			let task_outlet_report_data = await this.fetchTaskOutletReportData(
				outlet
			);
			let task_emp_report_list = "";
			if (task_outlet_report_data.status == 200) {
				task_emp_report_list = JSON.parse(task_outlet_report_data.data);
				if (task_emp_report_list.results) {
					this.task_report_employees = task_emp_report_list.results;
				}
			}
		},

		async getTaskCategoryData(outlet, title) {
			this.selected_task_report_dialog_title = title;
			this.task_report_type = "category";
			this.task_report_breadcrumb_elements.push({
				title: title,
				level: "category",
			});
			this.selected_task_report_outlet = outlet;
			this.showTaskReportDetailDialog();
			let task_outlet_report_data = await this.fetchTaskCategoryReportData(
				outlet
			);
			let task_emp_report_list = "";
			if (task_outlet_report_data.status == 200) {
				task_emp_report_list = JSON.parse(task_outlet_report_data.data);
				if (task_emp_report_list.results) {
					this.task_report_categories = task_emp_report_list.results;
				}
			}
		},

		async getTaskCategoryTasksData(category, title) {
			this.selected_task_report_dialog_title = title;
			this.all_task_report_dates = [];
			this.task_report_type = "task";
			this.task_report_breadcrumb_elements.push({
				title: title,
				level: "task",
			});
			this.selected_task_report_category = category;
			this.showTaskReportDetailDialog();
			let task_outlet_report_data = await this.fetchTaskReportTasksData(
				category
			);
			let task_emp_report_list = "";
			if (task_outlet_report_data.status == 200) {
				task_emp_report_list = JSON.parse(task_outlet_report_data.data);
				let arr = [];
				for (
					let dt = new Date(this.fromDate);
					dt <= new Date(this.toDate);
					dt.setDate(dt.getDate() + 1)
				) {
					arr.push(new Date(dt));
				}
				this.all_task_report_dates = arr;
				if (task_emp_report_list.results) {
					this.task_report_tasks = task_emp_report_list.results;
				}
			}
		},
		async getTaskEmployeeTasksData(category, title) {
			this.selected_task_report_dialog_title = title;
			this.all_task_report_dates = [];
			this.task_report_type = "task";
			this.task_report_breadcrumb_elements.push({
				title: title,
				level: "task",
			});
			this.showTaskReportDetailDialog();
			let task_outlet_report_data = await this.fetchEmployeeTaskReportTasksData(
				category
			);
			let task_emp_report_list = "";
			if (task_outlet_report_data.status == 200) {
				task_emp_report_list = JSON.parse(task_outlet_report_data.data);
				if (task_emp_report_list.results) {
					let arr = [];
					for (
						let dt = new Date(this.task_from_date);
						dt <= new Date(this.task_to_date);
						dt.setDate(dt.getDate() + 1)
					) {
						arr.push(new Date(dt));
					}
					this.all_task_report_dates = arr;
					this.task_report_tasks = task_emp_report_list.results;
				}
			}
		},

		fetchTaskOutletReportData(outlet) {
			this.is_task_report_list_loading = true;
			let startDate =
				this.activeTabLink == "INSIGHTS" ? this.fromDate : this.task_from_date;
			let endDate =
				this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
			if (!startDate || !endDate) {
				return;
			}
			return serverAddr
				.post(`/task_assignment/report/?get_all=true`, {
					basics: "employee",
					start_date: startDate,
					end_date: endDate,
					include_dates: false,
					employee: null,
					task: null,
					filters: {
						countries: [],
						regions: [],
						subregions: [],
						outlets: [outlet],
					},
					category: null,
				})
				.then((response) => {
					this.is_task_report_list_loading = false;
					return response;
				})
				.catch((error) => {
					console.error(error);
					this.is_task_report_list_loading = false;
				});
		},
		fetchTaskCategoryReportData(outlet) {
			this.is_task_report_list_loading = true;
			let startDate =
				this.activeTabLink == "INSIGHTS" ? this.fromDate : this.task_from_date;
			let endDate =
				this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
			const params = {
				basics: "category",
				start_date: startDate,
				end_date: endDate,
				include_dates: false,
				employee: null,
				task: null,
				filters: {
					countries: [],
					regions: [],
					subregions: [],
					outlets: [outlet],
				},
				category: null,
			};
			if (this.activeTabLink == "INSIGHTS") {
				params.intermediate_category = this.selected_audit_type;
			}
			if (!startDate || !endDate) {
				return;
			}
			if (
				this.selected_dropdown_category &&
				this.selected_dropdown_category.filter_from_1st
			) {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				let updatedFromDate = moment(firstDay).format("YYYY-MM-DD");
				if (updatedFromDate) {
					params.start_date = updatedFromDate;
				}
			}
			return serverAddr
				.post(`/task_assignment/report/?get_all=true`, params)
				.then((response) => {
					this.is_task_report_list_loading = false;
					return response;
				})
				.catch((error) => {
					console.error(error);
					this.is_task_report_list_loading = false;
				});
		},
		fetchTaskReportTasksData(category) {
			this.is_task_report_list_loading = true;
			let startDate =
				this.activeTabLink == "INSIGHTS" ? this.fromDate : this.task_from_date;
			let endDate =
				this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
			const params = {
				basics: "task",
				start_date: startDate,
				end_date: endDate,
				include_dates: true,
				employee: null,
				task: null,
				filters: {
					countries: [],
					regions: [],
					subregions: [],
					outlets: [this.selected_task_report_outlet],
				},
				category: category,
			};
			if (this.activeTabLink == "INSIGHTS") {
				params.intermediate_category = this.selected_audit_type;
			}
			if (!startDate || !endDate) {
				return;
			}
			return serverAddr
				.post(`/task_assignment/report/?get_all=true`, params)
				.then((response) => {
					this.is_task_report_list_loading = false;
					return response;
				})
				.catch((error) => {
					console.error(error);
					this.is_task_report_list_loading = false;
				});
		},
		fetchEmployeeTaskReportTasksData(employee) {
			this.is_task_report_list_loading = true;
			let startDate =
				this.activeTabLink == "INSIGHTS" ? this.fromDate : this.task_from_date;
			let endDate =
				this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
			const params = {
				basics: "task",
				start_date: startDate,
				end_date: endDate,
				include_dates: true,
				employee: employee,
				task: null,
				filters: {
					countries: [],
					regions: [],
					subregions: [],
					outlets: [this.selected_task_report_outlet],
				},
				category: null,
			};
			if (this.activeTabLink == "INSIGHTS") {
				params.intermediate_category = this.selected_audit_type;
			}
			if (!startDate || !endDate) {
				return;
			}
			return serverAddr
				.post(`/task_assignment/report/?get_all=true`, params)
				.then((response) => {
					this.is_task_report_list_loading = false;
					return response;
				})
				.catch((error) => {
					console.error(error);
					this.is_task_report_list_loading = false;
				});
		},
		async openTaskReportSubTask(task, title) {
			this.task_report_type = "subtask";
			let subtasks = await this.fetchTaskReportSummary(task);
			this.task_report_breadcrumb_elements.push({
				title: title,
				level: "subtask",
			});
			if (subtasks.status == 200) {
				let subtasksResponse = JSON.parse(subtasks.data);
				if (subtasksResponse.results) {
					this.task_reports_subtasks = subtasksResponse.results;
					let arr = [];
					let startDate =
						this.activeTabLink == "INSIGHTS"
							? this.fromDate
							: this.task_from_date;
					let endDate =
						this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
					for (
						let dt = new Date(startDate);
						dt <= new Date(endDate);
						dt.setDate(dt.getDate() + 1)
					) {
						arr.push(new Date(dt));
					}
					this.subtasks_reports_dates = arr;
				}
			}
		},
		fetchTaskReportSummary(task) {
			this.is_task_report_list_loading = true;
			let startDate =
				this.activeTabLink == "INSIGHTS" ? this.fromDate : this.task_from_date;
			let endDate =
				this.activeTabLink == "INSIGHTS" ? this.toDate : this.task_to_date;
			let params = {
				task: task,
				start_date: startDate,
				end_date: endDate,
			};
			if (this.activeTabLink == "INSIGHTS") {
				params.intermediate_category = this.selected_audit_type;
			}
			return serverAddr
				.post(`/subtask/report/?get_all=true`, params)
				.then((res) => {
					this.is_task_report_list_loading = false;
					return res;
				})
				.catch((err) => {
					this.is_task_report_list_loading = false;
					console.error(err);
				});
		},
		getSummaryData() {
			let basics = "summary";
			serverAddr
				.post(`/task_assignment/report/`, {
					start_date: this.fromDate,
					end_date: this.toDate,
					basics: basics,
					include_dates: false,
					employee: null,
					filters: this.filters,
				})
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						if (res.results.length) {
							this.reportSummary = res.results[0];
						}
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
					this.is_report_list_loading = false;
					this.is_tasks_list_loading = false;
				});
		},
		getReportCSVDownload() {
			let current_user_designation = null;
			if (this.user_access_level == "admin") {
				current_user_designation = "all";
			} else {
				current_user_designation = this.user_designation;
			}
			let params = {
				basics: "outlet",
				include_dates: false,
				task: null,
				filters: {
					outlets: [],
				},
				designation: current_user_designation,
			};
			serverAddrForCSV
				.post(`/bk_task_assignment/report/download/`, params)
				.then((response) => {
					if (response.status == 200) {
						let data = response.data;

						let urlData =
							"data:text/csv;charset=UTF-8," + encodeURIComponent(data);

						let tempLink = document.createElement("a");
						tempLink.href = urlData;
						tempLink.setAttribute("download", `task_reports.csv`);
						tempLink.click();
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		resetBreadCrumbs() {
			this.breadcrumbs = [
				{
					name: "All",
					type: "location",
				},
			];
		},
		resetTasksBreadCrumbs() {
			this.task_breadcrumbs = [
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
				{
					name: "",
					type: "",
					id: "",
				},
			];
		},
		dropDownUpdateForCreateTask(updt) {
			this.createTaskFilters = {
				countries: [],
				regions: [],
				subregions: [],
				outlets: [],
			};
			this.isSelectedLocationRegion = false;
			let selectedLocation = updt.selected;
			if (updt.selected.length) {
				if (updt.selected[0].type == "subregion") {
					this.createTaskFilters.subregions = selectedLocation.map((e) => {
						return e.id;
					});
				} else if (updt.selected[0].type == "country") {
					this.createTaskFilters.countries = selectedLocation.map((e) => {
						return e.id;
					});
				} else if (updt.selected[0].type == "region") {
					this.createTaskFilters.regions = selectedLocation.map((e) => {
						return e.id;
					});
				} else if (updt.selected[0].type == "outlet") {
					this.createTaskFilters.outlets = selectedLocation.map((e) => {
						return e.id;
					});
					this.isSelectedLocationRegion = true;
				}
				this.getDesignation();
				this.clearAssignTaskFields();
			} else {
				this.clearAssignTaskFields();
				this.createTaskFilters = {
					countries: [],
					regions: [],
					subregions: [],
					outlets: [],
				};
			}
		},
		clearAssignTaskFields() {
			this.selectedDesignationForAssignTask = "";
			this.select_task = "";
			this.selected_task_id = "";
			this.selected_assignTaskemp = "";
			this.selected_assignTaskStore = [];
			this.assignTask_storeList = [];
			this.designationList = [];
			this.assignTask_empList = [];
			this.task_list = [];
			this.selected_task_freq = "";
			this.selected_task_days = [];
			this.selectedDesignation = [];
		},
		async getDesignation() {
			await serverAddr
				.post(`/users/designations/list/`, {
					filters: this.createTaskFilters,
				})
				.then(async (response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						this.designationList = res;
						this.designationListNew = JSON.parse(response.data);
						// select task if only one in list
						if (this.designationList.length == 1) {
							this.selectedDesignation = [this.designationList[0].id];
							this.selectedDesignationForAssignTask =
								this.designationList[0].id;
							await this.getTaskList();
						}
						this.select_task = "";
						this.selected_task_id = "";
						this.task_list = [];
						this.assignTask_empList = [];
						this.assignTask_storeList = [];
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		getEmployeeByTask(action) {
			this.selected_assignTaskemp = "";
			this.assignTask_empList = [];
			if (!action) {
				this.selected_task_id = this.task_list[this.select_task].id;
			}
			for (
				let task_index = 0;
				task_index < this.task_list.length;
				task_index++
			) {
				if (this.selected_task_id == this.task_list[task_index].id) {
					this.selected_task_freq = this.task_list[task_index].frequency;
					this.start_time = this.task_list[this.select_task].start_time;
					this.end_time = this.task_list[this.select_task].end_time;
					if (this.selected_task_freq == "weekly") {
						this.selected_task_days =
							this.task_list[task_index].frequency_day_selection;
					} else if (this.selected_task_freq == "monthly") {
						this.selected_task_days =
							this.task_list[task_index].monthly_frequency;
					}
				}
			}
			let params = {};
			params.outlet = this.createTaskFilters.outlets[0]
				? this.createTaskFilters.outlets[0]
				: null;
			params.region = this.createTaskFilters.regions[0]
				? this.createTaskFilters.regions[0]
				: null;
			params.subregion = this.createTaskFilters.subregions[0]
				? this.createTaskFilters.subregions[0]
				: null;
			params.country = this.createTaskFilters.countries[0]
				? this.createTaskFilters.countries[0]
				: null;
			params.designation = this.selectedDesignationForAssignTask;
			params.task = this.selected_task_id;
			serverAddr
				.post(`/read/employees_for_task/`, params)
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						this.assignTask_empList = res;
						// select employee if only one in list
						if (this.assignTask_empList.length == 1) {
							this.selected_assignTaskemp = this.assignTask_empList[0].id;
							if (!this.isSelectedLocationRegion && !action) {
								this.getTaskAssignment();
							}
						}
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		getTaskAssignment() {
			this.selected_assignTaskStore = [];
			this.assignTask_storeList = [];
			let applicableStoreParam = "";
			applicableStoreParam = this.createTaskFilters.regions[0]
				? `region=${this.createTaskFilters.regions[0]}`
				: this.createTaskFilters.subregions[0]
				? `subregion=${this.createTaskFilters.subregions[0]}`
				: this.createTaskFilters.countries[0]
				? `country=${this.createTaskFilters.countries[0]}`
				: "";
			serverAddr
				.get(
					`/outlet/?${applicableStoreParam}&get_all=true&type=store&user=${this.selected_assignTaskemp}`
				)
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						this.assignTask_storeList = res;
						this.selected_assignTaskStore = [];
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		getTaskList() {
			let params = {};
			params.outlet = this.createTaskFilters.outlets[0]
				? this.createTaskFilters.outlets[0]
				: null;
			params.region = this.createTaskFilters.regions[0]
				? this.createTaskFilters.regions[0]
				: null;
			params.subregion = this.createTaskFilters.subregions[0]
				? this.createTaskFilters.subregions[0]
				: null;
			params.country = this.createTaskFilters.countries[0]
				? this.createTaskFilters.countries[0]
				: null;
			params.designation = this.selectedDesignationForAssignTask;
			serverAddr
				.post(`/read/tasks_for_designations/`, params)
				.then((response) => {
					if (response.status == 200) {
						let res = JSON.parse(response.data);
						let task_list = res;

						this.task_list = [];
						task_list.forEach((element) => {
							if (element.task_times_info.length >= 2) {
								element.task_times_info.forEach((time, index) => {
									let obj = {};
									obj.name = element.name;
									obj.monthly_frequency = element.monthly_frequency;
									obj.frequency_day_selection = element.frequency_day_selection;
									obj.frequency = element.frequency;
									obj.end_time = time.end_time;
									obj.start_time = time.start_time;
									obj.id = element.id;
									obj.isDuplicate = true;
									obj.duplicateId = index + 1;
									this.task_list.push(obj);
								});
							} else {
								let obj = {};
								obj.name = element.name;
								obj.monthly_frequency = element.monthly_frequency;
								obj.frequency_day_selection = element.frequency_day_selection;
								obj.frequency = element.frequency;
								obj.end_time = element.task_times_info.length
									? element.task_times_info[0].end_time
									: "";
								obj.start_time = element.task_times_info.length
									? element.task_times_info[0].start_time
									: "";
								obj.id = element.id;
								obj.isDuplicate = false;
								this.task_list.push(obj);
							}
						});
						this.select_task = "";
						this.selected_task_id = "";
						this.selected_assignTaskemp = "";
						this.selected_assignTaskStore = [];
						this.assignTask_empList = [];
						this.assignTask_storeList = [];
						this.selected_task_freq = "";
						this.selected_task_days = [];
						// select task if only one in list
						if (this.task_list.length == 1) {
							this.select_task = 0;
							this.getEmployeeByTask();
						}
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		assignTask(scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.is_emp_list_loading = true;
					let params = {};
					params.id = this.task_id ? this.task_id : null;
					params.task = this.selected_task_id;
					params.assigned_to = this.selected_assignTaskemp;
					params.start_date = this.assignTask_start_date;
					params.end_date = this.assignTask_end_date;
					if (
						!this.isSelectedLocationRegion &&
						!this.selected_assignTaskStore.includes("NA")
					) {
						params.applicable_outlets = this.selected_assignTaskStore;
					}
					params.start_time = this.start_time ? this.start_time : null;
					params.end_time = this.end_time ? this.end_time : null;
					//checked that is employees selected for task assigment
					LabourPalnningService.assignedTaskToEmployees(params)
						.then((res) => {
							if (res.status == 200) {
								this.is_emp_list_loading = false;
								this.assign_task_dialog_visible = false;
								this.goToTask(); //called get all task api to get updated task list
								this.$notify.success({
									title: "Success",
									message: "Task assigned..!",
								});
							}
						})
						.catch(
							function (err) {
								this.is_emp_list_loading = false;
								console.error(err);
							}.bind(this)
						);
				} else {
					this.$message.error("Required fields are missing");
				}
			});
		},
		changeLocationDropdown(update) {
			if (update.selected.length < 1) {
				return;
			}
			let selectedLocation = update.selected;
			if (update.selected.length) {
				this.resetTasksBreadCrumbs();
				this.outlets = [];
				this.countris = [];
				this.regions = [];
				this.subregions = [];
				if (update.basics == "subregion") {
					this.subregions = selectedLocation.map((e) => {
						this.filters = {
							countries: [],
							regions: [],
							subregions: [e.id],
							outlets: [],
						};
						this.task_breadcrumbs[2].name = e.name;
						this.task_breadcrumbs[2].type = update.basics;
						this.task_breadcrumbs[2].id = e.id;
						return { id: e.id };
					});
				} else if (update.basics == "country") {
					this.countris = selectedLocation.map((e) => {
						this.filters = {
							countries: [e.id],
							regions: [],
							subregions: [],
							outlets: [],
						};
						this.task_breadcrumbs[0].name = e.name;
						this.task_breadcrumbs[0].type = update.basics;
						this.task_breadcrumbs[0].id = e.id;
						return { id: e.id };
					});
				} else if (update.basics == "region") {
					this.regions = selectedLocation.map((e) => {
						this.filters = {
							countries: [],
							regions: [e.id],
							subregions: [],
							outlets: [],
						};
						this.task_breadcrumbs[1].name = e.name;
						this.task_breadcrumbs[1].type = update.basics;
						this.task_breadcrumbs[1].id = e.id;
						return { id: e.id };
					});
				} else if (update.basics == "outlet") {
					this.outlets = selectedLocation.map((e) => {
						this.filters = {
							countries: [],
							regions: [],
							subregions: [],
							outlets: e.id ? [e.id] : [],
						};
						this.task_breadcrumbs[3].name = e.name;
						this.task_breadcrumbs[3].type = update.basics;
						this.task_breadcrumbs[3].id = e.id;
						return { id: e.id };
					});
				}
				if (update.basics == "country") {
					this.basics = "region";
				} else if (update.basics == "region") {
					this.basics = "subregion";
				} else if (update.basics == "subregion") {
					this.basics = "outlet";
				} else if (update.basics == "outlet") {
					this.basics = "employee";
				}
				// set breadcrumbs
				if (update.list && update.list.length) {
					for (let country = 0; country < update.list.length; country++) {
						if (!update.list[country].isSelected) {
							for (
								let region = 0;
								region < update.list[country].regions.length;
								region++
							) {
								if (!update.list[country].regions[region].isSelected) {
									for (
										let subregion = 0;
										subregion <
										update.list[country].regions[region].subregions.length;
										subregion++
									) {
										if (
											!update.list[country].regions[region].subregions[
												subregion
											].isSelected
										) {
											for (
												let store = 0;
												store <
												update.list[country].regions[region].subregions[
													subregion
												].outlets.length;
												store++
											) {
												if (
													!update.list[country].regions[region].subregions[
														subregion
													].outlets[store].isSelected
												) {
												} else {
													if (this.user_access_level == "admin") {
														this.task_breadcrumbs[0].name =
															update.list[country].name;
														this.task_breadcrumbs[0].type =
															update.list[country].type;
														this.task_breadcrumbs[0].id =
															update.list[country].id;
													}
													if (
														this.user_access_level == "admin" ||
														this.user_access_level == "region"
													) {
														this.task_breadcrumbs[1].name =
															update.list[country].regions[region].name;
														this.task_breadcrumbs[1].type =
															update.list[country].regions[region].type;
														this.task_breadcrumbs[1].id =
															update.list[country].regions[region].id;
													}
													this.task_breadcrumbs[2].name =
														update.list[country].regions[region].subregions[
															subregion
														].name;
													this.task_breadcrumbs[2].type =
														update.list[country].regions[region].subregions[
															subregion
														].type;
													this.task_breadcrumbs[2].id =
														update.list[country].regions[region].subregions[
															subregion
														].id;
												}
											}
										} else {
											if (this.user_access_level == "admin") {
												this.task_breadcrumbs[0].name =
													update.list[country].name;
												this.task_breadcrumbs[0].type =
													update.list[country].type;
												this.task_breadcrumbs[0].id = update.list[country].id;
											}
											if (
												this.user_access_level == "admin" ||
												this.user_access_level == "region"
											) {
												this.task_breadcrumbs[1].name =
													update.list[country].regions[region].name;
												this.task_breadcrumbs[1].type =
													update.list[country].regions[region].type;
												this.task_breadcrumbs[1].id =
													update.list[country].regions[region].id;
											}
											this.task_breadcrumbs[3].name = "";
											this.task_breadcrumbs[3].type = "";
											this.task_breadcrumbs[3].id = "";
										}
									}
								} else {
									if (this.user_access_level == "admin") {
										this.task_breadcrumbs[0].name = update.list[country].name;
										this.task_breadcrumbs[0].type = update.list[country].type;
										this.task_breadcrumbs[0].id = update.list[country].id;
									}
									this.task_breadcrumbs[2].name = "";
									this.task_breadcrumbs[2].type = "";
									this.task_breadcrumbs[2].id = "";
									this.task_breadcrumbs[3].name = "";
									this.task_breadcrumbs[3].type = "";
									this.task_breadcrumbs[3].id = "";
								}
							}
						} else {
							this.task_breadcrumbs[1].name = "";
							this.task_breadcrumbs[1].type = "";
							this.task_breadcrumbs[1].id = "";
							this.task_breadcrumbs[2].name = "";
							this.task_breadcrumbs[2].type = "";
							this.task_breadcrumbs[2].id = "";
							this.task_breadcrumbs[3].name = "";
							this.task_breadcrumbs[3].type = "";
							this.task_breadcrumbs[3].id = "";
						}
					}
				}
			}
		},
		async showDateByQueryReport(view) {
			if (view == "wtd") {
				let date = "";
				date = this.select_week;
				let dt = new Date(date); // current date of week
				let currentWeekDay = dt.getDay();
				let lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
				let wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
				let wkEnd = "";
				wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
				if (wkEnd > new Date() && wkStart < new Date()) {
					wkEnd = new Date();
				}
				this.fromDate = moment(wkStart).format("YYYY-MM-DD");
				this.toDate = moment(wkEnd).format("YYYY-MM-DD");
			} else if (view == "daily" || view == "customDt") {
				let date = new Date();
				this.fromDate = moment(date).format("YYYY-MM-DD");
				this.toDate = moment(date).format("YYYY-MM-DD");
			} else if (view == "mtd") {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				this.fromDate = moment(firstDay).format("YYYY-MM-DD");
				this.toDate = moment(date).format("YYYY-MM-DD");
			} else if (view == "ytd") {
				let date = new Date(new Date().getFullYear(), 0, 1);
				this.fromDate = moment(date).format("YYYY-MM-DD");
				this.toDate = moment(new Date()).format("YYYY-MM-DD");
			}
		},
		async showDateByQueryReportForTask(view) {
			if (view == "wtd") {
				let date = "";
				date = this.select_week;
				let dt = new Date(date); // current date of week
				let currentWeekDay = dt.getDay();
				let lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
				let wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
				let wkEnd = "";
				wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
				if (wkEnd > new Date() && wkStart < new Date()) {
					wkEnd = new Date();
				}
				this.task_from_date = moment(wkStart).format("YYYY-MM-DD");
				this.task_to_date = moment(wkEnd).format("YYYY-MM-DD");
				this.fromDate = moment(wkStart).format("YYYY-MM-DD");
				this.toDate = moment(wkEnd).format("YYYY-MM-DD");
			} else if (view == "daily" || view == "customDt") {
				let date = new Date();
				this.task_from_date = moment(date).format("YYYY-MM-DD");
				this.fromDate = moment(date).format("YYYY-MM-DD");
				this.task_to_date = moment(date).format("YYYY-MM-DD");
				this.toDate = moment(date).format("YYYY-MM-DD");
			} else if (view == "mtd") {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				this.task_from_date = moment(firstDay).format("YYYY-MM-DD");
				this.task_to_date = moment(date).format("YYYY-MM-DD");
				this.fromDate = moment(firstDay).format("YYYY-MM-DD");
				this.toDate = moment(date).format("YYYY-MM-DD");
			} else if (view == "ytd") {
				let date = new Date(new Date().getFullYear(), 0, 1);
				this.task_from_date = moment(date).format("YYYY-MM-DD");
				this.task_to_date = moment(new Date()).format("YYYY-MM-DD");
				this.fromDate = moment(date).format("YYYY-MM-DD");
				this.toDate = moment(new Date()).format("YYYY-MM-DD");
			}
		},
		openImg(url) {
			window.open(url, "_blank");
		},
		changeFilterStatusStoreName() {
			if (this.selected_store_list.length) {
				this.storeActiveFilter = true;
			} else {
				this.storeActiveFilter = false;
			}
		},
		selectAllStoreName() {
			this.storeActiveFilter = true;
			this.selected_store_list = [];
			for (let i in this.task_assigned_store_filter_options) {
				this.selected_store_list.push(
					this.task_assigned_store_filter_options[i].text
				);
			}
		},
		resetSelectedStoreName() {
			this.storeActiveFilter = false;
			this.selected_store_list = [];
		},
		changeFilterStatusFunction() {
			if (this.selected_function_list.length) {
				this.functionActiveFilter = true;
			} else {
				this.functionActiveFilter = false;
			}
		},
		selectAllFunction() {
			this.functionActiveFilter = true;
			this.selected_function_list = [];
			for (let i in this.task_fun_filter_options) {
				this.selected_function_list.push(this.task_fun_filter_options[i].text);
			}
		},
		resetSelectedFunction() {
			this.functionActiveFilter = false;
			this.selected_function_list = [];
		},
		changeFilterStatusFreq() {
			if (this.selected_repeat_list.length) {
				this.repeatActiveFilter = true;
			} else {
				this.repeatActiveFilter = false;
			}
		},
		selectAllFreq() {
			this.repeatActiveFilter = true;
			this.selected_repeat_list = [];
			for (let i in this.task_repeat_options) {
				this.selected_repeat_list.push(this.task_repeat_options[i].text);
			}
		},
		resetSelectedFreq() {
			this.repeatActiveFilter = false;
			this.selected_repeat_list = [];
		},
		changeFilterStatusCreatedBy() {
			if (this.selected_created_list.length) {
				this.createdActiveFilter = true;
			} else {
				this.createdActiveFilter = false;
			}
		},
		selectAllCreatedBy() {
			this.createdActiveFilter = true;
			this.selected_created_list = [];
			for (let i in this.task_createdby_filter_options) {
				this.selected_created_list.push(
					this.task_createdby_filter_options[i].text
				);
			}
		},
		resetSelectedCreatedBy() {
			this.createdActiveFilter = false;
			this.selected_created_list = [];
		},
		changeFilterStatusAssignBy() {
			if (this.selected_assigned_by_list.length) {
				this.assignedByActiveFilter = true;
			} else {
				this.assignedByActiveFilter = false;
			}
		},
		selectAllAssignBy() {
			this.assignedByActiveFilter = true;
			this.selected_assigned_by_list = [];
			for (let i in this.task_assigners_filter_options) {
				this.selected_assigned_by_list.push(
					this.task_assigners_filter_options[i].text
				);
			}
		},
		resetSelectedAssignBy() {
			this.assignedByActiveFilter = false;
			this.selected_assigned_by_list = [];
		},
		changeFilterStatusEmp() {
			if (this.selected_emp_list.length) {
				this.empActiveFilter = true;
			} else {
				this.empActiveFilter = false;
			}
		},
		selectAllEmp() {
			this.empActiveFilter = true;
			this.selected_emp_list = [];
			for (let i in this.emp_filter_options) {
				this.selected_emp_list.push(this.emp_filter_options[i].text);
			}
		},
		resetSelectedEmp() {
			this.empActiveFilter = false;
			this.selected_emp_list = [];
		},
		changeFilterTaskStatus() {
			if (this.selected_status_list.length) {
				this.statusActiveFilter = true;
			} else {
				this.statusActiveFilter = false;
			}
		},
		selectAllTaskStatus() {
			this.statusActiveFilter = true;
			this.selected_status_list = [];
			for (let i in this.task_status_filter_options) {
				this.selected_status_list.push(this.task_status_filter_options[i].text);
			}
		},
		resetSelectedTaskStatus() {
			this.statusActiveFilter = false;
			this.selected_status_list = [];
		},
		changeFilterStatusApplicableStore() {
			if (this.selected_applicable_store.length) {
				this.applicableStoreActiveFilter = true;
			} else {
				this.applicableStoreActiveFilter = false;
			}
		},
		selectAllApplicableStore() {
			this.applicableStoreActiveFilter = true;
			this.selected_applicable_store = [];
			for (let i in this.applicable_store_filter_options) {
				this.selected_applicable_store.push(
					this.applicable_store_filter_options[i].text
				);
			}
		},
		resetSelectedApplicableStore() {
			this.applicableStoreActiveFilter = false;
			this.selected_applicable_store = [];
		},
		closeEditDialogVisible() {
			this.edit_task_dialog_visible = false;
		},
		downloadCsvReport(table_data) {
			let export_csv = this.createCsvJson(table_data);
			// *****************download csv file************************************
			let csv = Papa.unparse(export_csv);
			let csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
			let csvURL = null;
			if (navigator.msSaveBlob) {
				csvURL = navigator.msSaveBlob(csvData, "download.csv");
			} else {
				csvURL = window.URL.createObjectURL(csvData);
			}
			let tempLink = document.createElement("a");
			tempLink.href = csvURL;
			tempLink.setAttribute("download", "download.csv");
			tempLink.click();
		},
		editUnassignTask(task) {
			this.opeDialogOnCommand("CREATE_TASK_LIST");
			this.store_name.push(task.store);
			task.functions_info.forEach((element) => {
				this.function_name.push(element.name);
			});
			let check_list = [
				{
					label: "",
					serial_no: 1,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
				},
				{
					label: "",
					serial_no: 2,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
				},
			];
			this.check_list =
				task.checklist && task.checklist.length
					? JSON.parse(JSON.stringify(task.checklist))
					: check_list;
			this.repeat_frequency = task.frequency;
			this.description = task.description;
			this.selected_main_category = task.main_category;
			this.task_category = task.name;
			this.filter_.id = task.id;
			let location = {};
			this.createTaskFilters = {
				countries: [],
				regions: [],
				subregions: [],
				outlets: [],
			};
			if (task.store_info && task.store_info.id) {
				location = task.store_info;
				this.createTaskFilters.outlets = [task.store_info.id];
			} else if (task.region_info && task.region_info.id) {
				location = task.region_info;
				this.createTaskFilters.regions = [task.region_info.id];
			} else if (task.subregion_info && task.subregion_info.id) {
				location = task.subregion_info;
				this.createTaskFilters.subregions = [task.subregion_info.id];
			} else if (task.country_info && task.country_info.id) {
				location = task.country_info;
				this.createTaskFilters.countries = [task.country_info.id];
			}
			// get designation for edit task designation
			this.getDesignation();
			this.filter_.location = location.name;
			this.filter_.location_id = location.id;
			this.weekly_frequency = task.frequency_day_selection;
			if (task.designations_info) {
				task.designations_info.forEach((element) => {
					this.selectedDesignation.push(element.id);
				});
			}
			this.selected_category =
				task.category_info && task.category_info.id
					? task.category_info.id
					: "";
			this.task_assign_type = task.assignment_type;
			this.time_task_list =
				task.task_times_info && task.task_times_info.length
					? JSON.parse(JSON.stringify(task.task_times_info))
					: [];
			this.time_task_list.forEach((e) => {
				if (e.start_time && e.end_time) {
					e.start_time = e.start_time.slice(0, 5);
					e.end_time = e.end_time.slice(0, 5);
				}
			});
			if (task.last_day_of_month) {
				task.monthly_frequency.push(true);
			}
			this.monthly_frequency = task.monthly_frequency;
			this.task_preview = task;
		},
		goToTask() {
			if (
				this.activeTabLink == "AUDIT" ||
				this.activeTabLink == "TASKS" ||
				this.activeTabLink == "COMPETITION"
			) {
				if (
					this.active_assigned_task_category.main_category &&
					this.active_assigned_task_category.id
				) {
					this.getAllAssignedTasks(
						this.active_assigned_task_category.main_category,
						this.active_assigned_task_category.id
					);
				} else {
					this.getAllAssignedTasks();
				}
			} else if (this.activeTabLink == "UNASSIGNED_TASKS") {
				this.getAllUnAssignedTasks();
			}
		},
		setTabLink(link) {
			this.active_assigned_task_category = {
				name: "",
				id: "",
			};
			this.selected_dropdown_category = {};
			this.active_unassigned_task_category = "";
			this.is_task_progress_loading = false;
			this.selected_locations_for_nomination = [];
			this.enable_nomination = false;
			this.toogle_summary = false;
			this.active_report_tab = "COMPETITION";
			this.main_report_category_id = "";
			if (
				link == "AUDIT" ||
				link == "TASKS" ||
				link == "COMPETITION" ||
				link.includes("AUDIT_") ||
				link.includes("TASKS_")
			) {
				let store_list = [...this.store_list];
				store_list = store_list.filter((el)=>el.name!='central kitchen')
				store_list.sort(function (a, b) {
					return a.name.localeCompare(b.name);
				});
				this.store_list = [...store_list];
				this.select_outlet = store_list[0].id;
				let category = "";
				let sub_category = "";
				if (link == "AUDIT" || link == "INSIGHTS") {
					category = "audit";
				} else if (link == "COMPETITION") {
					category = "cleanliness";
				} else if (link.includes("AUDIT_")) {
					category = "audit";
					let allCategories = JSON.parse(link.replace("AUDIT_", ""));
					this.selected_dropdown_category = { ...allCategories };
					this.active_report_tab = "AUDIT";
					let temp_assigned_task_category_names = [
						...JSON.parse(JSON.stringify(allCategories.categories)),
					];
					this.assigned_task_category_names = [];
					for (let i = 0; i < temp_assigned_task_category_names.length; i++) {
						temp_assigned_task_category_names[i].main_category = "audit";
					}
					temp_assigned_task_category_names.sort(
						(a, b) => a.serial_no - b.serial_no
					);
					this.assigned_task_category_names = [
						...temp_assigned_task_category_names,
					];
					this.active_assigned_task_category =
						temp_assigned_task_category_names[0];
					sub_category = temp_assigned_task_category_names[0].id;
				} else if (link.includes("TASKS_")) {
					category = "other";
					let allCategories = JSON.parse(link.replace("TASKS_", ""));
					this.selected_dropdown_category = { ...allCategories };
					this.active_report_tab = "TASKS";
					let temp_assigned_task_category_names = [
						...JSON.parse(JSON.stringify(allCategories.categories)),
					];
					this.assigned_task_category_names = [];
					for (let i = 0; i < temp_assigned_task_category_names.length; i++) {
						temp_assigned_task_category_names[i].main_category = "other";
					}
					temp_assigned_task_category_names.sort(
						(a, b) => a.serial_no - b.serial_no
					);
					this.assigned_task_category_names = [
						...temp_assigned_task_category_names,
					];
					this.active_assigned_task_category =
						temp_assigned_task_category_names[0];
					sub_category = temp_assigned_task_category_names[0].id;
				} else {
					category = "other";
				}
				this.getAllAssignedTasks(category, sub_category);
			} else if (link == "UNASSIGNED_TASKS") {
				if (!this.select_outlet) {
					this.select_outlet = this.store_list
						? this.store_list.length
							? this.store_list[0]
								? this.store_list[0].id
								: null
							: null
						: null;
				}
				this.getAllUnAssignedTasks();
			} else if (link == "REPORTS") {
				this.setActiveReportTab("COMPETITION");
			} else if (link == "INSIGHTS") {
				this.setActiveReportTab("AUDIT");
			}

			if (link.includes("AUDIT_")) {
				this.activeTabLink = "AUDIT";
			} else if (link.includes("TASKS_")) {
				this.activeTabLink = "TASKS";
			} else {
				this.activeTabLink = link;
			}
			this.search_by_tasks_title = "";
			this.search_emp_name = "";
		},
		onTaskDurationChange() {
			this.employee_list.forEach((l) => {
				l.days.forEach((k) => {
					if (this.assignedCount < this.taskDuration) {
						k.noDurationAvailable = false;
					} else {
						k.is_selected = false;
						k.noDurationAvailable = false;
					}
				});
			});
		},
		opeDialogOnCommand(command) {
			this.clearFormInputs();
			EventBus.$emit("clearSelctedInputs");
			if (command == "CREATE_TASK_LIST") {
				this.create_task_dialog_visible = true;
				for (let i = 0; i < this.check_list.length; i++) {
					let obj = {
						label: `Step ${i + 1}`,
						value: `${i + 1}`,
					};
					this.if_yes_options.push(obj);
					this.if_no_options.push(obj);
				}
				this.if_yes_options.unshift({
					label: "Continue",
					value: null,
				});
			} else if (command == "ASSIGN_TASK") {
				this.assign_task_dialog_visible = true;
			}
		},
		closeCreateTaskDialog() {
			this.create_task_dialog_visible = false;
			this.filter_.id = "";
		},
		closeAssignTaskDialog() {
			this.assign_task_dialog_visible = false;
			this.task_id = "";
			this.assigned_emp = [];
			this.filter_.id = "";
		},
		clearFormInputs() {
			this.error_on_empty_fields = false;
			this.select_store_name = "";
			this.store_name = [];
			if (
				this.getUserAccessLevel &&
				this.getUserAccessLevel == "outlet" &&
				this.store_list.length
			) {
				this.store_name.push(this.store_list[0].id);
				this.select_store_name = this.store_list[0].id;
			}
			this.file_list = [];
			this.is_function_field_is_empty = false;
			this.select_function = [];
			this.task_category = "";
			this.description = "";
			this.select_task = "";
			this.selected_task_id = "";
			this.employee_list = [];
			this.impact_operations = "";
			this.assignedCount = 0;
			this.disableFrequencyOptions = null;
			this.start_time = "";
			this.end_time = "";
			this.filter_.id = "";
			this.selected_function = "";
			this.allFunctions = [];
			this.function_name = [];
			this.repeat_frequency = "one_time";
			this.weekly_frequency = [];
			this.monthly_frequency = [];
			this.functions_list = [];
			this.task_list = [];
			this.selected_main_category = "";
			this.selected_form_template_intermediate_category = "";
			this.selected_category = "";
			this.check_list_for_assign_task = [];
			this.check_list = [
				{
					label: "",
					serial_no: 1,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
					show_not_applicable: false,
				},
				{
					label: "",
					serial_no: 2,
					subtask_type: "",
					num_value_min: null,
					num_value_max: null,
					allow_comment: false,
					allow_image_upload: false,
					allow_conditions: false,
					boolean_value: true,
					allow_conditions: false,
					info: "",
					step_if_yes: "",
					step_if_no: "",
					radio_options: [
						{
							label: "",
							num_value: "",
							serial_no: 1,
						},
						{
							label: "",
							num_value: "",
							serial_no: 2,
						},
					],
					show_not_applicable: false,
				},
			];
			this.time_task_list = [
				{
					start_time: "",
					end_time: "",
				},
			];
			this.if_yes_options = [];
			this.if_no_options = [];
			this.task_assign_type = "auto";
			this.createTaskFilters = [];
			this.designationList = [];
			this.selectedDesignation = [];
			this.selectedDesignationForAssignTask = "";
			this.select_task = "";
			this.selected_task_id = "";
			this.selected_assignTaskemp = "";
			this.selected_assignTaskStore = [];
			this.assignTask_start_date = "";
			this.assignTask_end_date = "";
			this.start_time = "";
			this.end_time = "";
			this.assignTask_storeList = [];
			this.assignTask_empList = [];
			this.imageData = [];
			this.selected_task_freq = "";
			this.selected_task_days = [];
			this.selected_assigned_task = {
				atloyee: "",
				start_time: "",
				end_time: "",
				description: "",
				due_date: "",
				outlet_name: "",
				checklist: "",
				task_status: "",
				assigned_by: "",
				task_obj_id: "",
				task_id: "",
				task_name: "",
				created_date: "",
				impact_operation: "",
				marked_as_completed: false,
				selected_action: "",
				file_list: "",
			};
		},
		checkDateIsCurrent(date) {
			let newDate = new Date(date);
			let d = new Date();
			d.setHours(0, 0, 0, 0);
			if (newDate <= d) {
				return true;
			} else {
				return false;
			}
		},
		addMoreCheckList() {
			this.check_list.push({
				label: "",
				serial_no: this.check_list.length,
				subtask_type: "",
				num_value_min: null,
				num_value_max: null,
				allow_comment: false,
				allow_image_upload: false,
				allow_conditions: false,
				boolean_value: true,
				allow_conditions: false,
				image_mandatory: false,
				info: "",
				step_if_yes: "",
				step_if_no: "",
				radio_options: [
					{
						label: "",
						num_value: "",
						serial_no: 1,
					},
					{
						label: "",
						num_value: "",
						serial_no: 2,
					},
				],
			});
			let obj = {
				label: `Step ${this.check_list.length}`,
				value: `${this.check_list.length}`,
			};
			this.if_yes_options.push(obj);
			this.if_no_options.push(obj);
		},
		addMoreTimeToTaskList() {
			this.time_task_list.push({ start_time: "", end_time: "" });
		},
		deleteTimeFromTaskList(index) {
			this.time_task_list.splice(index, 1);
		},
		openDeleteTaskWarningDailog(id) {
			this.delete_id = id;
			this.delete_task_confirmation_dialog = true;
		},
		deleteTask() {
			this.delete_task_confirmation_dialog = false;
			if (this.activeTabLink == "AUDIT") {
				LabourPalnningService.deleteAssignTask({
					task_assignment_id: this.delete_id,
				})
					.then((res) => {
						if (res.status) {
							this.goToTask();
							this.$notify.success({
								title: "Success",
								message: "Task Deleted..!",
							});
						}
					})
					.catch((err) => {
						console.error(err);
					});
			} else if (this.activeTabLink == "UNASSIGNED_TASKS") {
				LabourPalnningService.deleteUnassignTask({ task_id: this.delete_id })
					.then((res) => {
						if (res.status) {
							this.goToTask();
							this.$notify.success({
								title: "Success",
								message: "Task Deleted..!",
							});
						}
					})
					.catch((err) => {
						console.error(err);
					});
			}
		},
		/*
    getStoreList() {
      LabourPalnningService.getNominatedStores()
        .then((response) => {
          let store_list = [];
          store_list = JSON.parse(response.data);
				store_list = store_list.filter((el)=>el.name!='central kitchen')

          if (store_list.length) {
            this.store_list = [];
            let local_stores = [];
            for (let i in store_list) {
              if (store_list[i].type == "store") {
                local_stores.push(store_list[i]);
              }
            }
            local_stores.sort((a, b) => a.name - b.name);
            this.store_list = [...local_stores];
            // this.select_outlet = local_stores[0].id;
            this.select_outlet = null;
            // this.getAllAssignedTasks();
          } else if (this.activeTabLink == 'COMPETITION') {
              this.is_tasks_list_loading = true;
              LabourPalnningService.getAllStoreDataForTask()
                .then(async (res) => {
                  let all_store_list = [];
                  all_store_list = JSON.parse(res.data);
                  if (all_store_list.length) {
                    this.store_list = [];
                    let temp_store_list = [];
                    for (let j = 0; j < all_store_list.length; j++) {
                      if (all_store_list[j].type == "store") {
                        temp_store_list.push(all_store_list[j]);
                      }
                    }
                    temp_store_list.sort((a, b) => a.name - b.name);
                    this.store_list = [...temp_store_list];
                    // this.select_outlet = temp_store_list[0].id;
                    this.select_outlet = null;
                    // await this.getAllAssignedTasks();
                  }
                }).catch(err => {
                  console.error(err);
                }).finally(result => {
                  this.is_tasks_list_loading = false;
                });
            } else if (this.activeTabLink !== 'COMPETITION' && this.activeTabLink !== '' && this.activeTabLink !== null && this.activeTabLink !== undefined) {
            this.is_tasks_list_loading = true;
            LabourPalnningService.getAllStoreDataForTask()
              .then(async (res) => {
                let all_store_list = [];
                all_store_list = JSON.parse(res.data);
                if (all_store_list.length) {
                  this.store_list = [];
                  let temp_store_list = [];
                  for (let j = 0; j < all_store_list.length; j++) {
                    if (all_store_list[j].type == "store") {
                      temp_store_list.push(all_store_list[j]);
                    }
                  }
                  temp_store_list.sort((a, b) => a.name - b.name);
                  this.store_list = [...temp_store_list];
                  // this.select_outlet = temp_store_list[0].id;
                  this.select_outlet = null;
                  // await this.getAllAssignedTasks();
                }
              }).catch(err => {
                console.error(err);
              }).finally(result => {
                this.is_tasks_list_loading = false;
              });
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(result => {
          EventBus.$emit('fetchGraphDetails', true);
        });
    },
    */
		async getStoreList() {
			// await LabourPalnningService.getAllStoreData()
			await LabourPalnningService.getAllTaskAndAuditOutlets()
				.then(async (res) => {
					let all_store_list = [];
					all_store_list = JSON.parse(res.data);
					if (all_store_list.length) {
						this.store_list = [];
						// let temp_store_list = all_store_list.filter(el => el.type == 'store');
						// temp_store_list.sort((a, b) => a.name - b.name);
						all_store_list.sort((a, b) => a.name - b.name);
						// this.store_list = [...temp_store_list];
						this.store_list = [...all_store_list];
						this.store_list = this.store_list.filter((el)=>el.name!='central kitchen')

						if (this.activeTabLink == "INSIGHTS") {
							this.select_outlet = null;
						} else if (
							this.activeTabLink != "INSIGHTS" &&
							this.store_list.length
						) {
							this.select_outlet = this.store_list[0].id;
						}
					}
				})
				.catch((err) => {
					console.error(err);
				})
				.finally((result) => {
					EventBus.$emit("fetchGraphDetails", true);
				});
		},
		getFunctionList() {
			let params = {};
			params.outlets = this.store_name;
			if (params) {
				LabourPalnningService.getFunctionByArea(params)
					.then((response) => {
						this.functions_list = JSON.parse(response.data);
					})
					.catch((err) => {
						console.error(err);
					});
			} else {
				this.functions_list = [];
			}
		},
		getFunctionforAssignTask(outlet) {
			let params = {};
			params.outlet_id = outlet;
			if (params) {
				LabourPalnningService.getWorkArea(params)
					.then((response) => {
						this.functions_list = JSON.parse(response.data);
						this.selected_function = "";
					})
					.catch((err) => {
						console.error(err);
					});
			} else {
				this.functions_list = [];
			}
		},
		getAllAssignedTasks(category = "", subcategory = "") {
			this.is_tasks_list_loading = true; //enabled loader
			if (category == "") {
				if (this.activeTabLink == "COMPETITION") {
					category = "cleanliness";
				} else if (this.activeTabLink == "AUDIT") {
					category = "audit";
				} else {
					category = "other";
				}
			}
			this.assigned_tasks_list = [];
			this.task_rank = {};
			this.is_task_deactivated = false;
			this.is_task_in_progress = false;
			this.is_task_submitted = false;
			this.task_assigned_store_filter_options = [];
			this.task_assigners_filter_options = [];
			this.task_status_filter_options = [];
			this.emp_filter_options = [];
			let current_user_designation = null;
			if (this.user_access_level == "admin") {
				current_user_designation = null;
			} else {
				current_user_designation = this.user_designation;
			}
			let params = {
				start_date: this.date,
				end_date: this.date,
				assigned: null,
				employee: null,
				filters: {
					outlets: this.select_outlet ? [this.select_outlet] : [],
				},
				designation: current_user_designation,
			};
			// FOR FILTER FROM 1ST PARAMETER LOGIC (31-05-2023) // Implementation Criteria
			if (
				this.selected_dropdown_category &&
				this.selected_dropdown_category.filter_from_1st
			) {
				let date = new Date();
				let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				let updatedFromDate = moment(firstDay).format("YYYY-MM-DD");
				if (updatedFromDate) {
					params.start_date = updatedFromDate;
				}
			}
			if (category != "") {
				params.main_category = category;
			}
			if (category != "audit" && category != "other") {
				this.assigned_task_category_names = [];
				let temp_assigned_task_category_names = [];
				for (let i = 0; i < this.category_list.length; i++) {
					if (this.category_list[i].main_category == params.main_category) {
						temp_assigned_task_category_names.push(this.category_list[i]);
					}
				}
				temp_assigned_task_category_names.sort(
					(a, b) => a.serial_no - b.serial_no
				);
				this.assigned_task_category_names = [
					...temp_assigned_task_category_names,
				];
			}
			let check;
			switch (params.main_category) {
				case "cleanliness":
					// Adding Reports under Competition
					check = this.assigned_task_category_names.find(
						(el) => el.id == "cleanliness_reports"
					);
					if (
						check === undefined &&
						this.assigned_task_category_names.length > 0
					) {
						this.assigned_task_category_names.push({
							main_category: "cleanliness",
							name: "Reports",
							id: "cleanliness_reports",
						});
					}
					break;
				// case 'audit':
				//   // Adding Reports under Audit
				//   check = this.assigned_task_category_names.find(el => el.id == 'audit_reports');
				//   if (check === undefined && this.assigned_task_category_names.length > 0) {
				//     this.assigned_task_category_names.push({
				//       main_category: "audit",
				//       name: "Reports",
				//       id: 'audit_reports'
				//     });
				//   }
				//   break;
				// case 'other':
				//   // Adding Reports under Tasks
				//   check = this.assigned_task_category_names.find(el => el.id == 'tasks_reports');
				//   if (check === undefined && this.assigned_task_category_names.length > 0) {
				//     this.assigned_task_category_names.push({
				//       main_category: "other",
				//       name: "Reports",
				//       id: 'tasks_reports'
				//     });
				//   }
				//   break;
				default:
					// Adding Reports under Competition
					check = this.assigned_task_category_names.find(
						(el) => el.id == "cleanliness_reports"
					);
					if (
						check === undefined &&
						this.assigned_task_category_names.length > 0
					) {
						this.assigned_task_category_names.push({
							main_category: "cleanliness",
							name: "Reports",
							id: "cleanliness_reports",
						});
					}
					break;
			}
			if (!subcategory && this.assigned_task_category_names.length > 0) {
				if (this.assigned_task_category_names.length) {
					params.category = this.assigned_task_category_names[0].id;
					this.active_assigned_task_category =
						this.assigned_task_category_names[0];
				}
			} else {
				params.category = subcategory;
				if (this.assigned_task_category_names.length) {
					this.active_assigned_task_category =
						this.assigned_task_category_names.find(
							(el) => el.id == subcategory
						);
				}
			}
			if (
				params.category == "cleanliness_reports" ||
				params.category == "audit_reports" ||
				params.category == "tasks_reports"
			) {
				params.category = "";
			}
			if (params.category) {
				console.log(
					"%cParams For Task and Audit Tab",
					"color: red; font-size: 12px; font-weight: 400;"
				);
				console.log(params);
				LabourPalnningService.getAssignedAndUnAssignedTasks(params)
					.then(async (response) => {
						if (response.status == 200) {
							let res = JSON.parse(response.data);
							let local_assigned_task_list = [];
							for (let i = 0; i < res.length; i++) {
								let outlet_info = {};
								let outlet_type = "";
								if (res[i].task_info.country_info) {
									outlet_info = res[i].task_info.country_info;
									outlet_type = "country";
								} else if (res[i].task_info.region_info) {
									outlet_info = res[i].task_info.region_info;
									outlet_type = "region";
								} else if (res[i].task_info.subregion_info) {
									outlet_info = res[i].task_info.subregion_info;
									outlet_type = "subregion";
								} else if (res[i].task_info.store_info) {
									outlet_info = res[i].task_info.store_info;
									outlet_type = "outlet";
								}
								let obj = {
									outlet_type: outlet_type,
									outlet_id: outlet_info.id,
									outlet_name: outlet_info.name,
									applicable_store: res[i].assigned_store_info,
									applicable_store_name: res[i].assigned_store_info
										? res[i].assigned_store_info.name
										: "",
									assigned_by: res[i].assigned_by_name,
									is_assigned: res[i].is_assigned,
									frequency: res[i].task_info.frequency,
									designation: res[i].task_info.designations_info,
									description: res[i].description,
									checklist: res[i].assigned_to.length
										? res[i].assigned_to[0].subtask_status_info
										: [],
									raw_checklist: res[i].assigned_to.length
										? res[i].assigned_to[0].subtask_status_info
										: [],
									task_id: res[i].task_info.id,
									serial_no: res[i].task_info
										? res[i].task_info.serial_no
											? res[i].task_info.serial_no
											: null
										: null,
									task_obj_id: res[i].id,
									task_name: res[i].task_info.name,
									task_status: res[i].status,
									start_time: res[i].start_time
										? res[i].start_time.slice(0, 5)
										: "",
									end_time: res[i].end_time ? res[i].end_time.slice(0, 5) : "",
									start_date: res[i].start_date,
									end_date: res[i].end_date,
									due_date: res[i].due_date,
									created_date: res[i].created_date,
									impact_operation: res[i].impact_operation,
									emp_name:
										res[i].assigned_to.length && res[i].assigned_to[0].user_info
											? res[i].assigned_to[0].user_info.full_name
											: "",
									emp_designation:
										res[i].assigned_to.length && res[i].assigned_to[0].user_info
											? res[i].assigned_to[0].user_info.designation_info
												? res[i].assigned_to[0].user_info.designation_info.name
													? res[i].assigned_to[0].user_info.designation_info
															.name
													: ""
												: ""
											: "",
									emp_id:
										res[i].assigned_to.length && res[i].assigned_to[0].user_info
											? res[i].assigned_to[0].user_info.id
											: "",
									atloyee: "",
									main_category: res[i].task_info.main_category,
									category: res[i].task_info.category_info,
									subtask_status_info: res[i].assigned_to.length
										? res[i].assigned_to[0].subtask_status_info
										: [],
									total_points_scored: res[i].total_points_scored,
									total_scoring_points: res[i].total_scoring_points,
									scoring_percentage: res[i].scoring_percentage,
									total_scoring_points_yes_no_achieved:
										res[i].total_scoring_points_yes_no_achieved,
									total_scoring_points_yes_no:
										res[i].total_scoring_points_yes_no,
									scoring_percentage_yes_no: res[i].scoring_percentage_yes_no,
								};
								obj.attachments = [];
								if (res[i].assigned_to.length) {
									res[i].assigned_to[0].subtask_status_info.forEach((ele) => {
										ele.attachments.forEach((attach) => {
											obj.attachments.push(attach);
										});
									});
								}
								if (obj.checklist.length) {
									for (let i = 0; i < obj.checklist.length; i++) {
										this.$set(
											obj.checklist[i],
											"time_zone",
											new Date().getTime()
										);
										this.$set(
											obj.checklist[i],
											"toggle_add_comment_section",
											obj.checklist[i].comment ? true : false
										);
										this.$set(
											obj.checklist[i],
											"toggle_add_image_section",
											false
										);
										this.$set(obj.checklist[i], "files", false);
										this.$set(
											obj.checklist[i],
											"not_applicable",
											obj.checklist[i].not_applicable
										);
									}
								}
								// create fitler options
								let store_filter_obj = {
									text: obj.outlet_name,
									value: obj.outlet_name,
								};
								this.task_assigned_store_filter_options.push(store_filter_obj);
								this.task_assigned_store_filter_options = _.uniqBy(
									this.task_assigned_store_filter_options,
									"text"
								);
								// create fitler options
								let task_status_filter_obj = {
									text: obj.task_status,
									value: obj.task_status,
								};
								this.task_status_filter_options.push(task_status_filter_obj);
								this.task_status_filter_options = _.uniqBy(
									this.task_status_filter_options,
									"text"
								);
								// create fitler options
								let emp_filter_obj = {
									text: obj.emp_name,
									value: obj.emp_name,
								};
								if (emp_filter_obj.text.length) {
									this.emp_filter_options.push(emp_filter_obj);
								}
								this.emp_filter_options = _.uniqBy(
									this.emp_filter_options,
									"text"
								);
								// create fitler options
								let task_assigners_filter_obj = {
									text: obj.assigned_by,
									value: obj.assigned_by,
								};
								if (task_assigners_filter_obj.text != null) {
									this.task_assigners_filter_options.push(
										task_assigners_filter_obj
									);
								}
								this.task_assigners_filter_options = _.uniqBy(
									this.task_assigners_filter_options,
									"text"
								);
								if (obj.applicable_store) {
									let applicable_store_filter_obj = {
										text: obj.applicable_store.name,
										value: obj.applicable_store.id,
									};
									if (applicable_store_filter_obj.text != null) {
										this.applicable_store_filter_options.push(
											applicable_store_filter_obj
										);
									}
									this.applicable_store_filter_options = _.uniqBy(
										this.applicable_store_filter_options,
										"text"
									);
								}
								// this.assigned_tasks_list.push(obj);
								local_assigned_task_list.push(obj);
							}
							local_assigned_task_list.sort(
								(a, b) => a.serial_no - b.serial_no
							);
							this.assigned_tasks_list = [
								...this.assigned_tasks_list,
								...local_assigned_task_list,
							];
							for (let i = 0; i < this.assigned_tasks_list.length; i++) {
								if (this.assigned_tasks_list[i].category != null) {
									this.assigned_tasks_list[i].category.main_category =
										this.assigned_tasks_list[i].main_category;
								}
							}
							if (this.assigned_task_category_names.length) {
								if (this.select_outlet) {
									if (this.activeTabLink == "COMPETITION") {
										let task_progress_res = await this.getTaskProgress();
										let task_time_res = await this.getTaskTime();
										if (
											task_progress_res.status == 200 &&
											task_time_res.status == 200
										) {
											this.task_rank = JSON.parse(task_progress_res.data);
											let percentage = JSON.parse(task_time_res.data);
											this.task_rank.percentage_completed =
												percentage.percentage_completed;
											let time = JSON.parse(task_time_res.data).data;
											if (time) {
												this.task_rank.start_time = time.start_time;
												this.task_rank.end_time = time.end_time;
											}
										}
										if (
											!this.task_rank.start_time &&
											!this.task_rank.end_time
										) {
											this.is_task_in_progress = false;
											this.is_task_submitted = false;
											this.is_task_deactivated = true;
										} else if (
											this.task_rank.start_time &&
											!this.task_rank.end_time
										) {
											this.is_task_deactivated = false;
											this.is_task_in_progress = true;
										} else if (
											this.task_rank.start_time &&
											this.task_rank.end_time
										) {
											this.is_task_submitted = true;
											this.is_task_in_progress = false;
											this.is_task_deactivated = false;
										}
									} else {
										let audit_summary_res = undefined;
										if (this.activeTabLink == "AUDIT") {
											audit_summary_res = await this.getAuditTaskSummary();
										} else {
											audit_summary_res = await this.getOtherTaskSummary();
										}

										if (audit_summary_res && audit_summary_res.status == 200) {
											let temp_audit_summary_list = JSON.parse(
												audit_summary_res.data
											).results;
											for (let property in temp_audit_summary_list) {
												if (property == "deduction") {
													let deduction_arr = temp_audit_summary_list[property];
													for (let i = 0; i < deduction_arr.length; i++) {
														if (deduction_arr[i].name == "Food Safety") {
															temp_audit_summary_list[property][i].name =
																temp_audit_summary_list[property][i].name +
																" (Deduction Applicable)";
														}
													}
												}
											}
											this.audit_summary_list = temp_audit_summary_list;
										}
									}
								}
							}
						}
						this.is_tasks_list_loading = false; //disabled loader
						EventBus.$emit("reloadGraphs", true);
					})
					.catch((error) => {
						console.error(error);
						this.is_tasks_list_loading = false; //disabled loader
					});
			}
		},
		getImagePath(path, list) {
			this.is_image_loading = true;
			let params = {
				attachment_id: path,
			};
			this.current_image_path = path;
			this.current_image_list = list;
			LabourPalnningService.getTaskAttachmentNew(params)
				.then((response) => {
					let res = JSON.parse(response.data);
					if (response.status == 200) {
						this.current_image = res.url;
						this.image_dialog_visible = true;
						this.is_image_loading = false;
					}
				})
				.catch(
					function (error) {
						console.error(error);
					}.bind(this)
				);
		},
		nextPreviousImg(action) {
			let index = this.current_image_list.findIndex(
				(x) => x.file_path === this.current_image_path
			);
			let list_length = this.current_image_list.length;
			if (action == "next") {
				if (index < list_length - 1) {
					this.current_image_path =
						this.current_image_list[index + 1].file_path;
					this.getImageFromNextPrev();
				} else {
					this.current_image_path = this.current_image_list[0].file_path;
					this.getImageFromNextPrev();
				}
			} else {
				if (index == 0) {
					this.current_image_path =
						this.current_image_list[list_length - 1].file_path;
					this.getImageFromNextPrev();
				} else {
					this.current_image_path =
						this.current_image_list[index - 1].file_path;
					this.getImageFromNextPrev();
				}
			}
		},
		getImageFromNextPrev() {
			this.is_image_loading = true;
			let params = {
				attchment_id: this.current_image_path,
			};
			LabourPalnningService.getTaskAttachmentNew(params)
				.then((response) => {
					let res = JSON.parse(response.data);
					if (response.status == 200) {
						this.current_image = res.url;
						this.is_image_loading = false;
					}
				})
				.catch(
					function (error) {
						console.error(error);
					}.bind(this)
				);
		},
		downloadImage() {
			let el = document.createElement("a");
			el.setAttribute("href", this.current_image);
			el.setAttribute("download", "img");
			document.body.appendChild(el);
			el.click();
			el.remove();
		},
		// api to get unassigned tasks
		getAllUnAssignedTasks() {
			this.is_tasks_list_loading = true; //enabled loader
			this.unassigned_tasks_list = [];
			this.unassigned_task_category_names = [];
			// cleared filter option list
			this.task_assigned_store_filter_options = [];
			this.task_fun_filter_options = [];
			this.task_repeat_options = [];
			this.task_createdby_filter_options = [];
			let params = {
				filters: {
					outlets: this.select_outlet ? [this.select_outlet] : [],
				},
			};
			LabourPalnningService.getAllTasks(params)
				.then((response) => {
					let res = JSON.parse(response.data);
					for (let i = 0; i < res.length; i++) {
						let outlet_info = {};
						let outlet_type = "";
						if (res[i].country_info) {
							outlet_info = res[i].country_info;
							outlet_type = "country";
						} else if (res[i].region_info) {
							outlet_info = res[i].region_info;
							outlet_type = "region";
						} else if (res[i].subregion_info) {
							outlet_info = res[i].subregion_info;
							outlet_type = "subregion";
						} else if (res[i].store_info) {
							outlet_info = res[i].store_info;
							outlet_type = "outlet";
						}
						res[i].outlet_name = outlet_info.name;
						res[i].created_by = res[i].created_by_name;
						// create fitler options
						let store_filter_obj = {
							text: res[i].outlet_name,
							value: res[i].outlet_name,
						};
						this.task_assigned_store_filter_options.push(store_filter_obj);
						this.task_assigned_store_filter_options = _.uniqBy(
							this.task_assigned_store_filter_options,
							"text"
						);
						let task_assigner_filter_obj = {
							text: res[i].created_by_name,
							value: res[i].created_by_name,
						};
						this.task_createdby_filter_options.push(task_assigner_filter_obj);
						this.task_createdby_filter_options = _.uniqBy(
							this.task_createdby_filter_options,
							"text"
						);
						if (res[i].functions_info && res[i].functions_info.length) {
							for (
								let fun_i = 0;
								fun_i < res[i].functions_info.length;
								fun_i++
							) {
								let fun_filter_obj = {
									text: res[i].functions_info[fun_i].name,
									value: res[i].functions_info[fun_i].name,
									id: res[i].id,
								};
								if (fun_filter_obj.text.length) {
									this.task_fun_filter_options.push(fun_filter_obj);
								}
							}
							this.task_fun_filter_options = _.uniqBy(
								this.task_fun_filter_options,
								"text"
							);
						}
						let repeat_opt_obj = {
							text: res[i].frequency,
							value: res[i].frequency,
						};
						this.task_repeat_options.push(repeat_opt_obj);
						this.task_repeat_options = _.uniqBy(
							this.task_repeat_options,
							"text"
						);

						this.unassigned_tasks_list.push(res[i]);
					}
					for (let i = 0; i < this.unassigned_tasks_list.length; i++) {
						if (
							this.unassigned_tasks_list[i].category_info != null &&
							this.unassigned_task_category_names.indexOf(
								this.unassigned_tasks_list[i].category_info.name
							) == -1
						) {
							this.unassigned_task_category_names.push(
								this.unassigned_tasks_list[i].category_info.name
							);
						}
					}
					if (this.unassigned_task_category_names.length) {
						this.active_unassigned_task_category =
							this.unassigned_task_category_names[0];
					}
					this.is_tasks_list_loading = false; //disabled loader
				})
				.catch((error) => {
					console.error(error);
					this.is_tasks_list_loading = false; //disabled loader
				});
		},
		handleAssignedTaskCategory(category) {
			let main_category_id = category.id;
			let current_category_name = category.name;
			if (current_category_name == "Reports") {
				this.active_assigned_task_category = category;
				this.main_report_category_id = main_category_id;
				if (main_category_id == "cleanliness_reports") {
					this.getReportData();
				} else if (main_category_id == "audit_reports") {
					this.getAuditReportData();
				} else if (main_category_id == "tasks_reports") {
					this.getTasksReportData();
				}
			} else {
				this.main_report_category_id = "";
				this.getAllAssignedTasks(category.main_category, category.id);
			}
		},
		async getAvailableTasks() {
			if (this.select_store_name && this.selected_function) {
				this.select_task = ""; //cleared selected tasks
				this.selected_task_id = ""; //cleared selected tasks
				this.employee_list = []; //cleared previously selected employees
				let params = {
					outlet_id: this.select_store_name,
					department_id: null,
					function_id:
						this.selected_function == "all" ? null : this.selected_function,
				};
				await LabourPalnningService.getTasksByDepartment(params)
					.then((response) => {
						if (response.status) {
							let res = JSON.parse(response.data);
							this.task_list = res;
						} else {
							this.task_list = [];
						}
					})
					.catch(
						function (error) {
							console.error(error);
							this.task_list = [];
						}.bind(this)
					);
			}
		},
		// function to filter task list by task status
		filterByTaskStatus(value, row) {
			return row.task_status == value;
		},
		// function to filter task list by task assigner
		filterByTaskAssigner(value, row) {
			return row.assigned_by == value;
		},
		// function to filter task list by task created by
		filterByTaskCreatedBy(value, row) {
			return row.created_by == value;
		},
		// function to filter task list by store name
		filterByTaskStore(value, row) {
			return row.outlet_name == value;
		},
		filterByRepeatOptions(value, row) {
			return row.frequency == value;
		},
		filterByFunction(value, row) {
			return row.functions_info.forEach((element) => {
				element.name == value;
			});
		},
		// api to create, update taks
		createTask(scope) {
			this.error_on_empty_fields = true;
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.is_create_task_loading = true; //enabled laoder
					let check_list = [];
					let task_time_list = [];
					this.time_task_list.forEach((element) => {
						if (element.start_time && element.end_time) {
							task_time_list.push(element);
						}
					});
					this.check_list.forEach((element) => {
						if (element.label != "" && element.subtask_type != "") {
							element.num_value_max =
								this.points_calculation_method == "overall_activity"
									? null
									: element.num_value_max;
							element.num_value_min =
								this.points_calculation_method == "overall_activity"
									? null
									: element.num_value_min;
							if (element.subtask_type != "radio_options") {
								delete element.radio_options;
							}
							element.step_if_yes = element.step_if_yes
								? element.step_if_yes
								: null;
							element.step_if_no = element.step_if_no
								? element.step_if_no
								: null;
							if (element.task_type == "yes_no_not_applicable") {
								element.task_type == "yes_no";
							}
							check_list.push(element);
						}
					});
					let params = {};
					if (this.filter_.id) {
						params.id = this.filter_.id;
					}
					let last_day_of_month = false;
					if (this.repeat_frequency == "monthly") {
						last_day_of_month = this.form_template_last_day_of_month;
					} else if (
						this.monthly_frequency.length &&
						this.monthly_frequency.includes(true)
					) {
						const index = this.monthly_frequency.indexOf(true);
						if (index > -1) {
							this.monthly_frequency.splice(index, 1);
						}
						last_day_of_month = true;
					}
					let funcList = this.function_name.includes("all")
						? ["all"]
						: this.function_name;
					params.store = this.store_name.length
						? this.store_name.toString()
						: ""; //send comma separated values
					params.name = this.task_category;
					params.department = null;
					params.functions = funcList;
					params.description = this.description;
					params.checklist = check_list;
					params.frequency = this.repeat_frequency;
					params.frequency_day_selection =
						this.repeat_frequency == "weekly" ? this.weekly_frequency : [];
					params.start_time = this.start_time ? this.start_time : null;
					params.end_time = this.end_time ? this.end_time : null;
					params.monthly_frequency = this.monthly_frequency;
					params.last_day_of_month = last_day_of_month;
					params.category = this.selected_category;
					params.main_category = this.selected_main_category;
					params.assignment_type = this.task_assign_type;
					params.task_times = task_time_list;
					params.filters = this.createTaskFilters;
					params.designations = this.selectedDesignation;
					params.calculate_audit_points_by = this.points_calculation_method;
					params.deduction_applicable = this.deduction_type;
					params.deduction_type_applicable = this.deduction_method;
					params.intermediate_category =
						this.selected_form_template_intermediate_category;
					if (this.points_calculation_method == "overall_activity") {
						params.expected_audit_value = this.expected_value;
						params.total_audit_points = this.total_points;
					}
					LabourPalnningService.saveCreateTaskCategory(params)
						.then((res) => {
							if (res.status == 200) {
								this.create_task_dialog_visible = false;
								this.goToTask(); //called get all task api to get updated task list
								this.$notify.success({
									title: "Success",
									message: this.filter_.id
										? "Task updated"
										: "New task created",
								});
								this.filter_.id = "";
								this.is_create_task_loading = false; //disabled laoder
							}
						})
						.catch(
							function (err) {
								console.error(err);
								this.is_create_task_loading = false; //disabled laoder
							}.bind(this)
						);
				} else {
					this.$message.error("Required fields are missing");
				}
			});
		},
		saveAssignedTaskToEmployees(scope) {
			this.error_on_empty_fields = true;

			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.is_emp_list_loading = true;
					let params = {};
					params.id = null;
					params.task = this.selected_task_id;
					params.is_recurring = false;
					params.assigned_to = [];
					params.impact_operation =
						this.impact_operations == "yes" ? true : false;
					if (this.start_time && this.end_time) {
						params.start_time = this.start_time;
						params.end_time = this.end_time;
					}
					if (this.employee_list.length) {
						for (let i = 0; i < this.employee_list.length; i++) {
							for (let j = 0; j < this.employee_list[i].days.length; j++) {
								if (this.employee_list[i].days[j].is_selected) {
									let obj = {};
									obj.employee = this.employee_list[i].id;
									obj.date = this.employee_list[i].days[j].date;
									params.assigned_to.push(obj);
								}
							}
						}
						if (params.assigned_to.length) {
							//checked that is employees selected for task assigment
							LabourPalnningService.saveAssignedTaskToEmployees(params)
								.then((res) => {
									if (res.status == 200) {
										this.is_emp_list_loading = false;
										this.task_id = "";
										this.assign_task_dialog_visible = false;
										this.goToTask(); //called get all task api to get updated task list
										this.$notify.success({
											title: "Success",
											message: "Task assigned..!",
										});
									}
								})
								.catch(
									function (err) {
										this.is_emp_list_loading = false;
										console.error(err);
									}.bind(this)
								);
						} else {
							//if no employees selected then displyaed
							this.$notify.error({
								title: "Error",
								message: "Select employee",
							});
							this.is_emp_list_loading = false;
						}
					} else {
						this.$notify.error({
							title: "Error",
							message: "No employees to assign task..!",
						});
						this.is_emp_list_loading = false;
					}
				} else {
					this.$message.error("Required fields are missing");
				}
			});
		},
		async showDayOfWeek() {
			let initialDateOfWeek = [];
			let allDatesOfWeek = [];
			let date = "";
			if (this.select_week) {
				date = this.select_week;
			} else {
				this.select_week = new Date();
				date = this.select_week;
			}
			let dt = new Date(date); // current date of week
			let currentWeekDay = dt.getDay();
			let lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
			let wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
			let wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
			this.firstdays = moment(wkStart).format("YYYY-MM-DD");
			this.lastdays = moment(wkEnd).format("YYYY-MM-DD");
			for (let i = 0; i < 7; i++) {
				//pushed 7 days in array
				let next = new Date(wkStart.getTime());
				next.setDate(wkStart.getDate() + i);
				initialDateOfWeek.push(new Date(next.toString()).getDate()); //get date in numbers only
				allDatesOfWeek.push(moment(next.toString()).format());
			}
			this.daysOfWeek = allDatesOfWeek;
			this.customDateFormat = `${this.firstdays} To ${this.lastdays}`;
			await this.getAvailableTasks(); //called api to get available  tasks
		},
		async editAssignedTask(task, action_type) {
			this.file_list = [];
			this.clearFormInputs();
			if (!task.is_assigned && action_type == "CHANGE_TASK_STATUS") {
				return;
			}
			this.createTaskFilters = {
				countries: [],
				regions: [],
				subregions: [],
				outlets: [],
			};
			if (task.outlet_type == "country") {
				this.createTaskFilters.countries = [task.outlet_id];
			} else if (task.outlet_type == "region") {
				this.createTaskFilters.regions = [task.outlet_id];
			}
			if (task.outlet_type == "subregion") {
				this.createTaskFilters.subregions = [task.outlet_id];
			}
			if (task.outlet_type == "outlet") {
				this.createTaskFilters.outlets = [task.outlet_id];
			}
			this.selected_task_id = task.task_id;
			this.selectedDesignationForAssignTask = "";
			this.employees_for_tasks = [];
			this.edit_task_dialog_visible = true; //open edit task open dialog
			let tempCheckList =
				task.checklist && task.checklist.length
					? JSON.parse(JSON.stringify(task.checklist))
					: [];
			if (tempCheckList && tempCheckList.length) {
				tempCheckList.sort((a, b) => a.serial_no - b.serial_no);
			}
			this.selected_assigned_task.start_date = task.start_date;
			this.selected_assigned_task.end_date = task.end_date;
			this.selected_assigned_task.start_time = task.start_time;
			this.selected_assigned_task.end_time = task.end_time;
			this.selected_assigned_task.description = task.description;
			this.selected_assigned_task.due_date = task.due_date;
			this.selected_assigned_task.outlet_name = task.outlet_name;
			this.selected_assigned_task.applicable_store_name =
				task.applicable_store_name;
			this.selected_assigned_task.checklist = tempCheckList;
			this.selected_assigned_task.task_status = task.task_status;
			this.selected_assigned_task.assigned_by = task.assigned_by;
			this.selected_assigned_task.task_obj_id = task.task_obj_id;
			this.selected_assigned_task.task_id = task.task_id;
			this.selected_assigned_task.task_name = task.task_name;
			this.selected_assigned_task.created_date = task.created_date;
			this.selected_assigned_task.impact_operation = task.impact_operation;
			this.selected_assigned_task.is_assigned = task.is_assigned;
			this.selected_assigned_task.marked_as_completed =
				task.task_status == "Completed" ? true : false;
			this.selected_assigned_task.selected_action = action_type;
			this.selected_assigned_task.total_scoring_points_yes_no =
				task.total_scoring_points_yes_no;
			this.selected_assigned_task.total_scoring_points_yes_no_achieved =
				task.total_scoring_points_yes_no_achieved;
			this.selected_assigned_task.file_list = [];
			for (
				let task_index = 0;
				task_index < task.subtask_status_info.length;
				task_index++
			) {
				for (let subtask_index in task.subtask_status_info[task_index]
					.attachments) {
					this.selected_assigned_task.file_list.push(
						task.subtask_status_info[task_index].attachments[subtask_index]
					);
				}
			}
			await this.getEmployeeByTask("editAssignTask");
			this.selected_assigned_task.atloyee = task.emp_id; //to show by default selected one employee on edit task dialog
		},
		getEmployeesForTasks() {
			if (
				this.selected_assigned_task.start_time &&
				this.selected_assigned_task.end_time
			) {
				this.employees_for_tasks = [];
				this.selected_assigned_task.atloyee = ""; //on changeing time cleared selected employee
				this.is_edit_task_loading = true; //displayed loader
				let params = {
					task: this.selected_assigned_task.task_id,
					date: moment(this.selected_assigned_task.due_date).format(
						"YYYY-MM-DD"
					),
					start_time: this.selected_assigned_task.start_time,
					end_time: this.selected_assigned_task.end_time,
				};
				LabourPalnningService.getEmployeesListToAssignTask(params)
					.then((res) => {
						if (res.status == 200) {
							let emp_list = JSON.parse(res.data);

							for (let key in emp_list) {
								let obj = {
									label: emp_list[key].name,
									value: emp_list[key].id,
								};
								this.employees_for_tasks.push(obj);
							}
						}

						this.is_edit_task_loading = false; //closed loader
					})
					.catch(
						function (err) {
							console.error(err);
							this.is_edit_task_loading = false; //closed loader
						}.bind(this)
					);
			}
		},
		// api to update edited assinged task
		saveEditAssignedTask(scope) {
			this.error_on_empty_fields = true; //enable to show validation message
			this.$validator
				.validateAll(scope)
				.then(
					async function (result) {
						if (result) {
							this.error_on_empty_fields = false; //disable validation message
							if (this.selected_assigned_task.selected_action == "EDIT_TASK") {
								this.is_edit_task_loading = true; //displayed loader
								let params = {
									id: this.selected_assigned_task.task_obj_id,
									task: this.selected_assigned_task.task_id,
									assigned_to: this.selected_assigned_task.atloyee,
									due_date: this.selected_assigned_task.due_date,
									description: this.selected_assigned_task.description,
									impact_operation:
										this.selected_assigned_task.impact_operation,
									start_time: this.selected_assigned_task.start_time.length
										? this.selected_assigned_task.start_time
										: null,
									end_time: this.selected_assigned_task.end_time.length
										? this.selected_assigned_task.end_time
										: null,
									start_date: this.selected_assigned_task.start_date,
									end_date: this.selected_assigned_task.end_date,

									selected_sub_tasks: [],
								};

								let temp = [];
								if (this.selected_assigned_task.checklist.length) {
									for (
										let i = 0;
										i < this.selected_assigned_task.checklist.length;
										i++
									) {
										let obj = {
											subtask_status_id:
												this.selected_assigned_task.checklist[i].id,
											id: this.selected_assigned_task.checklist[i].subtask_info
												.id,
											label:
												this.selected_assigned_task.checklist[i].subtask_info
													.label,
											serial_no:
												this.selected_assigned_task.checklist[i].subtask_info
													.serial_no,
											subtask_type:
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type,
											num_value_min:
												this.selected_assigned_task.checklist[i].subtask_info
													.num_value_min,
											num_value_max:
												this.selected_assigned_task.checklist[i].subtask_info
													.num_value_max,
											comment: this.selected_assigned_task.checklist[i].comment,
											radio_option_selected: this.selected_assigned_task
												.checklist[i].radio_option_selected
												? this.selected_assigned_task.checklist[i]
														.radio_option_selected
												: null,
											raise_ticket:
												this.selected_assigned_task.checklist[i].raise_ticket,
										};
										if (
											(this.selected_assigned_task.checklist[i].subtask_info &&
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type == "number") ||
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "scoring" ||
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "rating"
										) {
											obj.num_value = this.selected_assigned_task.checklist[i]
												.num_value
												? Number(
														this.selected_assigned_task.checklist[i].num_value
												  )
												: null;
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											(this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "temperature" ||
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type == "tpc")
										) {
											obj.num_value = this.selected_assigned_task.checklist[i]
												.num_value
												? Number(
														this.selected_assigned_task.checklist[i].num_value
												  )
												: null;
											obj.retest_value =
												this.selected_assigned_task.checklist[i].retest_value !=
													null &&
												this.selected_assigned_task.checklist[i].retest_value !=
													""
													? Number(
															this.selected_assigned_task.checklist[i]
																.retest_value
													  )
													: null;
											obj.description =
												this.selected_assigned_task.checklist[i].description;
											obj.date = this.selected_assigned_task.checklist[i].date
												? moment(
														this.selected_assigned_task.checklist[i].date
												  ).format("YYYY-MM-DD")
												: null;
										} else if (
											(this.selected_assigned_task.checklist[i].subtask_info &&
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type == "yes_no") ||
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "checklist"
										) {
											if (
												this.selected_assigned_task.checklist[i].not_applicable
											) {
												obj.not_applicable = true;
												obj.boolean_value = null;
											} else {
												obj.boolean_value =
													this.selected_assigned_task.checklist[i]
														.boolean_value === true
														? true
														: this.selected_assigned_task.checklist[i]
																.boolean_value === false
														? this.selected_assigned_task.checklist[i]
																.boolean_value == null
														: null;
												obj.not_applicable = false;
											}
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "text"
										) {
											obj.text_value =
												this.selected_assigned_task.checklist[i].text_value;
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "datetime"
										) {
											obj.datetime_value =
												this.selected_assigned_task.checklist[i].datetime_value;
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "radio_options"
										) {
											if (
												this.selected_assigned_task.checklist[i].subtask_info
													.radio_options.length
											) {
												let filtered_option =
													this.selected_assigned_task.checklist[
														i
													].subtask_info.radio_options.filter((e) => {
														return (
															e.id ==
															this.selected_assigned_task.checklist[i]
																.radio_option_selected
														);
													});
												if (filtered_option.length) {
													obj.num_value = filtered_option[0].num_value;
												}
											}
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "image"
										) {
											let file_list = [];
											file_list = this.imageData;
											if (this.selected_assigned_task.file_list) {
												this.selected_assigned_task.file_list.forEach(
													(element) => {
														let obj = {};
														obj.id = element.id;
														obj.file_name = element.file_name;
														obj.file_path = element.file_path;
														file_list.push(obj);
													}
												);
											}
											obj.attachments = file_list.length ? file_list : [];
										}
										temp.push(obj);
									}
									if (temp.length) {
										this.is_edit_task_loading = true; //displayed loader
										// sent checked task to change their status
										let mark_checked_task_as_completed_res =
											await this.markSubTaskAsComplete(temp);
										if (mark_checked_task_as_completed_res.status == 200) {
											this.goToTask();
											this.$notify.success({
												title: "Success",
												message: "Task updated",
											});
											this.edit_task_dialog_visible = false; //close edit task open dialog
										} else {
											this.$notify.error({
												title: "Error",
												message: "Failed to update Task",
											});
										}
										// Re-ordering check list for steps data
										this.selected_assigned_task.checklist.sort(
											(a, b) =>
												a.subtask_info.serial_no - b.subtask_info.serial_no
										);
										this.is_edit_task_loading = false; //disabled loader
									}
								} else if (!this.selected_assigned_task.checklist.length) {
									this.is_edit_task_loading = false; //displayed loader
									let mark_task_as_completed_res =
										await this.changeStatusOfTask(
											this.selected_assigned_task.task_obj_id,
											this.selected_assigned_task.marked_as_completed
										);
									if (mark_task_as_completed_res.status == 200) {
										this.goToTask();
										this.$notify.success({
											title: "Success",
											message: "Task updated",
										});
										this.edit_task_dialog_visible = false; //close edit task open dialog
									} else {
										this.$notify.error({
											title: "Error",
											message: "Failed to update Task",
										});
									}
									this.is_edit_task_loading = false; //disabled loader
								}

								LabourPalnningService.assignedTaskToEmployees(params)
									.then(async (res) => {
										if (res.status == 200) {
											this.goToTask();
											this.$notify.success({
												title: "Success",
												message: "Task updated",
											});
											this.edit_task_dialog_visible = false; //close edit task open dialog
										}
										this.is_edit_task_loading = false; //closed loader
									})
									.catch(
										function (err) {
											console.error(err);
											this.is_edit_task_loading = false; //closed loader
											this.$notify.error({
												title: "Error",
												message: "Failed to update Task",
											});
										}.bind(this)
									);
							} else if (
								this.selected_assigned_task.selected_action ==
								"CHANGE_TASK_STATUS"
							) {
								let temp = [];
								if (this.selected_assigned_task.checklist.length) {
									for (
										let i = 0;
										i < this.selected_assigned_task.checklist.length;
										i++
									) {
										let obj = {
											subtask_status_id:
												this.selected_assigned_task.checklist[i].id,
											id: this.selected_assigned_task.checklist[i].subtask_info
												.id,
											label:
												this.selected_assigned_task.checklist[i].subtask_info
													.label,
											serial_no:
												this.selected_assigned_task.checklist[i].subtask_info
													.serial_no,
											subtask_type:
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type,
											num_value_min:
												this.selected_assigned_task.checklist[i].subtask_info
													.num_value_min,
											num_value_max:
												this.selected_assigned_task.checklist[i].subtask_info
													.num_value_max,
											comment: this.selected_assigned_task.checklist[i].comment,
											radio_option_selected: this.selected_assigned_task
												.checklist[i].radio_option_selected
												? this.selected_assigned_task.checklist[i]
														.radio_option_selected
												: null,
											raise_ticket:
												this.selected_assigned_task.checklist[i].raise_ticket,
										};
										if (
											(this.selected_assigned_task.checklist[i].subtask_info &&
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type == "number") ||
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "scoring" ||
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "rating"
										) {
											obj.num_value = this.selected_assigned_task.checklist[i]
												.num_value
												? Number(
														this.selected_assigned_task.checklist[i].num_value
												  )
												: null;
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											(this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "temperature" ||
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type == "tpc")
										) {
											obj.num_value = this.selected_assigned_task.checklist[i]
												.num_value
												? Number(
														this.selected_assigned_task.checklist[i].num_value
												  )
												: null;
											obj.retest_value =
												this.selected_assigned_task.checklist[i].retest_value !=
													null &&
												this.selected_assigned_task.checklist[i].retest_value !=
													""
													? Number(
															this.selected_assigned_task.checklist[i]
																.retest_value
													  )
													: null;
											obj.description =
												this.selected_assigned_task.checklist[i].description;
											obj.date = this.selected_assigned_task.checklist[i].date
												? moment(
														this.selected_assigned_task.checklist[i].date
												  ).format("YYYY-MM-DD")
												: null;
										} else if (
											(this.selected_assigned_task.checklist[i].subtask_info &&
												this.selected_assigned_task.checklist[i].subtask_info
													.subtask_type == "yes_no") ||
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "checklist"
										) {
											if (
												this.selected_assigned_task.checklist[i].not_applicable
											) {
												obj.not_applicable = true;
												obj.boolean_value = null;
											} else {
												obj.boolean_value =
													this.selected_assigned_task.checklist[i]
														.boolean_value === true
														? true
														: this.selected_assigned_task.checklist[i]
																.boolean_value === false
														? this.selected_assigned_task.checklist[i]
																.boolean_value == null
														: null;
												obj.not_applicable = false;
											}
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "text"
										) {
											obj.text_value =
												this.selected_assigned_task.checklist[i].text_value;
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "datetime"
										) {
											obj.datetime_value =
												this.selected_assigned_task.checklist[i].datetime_value;
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "radio_options"
										) {
											if (
												this.selected_assigned_task.checklist[i].subtask_info
													.radio_options.length
											) {
												let filtered_option =
													this.selected_assigned_task.checklist[
														i
													].subtask_info.radio_options.filter((e) => {
														return (
															e.id ==
															this.selected_assigned_task.checklist[i]
																.radio_option_selected
														);
													});
												if (filtered_option.length) {
													obj.num_value = filtered_option[0].num_value;
												}
											}
										} else if (
											this.selected_assigned_task.checklist[i].subtask_info &&
											this.selected_assigned_task.checklist[i].subtask_info
												.subtask_type == "image"
										) {
											let file_list = [];
											file_list = this.imageData;
											if (this.selected_assigned_task.file_list) {
												this.selected_assigned_task.file_list.forEach(
													(element) => {
														let obj = {};
														obj.id = element.id;
														obj.file_name = element.file_name;
														obj.file_path = element.file_path;
														file_list.push(obj);
													}
												);
											}
											obj.attachments = file_list.length ? file_list : [];
										}
										temp.push(obj);
									}
									if (temp.length) {
										this.is_edit_task_loading = true; //displayed loader
										// sent checked task to change their status
										let mark_checked_task_as_completed_res =
											await this.markSubTaskAsComplete(temp);
										if (mark_checked_task_as_completed_res.status == 200) {
											this.goToTask();
											this.$notify.success({
												title: "Success",
												message: "Task updated",
											});
											this.edit_task_dialog_visible = false; //close edit task open dialog
										} else {
											this.$notify.error({
												title: "Error",
												message: "Failed to update Task",
											});
										}
										this.is_edit_task_loading = false; //disabled loader
									}
								} else if (!this.selected_assigned_task.checklist.length) {
									this.is_edit_task_loading = false; //displayed loader
									let mark_task_as_completed_res =
										await this.changeStatusOfTask(
											this.selected_assigned_task.task_obj_id,
											this.selected_assigned_task.marked_as_completed
										);
									if (mark_task_as_completed_res.status == 200) {
										this.goToTask();
										this.$notify.success({
											title: "Success",
											message: "Task updated",
										});
										this.edit_task_dialog_visible = false; //close edit task open dialog
									} else {
										this.$notify.error({
											title: "Error",
											message: "Failed to update Task",
										});
									}
									this.is_edit_task_loading = false; //disabled loader
								}
							}
						} else {
							this.$message.error("Required fields are missing");
						}
					}.bind(this)
				)
				.catch((err) => {
					console.error("Validation error", err);
				});
		},

		markSubTaskAsComplete(checked_task_list) {
			return LabourPalnningService.changeSubTaskStatus(checked_task_list)
				.then((res) => {
					return res;
				})
				.catch(
					function (err) {
						console.error(err);
						this.is_edit_task_loading = false; //hide loader
					}.bind(this)
				);
		},
		changeStatusOfTask(task_id, status) {
			let params = {};
			params.task_assignment = task_id;
			params.status = status == true ? "Completed" : "Open";
			return LabourPalnningService.updateTaskAssignmentStatus(params)
				.then((res) => {
					return res;
				})
				.catch(
					function (err) {
						console.error(err);
					}.bind(this)
				);
		},
		sendUploadedFilesToServer(params) {
			return LabourPalnningService.uploadTaskFiles(params)
				.then((response) => {
					return response;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		openFile() {
			document.getElementById("fileUpload").click();
		},
		getFile() {
			let size = 0;
			this.file_list = this.$refs["fileUpload"][0].files;
			for (let i = 0; i < this.file_list.length; i++) {
				size += this.file_list[i].size;
			}
			let lengthOfFile = this.file_list.length;
			// check length if already uploaded some files
			if (
				this.selected_assigned_task.file_list &&
				this.selected_assigned_task.file_list.length
			) {
				lengthOfFile =
					this.selected_assigned_task.file_list.length + this.file_list.length;
			}
			if (lengthOfFile <= 4) {
				if (size > 1040 * 1024 * 5) {
					this.$alert(
						`Total size is too large. Allowed maximum size is 5 MB`,
						"Error!",
						{
							confirmButtonText: "OK",
						}
					);
				} else {
					this.uploadImage();
				}
			} else if (lengthOfFile > 4) {
				this.$alert(
					`Maximum Files Allowed - 4, you selected ${lengthOfFile}`,
					"Error!",
					{
						confirmButtonText: "OK",
					}
				);
				this.file_list = [];
			}
		},
		removeFile(index) {
			this.imageData.splice(index, 1);
		},
		uploadImage() {
			let formData = new FormData();
			for (let file = 0; file < this.file_list.length; file++) {
				formData.append("attachments", this.file_list[file]);
			}
			formData.append("storage", "task");
			LabourPalnningService.uploadTaskFiles(formData)
				.then((response) => {
					let res = JSON.parse(response.data);
					this.imageData = res.data;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		removeSelectedFile(i, id) {
			let params = {
				id: id,
			};
			return LabourPalnningService.removeAttachmentFile(params)
				.then((response) => {
					if (response.status == 200) {
						this.selected_assigned_task.file_list.splice(i, 1);
						this.$notify.success({
							title: "Success",
							message: "Attachment Deleted..!",
						});
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},
		compareTaskReportDateTime(dates_str, element) {
			let comparison_arr = [];
			element.forEach((el) => {
				if (el.completed == 1 || el.completed == 0) {
					if (
						this.formatTimestamp(el.completed_date) ==
						this.formatTimestamp(dates_str)
					) {
						comparison_arr.push(el);
					}
				}
			});
			if (comparison_arr.length > 0) {
				let check = comparison_arr.find(
					(el) =>
						this.formatTimestamp(el.completed_date) ==
						this.formatTimestamp(dates_str)
				);
				if (check) {
					return '<i style="color: #67C23A; font-size: 16px;" class="text-base el-icon-success"></i>';
				} else {
					return '<i style="color: #F56C6C; font-size: 16px;" class="text-base el-icon-error"></i>';
				}
			} else {
				return "-";
			}
		},
		calculateSubTaskValue(date_str, records) {
			let records_arr = [];
			let sub_task_type = "text";
			records.forEach((el) => {
				if (
					this.formatTimestamp(el.due_date) == this.formatTimestamp(date_str)
				) {
					if (el.is_completed == true) {
						sub_task_type = el.subtask_type;
						records_arr.push(el);
					}
				}
			});
			if (records_arr.length > 0) {
				if (sub_task_type == "temperature") {
					if (
						records_arr[0].num_value >= records_arr[0].num_value_min &&
						records_arr[0].num_value <= records_arr[0].num_value_max
					) {
						return records_arr[0].num_value + "&deg; C";
					} else {
						return (
							'<span style="color: #F56C6C;">' +
							records_arr[0].num_value +
							"&deg; C</span>"
						);
					}
				} else if (sub_task_type == "tpc") {
					if (
						records_arr[0].num_value >= records_arr[0].num_value_min &&
						records_arr[0].num_value <= records_arr[0].num_value_max
					) {
						return records_arr[0].num_value + " TPM";
					} else {
						return (
							'<span style="color: #F56C6C;">' +
							records_arr[0].num_value +
							" TPM</span>"
						);
					}
				} else if (sub_task_type == "rating") {
					return (
						'<el-rate :value="' +
						Number(records_arr[0].num_value) +
						'" disabled show-score text-color="#ff9900" score-template="' +
						Number(records_arr[0].num_value) +
						' points"></el-rate>'
					);
				} else if (sub_task_type == "number") {
					return records_arr[0].num_value;
				} else if (sub_task_type == "scoring") {
					return Number(records_arr[0].num_value);
				} else if (sub_task_type == "text") {
					return records_arr[0].text_value;
				} else if (sub_task_type == "datetime") {
					return records_arr[0].datetime_value;
				} else if (sub_task_type == "yes_no") {
					if (records_arr[0].not_applicable) {
						return "-";
					} else {
						if (records_arr[0].boolean_value == true) {
							return '<i style="color: #67C23A;" class="text-base el-icon-success"></i>';
						} else {
							return '<i style="color: #F56C6C;" class="text-base el-icon-error"></i>';
						}
					}
				} else {
					return '<i style="color: #F56C6C;" class="text-base el-icon-error"></i>';
				}
			} else {
				return "-";
			}
		},
		handleTaskReportBreadcrumb(title, index) {
			let length = index + 1;
			let temp_arr = [...this.task_report_breadcrumb_elements];
			if (this.task_report_breadcrumb_elements[index].level == "employee") {
				this.task_report_type = "employee";
				this.task_report_categories = [];
				this.task_report_tasks = [];
				this.task_reports_subtasks = [];
			} else if (
				this.task_report_breadcrumb_elements[index].level == "category"
			) {
				this.task_report_type = "category";
				this.task_report_employees = [];
			} else if (this.task_report_breadcrumb_elements[index].level == "task") {
				this.task_report_type = "task";
			} else if (
				this.task_report_breadcrumb_elements[index].level == "subtask"
			) {
				this.task_report_type = "subtask";
			}
			this.task_report_breadcrumb_elements = temp_arr.slice(0, length);
		},
		async showTaskStepsAttachment(attachments, comment) {
			try {
				let fileArr = attachments.map((el) => el.id);
				for (let i = 0; i < fileArr.length; i++) {
					await this.getImageUrl(fileArr[i]);
				}
				this.showTaskReportsImageModal = true;
				this.taskReportsImageComment = comment;
			} catch (error) {
				console.error(error);
			}
		},
		resetImageModal() {
			this.taskReportsImgArr = [];
		},
		async openAuditSubTaskImageCommentModal(attachments, comment) {
      this.taskReportsImgArr = [];
      const getAttachmentsArr = async (path) => {
        let params = {
          attachment_id: path
        };
        await LabourPalnningService.getTaskAttachmentNew(params)
          .then(res => {
            let responseData = JSON.parse(res.data);
            this.taskReportsImgArr.push(responseData.url);
          }).catch(err => {
            console.error(err);
          });
      }
      for(let i = 0; i < attachments.length; i++) {
        await getAttachmentsArr(attachments[i]);
      }
      this.showTaskReportsImageModal = true;
      this.taskReportsImageComment = comment;
    },
		openAttachmentsModal(records, date) {
			try {
				if (records.length > 0) {
					this.taskReportsImgArr = [];
					let imageObj = {};
					if (date) {
						for (let i = 0; i < records.length; i++) {
							if (
								this.formatTimestamp(records[i].time_of_completion) ==
								this.formatTimestamp(date)
							) {
								imageObj = { ...records[i] };
							}
						}
					}
					if (
						imageObj &&
						Object.keys(imageObj).length === 0 &&
						Object.getPrototypeOf(imageObj) === Object.prototype
					) {
						this.$notify.error({
							title: "Fail",
							message: "Failed to open image",
						});
					} else {
						for (let i = 0; i < imageObj.attachments.length; i++) {
							this.getImageUrl(imageObj.attachments[i]);
						}
						this.showTaskReportsImageModal = true;
						this.taskReportsImageComment = imageObj.comment;
					}
				} else {
					this.$notify.error({
						title: "Fail",
						message: "No attachments available",
					});
				}
			} catch (error) {
				console.error(error);
				this.$notify.error({
					title: "Fail",
					message: "Failed to open image",
				});
			}
		},
		getTaskReportImageClass(date, records) {
			if (date && records.length > 0) {
				let completed = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						if (
							this.formatTimestamp(records[i].time_of_completion) ==
							this.formatTimestamp(date)
						) {
							completed = true;
						}
					}
				}
				if (completed == true) {
					return "color: #d26300";
				} else {
					return "";
				}
			} else {
				return "";
			}
		},
		async getImageUrl(path) {
			let params = {
				attachment_id: path,
			};

			await LabourPalnningService.getTaskAttachmentNew(params)
				.then((res) => {
					let responseData = JSON.parse(res.data);
					this.taskReportsImgArr.push(responseData.url);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		checkIfTaskIsCompleted(records, date) {
			let result = false;
			if (records.length > 0) {
				for (let i = 0; i < records.length; i++) {
					let time_of_completion = records[i].time_of_completion;
					let current_date = date;
					if (time_of_completion && current_date) {
						time_of_completion = this.formatTimestamp(time_of_completion);
						current_date = this.formatTimestamp(current_date);
						if (time_of_completion == current_date) {
							result = true;
						}
					}
				}
			}
			return result;
		},
		getTaskValue(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			if (current_date) {
				if (records.length > 0) {
					let subtask_type = "temperature";
					let index = 0;
					let result = "";
					for (let i = 0; i < records.length; i++) {
						let time_of_completion = records[i].time_of_completion;
						let due_date = records[i].due_date;
						if (time_of_completion && due_date) {
							time_of_completion = this.formatTimestamp(time_of_completion);
							due_date = this.formatTimestamp(due_date);
							if (time_of_completion == current_date) {
								// if (new Date(time_of_completion) <= new Date(due_date)) {
								index = i;
								subtask_type = records[i].subtask_type;
								// }
							}
						}
					}
					if (records[index].not_applicable) {
						result = "N.A";
					} else if (subtask_type == "datetime") {
						result = records[index].datetime_value;
					} else if (subtask_type == "radio_options") {
						result = records[index].num_value;
					} else if (subtask_type == "yes_no") {
						result = records[index].boolean_value ? "Yes" : "No";
					} else if (subtask_type == "temperature") {
						if (records[index].not_applicable === true) {
							result = `NA`;
						} else if (records[index].num_value != null) {
							if (
								records[index].num_value >= records[index].num_value_min &&
								records[index].num_value <= records[index].num_value_max
							) {
								result = `<div>Test Value: <span style="color:green;">${records[index].num_value}&deg C</span></div>`;
							} else if (records[index].retest_value != null) {
								if (
									records[index].retest_value >= records[index].num_value_min &&
									records[index].retest_value <= records[index].num_value_max
								) {
									result = `<div>Test Value: <span style="color:red;">${
										records[index].num_value
									}&deg C</span></div><div>Retest Value: ${
										records[index].retest_value == 0 ||
										records[index].retest_value
											? records[index].retest_value + "&deg C"
											: "-"
									}</div>`;
								} else {
									result = `<div>Test Value: <span style="color:red;">${
										records[index].num_value
									}&deg C</span></div><div>Retest Value: <span style="color:red;">${
										records[index].retest_value == 0 ||
										records[index].retest_value
											? records[index].retest_value + "&deg C"
											: "-"
									}<span></div>`;
								}
							} else {
								return "-";
							}
						} else {
							result = `<div>Test Value: ${
								records[index].num_value
							}&deg C</div><div>Retest Value: ${
								records[index].retest_value == 0 || records[index].retest_value
									? records[index].retest_value + "&deg C"
									: "-"
							}</div>`;
						}
					} else if (subtask_type == "tpc") {
						if (records[index].not_applicable === true) {
							result = `NA`;
						} else if (records[index].num_value != null) {
							if (
								records[index].num_value >= records[index].num_value_min &&
								records[index].num_value <= records[index].num_value_max
							) {
								result = `<div>Test Value: <span style="color:green;">${records[index].num_value} TPM</span></div>`;
							} else if (records[index].retest_value != null) {
								if (
									records[index].retest_value >= records[index].num_value_min &&
									records[index].retest_value <= records[index].num_value_max
								) {
									result = `<div>Test Value: <span style="color:red;">${
										records[index].num_value
									} TPM</span></div><div>Retest Value: ${
										records[index].retest_value == 0 ||
										records[index].retest_value
											? records[index].retest_value + " TPM"
											: "-"
									}</div>`;
								} else {
									result = `<div>Test Value: <span style="color:red;">${
										records[index].num_value
									} TPM</span></div><div>Retest Value: <span style="color:red;">${
										records[index].retest_value == 0 ||
										records[index].retest_value
											? records[index].retest_value + " TPM"
											: "-"
									}<span></div>`;
								}
							} else {
								return "-";
							}
						} else {
							result = `<div>Test Value: ${
								records[index].num_value
							} TPM</div><div>Retest Value: ${
								records[index].retest_value == 0 || records[index].retest_value
									? records[index].retest_value + " TPM"
									: "-"
							}</div>`;
						}
					} else if (subtask_type == "number") {
						result = records[index].num_value;
					} else if (subtask_type == "scoring") {
						result = records[index].num_value;
					} else if (subtask_type == "scoring") {
						result = records[index].num_value;
					} else if (subtask_type == "rating") {
						result = records[index].num_value;
					} else if (subtask_type == "checklist") {
						result = records[index].boolean_value
							? '<i style="color: #67C23A;" class="text-base el-icon-success"></i>'
							: '<i style="color: #F56C6C;" class="text-base el-icon-error"></i>';
					} else if (subtask_type == "text") {
						result = records[index].text_value;
					}
					return result;
				} else {
					return "-";
				}
			} else {
				return "-";
			}
		},
		checkIfDateHasImage(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			let result = false;
			if (records.length > 0) {
				for (let i = 0; i < records.length; i++) {
					if (records[i].attachments.length > 0) {
						let time_of_completion = records[i].time_of_completion;
						if (time_of_completion) {
							time_of_completion = this.formatTimestamp(time_of_completion);
						}
						if (time_of_completion == current_date) {
							result = true;
						}
					}
				}
			}
			return result;
		},
		checkIfDateHasComment(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			let result = false;
			if (records.length > 0) {
				for (let i = 0; i < records.length; i++) {
					if (records[i].comment) {
						let time_of_completion = records[i].time_of_completion;
						if (time_of_completion) {
							time_of_completion = this.formatTimestamp(time_of_completion);
						}
						if (time_of_completion == current_date) {
							result = true;
						}
					}
				}
			}
			return result;
		},
		checkIfDateHasTemperature(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			let result = false;
			if (records.length > 0) {
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						let time_of_completion = records[i].time_of_completion;
						if (time_of_completion) {
							time_of_completion = this.formatTimestamp(time_of_completion);
						}
						if (time_of_completion == current_date) {
							result = true;
						}
					}
				}
			}
			return result;
		},
		getTestValueDate(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			let result = "";
			if (records.length > 0) {
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						let time_of_completion = records[i].time_of_completion;
						if (time_of_completion) {
							time_of_completion = this.formatTimestamp(time_of_completion);
						}
						if (time_of_completion == current_date) {
							result = records[i].num_value;
						}
					}
				}
			}
			return result != "" ? result + "&deg; C" : "_";
		},
		getRetestValueDate(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			let result = "";
			if (records.length > 0) {
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						let time_of_completion = records[i].time_of_completion;
						if (time_of_completion) {
							time_of_completion = this.formatTimestamp(time_of_completion);
						}
						if (time_of_completion == current_date) {
							result = records[i].retest_value ? records[i].retest_value : "";
						}
					}
				}
			}
			return result != "" ? result + "&deg; C" : "_";
		},
		openCommentModal(records, date) {
			let current_date = date;
			if (current_date) {
				current_date = this.formatTimestamp(current_date);
			}
			if (records.length > 0) {
				let result = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].comment) {
						let time_of_completion = records[i].time_of_completion;
						if (time_of_completion) {
							time_of_completion = this.formatTimestamp(time_of_completion);
						}
						if (time_of_completion == current_date) {
							this.taskReportsImageComment = records[i].comment;
							this.showTaskReportsCommentModal = true;
						}
					}
				}
				return result;
			}
		},
		handleAuditReportsBreadcrumb(type) {
			if (type == "outlet") {
				this.selected_audit_report_category = {
					name: "",
					basics: "",
					current_step: false,
				};
				this.audit_report_tasks = [];
				this.selected_audit_report_task = {
					name: "",
					basics: "",
					current_step: false,
				};
				this.audit_report_sub_tasks = [];
				this.selected_audit_report_sub_task = {
					name: "",
					basics: "",
					current_step: false,
				};
			} else if (type == "category") {
				this.selected_audit_report_task = {
					name: "",
					basics: "",
					current_step: false,
				};
				this.audit_report_sub_tasks = [];
				this.selected_audit_report_sub_task = {
					name: "",
					basics: "",
					current_step: false,
				};
			}
		},
		downloadAuditReportsCsv() {
			this.loading = true;
			let params = {
				basics: "outlet",
				include_dates: false,
				task: null,
				filters: {
					outlets: [],
				},
				designation: null,
				main_category: "audit",
			};
			serverAddrForCSV
				.post(`/bk_task_assignment/audit/report/download/`, params)
				.then((response) => {
					if (response.status == 200) {
						let data = response.data;
						let urlData =
							"data:text/csv;charset=UTF-8," + encodeURIComponent(data);
						let tempLink = document.createElement("a");
						tempLink.href = urlData;
						tempLink.setAttribute("download", `audit_reports.csv`);
						tempLink.click();
					}
				})
				.catch((error) => {
					console.error(error);
				})
				.finally((res) => {
					this.loading = false;
				});
		},
		dashboardIntermidiateCategory() {
			let categoryList = [];
			if (this.dashboardActiveTabLink == "audit") {
				categoryList = [...this.auditIntermediateCategories];
			} else {
				categoryList = [...this.taskIntermediateCategories];
			}
			return categoryList;
		},
		async getLastAuditConducted() {
			this.reportLoader = true;
			const params = {
				basics: "outlet",
				include_dates: false,
				category_wise: false,
				include_cycle_data: true,
				start_date: this.fromDate,
				end_date: this.toDate,
				filters: {
					outlets: [],
				},
				designation: null,
				main_category: "audit",
				intermediate_category: this.selected_audit_type,
			};

			await LabourPalnningService.lastAuditConducted(params)
				.then((response) => {
					const responseData = JSON.parse(response.data);
					this.lastAuditConductedList = responseData.results;
				})
				.catch((error) => {
					console.error(error);
				})
				.finally((result) => {
					this.reportLoader = false;
				});
		},
		getTasksDashboardSummary() {
			if (!this.fromDate || !this.toDate) {
				return;
			}
			let params;
			this.taskDashboardSummary = {
				total: 0,
				completed: 0,
				in_progress: 0,
				incomplete: 0,
				completion_rate: 0,
			};
			if (this.dashboardActiveTabLink == "audit") {
				url = "/bk_task_assignment/report/?get_all=true";
				params = {
					basics: "outlet",
					include_dates: false,
					category_wise: false,
					include_cycle_data: true,
					start_date: this.fromDate,
					end_date: this.toDate,
					filters: {
						outlets: [],
					},
					designation: null,
					main_category: this.dashboardActiveTabLink,
					intermediate_category: this.selected_audit_type,
				};
			} else {
				url = "/task_assignment/report/?get_all=true";
				params = {
					basics: "outlet",
					start_date: this.fromDate,
					end_date: this.toDate,
					main_category: this.dashboardActiveTabLink,
					filters: {
						outlets: [],
					},
					intermediate_category: this.selected_audit_type,
				};
			}

			if (this.select_outlet) {
				params.filters.outlets.push(this.select_outlet);
			}
			let url;
			if (this.fromDate && this.toDate) {
				serverAddr
					.post(url, params)
					.then((response) => {
						const responseData = JSON.parse(response.data);
						let summary;
						if (this.dashboardActiveTabLink == "other") {
							summary = responseData.summary;
							this.taskDashboardSummary = {
								total: summary.total ? summary.total : 0,
								completed: summary.completed ? summary.completed : 0,
								in_progress: summary.assigned ? summary.assigned : 0,
								incomplete: summary.overdue ? summary.overdue : 0,
								completion_rate: summary.completetion_rate
									? summary.completetion_rate + "%"
									: "0%",
							};
							// TASK REPORTS UPDATED VALUE HERE
							this.task_reports = responseData.results;
						} else {
							summary = responseData.meta.summary;
							this.taskDashboardSummary = {
								total: summary.total_cycles ? summary.total_cycles : 0,
								completed: summary.cycles_completed
									? summary.cycles_completed
									: 0,
								in_progress: summary.cycles_inprogress
									? summary.cycles_inprogress
									: 0,
								incomplete: summary.cycles_incomplete
									? summary.cycles_incomplete
									: 0,
								completion_rate: summary.cycle_completion_percentage
									? summary.cycle_completion_percentage + "%"
									: "0%",
							};
							// LAST AUDIT CONDUCTED (UPDATED VALUE)
							this.lastAuditConductedList = responseData.results;
						}
					})
					.catch((error) => {
						console.error(error.response.data);
					});
			}
		},
		downloadTaskEmployeeReport() {
			let data = this.task_report_employees.map((el) => ({
				"Employee Name": el.name,
				Total: el.total,
				Completed: el.completed,
				Incomplete: el.total - el.completed,
				"Completion Rate": el.completion_rate,
			}));
			const fileName =
				"Task_Report_By_Employee_" + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
		},
		downloadTaskCategoryReport() {
			let data = this.task_report_categories.map((el) => ({
				Category: el.name,
				"Task Type": el.intermediate_category_name,
				Total: el.total,
				Completed: el.completed == "-" ? 0 : el.completed,
				Incomplete: el.total - el.completed,
				"Completion Rate":
					el.completion_rate == "-" ? "0%" : el.completion_rate + "%",
			}));
			const fileName =
				"Task_Report_By_Category_" + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
		},
		downloadTaskWiseReport() {
			let data = [];
			for (let x = 0; x < this.task_report_tasks.length; x++) {
				let task_name = this.task_report_tasks[x].name;
				let obj = {
					Task: task_name,
				};
				for (let i = 0; i < this.all_task_report_dates.length; i++) {
					let date = this.all_task_report_dates[i];
					let d = new Date(date);
					let label = moment(d).format("Do MMM YYYY");
					let value = "N";

					this.task_report_tasks[x].records.forEach((el) => {
						let completed_date = el.completed_date;
						if (completed_date) {
							completed_date = this.formatTimestamp(completed_date);
							if (
								this.formatTimestamp(date) ==
								this.formatTimestamp(completed_date)
							) {
								value = "Y";
							}
						}
					});
					obj[label] = value;
				}
				data.push(obj);
			}
			const fileName =
				"Task_Report_By_Task_" + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
		},
		downloadStepWiseReport() {
			let data = [];
			for (let x = 0; x < this.task_report_tasks.length; x++) {
				let task_name = this.task_report_tasks[x].name;
				let obj = {
					Task: task_name,
				};
				for (let i = 0; i < this.all_task_report_dates.length; i++) {
					let date = this.all_task_report_dates[i];
					let d = new Date(date);
					let label = moment(d).format("Do MMM YYYY");
					let value = "N";

					this.task_report_tasks[x].records.forEach((el) => {
						let completed_date = el.completed_date;
						if (completed_date) {
							completed_date = this.formatTimestamp(completed_date);
							if (
								this.formatTimestamp(date) ==
								this.formatTimestamp(completed_date)
							) {
								value = "Y";
							}
						}
					});
					obj[label] = value;
				}
				data.push(obj);
			}
			const fileName =
				"Task_Report_By_Task_" + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
		},
		downloadTaskCsvReport() {
			let sub_cat_arr = this.task_sub_category_list.filter((item) => {
				if (item.id == this.selected_audit_type) return item;
			});
			let params = {
				start_date: this.fromDate,
				end_date: this.toDate,
				filters: {
					outlets:
						this.select_outlet == null || this.select_outlet == undefined
							? []
							: this.select_outlet,
				},
				main_category: "other",
				intermediate_category: this.selected_audit_type,
				name: sub_cat_arr[0].name,
			};
			this.generateAuditTaskReportAction(params);
			// let data = this.task_reports.map(el => ({
			//   "Location": el.name,
			//   "Task Assigned": el.total,
			//   "Completed": el.completed,
			//   "Incomplete": el.total - el.completed,
			//   "Completion Rate": el.completion_rate != '-' ? (el.completion_rate + '%') : el.completion_rate
			// }));
			// const fileName = 'Task_Report_' + this.fromDate + '_to_' + this.toDate;
			// const exportType = exportFromJSON.types.csv;
			// exportFromJSON({ data, fileName, exportType });
		},
		...mapActions("CommonStore", ["generateAuditTaskReportAction"]),
		downloadLastAuditConducted() {
			let sub_cat_arr = this.audit_sub_category_list.filter((item) => {
				if (item.id == this.selected_audit_type) return item;
			});
			let params = {
				start_date: this.fromDate,
				end_date: this.toDate,
				filters: {
					outlets:
						this.select_outlet == null || this.select_outlet == undefined
							? []
							: this.select_outlet,
				},
				main_category: "audit",
				intermediate_category: this.selected_audit_type,
				name: sub_cat_arr[0].name,
			};
			this.generateAuditTaskReportAction(params);

			//prev code
			// if (navigator.msSaveBlob) {
			// 	csvURL = navigator.msSaveBlob(csvData, "download.csv");
			// } else {
			// 	csvURL = window.URL.createObjectURL(csvData);
			// }

			// const titleCase = (str) => {
			//   if(str) {
			//     let splitStr = str.toLowerCase().split(' ');
			//     for (let i = 0; i < splitStr.length; i++) {
			//         // You do not need to check if i is larger than splitStr length, as your for does that for you
			//         // Assign it back to the array
			//         splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			//     }
			//     // Directly return the joined string
			//     return splitStr.join(' ');
			//   } else {
			//     return str;
			//   }

			//   }
			// let data = this.lastAuditConductedList.map(el => ({
			//   "Location": titleCase(el.name),
			//   "Region": titleCase(el.region_name),
			//   "Area Lead": titleCase(el.subregion_name),
			//   "Grade": el.grade,
			//   "Points Available": el.total_yes_no_points ? el.total_yes_no_points : 0,
			//   "Points Achieved": el.total_yes_no_points_achieved,
			//   "Percentage": el.yes_no_points_percentage,
			//   "Conducted By": el.user_name ? el.user_name : '',
			//   "Status": el.yes_no_points_percentage == 0 ? 'Incomplete' : (el.yes_no_points_percentage > 0 && el.yes_no_points_percentage < 100 ? 'In Progress' : (el.yes_no_points_percentage == 100 ? 'Completed' : ''))
			// }));
			// const fileName = 'Last_Audit_Conducted_' + this.fromDate + '_' + this.toDate;
			// const exportType = exportFromJSON.types.csv;
			// exportFromJSON({ data, fileName, exportType });
		},
		getMissingLogs() {
			if (this.select_outlet) {
				if (!this.fromDate || !this.toDate) {
					return;
				}
				const params = {
					basics: "task",
					start_date: this.fromDate,
					end_date: this.toDate,
					include_dates: true,
					employee: null,
					task: null,
					filters: {
						countries: [],
						regions: [],
						subregions: [],
						outlets: [this.select_outlet],
					},
					category: null,
				};
				if (this.dashboardActiveTabLink == "audit") {
					params.basics = "category";
					params.designation = null;
					params.main_category = "audit";
					this.$delete(params, "category");
				}
				let url =
					this.dashboardActiveTabLink == "audit"
						? "/bk_task_assignment/report/?get_all=true"
						: "/task_assignment/report/?get_all=true";
				if (this.fromDate && this.toDate) {
					this.logsLoading = true;
					serverAddr
						.post(url, params)
						.then((response) => {
							let responseData = JSON.parse(response.data);
							this.logReports = responseData.results;
						})
						.catch((error) => {
							console.error(error);
						})
						.finally((result) => {
							this.logsLoading = false;
						});
				}
			}
		},
		selectAllAuditReportLocations() {
			this.selected_audit_report_locations = [...this.auditReportLocations];
		},
		resetSelectedAuditReportLocations() {
			this.selected_audit_report_locations = [];
		},
		selectAllAuditReportRegions() {
			this.selected_audit_report_regions = [...this.auditReportRegions];
		},
		resetSelectedAuditReportRegions() {
			this.selected_audit_report_regions = [];
		},
		selectAllAuditReportAreaLeads() {
			this.selected_audit_report_area_leads = [...this.auditReportAreaLeads];
		},
		resetSelectedAuditReportAreaLeads() {
			this.selected_audit_report_area_leads = [];
		},
		selectAllAuditReportGrades() {
			this.selected_audit_report_grades = [...this.auditReportGrades];
		},
		resetSelectedAuditReportGrades() {
			this.selected_audit_report_grades = [];
		},
		selectAllAuditReportSubCategories() {
			this.selected_audit_report_sub_categories = [
				...this.auditReportSubCategories,
			];
		},
		resetSelectedAuditReportSubCategories() {
			this.selected_audit_report_sub_categories = [];
		},
		selectAllAuditReportIntermediateCategories() {
			this.selected_audit_report_intermediate_categories = [
				...this.auditReportIntermediateCategories,
			];
		},
		resetSelectedAuditReportIntermediateCategories() {
			this.selected_audit_report_intermediate_categories = [];
		},
		selectAllAuditReportTasks() {
			this.selected_audit_report_tasks = [...this.auditReportTasks];
		},
		resetSelectedAuditReportTasks() {
			this.selected_audit_report_tasks = [];
		},
		selectAllAuditReportSubTasks() {
			this.selected_audit_report_subtasks = [...this.auditReportSubTasks];
		},
		resetSelectedAuditReportSubTasks() {
			this.selected_audit_report_subtasks = [];
		},
		// Task Report Filters
		selectAllTaskReportsEmployees() {
			this.selected_task_report_employee_names = [...this.taskReportEmployees];
		},
		resetSelectedTaskReportsEmployees() {
			this.selected_task_report_employee_names = [];
		},
		sortByTaskReportTotalAscending() {
			this.sort_by_task_report_total_ascending = true;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportTotalDescending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = true;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportCompletedAscending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = true;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportCompletedDescending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = true;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportIncompleteAscending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = true;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportIncompleteDescending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = true;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportCompletionRateAscending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = true;
			this.sort_by_task_report_completion_rate_descending = false;
		},
		sortByTaskReportCompletionRateDescending() {
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = true;
		},
		selectAllTaskReportCategories() {
			this.selected_task_report_categories = [...this.taskReportCategories];
		},
		resetAllSelectedTaskReportCategories() {
			this.selected_task_report_categories = [];
		},
		selectAllTaskReportIntermediateCategories() {
			this.selected_task_report_intermediate_categories = [
				...this.taskReportIntermediateCategories,
			];
		},
		resetAllSelectedTaskReportIntermediateCategories() {
			this.selected_task_report_intermediate_categories = [];
		},
		selectAllTaskReportTasks() {
			this.selected_task_report_task = [...this.taskReportTasks];
		},
		resetAllSelectedTaskReportTasks() {
			this.selected_task_report_task = [];
		},
		selectAllTaskReportFrequency() {
			this.selected_task_report_frequency = [...this.taskReportFrequency];
		},
		resetAllSelectedTaskReportFrequency() {
			this.selected_task_report_frequency = [];
		},
		selectAllTaskReportSubTask() {
			this.selected_task_report_sub_task = [...this.taskReportSubTask];
		},
		resetAllSelectedTaskReportSubTask() {
			this.selected_task_report_sub_task = [];
		},
		resetAllAuditReportFilters() {
			this.searched_audit_report_location = "";
			this.selected_audit_report_locations = [];
			this.searched_audit_report_region = "";
			this.selected_audit_report_regions = [];
			this.searched_audit_report_area_lead = "";
			this.selected_audit_report_area_leads = [];
			this.searched_audit_report_grade = "";
			this.selected_audit_report_grades = [];

			this.searched_audit_report_sub_category = "";
			this.selected_audit_report_sub_categories = [];
			this.searched_audit_report_intermediate_category = "";
			this.selected_audit_report_intermediate_categories = [];

			this.searched_audit_report_task = "";
			this.selected_audit_report_tasks = [];

			this.searched_audit_report_subtask = "";
			this.selected_audit_report_subtasks = [];
		},
		resetAllTaskReportFilters() {
			this.searched_task_report_employee_name = "";
			this.selected_task_report_employee_names = [];
			this.searched_task_report_category = "";
			this.selected_task_report_categories = [];
			this.searched_task_report_intermediate_category = "";
			this.selected_task_report_intermediate_categories = [];
			this.sort_by_task_report_total_ascending = false;
			this.sort_by_task_report_total_descending = false;
			this.sort_by_task_report_completed_ascending = false;
			this.sort_by_task_report_completed_descending = false;
			this.sort_by_task_report_incomplete_ascending = false;
			this.sort_by_task_report_incomplete_descending = false;
			this.sort_by_task_report_completion_rate_ascending = false;
			this.sort_by_task_report_completion_rate_descending = false;

			this.searched_task_report_task = "";
			this.selected_task_report_task = [];
			this.searched_task_report_frequency = "";
			this.selected_task_report_frequency = [];

			this.searched_task_report_sub_task = "";
			this.selected_task_report_sub_task = [];
		},
		handleChangeMissingLogReset(event) {
			if (event == null) {
				if (
					this.selected_audit_type == "overall_missing_logs" ||
					this.selected_audit_type == "equipments_and_products_missing_logs"
				) {
					window.location.reload(true);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import url("./Tasks.scss");
</style>

<style lang="scss">
@import url("./Tasks.scss");

.Tasks .assign_task_popup .el-dialog {
	margin-top: 0 !important;
}

.Tasks .assign_task_popup .el-dialog__body {
	height: 500px;
	overflow: auto;
}

.Tasks .open-status-dropdown {
	background-color: #d26300;
	border-color: #d26300;
	color: #fff;
	text-transform: uppercase;
	border-radius: 4px;
	width: 100px;
	margin: 0 auto;
	padding: 5px;
	font-size: 0.8rem;
	text-align: center;
}

.Tasks .completed-status-dropdown {
	background-color: #29b823;
	border-color: #29b823;
	color: #fff;
	text-transform: uppercase;
	border-radius: 4px;
	width: 100px;
	margin: 0 auto;
	padding: 5px;
	font-size: 0.8rem;
	text-align: center;
}

.Tasks .overdue-status-dropdown {
	background-color: #d60918;
	border-color: #d60918;
	color: #fff;
	text-transform: uppercase;
	border-radius: 4px;
	width: 100px;
	margin: 0 auto;
	padding: 5px;
	font-size: 0.8rem;
	text-align: center;
}

.Tasks .upcoming-status-dropdown {
	background-color: #0480fe;
	border-color: #0480fe;
	color: #fff;
	text-transform: uppercase;
	border-radius: 4px;
	width: 100px;
	margin: 0 auto;
	padding: 5px;
	font-size: 0.8rem;
	text-align: center;
}

.Tasks .unassigned-status-dropdown {
	background-color: #880e4f;
	border-color: #880e4f;
	color: #fff;
	text-transform: uppercase;
	border-radius: 4px;
	width: 100px;
	margin: 0 auto;
	padding: 5px;
	font-size: 0.8rem;
	text-align: center;
}

.Tasks .status-badge .el-select__caret {
	color: #fff !important;
}

.Tasks .image-popup {
	box-shadow: none;
}

.Tasks .image-popup .el-dialog__body {
	height: 630px;
	overflow: auto;
	background: transparent;
	border-radius: 7px;
}

.Tasks .image-popup .el-dialog {
	margin-top: 40px !important;
	margin-bottom: 0px !important;
	border-radius: 7px;
	background: transparent;
	box-shadow: none;
}

.Tasks .image-popup .el-dialog__header {
	display: none;
	background: #ffff;
}

.Tasks .el-dialog__header {
	background: #2e323a;
	padding: 14px;

	.el-dialog__title {
		color: #fff;
	}
}

.Tasks {
	.el-table__empty-text {
		color: #d26300;
	}

	.el-table__column-filter-trigger i {
		font-weight: bold;
		font-size: 15px;
		margin-left: 2px;
	}

	.edit-col .el-table__column-filter-trigger {
		display: none;
	}
}

.el-table-filter__wrap {
	.el-checkbox__label {
		text-transform: capitalize;
	}
}

.el-table-filter__bottom {
	display: flex;
	justify-content: space-between;
}

.reportPopup .customClass {
	position: absolute;
	right: 0;
	margin: 0;
}

.reportPopup .el-dialog__header {
	display: none;
}

.reportPopup .el-dialog__body {
	padding: 1rem;
	min-height: 100vh;
	background: #ffffff;
}
.reportPopup .el-switch__label.is-active {
	color: #333333;
}
.Tasks .custom-number-input::placeholder {
	font-size: 0.7rem;
}

.Tasks .custom-size-checkbox .el-checkbox__inner {
	width: 17px;
	height: 17px;
}

.Tasks .el-rate__icon {
	font-size: 23px;
}

.Tasks .el-rate__item {
	margin: 0 10px;
}

.Tasks .el-rate__item:first-child {
	margin-right: 10px;
	margin-left: 0px;
}

.Tasks .custom-number-input {
	background-color: #fff;
	background-image: none;
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	color: #606266;
	display: inline-block;
	font-size: inherit;
	height: 40px;
	line-height: 40px;
	outline: 0;
	padding: 0 15px;
	-webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	width: 100%;
}

.Tasks input::-webkit-outer-spin-button,
.Tasks input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.Tasks .steps-input-type-table {
	width: 100%;
	border-collapse: collapse;
	border-spacing: 0;
	border: 1px solid #eee;

	thead,
	tbody,
	tr,
	td,
	th {
		display: block;
	}

	tbody tr {
		border-bottom: 1px solid #eee;
	}

	tr:after {
		content: " ";
		display: block;
		visibility: hidden;
		clear: both;
	}

	thead th {
		text-align: left;
	}

	tbody {
		height: 290px;
		overflow-y: auto;
	}

	thead {
		background: #f5f5f5;
	}

	tbody td,
	thead th {
		float: left;
	}

	th,
	td {
		padding: 10px;
	}
}

.Tasks .gray-background {
	background: #f2f2f2;

	.el-dialog__body {
		padding: 0;
	}
}

.all-tasks-table {
	width: 100%;

	tr {
		border-bottom: 1px solid #dddddd;
	}

	thead {
		background: #f5f5f5;
	}

	th {
		padding: 12px;
		color: #000;
		text-transform: uppercase;
		font-size: 13px;
		height: 50px;
		font-weight: bold;
	}

	td {
		padding: 10px;
		font-size: 13px;
		text-align: center;
	}

	tbody {
		display: block;
		max-height: 450px;
		overflow-y: auto;
	}

	thead,
	tbody tr {
		display: table;
		width: 100%;
		table-layout: fixed;
	}
}

.preview-btn {
	background: #fff !important;
	color: #d26300 !important;
}

.submit {
	background: #29b823 !important;
	border-color: #29b823 !important;
}

.Tasks .el-button.is-disabled {
	color: #c0c4cc !important;
	cursor: not-allowed;
	background-image: none !important;
	background-color: #fff !important;
	border-color: #ebeef5 !important;
}

.el-row {
	display: flex;
	align-items: center;
}

.el-dialog.add-info__header > .el-dialog__header {
	background: white;
}

.el-dialog.add-info__header > .el-dialog__header > span.el-dialog__title {
	color: #606266 !important;
}

.link-text {
	cursor: pointer;
}

.link-text:hover {
	text-decoration: underline;
}

.Tasks .sales-sec {
	text-align: center !important;
}

.Tasks .sales-sec > .sales-block {
	background: #ffffff;
}

.Tasks .sales-sec > .sales-block > .sales-head {
	background: #502314 !important;
	color: #ffffff !important;
	padding: 8px;
}

.Tasks .sales-amount {
	margin-bottom: 15px;
	color: #502314 !important;
}

.el-dialog__body {
	overflow: scroll !important;
}

.event-table table th {
	background-color: #502314 !important;
	color: #ffffff !important;
}

.event-table table td {
	text-align: center !important;
	color: #502314 !important;
}

.reportPopup .el-radio {
	white-space: pre-wrap;
}

.AppLayout .el-input__inner {
	text-transform: capitalize !important;
}

.comment_modal_task_reports .el-dialog__header,
.image_modal_task_reports .el-dialog__header {
	display: none !important;
}

.Tasks .el-dialog__body {
	padding: 1rem 1rem 1rem 1rem;
	color: unset;
	min-height: 100vh;
}

.Tasks .customClass .el-dialog__header {
	display: none;
}

.el-dialog.customClass {
	position: absolute;
	right: 0;
	margin: 0;
}

.Tasks .table-outer {
	overflow-x: scroll;
}

table {
	border-collapse: collapse;
}

.event-table * {
	text-transform: capitalize;
}

.event-table table {
	width: 100%;
	margin: 0 auto 10px;
	text-align: left;
	border-left: none;
	border-right: none;
}

.Tasks .report-tbl-inner {
	width: 100%;
}

.Tasks .fixed-div {
	position: absolute;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
}

.Tasks .fix-div3 {
	position: absolute;
	left: 35px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
}

.Tasks .fix-div {
	position: absolute;
	left: 180px;
}

.Tasks .fix-div2 {
	position: absolute;
	left: 330px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	width: 120px !important;
	border-right: 1px solid #ddd;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
}

.event-table table thead,
.event-table table tbody tr {
	display: table;
	width: 100%;
	table-layout: fixed;
}

.el-dialog__wrapper {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: auto;
	margin: 0;
}

.Tasks .event-table table tbody {
	height: auto;
	overflow-y: auto;
}

.Tasks .task-fix-div {
	left: 35px !important;
}

.Tasks .event-table td {
	height: 100px;
}

.Tasks .task-table-outer {
	margin-left: 180px !important;
}

.Tasks .link {
	text-decoration: underline;
}

.Tasks .el-radio__input.is-checked .el-radio__inner {
	border-color: #d26300;
	background: #d26300;
}

.Tasks .el-radio__input.is-checked + .el-radio__label {
	color: #d26300;
}

.Tasks .submit-btn:disabled {
	background: rgba(210, 98, 0, 0.4) !important;
	color: white !important;
	border-color: transparent !important;
	cursor: not-allowed !important;
}

.Tasks .el-checkbox__input.is-checked .el-checkbox__inner {
	background-color: #d26300 !important;
	border-color: #d26300 !important;
}
.Tasks .el-checkbox__inner:hover {
	border-color: #d26300 !important;
}
.Tasks .el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #d26300 !important;
}
.Tasks .customClass.audit-report-details .el-dialog__body {
	background-color: #ffffff;
}
.Tasks {
	.event-table {
		table {
			th {
				padding: 8px 4px;
				font-size: 10px;
			}
			td {
				min-height: 60px;
			}
		}
	}
}
</style>

<style>
.el-table.audit-report-tasks-dashboard-task-table td.el-table__cell div {
	text-transform: capitalize !important;
}
.el-table.audit-report-tasks-dashboard-task-table th.el-table__cell {
	min-height: fit-content !important;
}
.el-table.audit-report-tasks-dashboard-task-table th.el-table__cell {
	padding: 8px 0 !important;
	background: #502314 !important;
}
.el-table.audit-report-tasks-dashboard-task-table .icon-white {
	color: #fff;
}
.el-table.audit-report-tasks-dashboard-task-table th.el-table__cell > .cell {
	color: #fff !important;
}
.steps-actions-wrapper {
	display: flex;
	flex-direction: row;
	align-items: end;
	gap: 10px;
}
.steps-actions-wrapper i {
	color: #d26300;
	font-size: 14px !important;
	cursor: pointer;
}
</style>
